(function () {
    'use strict';

    angular.module('ProjectDirectory.pages', [
        'ui.router',
        'ngFileUpload',

        'ProjectDirectory.pages.main',
        'ProjectDirectory.pages.security',
        'ProjectDirectory.pages.user',
        'ProjectDirectory.pages.dashboard',
        'ProjectDirectory.pages.project',
        'ProjectDirectory.pages.resources',
        'ProjectDirectory.pages.files',
        'ProjectDirectory.pages.static',
        'ProjectDirectory.pages.configuration',
        'ProjectDirectory.pages.associated',
        'ProjectDirectory.pages.subscription',
        'ProjectDirectory.pages.bulletin',
        'ProjectDirectory.pages.banner',
        'ProjectDirectory.pages.images',
        'ProjectDirectory.pages.notification',
        'ProjectDirectory.pages.article',
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
        $urlRouterProvider.otherwise('/signin');
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources', [
        'ui.bootstrap'
    ])
        .config(function (pdConfigProvider, LoopBackResourceProvider, $httpProvider, $locationProvider, uiGmapGoogleMapApiProvider) {

            /** loopback configuration */
            LoopBackResourceProvider.setAuthHeader('access-token');
            LoopBackResourceProvider.setUrlBase(pdConfigProvider.apiUrlBase);

            // /** remove # from base url */
            // $locationProvider.html5Mode(true);

            /** google maps */
            uiGmapGoogleMapApiProvider.configure({
                key: pdConfigProvider.gmapsApiKey,
                v: '3.37',
                libraries: 'weather,geometry,visualization'
            });

            /** interceptors */
            $httpProvider.interceptors.push(function ($q, $location, LoopBackAuth, $injector) {
                return {
                    responseError: function (rejection) {
                        if (rejection.status === 401) {

                            LoopBackAuth.clearUser();
                            LoopBackAuth.clearStorage();

                            var currentPath = $location.path();
                            var state = $injector.get('$state');
                            if (!$location.nextAfterLogin) {
                                $location.nextAfterLogin = !state.is('signin') ? currentPath : null;
                            }

                            /** avoid redirect in reset password */
                            if (state.is('reset_password')) {
                                return $q.reject(rejection);
                            }

                            $location.path('/signin');
                            return $q.reject(rejection);

                        } else {
                            return $q.reject(rejection);
                        }
                    }
                };
            });

        });

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.article', [
        'ngSanitize',
        'textAngular',
        'ngFileUpload',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $provide) {
        $stateProvider
            .state('main.article', {
                url: '/article',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Artículos',
                sidebarMeta: {
                    icon: 'fa fa-file-o',
                    order: 400
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.article.list', {
                url: '',
                title: 'Listado Artículos',
                templateUrl: 'app/pages/article/list.html',
                controller: 'ArticlePageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.article.configuration', {
                url: '/configuration',
                title: 'Configuración',
                templateUrl: 'app/pages/article/configuration.html',
                controller: 'ArticleConfigPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.article.create', {
                url: '/create',
                title: 'Nuevo Artículo',
                templateUrl: 'app/pages/article/create.html',
                controller: 'ArticlePageCtrl',
            })
            .state('main.article.edit', {
                url: '/:id/edit',
                title: 'Edición de Artículo',
                templateUrl: 'app/pages/article/edit.html',
                controller: 'ArticlePageCtrl'
            });

        $provide.decorator('taOptions', ['taRegisterTool', '$delegate', '$uibModal', function (taRegisterTool, taOptions, $uibModal) {
            // taOptions.toolbar = [
            //     ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
            //     ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            //     ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
            //     ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
            // ];

            /** custom upload image */
            taRegisterTool('uploadArticleImage', {
                buttontext: 'Insertar imagen',
                tooltiptext: 'Insertar imagen',
                iconclass: "fa fa-image",
                action: function (deferred, restoreSelection) {

                    var textAngular = this;

                    $uibModal.open({
                        animation: true,
                        templateUrl: 'app/resources/components/taUploadArticleImage/taFilesModal.html',
                        size: 'md',
                        controller: 'UploadArticleImageCtrl'

                    }).result.then(function (result) {
                            restoreSelection();

                            // textAngular.$editor().wrapSelection('insertImage', result);

                            var embed = '<img src="' + result + '" style="float:left;" class="text-editor-m-10">';
                            textAngular.$editor().wrapSelection('insertHTML', embed, true);

                            deferred.resolve();
                        },
                        function () {
                            deferred.resolve();
                        }
                    );
                    return false;
                }
            });

            taOptions.toolbar.push(['uploadArticleImage']);
            /** /custom upload image */

            // var display = "<button type='button' class=\"btn btn-default font-size-dropdown\" uib-dropdown uib-dropdown-toggle ng-disabled='showHtml()'>" +
            //     "      <i class='fa fa-text-height'></i><i class='fa fa-caret-down'></i>" +
            //     "      <ul class=\"\" uib-dropdown-menu>" +
            //     "        <li ng-repeat='o in options'>" +
            //     "           <div class=\"btn btn-xs btn-block\" style='font-size: {{o.css}};' ng-click='action($event, o.value)'><i ng-if='o.active' class='fa fa-check'></i> {{o.name}}</button>" +
            //     "        </li>" +
            //     "      </ul>" +
            //     "    </button>";
            //
            // taRegisterTool('fontSize', {
            //     display: display,
            //     action: function (event, size) {
            //         //Ask if event is really an event.
            //         if (!!event.stopPropagation) {
            //             //With this, you stop the event of textAngular.
            //             event.stopPropagation();
            //             //Then click in the body to close the dropdown.
            //             $("body").trigger("click");
            //         }
            //         return this.$editor().wrapSelection('fontSize', parseInt(size));
            //     },
            //     options: [
            //         {name: 'xx-small', css: 'xx-small', value: 1},
            //         {name: 'x-small', css: 'x-small', value: 2},
            //         {name: 'small', css: 'small', value: 3},
            //         {name: 'medium', css: 'medium', value: 4},
            //         {name: 'large', css: 'large', value: 5},
            //         {name: 'x-large', css: 'x-large', value: 6},
            //         {name: 'xx-large', css: 'xx-large', value: 7}
            //     ]
            // });
            //
            // taOptions.toolbar[1].push('fontSize');
            //
            // // remove fontSize actions included tag type header (h1, h2, ... h6)
            // for (var i = 1; i <= 6; i++) {
            //     var index = taOptions.toolbar[0].indexOf('h' + i);
            //     if (index > -1) {
            //         taOptions.toolbar[0].splice(index, 1);
            //     }
            // }
            // var indexFontSize = taOptions.toolbar[1].indexOf('fontSize');
            // if (indexFontSize > -1) {
            //     taOptions.toolbar[1].splice(indexFontSize, 1);
            // }

            return taOptions;
        }]);
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated', [
        'ProjectDirectory.pages.associated.company'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.associated', {
                url: '/associated',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Asociados',
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 400
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.associated.list', {
                url: '',
                title: 'Listado Asociados',
                templateUrl: 'app/pages/associated/list.html',
                controller: 'AssociatedPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.associated.sync', {
                url: '/sync',
                title: 'Sincronización',
                templateUrl: 'app/pages/associated/sync.html',
                controller: 'SyncPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.associated.create', {
                url: '/create',
                title: 'Nuevo Asociado',
                templateUrl: 'app/pages/associated/create.html',
                controller: 'AssociatedPageCtrl',
            })
            .state('main.associated.edit', {
                url: '/:id/edit',
                title: 'Edición de Asociado',
                templateUrl: 'app/pages/associated/edit.html',
                controller: 'AssociatedPageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.banner', [
        'ngSanitize'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.banner', {
                url: '/banner',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Banners Publicitarios',
                sidebarMeta: {
                    icon: 'fa fa-image',
                    order: 500
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.banner.list', {
                url: '',
                title: 'Listado Banners',
                templateUrl: 'app/pages/banner/list.html',
                controller: 'BannerPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.banner.create', {
                url: '/create',
                title: 'Nuevo Banner',
                templateUrl: 'app/pages/banner/create.html',
                controller: 'BannerPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.banner.edit', {
                url: '/:id/edit',
                title: 'Edición de Banner',
                templateUrl: 'app/pages/banner/edit.html',
                controller: 'BannerPageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.bulletin', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.bulletin', {
                url: '/bulletin',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Boletines',
                sidebarMeta: {
                    icon: 'fa fa-envelope',
                    order: 500
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.bulletin.list', {
                url: '',
                title: 'Listado Boletines',
                templateUrl: 'app/pages/bulletin/list.html',
                controller: 'BulletinPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            // .state('main.bulletin.create', {
            //     url: '/create',
            //     title: 'Nuevo Boletín',
            //     templateUrl: 'app/pages/bulletin/create.html',
            //     controller: 'BulletinPageCtrl',
            //     sidebarMeta: {
            //         order: 1
            //     },
            // })
            .state('main.bulletin.create_custom', {
                url: '/create_custom',
                title: 'Nuevo Boletín',
                templateUrl: 'app/pages/bulletin/create_custom.html',
                controller: 'BulletinCustomPageCtrl',
                sidebarMeta: {
                    order: 1
                },
            })
            .state('main.bulletin.show', {
                url: '/:id/show',
                title: 'Estadísticas del Envío',
                templateUrl: 'app/pages/bulletin/show.html',
                controller: 'BulletinPageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.configuration', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.configuration', {
                url: '/configuration',
                templateUrl: 'app/pages/configuration/configuration.html',
                controller: 'ConfigurationPageCtrl',
                title: 'Configuración',
                sidebarMeta: {
                    icon: 'ion-gear-a',
                    order: 1000
                },
                data: {
                    roles: ['admin']
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.dashboard', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.dashboard', {
                url: '/dashboard?startDate=&endDate=',
                templateUrl: 'app/pages/dashboard/ganalytics.html',
                controller: 'GAnalyticsPageCtrl',
                title: 'Dashboard',
                params: {
                    startDate: {
                        value: '',
                        squash: false
                    },
                    endDate: {
                        value: '',
                        squash: false
                    }
                },
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 100,
                    root: true
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.reports', {
                url: '/dashboard/reports',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                data: {
                    roles: ['admin']
                }
            })
            .state('main.reports.destination_page', {
                url: '/destination-page?startDate=&endDate=',
                title: 'Páginas de destino',
                templateUrl: 'app/pages/dashboard/reports/destination_page.html',
                controller: 'DashboardReportsPageCtrl',
                params: {
                    startDate: {
                        value: '',
                        squash: false
                    },
                    endDate: {
                        value: '',
                        squash: false
                    }
                }
            })
            .state('main.reports.exit_page', {
                url: '/exit-page?startDate=&endDate=',
                title: 'Páginas de salida',
                templateUrl: 'app/pages/dashboard/reports/exit_page.html',
                controller: 'DashboardReportsPageCtrl',
                params: {
                    startDate: {
                        value: '',
                        squash: false
                    },
                    endDate: {
                        value: '',
                        squash: false
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.files', ['angularFileUpload', 'ngclipboard'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.files', {
                url: '/files',
                templateUrl: 'app/pages/files/files.html',
                controller: 'FilesPageCtrl',
                title: 'Archivos',
                sidebarMeta: {
                    icon: 'fa fa-folder',
                    order: 800
                },
                data: {
                    roles: ['admin']
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.images', [
        'ngSanitize'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.images', {
                url: '/images',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Slide de Imágenes',
                sidebarMeta: {
                    icon: 'fa fa-image',
                    order: 500
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.images.list', {
                url: '',
                title: 'Listado Imágenes',
                templateUrl: 'app/pages/images/list.html',
                controller: 'ImagesPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.images.create', {
                url: '/create',
                title: 'Nueva Imagen',
                templateUrl: 'app/pages/images/create.html',
                controller: 'ImagesPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.images.edit', {
                url: '/:id/edit',
                title: 'Edición de Imagen',
                templateUrl: 'app/pages/images/edit.html',
                controller: 'ImagesPageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.main', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main', {
                url: '/main',
                templateUrl: 'app/pages/main/main.html',
                redirectTo: 'main.dashboard',
                authenticate: true
            });
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.notification', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.notification', {
                url: '/notification',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Notificaciones',
                sidebarMeta: {
                    icon: 'fa fa-bell',
                    order: 401
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.notification.user', {
                url: '/user',
                title: 'Asignación por Admin',
                templateUrl: 'app/pages/notification/user_list.html',
                controller: 'NotificationPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.project', [
        'ProjectDirectory.pages.project.updates'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.project', {
                url: '/project',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Proyectos',
                sidebarMeta: {
                    icon: 'fa fa-pagelines',
                    order: 200
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.project.create', {
                url: '/create',
                title: 'Nuevo Proyecto',
                templateUrl: 'app/pages/project/createOrUpdate.html',
                controller: 'ProjectPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.project.edit', {
                url: '/:id/edit',
                title: 'Edición de Proyecto',
                templateUrl: 'app/pages/project/createOrUpdate.html',
                controller: 'ProjectPageCtrl'
            })
            .state('main.project.list', {
                url: '',
                title: 'Listar Proyectos',
                templateUrl: 'app/pages/project/list.html',
                controller: 'ProjectPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.project.configuration', {
                url: '/configuration',
                title: 'Campos de Proyectos',
                templateUrl: 'app/pages/project/configuration.html',
                controller: 'ProjectConfigPageCtrl',
                sidebarMeta: {
                    order: 3
                }
            })
            .state('main.project.export', {
                url: '/export',
                title: 'Exportar',
                templateUrl: 'app/pages/project/export.html',
                controller: 'ProjectPageCtrl',
                sidebarMeta: {
                    order: 4
                }
            });

    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources', [
        'ProjectDirectory.pages.resources.objective',
        'ProjectDirectory.pages.resources.sector',
        'ProjectDirectory.pages.resources.region',
        'ProjectDirectory.pages.resources.category',
        'ProjectDirectory.pages.resources.alliance',
        'ProjectDirectory.pages.resources.beneficiary',
        'ProjectDirectory.pages.resources.province',
        'ProjectDirectory.pages.resources.information_base',
        'ProjectDirectory.pages.resources.activity',
        'ProjectDirectory.pages.resources.diffusion',
        'ProjectDirectory.pages.resources.financing',
        'ProjectDirectory.pages.resources.district',
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.res', {
                url: '/res',
                abstract: true,
                template: '<div ui-view autoscroll="true" autoscroll-body-top></div>',
                title: 'Recursos',
                sidebarMeta: {
                    icon: 'fa fa-bookmark',
                    order: 201,
                    root: true
                },
                data: {
                    roles: ['admin']
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.security', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('signin', {
                url: '/signin',
                templateUrl: 'app/pages/security/signin.html',
                controller: 'SecurityPageCtrl'
            })
            .state('request_reset_password', {
                url: '/req-reset-password',
                templateUrl: 'app/pages/security/request-reset-password.html',
                controller: 'SecurityPageCtrl'
            })
            .state('reset_password', {
                url: '/reset-password/:access_token',
                templateUrl: 'app/pages/security/reset-password.html',
                controller: 'SecurityPageCtrl'
            })
            .state('main.profile', {
                url: '/profile',
                title: 'Mi perfil',
                templateUrl: 'app/pages/security/profile.html',
                controller: 'SecurityPageCtrl'
            })
            .state('main.change_password', {
                url: '/change-password',
                title: 'Cambiar clave',
                templateUrl: 'app/pages/security/change-password.html',
                controller: 'SecurityPageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.static', [
        'ngSanitize',
        'textAngular',
        'ngFileUpload',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $provide) {
        $stateProvider
            .state('main.static', {
                url: '/pages',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Páginas',
                sidebarMeta: {
                    icon: 'fa fa-code',
                    order: 300
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.static.about-us', {
                url: '/about-us',
                title: 'Quiénes somos',
                templateUrl: 'app/pages/static/about_us.html',
                controller: 'StaticPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.static.contact', {
                url: '/contact',
                title: 'Contacto',
                templateUrl: 'app/pages/static/contact.html',
                controller: 'StaticPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.static.objectives', {
                url: '/ods',
                title: 'Objetivos',
                templateUrl: 'app/pages/static/ods.html',
                controller: 'StaticPageCtrl',
                sidebarMeta: {
                    order: 3
                }
            })
            .state('main.static.terms', {
                url: '/terms',
                title: 'Términos y Condiciones',
                templateUrl: 'app/pages/static/terms.html',
                controller: 'StaticPageCtrl',
                sidebarMeta: {
                    order: 4
                }
            });

        $provide.decorator('taOptions', ['taRegisterTool', '$delegate', '$uibModal', function (taRegisterTool, taOptions, $uibModal) {
            // taOptions.toolbar = [
            //     ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
            //     ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            //     ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
            //     ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
            // ];

            /** custom upload image */
            taRegisterTool('uploadImage', {
                buttontext: 'Insertar imagen',
                tooltiptext: 'Insertar imagen',
                iconclass: "fa fa-image",
                action: function (deferred, restoreSelection) {

                    var textAngular = this;

                    $uibModal.open({
                        animation: true,
                        templateUrl: 'app/resources/components/taUploadImage/taFilesModal.html',
                        size: 'md',
                        controller: 'UploadImageCtrl'

                    }).result.then(function (result) {
                            restoreSelection();

                            // textAngular.$editor().wrapSelection('insertImage', result);

                            var embed = '<img src="' + result + '" style="float:left;" class="text-editor-m-10">';
                            textAngular.$editor().wrapSelection('insertHTML', embed, true);

                            deferred.resolve();
                        },
                        function () {
                            deferred.resolve();
                        }
                    );
                    return false;
                }
            });

            taOptions.toolbar.push(['uploadImage']);
            /** /custom upload image */

            var display = "<button type='button' class=\"btn btn-default font-size-dropdown\" uib-dropdown uib-dropdown-toggle ng-disabled='showHtml()'>" +
                "      <i class='fa fa-text-height'></i><i class='fa fa-caret-down'></i>" +
                "      <ul class=\"\" uib-dropdown-menu>" +
                "        <li ng-repeat='o in options'>" +
                "           <div class=\"btn btn-xs btn-block\" style='font-size: {{o.css}};' ng-click='action($event, o.value)'><i ng-if='o.active' class='fa fa-check'></i> {{o.name}}</button>" +
                "        </li>" +
                "      </ul>" +
                "    </button>";

            taRegisterTool('fontSize', {
                display: display,
                action: function (event, size) {
                    //Ask if event is really an event.
                    if (!!event.stopPropagation) {
                        //With this, you stop the event of textAngular.
                        event.stopPropagation();
                        //Then click in the body to close the dropdown.
                        $("body").trigger("click");
                    }
                    return this.$editor().wrapSelection('fontSize', parseInt(size));
                },
                options: [
                    {name: 'xx-small', css: 'xx-small', value: 1},
                    {name: 'x-small', css: 'x-small', value: 2},
                    {name: 'small', css: 'small', value: 3},
                    {name: 'medium', css: 'medium', value: 4},
                    {name: 'large', css: 'large', value: 5},
                    {name: 'x-large', css: 'x-large', value: 6},
                    {name: 'xx-large', css: 'xx-large', value: 7}
                ]
            });

            taOptions.toolbar[1].push('fontSize');

            // remove fontSize actions included tag type header (h1, h2, ... h6)
            for (var i = 1; i <= 6; i++) {
                var index = taOptions.toolbar[0].indexOf('h' + i);
                if (index > -1) {
                    taOptions.toolbar[0].splice(index, 1);
                }
            }
            var indexFontSize = taOptions.toolbar[1].indexOf('fontSize');
            if (indexFontSize > -1) {
                taOptions.toolbar[1].splice(indexFontSize, 1);
            }

            return taOptions;
        }]);

    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.subscription', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.subscription', {
                url: '/subscription',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Suscripciones',
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 600
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.subscription.list', {
                url: '',
                title: 'Listado Suscripciones',
                templateUrl: 'app/pages/subscription/list.html',
                controller: 'SubscriptionPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.subscription.create', {
                url: '/create',
                title: 'Nueva Suscripción',
                templateUrl: 'app/pages/subscription/create.html',
                controller: 'SubscriptionPageCtrl',
                sidebarMeta: {
                    order: 1
                },
            })
            .state('main.subscription.edit', {
                url: '/:id/edit',
                title: 'Edición de Suscripción',
                templateUrl: 'app/pages/subscription/edit.html',
                controller: 'SubscriptionPageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.user', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user', {
                url: '/user',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Administradores',
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 700
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.user.list', {
                url: '',
                title: 'Listado Usuarios',
                templateUrl: 'app/pages/user/list.html',
                controller: 'UserPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.user.create', {
                url: '/create',
                title: 'Nuevo Usuario',
                templateUrl: 'app/pages/user/create.html',
                controller: 'UserPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.user.edit', {
                url: '/:id/edit',
                title: 'Edición de Usuario',
                templateUrl: 'app/pages/user/edit.html',
                controller: 'UserPageCtrl'
            });
    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated.company', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.associated.company', {
                url: '/:id/company',
                templateUrl: 'app/pages/associated/company/associated_company.html',
                controller: 'AssociatedCompanyPageCtrl',
                title: 'Empresa del Asociado'
            });
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.project.updates', [
        'ngAnimate',
        'ngSanitize',
        'ui.bootstrap',
        'textAngular',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.project.updates', {
                url: '/updates',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Actualización',
                sidebarMeta: {
                    icon: 'fa fa-tag',
                    order: 103
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.project.updates.list', {
                url: '',
                title: 'Actualización',
                templateUrl: 'app/pages/project/updates/list.html',
                controller: 'ProjectUpdatesPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.project.updates.create', {
                url: '/create',
                title: 'Nueva Actualización',
                templateUrl: 'app/pages/project/updates/create.html',
                controller: 'ProjectUpdatesPageCtrl',
            })
            .state('main.project.updates.edit', {
                url: '/:id/edit',
                title: 'Edición de Actualización',
                templateUrl: 'app/pages/project/updates/edit.html',
                controller: 'ProjectUpdatesPageCtrl'
            });
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.alliance', [
        'ngSanitize'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.res.alliance', {
                url: '/alliance',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Alianzas',
                sidebarMeta: {
                    order: 107
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.res.alliance.list', {
                url: '',
                title: 'Listado Alianzas',
                templateUrl: 'app/pages/resources/alliance/list.html',
                controller: 'AlliancePageCtrl'
            })
            .state('main.res.alliance.create', {
                url: '/create',
                title: 'Nueva Alianza',
                templateUrl: 'app/pages/resources/alliance/create.html',
                controller: 'AlliancePageCtrl',
            })
            .state('main.res.alliance.edit', {
                url: '/:id/edit',
                title: 'Edición de Alianza',
                templateUrl: 'app/pages/resources/alliance/edit.html',
                controller: 'AlliancePageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.activity', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.res.activity', {
                url: '/activity',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Actividades',
                sidebarMeta: {
                    icon: 'fa fa-tag',
                    order: 103
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.res.activity.list', {
                url: '',
                title: 'Listado Actividades',
                templateUrl: 'app/pages/resources/activity/list.html',
                controller: 'ActivityPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.res.activity.create', {
                url: '/create',
                title: 'Nueva Actividad',
                templateUrl: 'app/pages/resources/activity/create.html',
                controller: 'ActivityPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.res.activity.edit', {
                url: '/:id/edit',
                title: 'Edición de Actividad',
                templateUrl: 'app/pages/resources/activity/edit.html',
                controller: 'ActivityPageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.beneficiary', [
        'ngSanitize'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.res.beneficiary', {
                url: '/beneficiary',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Beneficiarios',
                sidebarMeta: {
                    order: 109
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.res.beneficiary.list', {
                url: '',
                title: 'Listado Beneficiarios',
                templateUrl: 'app/pages/resources/beneficiary/list.html',
                controller: 'BeneficiaryPageCtrl'
            })
            .state('main.res.beneficiary.create', {
                url: '/create',
                title: 'Nuevo Beneficiario',
                templateUrl: 'app/pages/resources/beneficiary/create.html',
                controller: 'BeneficiaryPageCtrl',
            })
            .state('main.res.beneficiary.edit', {
                url: '/:id/edit',
                title: 'Edición de Beneficiario',
                templateUrl: 'app/pages/resources/beneficiary/edit.html',
                controller: 'BeneficiaryPageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.category', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.res.category', {
                url: '/category',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Categorías',
                sidebarMeta: {
                    icon: 'fa fa-pagelines',
                    order: 105
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.res.category.list', {
                url: '',
                title: 'Listado Categorías',
                templateUrl: 'app/pages/resources/category/list.html',
                controller: 'CategoryPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.res.category.create', {
                url: '/create',
                title: 'Nueva Categoría',
                templateUrl: 'app/pages/resources/category/create.html',
                controller: 'CategoryPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.res.category.edit', {
                url: '/:id/edit',
                title: 'Edición de Categoría',
                templateUrl: 'app/pages/resources/category/edit.html',
                controller: 'CategoryPageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.diffusion', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.res.diffusion', {
                url: '/diffusion',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Difusión',
                sidebarMeta: {
                    icon: 'fa fa-tag',
                    order: 110
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.res.diffusion.list', {
                url: '',
                title: 'Listado Difusión',
                templateUrl: 'app/pages/resources/diffusion/list.html',
                controller: 'DiffusionPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.res.diffusion.create', {
                url: '/create',
                title: 'Nueva Difusión',
                templateUrl: 'app/pages/resources/diffusion/create.html',
                controller: 'DiffusionPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.res.diffusion.edit', {
                url: '/:id/edit',
                title: 'Edición de Difusión',
                templateUrl: 'app/pages/resources/diffusion/edit.html',
                controller: 'DiffusionPageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.district', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.res.district', {
                url: '/district',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Distritos',
                sidebarMeta: {
                    icon: 'fa fa-globe',
                    order: 102
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.res.district.list', {
                url: '',
                title: 'Listado Distritos',
                templateUrl: 'app/pages/resources/district/list.html',
                controller: 'DistrictPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.res.district.create', {
                url: '/create',
                title: 'Nuevo Distrito',
                templateUrl: 'app/pages/resources/district/create.html',
                controller: 'DistrictPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.res.district.edit', {
                url: '/:id/edit',
                title: 'Edición de Distrito',
                templateUrl: 'app/pages/resources/district/edit.html',
                controller: 'DistrictPageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.financing', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.res.financing', {
                url: '/financing',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Financiamiento',
                sidebarMeta: {
                    icon: 'fa fa-tag',
                    order: 108
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.res.financing.list', {
                url: '',
                title: 'Listado Financiamiento',
                templateUrl: 'app/pages/resources/financing/list.html',
                controller: 'FinancingPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.res.financing.create', {
                url: '/create',
                title: 'Nuevo Financiamiento',
                templateUrl: 'app/pages/resources/financing/create.html',
                controller: 'FinancingPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.res.financing.edit', {
                url: '/:id/edit',
                title: 'Edición de Financiamiento',
                templateUrl: 'app/pages/resources/financing/edit.html',
                controller: 'FinancingPageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.information_base', [
        'ngSanitize'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.res.information_base', {
                url: '/information-base',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Base de Información',
                sidebarMeta: {
                    order: 104
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.res.information_base.list', {
                url: '',
                title: 'Listado Bases',
                templateUrl: 'app/pages/resources/information_base/list.html',
                controller: 'InformationBasePageCtrl'
            })
            .state('main.res.information_base.create', {
                url: '/create',
                title: 'Nueva Base',
                templateUrl: 'app/pages/resources/information_base/create.html',
                controller: 'InformationBasePageCtrl',
            })
            .state('main.res.information_base.edit', {
                url: '/:id/edit',
                title: 'Edición de Base',
                templateUrl: 'app/pages/resources/information_base/edit.html',
                controller: 'InformationBasePageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.objective', [
        'ngSanitize'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.res.objective', {
                url: '/objective',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'ODS',
                sidebarMeta: {
                    order: 106
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.res.objective.list', {
                url: '',
                title: 'Listado Objetivos',
                templateUrl: 'app/pages/resources/objective/list.html',
                controller: 'ObjectivePageCtrl'
            })
            .state('main.res.objective.create', {
                url: '/create',
                title: 'Nuevo Objetivo',
                templateUrl: 'app/pages/resources/objective/create.html',
                controller: 'ObjectivePageCtrl',
            })
            .state('main.res.objective.edit', {
                url: '/:id/edit',
                title: 'Edición de Objetivo',
                templateUrl: 'app/pages/resources/objective/edit.html',
                controller: 'ObjectivePageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.province', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.res.province', {
                url: '/province',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Provincias',
                sidebarMeta: {
                    icon: 'fa fa-globe',
                    order: 101
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.res.province.list', {
                url: '',
                title: 'Listado Provincias',
                templateUrl: 'app/pages/resources/province/list.html',
                controller: 'ProvincePageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.res.province.create', {
                url: '/create',
                title: 'Nueva Provincia',
                templateUrl: 'app/pages/resources/province/create.html',
                controller: 'ProvincePageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.res.province.edit', {
                url: '/:id/edit',
                title: 'Edición de Provincia',
                templateUrl: 'app/pages/resources/province/edit.html',
                controller: 'ProvincePageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.region', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.res.region', {
                url: '/region',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Regiones',
                sidebarMeta: {
                    icon: 'fa fa-globe',
                    order: 100
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.res.region.list', {
                url: '',
                title: 'Listado Regiones',
                templateUrl: 'app/pages/resources/region/list.html',
                controller: 'RegionPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.res.region.create', {
                url: '/create',
                title: 'Nueva Región',
                templateUrl: 'app/pages/resources/region/create.html',
                controller: 'RegionPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.res.region.edit', {
                url: '/:id/edit',
                title: 'Edición de Región',
                templateUrl: 'app/pages/resources/region/edit.html',
                controller: 'RegionPageCtrl'
            });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.sector', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.res.sector', {
                url: '/sector',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: 'Sectores',
                sidebarMeta: {
                    icon: 'fa fa-tag',
                    order: 111
                },
                data: {
                    roles: ['admin']
                }
            })
            .state('main.res.sector.list', {
                url: '',
                title: 'Listado Sectores',
                templateUrl: 'app/pages/resources/sector/list.html',
                controller: 'SectorPageCtrl',
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.res.sector.create', {
                url: '/create',
                title: 'Nuevo Sector',
                templateUrl: 'app/pages/resources/sector/create.html',
                controller: 'SectorPageCtrl',
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.res.sector.edit', {
                url: '/:id/edit',
                title: 'Edición de Sector',
                templateUrl: 'app/pages/resources/sector/edit.html',
                controller: 'SectorPageCtrl'
            });
    }

})();

'use strict';

angular.module('BlurAdmin', [
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'angular-progress-button-styles',
    'uiGmapgoogle-maps',
    'ta-maxlength',

    'ngResource',
    'lbServices',
    'angularValidator',
    'datatables',
    'ngclipboard',
    'ngTagsInput',
    'daterangepicker',
    'btorfs.multiselect',
    'ls.LiveSet',
    'ls.ChangeStream',

    'BlurAdmin.theme',
    'ProjectDirectory.resources',
    'ProjectDirectory.pages',
]);
(function () {
    'use strict';

    var basic = {
        default: '#ffffff',
        defaultText: '#666666',
        border: '#dddddd',
        borderDark: '#aaaaaa',
    };

    var colorScheme = {
        primary: '#006440',
        info: '#2dacd1',
        success: '#90b900',
        warning: '#dfb81c',
        danger: '#e85656',
    };

    var dashboardColors = {
        blueStone: '#005562',
        surfieGreen: '#0e8174',
        silverTree: '#6eba8c',
        gossip: '#b9f2a1',
        white: '#10c4b5',
    };

    angular.module('ProjectDirectory.resources')
        .provider('pdConfig', configProvider);

    /** @ngInject */
    function configProvider() {
        var conf = {
            apiUrlBase: 'https://api.com-unidad.pe/api/v1',
            apiWsBase: 'https://api.com-unidad.pe',
            gaViewId: '203370737',
            geocodeApiKey: 'AIzaSyDhpcbnnt8wGh-HQecUWoWzX9t1Nj6IV5g',
            gmapsApiKey: 'AIzaSyDhpcbnnt8wGh-HQecUWoWzX9t1Nj6IV5g',

            colors: {
                default: basic.default,
                defaultText: basic.defaultText,
                border: basic.border,
                borderDark: basic.borderDark,

                primary: colorScheme.primary,
                info: colorScheme.info,
                success: colorScheme.success,
                warning: colorScheme.warning,
                danger: colorScheme.danger,

                dashboard: {
                    blueStone: dashboardColors.blueStone,
                    surfieGreen: dashboardColors.surfieGreen,
                    silverTree: dashboardColors.silverTree,
                    gossip: dashboardColors.gossip,
                    white: dashboardColors.white,
                },
            }
        };

        conf.$get = function () {
            delete conf.$get;
            return conf;
        };
        return conf;
    }
})();

(function () {
    'use strict';

    var IMAGES_ROOT = 'assets/img/';

    angular.module('ProjectDirectory.resources')
        .constant('paginateHelper', {
            pageSizeOptions: [25, 50, 75, 100],
            pageSize: 25
        })
        .constant('assetPaths', {
            images: {
                root: IMAGES_ROOT,
                noImageUrl: IMAGES_ROOT + 'no-photo.png',
                unknowUserImageUrl: IMAGES_ROOT + 'unknow-user.png',
                addFileUrl: IMAGES_ROOT + 'add-file.png',
                imageFileUrl: IMAGES_ROOT + 'image-file.png',
                pdfFileUrl: IMAGES_ROOT + 'pdf-file.png',
            },
            symbols: {
                M: IMAGES_ROOT + 'app/symbols/M.png',
                H: IMAGES_ROOT + 'app/symbols/H.png',
                E: IMAGES_ROOT + 'app/symbols/E.png',
                S: IMAGES_ROOT + 'app/symbols/S.png'
            }
        })
        .constant('errorCodes', {
            AVOID_SELF_DELETION: "AVOID_SELF_DELETION",
            AVOID_OWNER_DELETION: "AVOID_OWNER_DELETION",
            MODEL_NOT_FOUND: "MODEL_NOT_FOUND",
            INVALID_TOKEN: "INVALID_TOKEN",
            EMPTY_SUBSCRIPTION_ADDRESSES: "EMPTY_SUBSCRIPTION_ADDRESSES",
            INVALID_PROJECT: "INVALID_PROJECT",
        })
        .constant('messagesHelper', {
            success_operation: 'Operación realizada correctamente.',
            fail_operation: 'No se pudo realizar la operación.',
            resource_does_not_exists: 'El recurso solicitado no existe.',
            confirm_operation: '¿Confirma que desea realizar la operación?',
            not_selected_elements: 'No existen elementos seleccionados.',
            bad_credentials: 'Usuario o contraseña incorrectos.',
            unverified_account: 'Cuenta no verificada.',
            email_already_exists: 'El email ya está en uso.',
            not_allowed_self_deletion: 'Un usuario no puede eliminarse a si mismo.',
            sended_recovery_email: 'Email de recuperación enviado correctamente.',
            invalid_token: 'El token no es válido.',
            empty_subscription_addresses: 'No existen direcciones de correo confirmadas en el listado de suscriptores.',
            complete_the_field: 'Complete el campo.',
            complete_all_fields: 'Complete todos los campos.',
            complete_all_location_fields: 'Complete todos los campos del lugar.',
            invalid_coordinates: 'El valor de las coordenadas es incorrecto.',
            success_upload: 'Archivo subido correctamente.',
            invalid_project: 'El formulario de proyecto contiene algún error. Verifique los campos y envíelo nuevamente.',
            username_already_exists: 'El usuario ya está en uso.',
        })
        .constant('projectStatus', {
            DRAFT: 'draft',
            PENDING: 'pending',
            PUBLISHED: 'published'
        })
        .constant('projectStatusName', {
            draft: 'Editable',
            pending: 'Por Revisar',
            published: 'Publicado'
        })
        .constant('updateStatus', {
            PENDING: 'pending',
            PUBLISHED: 'published'
        })
        .constant('subscriptionStatus', {
            CONFIRMED: 'confirmed',
            PENDING: 'pending'
        })
        .constant('projectFieldVisibility', {
            PUBLIC: "public",
            PRIVATE: "private",
            HIDDEN: "hidden"
        })
        .constant('projectFieldValidation', {
            REQUIRED: "required",
            UNREQUIRED: "unrequired"
        })
        .constant('bannerStatus', {
            "ENABLED": "enabled",
            "DISABLED": "disabled"
        })
        .constant('bannerImageType', {
            "WEB": "web",
            "MOBILE": "mobile"
        })
        .constant('sectorImageType', {
            "MARKER": "marker",
            "LOGO": "logo"
        })
        .constant('entityType', {
            "REMOTE": "remote",
            "LOCAL": "local"
        })
        .constant('nomenclator', {
            subscriptionStatus: [{
                id: 'pending',
                name: 'Pendiente de confirmación',
                desc: '(Debe confirmar el email)'
            }, {
                id: 'confirmed',
                name: 'Confirmado',
                desc: '(Puede recibir boletines)'
            }],
            socialNetworks: [{
                id: 'facebook',
                name: 'Facebook'
            }, {
                id: 'twitter',
                name: 'Twitter'
            }, {
                id: 'linkedin',
                name: 'Linkedin'
            }],
            appPlatforms: [{
                id: 'android',
                name: 'Android'
            }, {
                id: 'apple',
                name: 'IOS'
            }],
            projectFieldVisibility: [{
                id: 'public',
                name: 'Público',
                desc: 'Visible para todos los entornos y usuarios. (Usuarios anónimos, Asociados y Administradores)'
            }, {
                id: 'private',
                name: 'Privado',
                desc: 'Visible solo para los Asociados y Administradores desde la administración y la intranet de asociados.'
            }, {
                id: 'hidden',
                name: 'Oculto',
                desc: 'Oculto para todos los entornos y usuarios.'
            }],
            projectFieldValidation: [{
                id: 'required',
                name: 'Requerido',
                desc: 'El campo es obligatorio.'
            }, {
                id: 'unrequired',
                name: 'No requerido',
                desc: 'El campo es opcional.'
            }],
        })
        .constant('recommendedSizes', {
            mainSlide: {
                desktop: {
                    width: 1140,
                    height: 175
                },
                mobile: {
                    width: 363,
                    height: 175
                }
            },
            publicityBanner: {
                desktop: {
                    width: 165,
                    height: 605
                },
                mobile: {
                    width: 165,
                    height: 165
                },
            },
            projectSlide: {
                width: 437,
                height: 379
            },
            markerIcon: {
                width: 41,
                height: 41,
                type: 'png'
            },
            sectorIcon: {
                width: 57,
                height: 59,
                type: 'png'
            },
            articleImage: {
                width: 437,
                height: 379
            },
        })
        .constant('markerColors', {
            M: "#FAB61D",
            H: "#FAB61D",
            E: "#007FFF",
            S: "#FF0000"
        });
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .run(themeRun);

    /** @ngInject */
    function themeRun($rootScope, UserEntity, $state, $stateParams, $location, LoopBackAuth) {

        $rootScope.userLogged = null;
        if (UserEntity.isAuthenticated()) {
            UserEntity.getCurrent(function (user) {
                $rootScope.userLogged = user;
            }, function (errorResponse) {

            });
        }


        $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState, fromStateParams) {

            if (toState.redirectTo) {
                event.preventDefault();
                $state.go(toState.redirectTo, toStateParams, {location: 'replace'});
            }

            if (toState.data && toState.data.roles) {
                if (toState.data.roles.indexOf('*') !== -1) {

                } else {
                    if (UserEntity.isAuthenticated()) {

                        var isInAnyRole = function (stateRoles, userRoles) {
                            for (var i = 0; i < stateRoles.length; i++) {
                                if (userRoles.indexOf(stateRoles[i]) != -1) {
                                    return true;
                                }
                            }
                            return false;
                        };

                        if ($rootScope.userLogged && !isInAnyRole(toState.data.roles, $rootScope.userLogged.roles)) {
                            // alert('no tiene permisos');
                            event.preventDefault();
                            $state.go('signin');
                        }

                    } else {
                        event.preventDefault();
                        $state.go('signin');
                    }
                }
            }
        });
    }

})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .run(themeRun);

    /** @ngInject */
    function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings, Configuration, projectFieldUtils, pdConfig, PubSub) {
        var whatToWait = [
            preloader.loadAmCharts(),
            $timeout(3000)
        ];

        var theme = themeLayoutSettings;
        if (theme.blur) {
            if (theme.mobile) {
                whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
            } else {
                whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
                whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
            }
        }

        $rootScope.$projectFieldUtils = projectFieldUtils;
        $rootScope.currentConfig = null;
        whatToWait.unshift(Configuration.findOne(function (configuration, httpHeader) {
            PubSub.subscribe({
                collectionName: 'Configuration',
                method: 'PUT',
                modelId: configuration.id
            }, onConfigurationUpdate);
        }).$promise);

        var onConfigurationUpdate = function (data) {
            console.log("Configuration updated ==>", data);
            if (data) {
                $rootScope.$apply(function () {
                    $rootScope.currentConfig = data;
                });
            }
        };

        $q.all(whatToWait).then(function (results) {
            if (results && Array.isArray(results)) {
                $rootScope.currentConfig = results[0];
            } else if (results) {
                $rootScope.currentConfig = results;
            }
            $rootScope.$pageFinishedLoading = true;
        });

        $timeout(function () {
            if (!$rootScope.$pageFinishedLoading) {
                $rootScope.$pageFinishedLoading = true;
            }
        }, 7000);

        // var urlToChangeStream = pdConfig.apiUrlBase + '/Configuration/change-stream?_format=event-stream';
        // var src = new EventSource(urlToChangeStream);
        // src.addEventListener('data', function (msg) {
        //     var data = JSON.parse(msg.data);
        //     console.log("Current config.", data);
        //     if (data.data) {
        //         $rootScope.$apply(function () {
        //             $rootScope.currentConfig = data.data;
        //         });
        //     }
        // });

        $rootScope.$baSidebarService = baSidebarService;
    }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.article')
        .controller('ArticleConfigPageCtrl', ArticleConfigPageCtrl);

    /** @ngInject */
    function ArticleConfigPageCtrl($scope, $rootScope, $state, $stateParams, UserEntity, toastr, $q, confirmModal, Configuration, nomenclator, messagesHelper, validationUtils) {

        $scope.configuration = {};
        $scope.configurationArticle = $rootScope.currentConfig && $rootScope.currentConfig.article ? $rootScope.currentConfig.article : {};

        /** find */
        $scope.loadConfiguration = function () {
            Configuration.findOne({}, function (response) {
                $scope.configuration = response;
                $rootScope.currentConfig = response;
                $scope.configurationArticle = response.article || {};
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** update article settings */
        $scope.updateArticleSettings = function (isValid) {
            if (isValid) {
                var configurationPatch = {
                    article: $scope.configurationArticle
                };
                Configuration.prototype$patchAttributes({id: $scope.configuration.id}, configurationPatch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $rootScope.currentConfig = response;
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.article')
        .controller('ArticlePageCtrl', ArticlePageCtrl);

    /** @ngInject */
    function ArticlePageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, confirmModal, paginateHelper, messagesHelper, validationUtils, ScreenLoader, LoopBackResource, LoopBackAuth, entityType, Sector, Article, Company) {

        $scope.article = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.sectors = [];
        $scope.companies = [];

        $scope.avatarErrors = [];
        $scope.imagesErrors = [];

        $scope.charLimits = {
            title: 70,
            summary: 250,
            tag: 50,
            location: 100,
        };

        /** used for article gallery management */
        $scope.galleryItem = {};

        $scope.optionsDatepickerRow = {
            singleDatePicker: true,
            showDropdowns: true,
            // timePicker: true,
            applyClass: 'btn-primary',
            cancelClass: 'btn',

            pickerClasses: 'custom-display', //angular-daterangepicker extra
            buttonClasses: 'btn',
            applyButtonClasses: 'btn-primary',
            cancelButtonClasses: 'btn-danger',

            locale: {
                applyLabel: "Aplicar",
                cancelLabel: 'Cancelar',
                format: 'DD/MM/YYYY'
            },
            eventHandlers: {
                'apply.daterangepicker': function (ev, picker) {
                    if (ev.model.isValid()) {
                        var articleId = ev.$parent.row.id;
                        var publishedDate = ev.model.toDate();
                        ScreenLoader.show();
                        Article.changePublishedDate({id: articleId, publishedDate: publishedDate}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            ScreenLoader.hide();
                        }, function (errorResponse) {
                            ScreenLoader.hide();
                            validationUtils.processErrorResponse(errorResponse);
                        });
                    }
                }
            },
        };
        $scope.rowsDatePickers = {};

        $scope.optionsFormDatepicker = {
            singleDatePicker: true,
            showDropdowns: true,
            // timePicker: true,
            applyClass: 'btn-primary',
            cancelClass: 'btn',

            pickerClasses: 'custom-display', //angular-daterangepicker extra
            buttonClasses: 'btn',
            applyButtonClasses: 'btn-primary',
            cancelButtonClasses: 'btn-danger',

            locale: {
                applyLabel: "Aplicar",
                cancelLabel: 'Cancelar',
                format: 'DD/MM/YYYY'
            },
        };

        $scope.taToolbar = [
            [/*'h1', 'h2', 'h3', 'h4', 'h5', 'h6',*/ 'p', 'pre', 'quote', 'fontSize'],
            ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
            ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount'],
            ['uploadArticleImage'],
        ];

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        if (property === 'idSector' || property === 'idCompany') {
                            var parts = predicateObject[property].split(':');
                            where[property] = parts.length > 1 ? parseInt(parts[1]) : null;
                        } else {
                            where[property] = {like: '%' + predicateObject[property] + '%'}
                        }
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order,
                include: ["sector", "company"],
            };

            $timeout(function () {
                $q.all([
                    Article.count({where: $scope.query.filter.where}).$promise,
                    Article.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    var pickers = {};
                    results[1].forEach(function (item) {
                        var date = moment(item.publishedAt);
                        pickers[item.id] = {
                            date: date.isValid() ? date : '',
                        }
                    });
                    $scope.rowsDatePickers = pickers;

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadArticle = function () {
            $scope.article = {};
            Article.findById({
                id: $stateParams.id,
                filter: {include: ["avatar", "images"]},
            }, function (response) {
                $scope.article = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            var avatarErrors = $scope.validateArticleImage();
            $scope.avatarErrors = avatarErrors;

            if (isValid && !avatarErrors.length) {
                Article.create($scope.article,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.article.list');
                    }, function (errorResponse) {
                        toastr.clear();
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            var avatarErrors = $scope.validateArticleImage();
            $scope.avatarErrors = avatarErrors;

            if (isValid && !avatarErrors.length) {
                var articlePatch = {
                    title: $scope.article.title,
                    idSector: $scope.article.idSector,
                    idCompany: $scope.article.idCompany,
                    idAvatar: $scope.article.idAvatar,
                    tag: $scope.article.tag,
                    location: $scope.article.location,
                    summary: $scope.article.summary,
                    content: $scope.article.content,
                    publishedAt: $scope.article.publishedAt,
                    publicUpdatedAt: $scope.article.publicUpdatedAt,
                    images: $scope.article.images,
                    links: $scope.article.links,
                };
                Article.prototype$patchAttributes({id: $scope.article.id}, articlePatch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.article.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Article.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** load filter resources */
        $scope.loadFilterResources = function () {
            $q.all([
                Sector.find().$promise,
                Company.find().$promise,
            ]).then(function (results) {
                $scope.sectors = results[0];
                $scope.companies = results[1];
            }, function (error) {
            });
        };

        /** get sector name */
        $scope.getSectorName = function (sector) {
            return sector ? sector.name : '';
        };

        /** get company name */
        $scope.getCompanyName = function (company) {
            return company ? company.publicName : '';
        };

        /** image error */
        $scope.validateArticleImage = function () {
            var errors = [];
            if (!$scope.article.idAvatar) {
                errors.push("La imagen del artículo es requerida.");
            }
            return errors;
        };

        /** image error watch */
        $scope.$watch('article.idAvatar', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                $scope.avatarErrors = $scope.validateArticleImage();
            }
        }, true);

        /** article gallery management */
        $scope.$watch('galleryItem.file', function (newValue, oldValue) {
            if (newValue !== oldValue && newValue) {
                if (!$scope.article.images || !Array.isArray($scope.article.images)) {
                    $scope.article.images = [];
                }
                $scope.article.images.push(angular.copy(newValue));
                $scope.galleryItem = {};
            }
        }, true);

        /** remove gallery image */
        $scope.removeGalleryImage = function (index) {
            if ($scope.article.images && Array.isArray($scope.article.images)) {
                $scope.article.images.splice(index, 1);
            }
        };

        /** init */
        $scope.init = function (action) {
            if (action === 'list') {
                $scope.loadFilterResources();
            }
            if (action === 'create') {
                $scope.loadFilterResources();
            }
            if (action === 'edit') {
                $scope.loadArticle();
                $scope.loadFilterResources();
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated')
        .controller('AssociatedPageCtrl', AssociatedPageCtrl);

    /** @ngInject */
    function AssociatedPageCtrl($scope, $state, $stateParams, UserAssociated, toastr, $timeout, $q, confirmModal, paginateHelper, messagesHelper, validationUtils, ScreenLoader, LoopBackResource, LoopBackAuth, entityType, Sector) {

        $scope.associated = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        /** filter resources */
        $scope.filters = {
            username: "",
            companyName: ""
        };
        $scope.sectors = [];

        $scope.total = 0;
        $scope.filteredTotal = 0;

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            $scope.filters.offset = start;
            $scope.filters.limit = number;

            ScreenLoader.show();
            $timeout(function () {
                $q.all([
                    UserAssociated.advancedCount($scope.filters).$promise,
                    UserAssociated.advancedSearch($scope.filters).$promise,
                    UserAssociated.count().$promise
                ]).then(function (results) {

                    ScreenLoader.hide();
                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                    /** total without filters */
                    $scope.total = results[2].count;
                    /** total filtered */
                    $scope.filteredTotal = results[0].count;

                }, function (error) {
                    ScreenLoader.hide();
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadAssociated = function () {
            $scope.associated = {};
            UserAssociated.findById({id: $stateParams.id}, function (response) {
                $scope.associated = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                $scope.associated.emailVerified = true;
                $scope.associated.type = entityType.LOCAL;
                UserAssociated.create($scope.associated,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.associated.list');
                    }, function (errorResponse) {

                        toastr.clear();
                        if (validationUtils.hasUniquenessError(errorResponse, "username")) {
                            toastr.error(messagesHelper.username_already_exists);
                            return;
                        }

                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var associatedPatch = {
                    username: $scope.associated.username
                };
                if ($scope.associated.password) {
                    associatedPatch.password = $scope.associated.password;
                }
                UserAssociated.prototype$patchAttributes({id: $scope.associated.id}, associatedPatch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.associated.list');
                    }, function (errorResponse) {
                        if (validationUtils.hasUniquenessError(errorResponse, "username")) {
                            toastr.error(messagesHelper.username_already_exists);
                            return;
                        }
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    UserAssociated.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** generate password */
        $scope.generatePassword = function (id, index) {
            ScreenLoader.show();
            $scope.hidePassword(index);
            UserAssociated.sendNewPassword({id: id}, function (response) {
                    ScreenLoader.hide();
                    toastr.clear();
                    toastr.success(messagesHelper.success_operation);
                }, function (errorResponse) {
                    ScreenLoader.hide();
                    validationUtils.processErrorResponse(errorResponse);
                }
            );
        };

        /** show password */
        $scope.showPassword = function (id, index) {
            ScreenLoader.show();
            UserAssociated.showPassword({id: id}, function (response) {
                    ScreenLoader.hide();
                    $scope.results[index].plainPassword = response.password;
                }, function (errorResponse) {
                    ScreenLoader.hide();
                    validationUtils.processErrorResponse(errorResponse);
                }
            );
        };

        /** hide password */
        $scope.hidePassword = function (index) {
            delete $scope.results[index].plainPassword;
        };

        /** success copy password */
        $scope.onSuccess = function (e) {
            toastr.clear();
            toastr.info('Contraseña copiada al portapapeles.');
        };

        /** fail copy password */
        $scope.onError = function (e) {
            toastr.clear();
            toastr.error('No se pudo copiar la contraseña.');
        };

        /** export file */
        $scope.export = function () {
            window.location.href = LoopBackResource.getUrlBase() + "/user-associated/export-excel?access_token=" + LoopBackAuth.accessTokenId;
        };

        /** load filter resources */
        $scope.loadFilterResources = function () {
            $q.all([
                Sector.find().$promise
            ]).then(function (results) {
                $scope.sectors = results[0];
            }, function (error) {
            });
        };

        /** apply filters */
        $scope.applyFilters = function (unused, filters) {
            $scope.filters = filters;
            $scope.reloadTable();
        };

        /** init */
        $scope.init = function (action) {
            if (action === 'list') {
                $scope.loadFilterResources();
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated')
        .controller('SyncPageCtrl', SyncPageCtrl);

    /** @ngInject */
    function SyncPageCtrl($scope, $state, $stateParams, Synchronization, toastr, $timeout, $q, confirmModal, paginateHelper, messagesHelper, validationUtils, ScreenLoader) {

        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    Synchronization.count({where: $scope.query.filter.where}).$promise,
                    Synchronization.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Synchronization.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** sync users */
        $scope.syncUsers = function () {
            ScreenLoader.show();
            Synchronization.syncUsers(function (response) {
                ScreenLoader.hide();
                toastr.clear();
                toastr.success(messagesHelper.success_operation);
                $scope.reloadTable();
            }, function (errorResponse) {
                ScreenLoader.hide();
                validationUtils.processErrorResponse(errorResponse);
            })
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.banner')
        .controller('BannerPageCtrl', BannerPageCtrl);

    /** @ngInject */
    function BannerPageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, $uibModal, confirmModal, paginateHelper, Banner, Files, Upload, pdConfig, LoopBackAuth, validationUtils, messagesHelper, bannerStatus, bannerImageType, ScreenLoader, recommendedSizes) {

        $scope.banner = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;
        $scope.statusList = [{
            key: bannerStatus.ENABLED,
            name: 'Habilitado'
        }, {
            key: bannerStatus.DISABLED,
            name: 'Deshabilitado'
        }];
        $scope.recommendedSizes = recommendedSizes.publicityBanner;

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order,
                include: ["imageWeb", "imageMobile"],
            };

            $timeout(function () {
                $q.all([
                    Banner.count({where: $scope.query.filter.where}).$promise,
                    Banner.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadBanner = function () {
            $scope.banner = {};
            Banner.findById({id: $stateParams.id, filter: {include: ["imageWeb", "imageMobile"]}}, function (response) {
                $scope.banner = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {

                if (!$scope.banner.idFileWeb || !$scope.banner.idFileMobile) {
                    toastr.error('Debe seleccionar la imagen para vista web y vista móvil.');
                    return;
                }

                Banner.create($scope.banner,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.banner.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {

                if (!$scope.banner.idFileWeb || !$scope.banner.idFileMobile) {
                    toastr.error('Debe seleccionar la imagen para vista web y vista móvil.');
                    return;
                }

                var patch = {
                    name: $scope.banner.name,
                    title: $scope.banner.title,
                    url: $scope.banner.url,
                    status: $scope.banner.status,
                    idFileWeb: $scope.banner.idFileWeb,
                    idFileMobile: $scope.banner.idFileMobile,
                };
                Banner.prototype$patchAttributes({id: $scope.banner.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.banner.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Banner.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** change status */
        $scope.changeStatus = function (id, status) {
            var patch = {
                status: status,
            };
            ScreenLoader.show();
            Banner.prototype$patchAttributes({id: id}, patch,
                function (response) {
                    ScreenLoader.hide();
                    toastr.clear();
                    toastr.success(messagesHelper.success_operation);
                }, function (errorResponse) {
                    ScreenLoader.hide();
                    validationUtils.processErrorResponse(errorResponse);
                }
            );
        };

        /** ************************** */
        /** banner image management */
        /** ************************** */

        $scope.modalInstance = null;

        /** show file dialog */
        $scope.showFileDialog = function (imageType) {
            $scope.imageType = imageType;
            $scope.modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/banner/filesModal.html',
                size: 'md',
                scope: $scope
            });
        };

        /** file list */
        $scope.callLogoFilesServer = function callServer(tableState, tableCtrl) {
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;
            var number = pagination.number || 10;

            var where = {container: 'Banners'};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    Files.count({where: $scope.query.filter.where}).$promise,
                    Files.find({filter: $scope.query.filter}).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** upload file */
        $scope.uploadFile = function (file, errFiles, imageType) {
            $scope.f = file;
            $scope.errFile = errFiles && errFiles[0];
            if (file) {
                file.upload = Upload.upload({
                    url: pdConfig.apiUrlBase + '/files/Banners/upload?access_token=' + LoopBackAuth.accessTokenId,
                    data: {file: file}
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        file.result = response.data;
                        $scope.setBannerImage(response.data[0], imageType);
                    });
                }, function (response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
        };

        /** attach image to banner */
        $scope.setBannerImage = function (file, imageType) {

            if (imageType === bannerImageType.WEB) {

                $scope.banner.idFileWeb = file.id;
                $scope.banner.imageWeb = file;

            } else if (imageType === bannerImageType.MOBILE) {

                $scope.banner.idFileMobile = file.id;
                $scope.banner.imageMobile = file;

            } else {
                console.log("Image type not allowed");
            }

            $scope.f = null;
            $scope.errFile = null;
            $scope.modalInstance.dismiss();
        };

        /** remove image */
        $scope.removeFile = function (imageType) {

            if (imageType === bannerImageType.WEB) {

                $scope.banner.idFileWeb = null;
                $scope.banner.imageWeb = null;

            } else if (imageType === bannerImageType.MOBILE) {

                $scope.banner.idFileMobile = null;
                $scope.banner.imageMobile = null;

            } else {
                console.log("Image type not allowed");
            }

        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.bulletin')
        .controller('BulletinCustomPageCtrl', BulletinCustomPageCtrl);

    /** @ngInject */
    function BulletinCustomPageCtrl($scope, $state, $stateParams, Bulletin, toastr, $timeout, $q, confirmModal, paginateHelper, messagesHelper, validationUtils, nomenclator, Project, subscriptionStatus, LoopBackAuth, LoopBackResource, $sce, $httpParamSerializer, ScreenLoader, Subscription, UserAssociated) {

        $scope.groups = [
            {text: 'Suscriptores'},
            {text: 'Asocidados'}
        ];
        $scope.bulletin = {};

        /** email validation */
        $scope.validateEmail = function (email) {
            return validationUtils.isValidEmail(email);
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                ScreenLoader.show();
                Bulletin.create($scope.bulletin,
                    function (response) {
                        ScreenLoader.hide();
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.bulletin.list');
                    }, function (errorResponse) {
                        ScreenLoader.hide();
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        $scope.loadSusbcribers = function (query) {
            var deferred = $q.defer();
            Subscription.find({
                filter: {
                    where: {status: 'confirmed', email: {like: '%' + query + '%'}},
                    limit: 10
                }
            }, function (response) {
                var subscribers = response.map(function (item) {
                    return item.email;
                });
                deferred.resolve(subscribers);
            }, function (errorResponse) {
                toastr.clear();
                toastr.error('No se pudo realizar la operación.');
                console.log('Error al obtener los suscriptores. ', errorResponse);
                deferred.resolve([]);
            });
            return deferred.promise;
        };

        /** unique array elements */
        function arrayUnique(array) {
            var a = array.concat();
            for (var i = 0; i < a.length; ++i) {
                for (var j = i + 1; j < a.length; ++j) {
                    if (a[i] === a[j])
                        a.splice(j--, 1);
                }
            }
            return a;
        }

        /** load associates */
        $scope.loadAssociates = function () {
            ScreenLoader.show();
            UserAssociated.find({include: 'company'}, function (response) {
                ScreenLoader.hide();
                var address = [];

                response.forEach(function (item) {
                    if (item.company) {
                        if (item.company.email) {
                            address.push(item.company.email);
                        }
                        if (item.company.email2) {
                            address.push(item.company.email2);
                        }
                        if (item.company.email3) {
                            address.push(item.company.email3);
                        }
                        if (item.company.email4) {
                            address.push(item.company.email4);
                        }
                    }
                });

                if (!$scope.bulletin.to) {
                    $scope.bulletin.to = [];
                }
                $scope.bulletin.to = arrayUnique($scope.bulletin.to.concat(address));
            }, function (errorResponse) {
                ScreenLoader.hide();
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** load subscribers */
        $scope.loadSubscribers = function () {
            ScreenLoader.show();
            Subscription.find({}, function (response) {
                ScreenLoader.hide();
                var address = response.map(function (item) {
                    return item.email;
                });
                if (!$scope.bulletin.to) {
                    $scope.bulletin.to = [];
                }
                $scope.bulletin.to = arrayUnique($scope.bulletin.to.concat(address));
            }, function (errorResponse) {
                ScreenLoader.hide();
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** load address */
        $scope.loadGroups = function (query) {
            var deferred = $q.defer();
            var matches = $scope.groups.filter(function (item) {
                return item.text.toLowerCase().indexOf(query.toLowerCase()) !== -1
            });
            console.log(matches);
            deferred.resolve(matches);
            return deferred.promise;
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.bulletin')
        .controller('BulletinPageCtrl', BulletinPageCtrl);

    /** @ngInject */
    function BulletinPageCtrl($scope, $state, $stateParams, Bulletin, toastr, $timeout, $q, confirmModal, paginateHelper, messagesHelper, validationUtils, nomenclator, Project, subscriptionStatus, LoopBackAuth, LoopBackResource, $sce, $httpParamSerializer, ScreenLoader, colorHelper, pdConfig) {

        $scope.bulletin = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.selectedProjects = [];
        $scope.maxItemsInSelect = 30;

        $scope.doughnutData = {};
        $scope.statistics = {};
        $scope.isLoadingStatistics = false;

        var dashboardColors = pdConfig.colors.dashboard;

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** email validation */
        $scope.validateEmail = function (email) {
            return validationUtils.isValidEmail(email);
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    Bulletin.count({where: $scope.query.filter.where}).$promise,
                    Bulletin.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                ScreenLoader.show();
                Bulletin.create($scope.bulletin,
                    function (response) {
                        ScreenLoader.hide();
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.bulletin.list');
                    }, function (errorResponse) {
                        ScreenLoader.hide();
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Bulletin.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** find projects */
        $scope.loadProjects = function (query) {
            var deferred = $q.defer();
            Project.find({
                filter: {
                    where: {
                        nameToPublish: {like: '%' + query + '%'},
                        order: "created_at DESC"
                    },
                    limit: $scope.maxItemsInSelect
                }
            }, function (response) {
                deferred.resolve(response);
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
                deferred.resolve([]);
            });
            return deferred.promise;
        };

        /** change selected projects order */
        $scope.changeProjectOrder = function (event, idx, dir) {
            event.preventDefault();
            event.stopPropagation();

            if (dir === 'up') {
                if (idx === 0) {
                    return;
                }
                var prev = $scope.selectedProjects[idx - 1];
                $scope.selectedProjects[idx - 1] = $scope.selectedProjects[idx];
                $scope.selectedProjects[idx] = prev;
            } else {
                if (idx > $scope.selectedProjects.length - 1) {
                    return;
                }
                var next = $scope.selectedProjects[idx + 1];
                $scope.selectedProjects[idx + 1] = $scope.selectedProjects[idx];
                $scope.selectedProjects[idx] = next;
            }
        };

        /** bulletin preview */
        $scope.loadPreview = function () {
            var ids = $scope.selectedProjects.map(function (project) {
                return project.id
            });
            var params = {
                projects: ids,
                access_token: LoopBackAuth.accessTokenId
            };
            $scope.bulletin.projects = ids;
            $scope.previewUrl = LoopBackResource.getUrlBase() + '/bulletin/preview?' + $httpParamSerializer(params);
            $scope.refreshIframe = true;
        };

        /** trust source */
        $scope.trustSrc = function (src) {
            return $sce.trustAsResourceUrl(src);
        };

        /** reload preview after changes */
        $scope.$watch('selectedProjects', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                $scope.loadPreview();
            } else {
                $scope.previewUrl = '';
            }
        }, true);

        /** load statistics*/
        $scope.loadStatistics = function () {
            $scope.isLoadingStatistics = true;
            ScreenLoader.show();
            $scope.doughnutData = {};
            $scope.statistics = {};
            Bulletin.getStatus({id: $stateParams.id}, function (response) {
                ScreenLoader.hide();
                $scope.isLoadingStatistics = false;
                $scope.statistics = response;
                $scope.doughnutData = {
                    labels: [
                        'Entregados',
                        'Pendientes',
                        'Fallos'
                    ],
                    datasets: [
                        {
                            data: [
                                response.deliveredcount,
                                response.pendingcount,
                                response.failedcount
                            ],
                            backgroundColor: [
                                dashboardColors.white,
                                dashboardColors.blueStone,
                                dashboardColors.surfieGreen,
                                dashboardColors.silverTree,
                                dashboardColors.gossip
                            ],
                            hoverBackgroundColor: [
                                colorHelper.shade(dashboardColors.white, 15),
                                colorHelper.shade(dashboardColors.blueStone, 15),
                                colorHelper.shade(dashboardColors.surfieGreen, 15)
                            ],
                            percentage: [
                                response.deliveredcount * 100 / response.recipientscount,
                                response.pendingcount * 100 / response.recipientscount,
                                response.failedcount * 100 / response.recipientscount,
                            ]
                        }
                    ]
                };

                var ctx = document.getElementById('chart-area').getContext('2d');
                window.myDoughnut = new Chart(ctx, {
                    type: 'doughnut',
                    data: $scope.doughnutData,
                    options: {
                        cutoutPercentage: 64,
                        responsive: true,
                        elements: {
                            arc: {
                                borderWidth: 0
                            }
                        }
                    }
                });
            }, function (errorResponse) {
                ScreenLoader.hide();
                $scope.isLoadingStatistics = false;
                validationUtils.processErrorResponse(errorResponse);
            });
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.configuration')
        .controller('ConfigurationPageCtrl', ConfigurationPageCtrl);

    /** @ngInject */
    function ConfigurationPageCtrl($scope, $rootScope, $state, $stateParams, UserEntity, toastr, $q, confirmModal, Configuration, nomenclator, messagesHelper, validationUtils) {

        $scope.configuration = {};
        $scope.socialNetworks = nomenclator.socialNetworks;
        $scope.appPlatforms = nomenclator.appPlatforms;
        $scope.configuration.social = [];
        $scope.configuration.app = [];
        $scope.configurationSocial = {};
        $scope.configurationApp = {};
        $scope.lastRegisteredUsers = [];
        $scope.configuration.message = "";

        /** find */
        $scope.loadConfiguration = function () {
            Configuration.findOne({}, function (response) {
                $scope.configuration = response;
                $rootScope.currentConfig = response;

                var configurationSocial = {};
                if (Array.isArray($scope.configuration.social)) {
                    $scope.configuration.social.forEach(function (social) {
                        configurationSocial[social.id] = {
                            url: social.url,
                            enabled: social.enabled
                        };
                    });
                } else {
                    $scope.configuration.social = [];
                }
                $scope.configurationSocial = configurationSocial;

                var configurationApp = {};
                if (Array.isArray($scope.configuration.app)) {
                    $scope.configuration.app.forEach(function (app) {
                        configurationApp[app.id] = {
                            url: app.url,
                            enabled: app.enabled
                        };
                    });
                } else {
                    $scope.configuration.app = [];
                }
                $scope.configurationApp = configurationApp;
                $scope.configurationProject = response.project;

            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** update social*/
        $scope.updateSocials = function (isValid) {
            if (isValid) {
                var configurationPatch = {
                    social: $scope.configuration.social
                };
                Configuration.prototype$patchAttributes({id: $scope.configuration.id}, configurationPatch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $rootScope.currentSocialNetworks = response.social;
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update apps link*/
        $scope.updateApps = function (isValid) {
            if (isValid) {
                var configurationPatch = {
                    app: $scope.configuration.app
                };
                Configuration.prototype$patchAttributes({id: $scope.configuration.id}, configurationPatch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $rootScope.currentAppPlatforms = response.app;
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update metas */
        $scope.updateMetas = function (isValid) {
            if (isValid) {
                var configurationPatch = {
                    meta: $scope.configuration.meta
                };
                Configuration.prototype$patchAttributes({id: $scope.configuration.id}, configurationPatch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $rootScope.currentAppPlatforms = response.app;
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update message */
        $scope.updateMessage = function (isValid) {
            if (isValid) {
                var configurationPatch = {
                    message: $scope.configuration.message
                };
                Configuration.prototype$patchAttributes({id: $scope.configuration.id}, configurationPatch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** watch social changes */
        $scope.$watch('configurationSocial', function (newValue, oldValue) {
            $scope.configuration.social = [];
            $scope.socialNetworks.forEach(function (social) {
                var key = social.id;
                if (newValue.hasOwnProperty(key) && newValue[key].url) {
                    $scope.configuration.social.push({
                        id: key,
                        url: newValue[key].url,
                        enabled: newValue[key].enabled
                    });
                }
            });
        }, true);

        /** watch apps link changes */
        $scope.$watch('configurationApp', function (newValue, oldValue) {
            $scope.configuration.app = [];
            $scope.appPlatforms.forEach(function (app) {
                var key = app.id;
                if (newValue.hasOwnProperty(key) && newValue[key].url) {
                    $scope.configuration.app.push({
                        id: key,
                        url: newValue[key].url,
                        enabled: newValue[key].enabled
                    });
                }
            });

        }, true);

        /** find latest registered users */
        $scope.loadLastRegisteredUsers = function () {
            $q.all([
                UserEntity.find({filter: {limit: 10, order: 'created_at DESC'}}).$promise
            ]).then(function (results) {
                $scope.lastRegisteredUsers = results[0];
            }, function (error) {
                validationUtils.processErrorResponse(error);
            });
        };

        /** init */
        $scope.init = function () {
            $scope.loadConfiguration();
            $scope.loadLastRegisteredUsers();
        }
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.dashboard')
        .controller('DashboardReportsPageCtrl', DashboardReportsPageCtrl);

    /** @ngInject */
    function DashboardReportsPageCtrl($scope, $state, $stateParams, toastr, $q, UserEntity, Analytic, ScreenLoader) {

        $scope.action = '';
        $scope.datePicker = {
            date: {startDate: moment().subtract(15, 'days'), endDate: moment().subtract(1, 'days')}
        };

        if ($stateParams.startDate && $stateParams.endDate) {
            $scope.datePicker = {
                date: {startDate: moment($stateParams.startDate), endDate: moment($stateParams.endDate)}
            };
        }

        $scope.options = {
            applyClass: 'btn-success',
            locale: {
                applyLabel: "Aplicar",
                fromLabel: "Desde",
                format: "YYYY-MM-DD",
                toLabel: "Hasta",
                cancelLabel: 'Cancelar',
                customRangeLabel: 'Rango personalizado'
            },
            ranges: {
                'Últimos 7 días': [moment().subtract(7, 'days'), moment().subtract(1, 'days')],
                'Últimos 15 días': [moment().subtract(15, 'days'), moment().subtract(1, 'days')],
                'Últimos 30 días': [moment().subtract(30, 'days'), moment().subtract(1, 'days')]
            },
            eventHandlers: {
                'apply.daterangepicker': function (ev, picker) {
                    $scope.init($scope.action);
                }
            },
            opens: 'left'
        };

        $scope.isLoading = false;
        $scope.destinationPage = {};
        $scope.exitPage = {};

        $scope.calculatePercent = function (amount, total) {
            return parseFloat(amount * 100 / total).toFixed(2);
        };

        // Cargar las páginas de destino
        $scope.loadDestinationPage = function () {
            var startDate = $scope.datePicker.date.startDate.format('YYYY-MM-DD');
            var endDate = $scope.datePicker.date.endDate.format('YYYY-MM-DD');
            $state.go('.', {startDate: startDate, endDate: endDate}, {notify: false});
            return Analytic.destinationPage({
                startDate: startDate,
                endDate: endDate
            }).$promise;
        };

        // Cargar las páginas de salida
        $scope.loadExitPage = function () {
            var startDate = $scope.datePicker.date.startDate.format('YYYY-MM-DD');
            var endDate = $scope.datePicker.date.endDate.format('YYYY-MM-DD');
            $state.go('.', {startDate: startDate, endDate: endDate}, {notify: false});
            return Analytic.exitPage({
                startDate: startDate,
                endDate: endDate
            }).$promise;
        };

        ///////////////////
        // Carga Inicial //
        ///////////////////

        $scope.init = function (action) {

            if (action) {
                $scope.action = action;
            }

            if (action === 'exit-page') {
                ScreenLoader.show();
                $scope.loadExitPage().then(function (response) {
                    ScreenLoader.hide();
                    $scope.exitPage = response.data;
                }).catch(function (error) {
                    ScreenLoader.hide();
                });
            } else if (action === 'destination-page') {
                ScreenLoader.show();
                $scope.loadDestinationPage().then(function (response) {
                    ScreenLoader.hide();
                    $scope.destinationPage = response.data;
                }).catch(function (error) {
                    ScreenLoader.hide();
                });
            }
        };

    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.dashboard')
        .controller('GAnalyticsPageCtrl', GAnalyticsPageCtrl);

    /** @ngInject */
    function GAnalyticsPageCtrl($scope, $state, $stateParams, toastr, $q, UserEntity, Analytic, ScreenLoader, colorHelper, pdConfig) {

        $scope.datePicker = {
            date: {startDate: moment().subtract(15, 'days'), endDate: moment().subtract(1, 'days')}
        };

        if ($stateParams.startDate && $stateParams.endDate) {
            $scope.datePicker = {
                date: {startDate: moment($stateParams.startDate), endDate: moment($stateParams.endDate)}
            };
        }

        $scope.isLoading = false;
        $scope.hasError = false;
        $scope.totalStatistics = {};
        $scope.countryUsers = {};
        $scope.mainChannel = {};
        $scope.visitor = {};
        $scope.device = {};
        $scope.destinationPage = [];
        $scope.exitPage = [];
        $scope.mapData = [];
        $scope.areaChartData = [];
        $scope.visitorChartData = [];
        $scope.deviceChartData = [];
        $scope.socialMediaChartData = [];

        $scope.options = {
            applyClass: 'btn-success',
            locale: {
                applyLabel: "Aplicar",
                fromLabel: "Desde",
                format: "YYYY-MM-DD",
                toLabel: "Hasta",
                cancelLabel: 'Cancelar',
                customRangeLabel: 'Rango personalizado'
            },
            ranges: {
                'Últimos 7 días': [moment().subtract(7, 'days'), moment().subtract(1, 'days')],
                'Últimos 15 días': [moment().subtract(15, 'days'), moment().subtract(1, 'days')],
                'Últimos 30 días': [moment().subtract(30, 'days'), moment().subtract(1, 'days')]
            },
            eventHandlers: {
                'apply.daterangepicker': function (ev, picker) {
                    $scope.loadCharts();
                }
            },
            opens: 'left'
        };

        // Cargar las estadísticas generales
        $scope.loadTotalStatistics = function () {
            return Analytic.totalStatistic({
                startDate: $scope.datePicker.date.startDate.format('YYYY-MM-DD'),
                endDate: $scope.datePicker.date.endDate.format('YYYY-MM-DD')
            }).$promise;
        };

        // Cargar los usuarios por día
        $scope.loadDateUsers = function () {
            return Analytic.users({
                startDate: $scope.datePicker.date.startDate.format('YYYY-MM-DD'),
                endDate: $scope.datePicker.date.endDate.format('YYYY-MM-DD')
            }).$promise;
        };

        // Cargar los canales principales
        $scope.loadMainChannels = function () {
            return Analytic.mainChannel({
                startDate: $scope.datePicker.date.startDate.format('YYYY-MM-DD'),
                endDate: $scope.datePicker.date.endDate.format('YYYY-MM-DD')
            }).$promise;
        };

        // Cargar los usuarios por países
        $scope.loadCountryUsers = function () {
            return Analytic.countryUser({
                startDate: $scope.datePicker.date.startDate.format('YYYY-MM-DD'),
                endDate: $scope.datePicker.date.endDate.format('YYYY-MM-DD')
            }).$promise;
        };

        // Cargar las visitas
        $scope.loadVisitors = function () {
            return Analytic.visitor({
                startDate: $scope.datePicker.date.startDate.format('YYYY-MM-DD'),
                endDate: $scope.datePicker.date.endDate.format('YYYY-MM-DD')
            }).$promise;
        };

        // Cargar las dispositivos
        $scope.loadDevices = function () {
            return Analytic.device({
                startDate: $scope.datePicker.date.startDate.format('YYYY-MM-DD'),
                endDate: $scope.datePicker.date.endDate.format('YYYY-MM-DD')
            }).$promise;
        };

        // Cargar los medios sociales
        $scope.loadSocialMedia = function () {
            return Analytic.socialMedia({
                startDate: $scope.datePicker.date.startDate.format('YYYY-MM-DD'),
                endDate: $scope.datePicker.date.endDate.format('YYYY-MM-DD')
            }).$promise;
        };

        // Cargar las páginas de destino
        $scope.loadDestinationPage = function () {
            return Analytic.destinationPage({
                startDate: $scope.datePicker.date.startDate.format('YYYY-MM-DD'),
                endDate: $scope.datePicker.date.endDate.format('YYYY-MM-DD')
            }).$promise;
        };

        // Cargar las páginas de salida
        $scope.loadExitPage = function () {
            return Analytic.exitPage({
                startDate: $scope.datePicker.date.startDate.format('YYYY-MM-DD'),
                endDate: $scope.datePicker.date.endDate.format('YYYY-MM-DD')
            }).$promise;
        };

        // Cargar todos los datos al cambiar las fechas
        $scope.loadCharts = function () {
            ScreenLoader.show();
            Promise.all([
                $scope.loadTotalStatistics(),
                $scope.loadMainChannels(),
                $scope.loadCountryUsers(),
                $scope.loadDateUsers(),
                $scope.loadVisitors(),
                $scope.loadDestinationPage(),
                // $scope.loadSearch(),
                // $scope.loadEditionMostDownloaded(),
                $scope.loadExitPage(),
                $scope.loadDevices(),
                $scope.loadSocialMedia(),

            ]).then(function (response) {
                $scope.isLoading = false;
                ScreenLoader.hide();

                $scope.totalStatistics = response[0];
                $scope.mainChannel = response[1].data;
                $scope.countryUsers = response[2].data;
                $scope.visitor = response[4].data;
                $scope.destinationPage = response[5].data;
                // $scope.searches = response[6];
                // $scope.mostDownloaded = response[6];
                $scope.exitPage = response[6].data;
                $scope.device = response[7].data;

                // Datos de la gráfica de mapa
                $scope.mapData = [];
                $scope.countryUsers.values.forEach(function (item) {
                    $scope.mapData.push({
                            title: item.name,
                            id: item.iso,
                            color: pdConfig.colors.primary,
                            customData: item.users
                        }
                    )
                });

                // Datos de la gráfica de usuarios por días
                $scope.areaChartData = [];
                response[3].data.forEach(function (item) {
                    $scope.areaChartData.push({
                        lineColor: pdConfig.colors.primary,
                        date: item.date,
                        users: item.value
                    });
                });

                // Datos de la gráfica de visitas recurrentes
                $scope.visitorChartData = [];
                response[4].data.values.forEach(function (item) {
                    var visitor = {
                        dimension: item.dimension,
                        value: item.value
                    };
                    if (item.dimension === "New Visitor") {
                        visitor.color = pdConfig.colors.primary;
                    }
                    if (item.dimension === "Returning Visitor") {
                        visitor.color = '#90b900';
                    }
                    $scope.visitorChartData.push(visitor);
                });

                // Datos de la gráfica de dispositivos
                $scope.deviceChartData = [];
                response[7].data.values.forEach(function (item) {
                    var device = {
                        dimension: item.device,
                        value: item.sessions
                    };
                    device.color = colorHelper.shade(pdConfig.colors.primary, item.sessions * 100 / response[7].data.totalSessions);
                    $scope.deviceChartData.push(device);
                });

                // Datos de la gráfica de medios sociales
                $scope.socialMediaChartData = [];
                response[8].data.values.forEach(function (item) {
                    var social = {
                        dimension: item.socialMedia,
                        value: item.sessions
                    };
                    social.color = colorHelper.shade(pdConfig.colors.primary, item.sessions * 100 / response[8].data.totalSessions);
                    $scope.socialMediaChartData.push(social);
                });

            }).catch(function (error) {
                $scope.isLoading = false;
                ScreenLoader.hide();
                console.log('Error al obtener los datos.', error);
            });
        };

        // Generar la etiqueta del canal principal
        $scope.generateChannelTag = function (channel) {
            var percent = parseFloat(channel.value * 100 / $scope.mainChannel.total).toFixed(1);
            return channel.value + " Usuarios (" + percent + "%)";
        };

        $scope.calculatePercent = function (amount, total) {
            return parseFloat(amount * 100 / total).toFixed(2);
        };

        ///////////////////
        // Carga Inicial //
        ///////////////////

        $scope.isLoading = true;
        $scope.loadCharts();

    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.files')
        .controller('FilesPageCtrl', FilesPageCtrl);

    /** @ngInject */
    function FilesPageCtrl($scope, $state, $stateParams, toastr, $q, confirmModal, pdConfig, $http, Container, ScreenLoader, paginateHelper, Files, $timeout) {

        $scope.containers = [];
        $scope.selectedContainer = null;
        $scope.selectedFile = {};

        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.apiUrlBase = pdConfig.apiUrlBase;

        $scope.loadContainers = function () {
            Container.getContainers(function (response) {
                $scope.containers = response;
                if (response.length > 0) {
                    $timeout(function () {
                        $scope.loadFiles(response[0]);
                    });
                }
            }, function (errorResponse) {
                console.log('Error al obtener los contenedores. ', errorResponse);
            });
        };

        $scope.loadFiles = function (container) {
            if (container === $scope.selectedContainer) {
                return;
            }
            $scope.selectedContainer = container;
            $scope.reloadTable();
        };

        // $scope.load = function () {
        //     $http.get(pdConfig.apiUrlBase + '/container/userpics/files').success(function (data) {
        //         console.log(data);
        //         $scope.files = data;
        //     });
        // };

        // $scope.delete = function (index, id) {
        //     $http.delete(pdConfig.apiUrlBase + '/container/userpics/files/' + encodeURIComponent(id)).success(function (data, status, headers) {
        //         $scope.files.splice(index, 1);
        //     });
        // };

        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {container: $scope.selectedContainer && $scope.selectedContainer.name ? $scope.selectedContainer.name : null};

            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order,
                include: []
            };

            ScreenLoader.show();
            $timeout(function () {
                $q.all([
                    Files.count({where: $scope.query.filter.where}).$promise,
                    Files.find({filter: $scope.query.filter}).$promise
                ]).then(function (results) {
                    ScreenLoader.hide();
                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    ScreenLoader.hide();
                    $scope.isLoading = false;
                });
            }, 500);
        };

        $scope.onSuccess = function (e) {
            toastr.clear();
            toastr.info('Url del fichero copiado al portapapeles.');
        };

        $scope.onError = function (e) {
            toastr.clear();
            toastr.error('No se pudo copiar la url del fichero.');
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.files')
        .controller('TestFilesPageCtrl', TestFilesPageCtrl);

    /** @ngInject */
    function TestFilesPageCtrl($scope, $state, $stateParams, UserEntity, toastr, $q, confirmModal, maConfig, FileUploader, $http) {

        var uploader = $scope.uploader = new FileUploader({
            scope: $scope,                          // to automatically update the html. Default: $rootScope
            url: maConfig.apiUrlBase + '/container/articles/upload',
            formData: [
                {key: 'file'}
            ]
        });

        // ADDING FILTERS
        uploader.filters.push({
            name: 'filterName',
            fn: function (item, options) { // second user filter
                console.info('filter2');
                return true;
            }
        });

        // REGISTER HANDLERS
        // --------------------
        uploader.onAfterAddingFile = function (item) {
            console.info('After adding a file', item);
        };
        // --------------------
        uploader.onAfterAddingAll = function (items) {
            console.info('After adding all files', items);
        };
        // --------------------
        uploader.onWhenAddingFileFailed = function (item, filter, options) {
            console.info('When adding a file failed', item);
        };
        // --------------------
        uploader.onBeforeUploadItem = function (item) {
            console.info('Before upload', item);
        };
        // --------------------
        uploader.onProgressItem = function (item, progress) {
            console.info('Progress: ' + progress, item);
        };
        // --------------------
        uploader.onProgressAll = function (progress) {
            console.info('Total progress: ' + progress);
        };
        // --------------------
        uploader.onSuccessItem = function (item, response, status, headers) {
            console.info('Success', response, status, headers);
            $scope.$broadcast('uploadCompleted', item);
        };
        // --------------------
        uploader.onErrorItem = function (item, response, status, headers) {
            console.info('Error', response, status, headers);
        };
        // --------------------
        uploader.onCancelItem = function (item, response, status, headers) {
            console.info('Cancel', response, status);
        };
        // --------------------
        uploader.onCompleteItem = function (item, response, status, headers) {
            console.info('Complete', response, status, headers);
        };
        // --------------------
        uploader.onCompleteAll = function () {
            console.info('Complete all');
        };
        // --------------------


    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.images')
        .controller('ImagesPageCtrl', ImagesPageCtrl);

    /** @ngInject */
    function ImagesPageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, $uibModal, confirmModal, paginateHelper, Image, Files, Upload, pdConfig, LoopBackAuth, validationUtils, messagesHelper, bannerStatus, bannerImageType, ScreenLoader, recommendedSizes) {

        $scope.image = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;
        $scope.statusList = [{
            key: bannerStatus.ENABLED,
            name: 'Habilitado'
        }, {
            key: bannerStatus.DISABLED,
            name: 'Deshabilitado'
        }];
        $scope.recommendedSizes = recommendedSizes.mainSlide;

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order,
                include: ["imageWeb", "imageMobile"],
            };

            $timeout(function () {
                $q.all([
                    Image.count({where: $scope.query.filter.where}).$promise,
                    Image.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadImage = function () {
            $scope.image = {};
            Image.findById({id: $stateParams.id, filter: {include: ["imageWeb", "imageMobile"]}}, function (response) {
                $scope.image = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {

                if (!$scope.image.idFileWeb || !$scope.image.idFileMobile) {
                    toastr.error('Debe seleccionar la imagen para vista web y vista móvil.');
                    return;
                }

                Image.create($scope.image,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.images.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {

                if (!$scope.image.idFileWeb || !$scope.image.idFileMobile) {
                    toastr.error('Debe seleccionar la imagen para vista web y vista móvil.');
                    return;
                }

                var patch = {
                    name: $scope.image.name,
                    title: $scope.image.title,
                    url: $scope.image.url,
                    status: $scope.image.status,
                    idFileWeb: $scope.image.idFileWeb,
                    idFileMobile: $scope.image.idFileMobile,
                };
                Image.prototype$patchAttributes({id: $scope.image.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.images.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Image.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** change status */
        $scope.changeStatus = function (id, status) {
            var patch = {
                status: status,
            };
            ScreenLoader.show();
            Image.prototype$patchAttributes({id: id}, patch,
                function (response) {
                    ScreenLoader.hide();
                    toastr.clear();
                    toastr.success(messagesHelper.success_operation);
                }, function (errorResponse) {
                    ScreenLoader.hide();
                    validationUtils.processErrorResponse(errorResponse);
                }
            );
        };

        /** ************************** */
        /** slide image management */
        /** ************************** */

        $scope.modalInstance = null;

        /** show file dialog */
        $scope.showFileDialog = function (imageType) {
            $scope.imageType = imageType;
            $scope.modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/images/filesModal.html',
                size: 'md',
                scope: $scope
            });
        };

        /** file list */
        $scope.callLogoFilesServer = function callServer(tableState, tableCtrl) {
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;
            var number = pagination.number || 10;

            var where = {container: 'Slides'};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    Files.count({where: $scope.query.filter.where}).$promise,
                    Files.find({filter: $scope.query.filter}).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** upload file */
        $scope.uploadFile = function (file, errFiles, imageType) {
            $scope.f = file;
            $scope.errFile = errFiles && errFiles[0];
            if (file) {
                file.upload = Upload.upload({
                    url: pdConfig.apiUrlBase + '/files/Slides/upload?access_token=' + LoopBackAuth.accessTokenId,
                    data: {file: file}
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        file.result = response.data;
                        $scope.setSlideImage(response.data[0], imageType);
                    });
                }, function (response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
        };

        /** attach image to slide */
        $scope.setSlideImage = function (file, imageType) {

            if (imageType === bannerImageType.WEB) {

                $scope.image.idFileWeb = file.id;
                $scope.image.imageWeb = file;

            } else if (imageType === bannerImageType.MOBILE) {

                $scope.image.idFileMobile = file.id;
                $scope.image.imageMobile = file;

            } else {
                console.log("Image type not allowed");
            }

            $scope.f = null;
            $scope.errFile = null;
            $scope.modalInstance.dismiss();
        };

        /** remove image */
        $scope.removeFile = function (imageType) {

            if (imageType === bannerImageType.WEB) {

                $scope.image.idFileWeb = null;
                $scope.image.imageWeb = null;

            } else if (imageType === bannerImageType.MOBILE) {

                $scope.image.idFileMobile = null;
                $scope.image.imageMobile = null;

            } else {
                console.log("Image type not allowed");
            }

        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.notification')
        .controller('NotificationPageCtrl', NotificationPageCtrl);

    /** @ngInject */
    function NotificationPageCtrl($scope, $state, $stateParams, UserEntity, Company, toastr, $timeout, $q, confirmModal, paginateHelper, messagesHelper, validationUtils, ScreenLoader, LoopBackResource, LoopBackAuth) {

        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;
        $scope.companies = [];

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order,
                include: ['notificationCompanies']
            };

            $timeout(function () {
                $q.all([
                    UserEntity.count({where: $scope.query.filter.where}).$promise,
                    UserEntity.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadResources = function () {
            $scope.companies = [];
            Company.find({}, function (response) {
                $scope.companies = response;
            }, function (errorResponse) {
                console.log('Load companies error.', errorResponse);
            });
        };

        /** add company tag */
        $scope.tagAdded = function (idUser, company) {
            ScreenLoader.show();
            UserEntity.prototype$__link__notificationCompanies({id: idUser, fk: company.id}, function (response) {
                ScreenLoader.hide();
            }, function (errorResponse) {
                ScreenLoader.hide();
                console.log('Link company admin error.', errorResponse);
            })
        };

        /** removed company tag */
        $scope.tagRemoved = function (idUser, company) {
            ScreenLoader.show();
            UserEntity.prototype$__unlink__notificationCompanies({id: idUser, fk: company.id}, function (response) {
                ScreenLoader.hide();
            }, function (errorResponse) {
                ScreenLoader.hide();
                console.log('Unlink company admin error.', errorResponse);
            })
        };

        /** load companies */
        $scope.loadCompanies = function (query) {
            var results = [];
            if (query) {
                results = $scope.companies.filter(function (item) {
                    return item.publicName.indexOf(query) !== -1;
                });
            } else {
                results = $scope.companies;
            }
            return results;
        };

        /** setReceiveNotificationFromAll */
        $scope.setReceiveNotificationFromAll = function (row) {
            ScreenLoader.show();
            UserEntity.setReceiveNotificationFromAll({
                id: row.id,
                enabled: row.receiveNotificationFromAll
            }, function (response) {
                ScreenLoader.hide();
                row.notificationCompanies = [];
            }, function (errorResponse) {
                ScreenLoader.hide();
                $scope.reloadTable();
                console.log('User setReceiveNotificationFromAll error.', errorResponse);
            });
        };

        /** init */
        $scope.loadResources();
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.configuration')
        .controller('ProjectConfigPageCtrl', ProjectConfigPageCtrl);

    /** @ngInject */
    function ProjectConfigPageCtrl($scope, $rootScope, toastr, Configuration, nomenclator, messagesHelper, validationUtils) {

        $scope.configuration = {};
        $scope.configurationProject = $rootScope.currentConfig ? $rootScope.currentConfig.project : {};
        $scope.fieldVisibilities = nomenclator.projectFieldVisibility;
        $scope.fieldValidation = nomenclator.projectFieldValidation;

        /** find */
        $scope.loadConfiguration = function () {
            Configuration.findOne({}, function (response) {
                $scope.configuration = response;
                $rootScope.currentConfig = response;
                $scope.configurationProject = response.project;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** update project settings */
        $scope.updateProjectSettings = function (isValid) {
            if (isValid) {
                var configurationPatch = {
                    project: $scope.configurationProject
                };
                Configuration.prototype$patchAttributes({id: $scope.configuration.id}, configurationPatch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $rootScope.currentConfig = response;
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** get object keys*/
        $scope.getObjectKeys = function (obj) {
            return Object.keys(obj).filter(function (key) {
                return obj.hasOwnProperty(key);
            });
        };

        /** init */
        $scope.init = function () {
            $scope.loadConfiguration();
        }
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.project')
        .controller('ProjectPageCtrl', ProjectPageCtrl);

    /** @ngInject */
    function ProjectPageCtrl($scope, $state, $stateParams, $httpParamSerializer, toastr, $timeout, $q, confirmModal, paginateHelper, Project, Sector, Region, Province, District, Company, Activity, InformationBase, Category, Objective, Alliance, Financing, Beneficiary, Diffusion, ScreenLoader, validationUtils, messagesHelper, projectStatus, projectStatusName, errorCodes, LoopBackResource, LoopBackAuth, $uibModal) {

        moment.locale('precise-es', {
            relativeTime: {
                future: "en %s",
                past: "hace %s segundos",
                s: "%d segundos", //see https://github.com/timrwood/moment/pull/232#issuecomment-4699806
                m: "un minuto",
                mm: "%d minutes",
                h: "una hora",
                hh: "%d horas",
                d: "un día",
                dd: "%d días",
                M: "un mes",
                MM: "%d meses",
                y: "un año",
                yy: "%d años"
            }
        });
        $scope.startDatePicker = {
            date: ''
        };
        $scope.endDatePicker = {
            date: ''
        };
        $scope.options = {
            singleDatePicker: true,
            showDropdowns: true,
            // timePicker: true,
            applyClass: 'btn-primary',
            cancelClass: 'btn',
            locale: {
                applyLabel: "Aplicar",
                cancelLabel: 'Cancelar',
                format: 'DD/MM/YYYY'
            },
            eventHandlers: {
                'apply.daterangepicker': function (ev, picker) {

                    // var startDate = moment($scope.startDatePicker.date);
                    // var endDate = moment($scope.endDatePicker.date);
                    //
                    // $scope.project.startDate = startDate.isValid() ? startDate.format() : null;
                    // $scope.project.endDate = endDate.isValid() ? endDate.format() : null;
                    // $scope.project.duration = startDate.isValid() && endDate.isValid()
                    //     ? moment.duration(startDate.diff(endDate)).locale('precise-es').humanize()
                    //     : null;
                }
            },
        };

        $scope.optionsDatepickerRow = {
            singleDatePicker: true,
            showDropdowns: true,
            // timePicker: true,
            applyClass: 'btn-primary',
            cancelClass: 'btn',

            pickerClasses: 'custom-display', //angular-daterangepicker extra
            buttonClasses: 'btn',
            applyButtonClasses: 'btn-primary',
            cancelButtonClasses: 'btn-danger',

            locale: {
                applyLabel: "Aplicar",
                cancelLabel: 'Cancelar',
                format: 'DD/MM/YYYY'
            },
            eventHandlers: {
                'apply.daterangepicker': function (ev, picker) {
                    if (ev.model.isValid()) {
                        var projectId = ev.$parent.row.id;
                        var publishedDate = ev.model.toDate();
                        ScreenLoader.show();
                        Project.changePublishedDate({id: projectId, publishedDate: publishedDate}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            ScreenLoader.hide();
                        }, function (errorResponse) {
                            ScreenLoader.hide();
                            validationUtils.processErrorResponse(errorResponse);
                        });
                    }
                }
            },
        };

        $scope.rowsDatePickers = {};

        $scope.project = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.selectedActivities = [];
        $scope.selectedAlliances = [];
        $scope.selectedCategories = [];
        $scope.selectedBeneficiaries = [];
        $scope.selectedInformationBases = [];
        $scope.selectedObjectives = [];
        $scope.selectedFinancings = [];
        $scope.selectedDiffusions = [];
        $scope.selectedLocations = [];

        $scope.errorDetails = {};

        $scope.charLimits = {
            objective: 400,
            summary: 2000,
            action: 2000,
            goals: 2000,
            referred: 600,
            history: 600,
            award: 600,
            results: 2000,
            impact: 2000,
            monitoring: 2000
        };

        /** filter resources */
        $scope.filters = {
            projectName: "",
            objectives: [],
            status: [],

            sectors: [],
            categories: [],
            companies: [],

            regions: [],
            provinces: [],
            districts: [],

            rangeDates: {
                startDate: '',
                endDate: ''
            }
        };

        $scope.regions = [];
        $scope.provinces = [];
        $scope.districts = [];
        $scope.sectors = [];
        $scope.categories = [];
        $scope.companies = [];
        $scope.objectives = [];
        $scope.status = [{
            id: projectStatus.DRAFT,
            name: projectStatusName[projectStatus.DRAFT]
        }, {
            id: projectStatus.PENDING,
            name: projectStatusName[projectStatus.PENDING]
        }, {
            id: projectStatus.PUBLISHED,
            name: projectStatusName[projectStatus.PUBLISHED]
        }];

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            $scope.filters.offset = start;
            $scope.filters.limit = number;

            ScreenLoader.show();
            $timeout(function () {
                $q.all([
                    Project.advancedCount($scope.filters).$promise,
                    Project.advancedSearch($scope.filters).$promise
                ]).then(function (results) {

                    ScreenLoader.hide();
                    $scope.isLoading = false;

                    var pickers = {};
                    results[1].forEach(function (item) {
                        var date = moment(item.publishedAt);
                        pickers[item.id] = {
                            date: date.isValid() ? date : '',
                        }
                    });
                    $scope.rowsDatePickers = pickers;

                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    ScreenLoader.hide();
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadProject = function () {
            $scope.project = {};
            var filter = {
                include: [
                    "activities",
                    "alliances",
                    "objectives",
                    "informationBases",
                    "categories",
                    "beneficiaries",
                    "diffusions",
                    "financings",
                    "locations",
                    "images",
                    "avatar",
                    "company",
                ],
            };
            Project.findById({id: $stateParams.id, filter: filter}, function (response) {
                $scope.project = response;

                /** equalize relations data for directives */
                $scope.selectedActivities = response.activities.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customActivity"].value
                    }
                });
                $scope.selectedAlliances = response.alliances.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customAlliance"].value
                    }
                });
                $scope.selectedInformationBases = response.informationBases.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customInformationBase"].value
                    }
                });
                $scope.selectedCategories = response.categories.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customCategory"].value
                    }
                });
                $scope.selectedDiffusions = response.diffusions.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customDiffusion"].value
                    }
                });
                $scope.selectedFinancings = response.financings.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customFinancing"].value
                    }
                });
                $scope.selectedBeneficiaries = response.beneficiaries.map(function (item) {
                    return {
                        id: item.id,
                        customValue: item["customBeneficiary"].value,
                        customAmount: item["customBeneficiary"].amount
                    }
                });
                $scope.selectedLocations = response.locations || [];

                /** datepicker value */
                var startDate = moment(response.startDate);
                var endDate = moment(response.endDate);
                $scope.startDatePicker.date = startDate.isValid() ? startDate : '';
                $scope.endDatePicker.date = endDate.isValid() ? endDate : '';

            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create or update */
        $scope.createOrUpdate = function (isValid) {
            if (isValid) {
                var data = {
                    project: $scope.project,
                };

                data.activities = $scope.selectedActivities.map(function (item) {
                    return {
                        idActivity: item.id,
                        value: item.customValue
                    }
                });
                data.alliances = $scope.selectedAlliances.map(function (item) {
                    return {
                        idAlliance: item.id,
                        value: item.customValue
                    }
                });
                data.beneficiaries = $scope.selectedBeneficiaries.map(function (item) {
                    return {
                        idBeneficiary: item.id,
                        value: item.customValue,
                        amount: item.customAmount
                    }
                });
                data.categories = $scope.selectedCategories.map(function (item) {
                    return {
                        idCategory: item.id,
                        value: item.customValue
                    }
                });
                data.diffusions = $scope.selectedDiffusions.map(function (item) {
                    return {
                        idDiffusion: item.id,
                        value: item.customValue
                    }
                });
                data.financings = $scope.selectedFinancings.map(function (item) {
                    return {
                        idFinancing: item.id,
                        value: item.customValue
                    }
                });
                data.images = $scope.project.images.map(function (item) {
                    return {
                        idImage: item.id,
                    }
                });
                data.informationBases = $scope.selectedInformationBases.map(function (item) {
                    return {
                        idInformationBase: item.id,
                        value: item.customValue
                    }
                });
                data.objectives = $scope.project.objectives.map(function (item) {
                    return {
                        idObjective: item.id
                    }
                });
                data.locations = $scope.selectedLocations;

                ScreenLoader.show();
                $scope.errorDetails = {};
                Project.createOrUpdate(data,
                    function (response) {
                        ScreenLoader.hide();
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.project.list');
                    }, function (errorResponse) {
                        ScreenLoader.hide();

                        if (errorResponse &&
                            errorResponse.data &&
                            errorResponse.data.error &&
                            errorResponse.data.error.code &&
                            errorResponse.data.error.code === errorCodes.INVALID_PROJECT &&
                            errorResponse.data.error.details) {
                            $scope.errorDetails = errorResponse.data.error.details;
                        }

                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Project.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {
                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** load filter resources */
        $scope.loadFilterResources = function () {
            $q.all([
                Region.find({filter: {"order": "name ASC"}}).$promise,
                Province.find({filter: {"order": "name ASC"}}).$promise,
                District.find({filter: {"order": "name ASC"}}).$promise,
                Sector.find().$promise,
                Category.find({filter: {"order": "name ASC"}}).$promise,
                Company.find({filter: {"order": "publicName ASC"}}).$promise,
                Objective.find().$promise,
            ]).then(function (results) {
                $scope.regions = results[0];
                $scope.provinces = results[1];
                $scope.districts = results[2];
                $scope.sectors = results[3];
                $scope.categories = results[4];
                $scope.companies = results[5];
                $scope.objectives = results[6];
            }, function (error) {
            });
        };

        /** apply filters */
        $scope.applyFilters = function (unused, filters) {
            $scope.filters = filters;
            $scope.reloadTable();
        };

        /** export form view */
        $scope.export = function () {
            ScreenLoader.show();

            var transform = $(".gm-style>div:first>div:first>div:last>div").css("transform");
            var comp = transform.split(","); //split up the transform matrix
            var mapleft = parseFloat(comp[4]); //get left value
            var maptop = parseFloat(comp[5]); //get top value

            $(".gm-style>div:first>div:first>div:last>div").css({ //get the map container. not sure if stable
                "transform": "none",
                "left": mapleft,
                "top": maptop,
            });
            $('#project-form .ta-editor').addClass("height-auto");

            html2canvas(document.getElementById('project-form'), {
                imageTimeout: 0,
                useCORS: true,
                logging: false,
            }).then(function (canvas) {
                ScreenLoader.hide();

                var data = canvas.toDataURL();

                $(".gm-style>div:first>div:first>div:last>div").css({
                    left: 0,
                    top: 0,
                    "transform": transform
                });
                $('#project-form .ta-editor').removeClass("height-auto");

                var width = canvas.width * 1; // optimized 0.75
                var height = canvas.height * 1; // optimized 0.75

                var docDefinition = {
                    pageSize: {
                        width: width,
                        height: height
                    },
                    pageMargins: [0, 0, 0, 0],
                    content: [{
                        width: width,
                        height: height,
                        image: data
                    }]
                };
                pdfMake.createPdf(docDefinition).download("Captura_de_Formulario_" + Date.now() + ".pdf");
            });
        };

        /** export */
        $scope.exportProjects = function (unused, filters) {
            var params = {
                access_token: LoopBackAuth.accessTokenId,
                filter: filters
            };
            window.location.href = LoopBackResource.getUrlBase() + "/project/export-excel?" + $httpParamSerializer(params);
        };

        /** get status name */
        $scope.getStatusName = function (status) {
            return projectStatusName[status];
        };

        /** show changes dialog */
        $scope.showChangesDialog = function (projectId) {
            ScreenLoader.show();
            Project.compareWithPublished({id: projectId}, function (response) {
                ScreenLoader.hide();
                // var changes = {};
                // response.forEach(function (item) {
                //     changes[item.key] = {
                //         name: changes.name,
                //         description: changes.description,
                //         oldValue: changes.oldValue,
                //         newValue: changes.newValue,
                //     }
                // });
                $scope.changes = response;
                $scope.modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/pages/project/changesModal.html',
                    size: 'lg',
                    scope: $scope
                });
            }, function (errorResponse) {
                ScreenLoader.hide();
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** change status */
        $scope.changeStatus = function (projectId, status) {
            ScreenLoader.show();
            Project.changeStatus({id: projectId, status: status}, function (response) {
                ScreenLoader.hide();
                $scope.reloadTable();
            }, function (errorResponse) {
                ScreenLoader.hide();
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** delete published version */
        $scope.deletePublishedVersion = function (projectId) {
            var desc = '\nAl eliminar la versión publicada el proyecto pasará a estado "' + projectStatusName[projectStatus.DRAFT] + '".';
            confirmModal(messagesHelper.confirm_operation + desc, 'Confirmación').then(function (result) {
                ScreenLoader.show();
                Project.deletePublishedVersion({id: projectId}, function (response) {
                    ScreenLoader.hide();
                    $scope.reloadTable();
                }, function (errorResponse) {
                    ScreenLoader.hide();
                    validationUtils.processErrorResponse(errorResponse);
                });
            });
        };

        /** get regions names */
        $scope.getRegionNames = function (locations) {
            var uniqueRegions = [];
            if (locations && Array.isArray(locations)) {
                locations.forEach(function (location) {
                    var region = location.region;
                    if (region && uniqueRegions.indexOf(region.name) === -1) {
                        uniqueRegions.push(region.name);
                    }
                });
            }
            return uniqueRegions.join(', ');
        };

        /** get sector names */
        $scope.getSectorName = function (company) {
            return company && company.sector ? company.sector.name : '';
        };

        /** get associated names */
        $scope.getAssociatedName = function (company) {
            return company ? company.publicName : '';
        };

        /** clear start date */
        $scope.clearStartDate = function () {
            $scope.startDatePicker.date = '';
        };

        /** clear end date */
        $scope.clearEndDate = function () {
            $scope.endDatePicker.date = '';
        };

        /** watch datepickers values */
        var unregisterStartDatepickerWatch = $scope.$watch('startDatePicker.date', function (newValue) {

            var date = moment(newValue);
            var current = moment();
            var picker = $('#startDate').data('daterangepicker');

            if (date.isValid()) {
                $scope.project.startDate = date;
                if (picker) {
                    picker.setStartDate(date);
                    picker.setEndDate(date);
                }
            } else {
                $scope.project.startDate = null;
                if (picker) {
                    picker.setStartDate(current);
                    picker.setEndDate(current);
                }
            }

        }, true);

        var unregisterEndDatepickerWatch = $scope.$watch('endDatePicker.date', function (newValue) {

            var date = moment(newValue);
            var current = moment();
            var picker = $('#endDate').data('daterangepicker');

            if (date.isValid()) {
                $scope.project.endDate = date;
                if (picker) {
                    picker.setStartDate(date);
                    picker.setEndDate(date);
                }
            } else {
                $scope.project.endDate = null;
                if (picker) {
                    picker.setStartDate(current);
                    picker.setEndDate(current);
                }
            }

        }, true);

        /** removing errors after project fields changed */
        var keys = [
            'project.idCompany', // backend
            'project.status', // backend

            'project.name',
            'project.nameToPublish',
            'project.objective',
            'project.womanEmpowerment',
            'project.objectives',
            'project.summary',
            'project.startDate',
            'project.endDate',
            'project.duration',
            'project.actions',
            'project.goals',
            'project.monitoring',
            'project.results',
            'project.impact',
            'project.history',
            'project.satisfactionIndicator',
            'project.images',
            'project.idAvatar',
            'project.videos',
            'project.links',
            'project.awards',
            'project.referred',
            'project.companyName',
            'project.companyCharge',
            'project.companyEmail',
            'project.companyPhone',

            'selectedActivities',
            'selectedAlliances',
            'selectedBeneficiaries',
            'selectedCategories',
            'selectedDiffusions',
            'selectedFinancings',
            'selectedInformationBases',
            'selectedLocations'
        ];
        var errKeys = {
            'project.idCompany': 'idCompany', // backend
            'project.status': 'status', // backend

            'project.name': 'name',
            'project.nameToPublish': 'nameToPublish',
            'project.objective': 'objective',
            'project.womanEmpowerment': 'womanEmpowerment',
            'project.objectives': 'objectives',
            'project.summary': 'summary',
            'project.startDate': 'startDate',
            'project.endDate': 'endDate',
            'project.duration': 'duration',
            'project.actions': 'actions',
            'project.goals': 'goals',
            'project.monitoring': 'monitoring',
            'project.results': 'results',
            'project.impact': 'impact',
            'project.history': 'history',
            'project.satisfactionIndicator': 'satisfactionIndicator',
            'project.images': 'images',
            'project.idAvatar': 'idAvatar',
            'project.videos': 'videos',
            'project.links': 'links',
            'project.awards': 'awards',
            'project.referred': 'referred',
            'project.companyName': 'companyName',
            'project.companyCharge': 'companyCharge',
            'project.companyEmail': 'companyEmail',
            'project.companyPhone': 'companyPhone',

            'selectedActivities': 'activities',
            'selectedAlliances': 'alliances',
            'selectedBeneficiaries': 'beneficiaries',
            'selectedCategories': 'categories',
            'selectedDiffusions': 'diffusions',
            'selectedFinancings': 'financing',
            'selectedInformationBases': 'informationBases',
            'selectedLocations': 'locations'
        };
        var unregisterFieldsWatchers = [];

        angular.forEach(keys, function (key) {
            unregisterFieldsWatchers.push(
                $scope.$watch(key, function (newValue, oldValue) {
                    if (errKeys[key]) {
                        delete $scope.errorDetails[errKeys[key]];
                    } else {
                        console.log("no has err key for: ", key)
                    }
                }, true)
            );
        });

        $scope.$on('$destroy', function () {
            unregisterStartDatepickerWatch();
            unregisterEndDatepickerWatch();

            angular.forEach(unregisterFieldsWatchers, function (watcher) {
                watcher();
            });
        });

        /** toggle endDateExecution */
        $scope.toggleEndDateExecution = function (endDateExecution) {
            if (endDateExecution === true) {
                $scope.endDatePicker.date = '';
            }
        };

        /** init */
        $scope.init = function (action) {
            if (action === 'list') {
                $scope.loadFilterResources();
            }
        };

        if ($state.is('main.project.edit') && $stateParams.id) {
            $scope.loadProject();
        }

        if ($state.is('main.project.create')) {
            $scope.startDatePicker.date = '';
            $scope.endDatePicker.date = '';
        }
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.security')
        .controller('SecurityPageCtrl', SecurityPageCtrl);

    /** @ngInject */
    function SecurityPageCtrl($rootScope, $scope, LoopBackAuth, UserEntity, toastr, $state, $stateParams, $location, $http, $filter, fileReaderService, confirmModal, assetPaths, ScreenLoader, messagesHelper, validationUtils, LoopBackResource) {

        $scope.credentials = {};
        $scope.resetPassword = {};
        $scope.user = {};
        $scope.changePassword = {};

        $scope.picture = $filter('imageUrl')($rootScope.userLogged ? $rootScope.userLogged.avatarFilename : null, 'userpics');
        $scope.file = '';

        /** email validation */
        $scope.validateEmail = function (email) {
            return validationUtils.isValidEmail(email);
        };

        $scope.removePicture = function () {
            confirmModal('¿Confirma que desea realizar la operación?', 'Confirmación').then(function (result) {
                UserEntity.removeAvatar({id: LoopBackAuth.currentUserId}, function (response) {
                        toastr.clear();
                        toastr.success('Imagen eliminada correctamente.');
                        $scope.picture = assetPaths.images.unknowUserImageUrl;
                        $scope.noPicture = true;
                    }, function (errorResponse) {
                        toastr.clear();
                        toastr.error('No se pudo realizar la operación.');
                        console.log('Error al eliminar la edición. ', errorResponse);
                    }
                );
            });
        };

        $scope.uploadPicture = function () {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        };

        $scope.getFile = function (file) {

            console.log('EN CONTROLADOR ', $scope.file);

            fileReaderService.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    $scope.picture = result;
                });
        };


        /** trigger for login user*/
        $scope.signin = function (isValid) {
            if (isValid) {
                $scope.login($scope.credentials, true);
            }
        };

        /** login user */
        $scope.login = function (credentials, rememberMe) {

            rememberMe = rememberMe ? true : false;
            ScreenLoader.show();
            UserEntity.login({rememberMe: rememberMe}, credentials, function (response) {
                ScreenLoader.hide();
                $rootScope.userLogged = LoopBackAuth.currentUserData;

                var next = $location.nextAfterLogin || '/main/dashboard';
                $location.nextAfterLogin = null;
                console.log("next path ", next);

                try {
                    if (OneSignal) {
                        OneSignal.push(function () {
                            OneSignal.sendTags({'email': credentials.email});
                        });
                    }
                } catch (e) {
                    console.log('OneSignal sendTag error', e);
                }

                $location.path(next);

            }, function (errorResponse) {
                ScreenLoader.hide();

                /** unverified account */
                if (errorResponse &&
                    errorResponse.data &&
                    errorResponse.data.error &&
                    errorResponse.data.error.code === "LOGIN_FAILED_EMAIL_NOT_VERIFIED") {
                    toastr.clear();
                    toastr.error(messagesHelper.unverified_account);
                    return;
                }

                toastr.clear();
                toastr.error(messagesHelper.bad_credentials);
            });
        };

        /** recovery password */
        $scope.requestResetPassword = function (isValid) {
            if (isValid) {
                ScreenLoader.show();
                UserEntity.resetPassword({email: $scope.recoveryEmail}, function (response) {
                    ScreenLoader.hide();
                    toastr.clear();
                    $scope.recoveryEmail = '';
                    toastr.success(messagesHelper.sended_recovery_email);
                }, function (errorResponse) {
                    ScreenLoader.hide();
                    validationUtils.processErrorResponse(errorResponse);
                });
            }
        };

        /** reset password */
        $scope.resetPassword = function (isValid) {
            if (isValid) {
                var url = LoopBackResource.getUrlBase() + '/user/reset-password?access_token=' + $stateParams.access_token;
                $http.post(url, {newPassword: $scope.newPassword}).then(function () {
                    $scope.newPassword = '';
                    $scope.retPassword = '';
                    toastr.clear();
                    toastr.success(messagesHelper.success_operation);
                    $state.go('signin');
                }, function (errorResponse) {
                    validationUtils.processErrorResponse(errorResponse);
                });
            }
        };

        /** logout user */
        $scope.logout = function () {
            UserEntity.logout(function (response) {
                $rootScope.$broadcast('user-logout');
                console.log(response);
                try {
                    if (OneSignal) {
                        OneSignal.push(function () {
                            OneSignal.deleteTags(['email']);
                        });
                    }
                } catch (e) {
                    console.log('OneSignal deleteTag error', e);
                }
            }, function (errorResponse) {
                $rootScope.$broadcast('user-logout');
            });
        };

        $rootScope.$on('user-logout', function () {
            $rootScope.userLogged = null;
            $location.nextAfterLogin = null;
            $state.go('signin');
        });

        // valida el email
        $scope.validateEmail = function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        };

        // cargar el usuario actual
        $scope.loadCurrentUser = function () {
            UserEntity.getCurrent(function (response) {
                $scope.user = response;
                $rootScope.userLogged = response;
            }, function (errorResponse) {
                toastr.clear();
                toastr.error(messagesHelper.fail_operation);
            });
        };

        // actualiza el perfil de usuario
        $scope.updateProfile = function (isValid) {
            if (isValid) {
                UserEntity.profile($scope.user, function (response) {
                    toastr.clear();
                    toastr.success(messagesHelper.success_operation);
                }, function (errorResponse) {
                    toastr.clear();
                    toastr.error(messagesHelper.fail_operation);
                });
            }
        };

        // cambiar el password del usuario
        $scope.updatePassword = function (isValid) {
            if (isValid) {
                UserEntity.changePassword($scope.changePassword, function (response) {
                    toastr.clear();
                    toastr.success('La clave ha sido cambiada correctamente.');
                }, function (errorResponse) {
                    // Clave actual incorrecta
                    if (errorResponse.data.error.code == "INVALID_PASSWORD") {
                        toastr.clear();
                        toastr.error('La clave actual es incorrecta.');
                        return;
                    }
                    toastr.clear();
                    toastr.error('No es posible actualizar la contraseña.');
                    console.log("Error al actualizar la contraseña.", errorResponse);
                });
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.static')
        .controller('StaticPageCtrl', StaticPageCtrl);

    /** @ngInject */
    function StaticPageCtrl($scope, $state, $stateParams, toastr, messagesHelper, Page) {

        $scope.page = {};

        $scope.taToolbar = [
            [/*'h1', 'h2', 'h3', 'h4', 'h5', 'h6',*/ 'p', 'pre', 'quote', 'fontSize'],
            ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
            ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount'],
            ['uploadImage'],
        ];

        /** create or update */
        $scope.createOrUpdate = function (isValid) {
            if (isValid) {
                Page.patchOrCreate($scope.page,
                    function (response) {
                        $scope.page = response;
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                    }, function (errorResponse) {
                        // slug not unique
                        if ((errorResponse.data.error.details &&
                            errorResponse.data.error.details.codes &&
                            errorResponse.data.error.details.codes.slug &&
                            errorResponse.data.error.details.codes.slug.indexOf('uniqueness') !== 1) ||
                            errorResponse.data.error.code === 'ER_DUP_ENTRY') {
                            toastr.clear();
                            toastr.error('Ya existe otra página con el título especificado.');
                            return;
                        }
                        toastr.clear();
                        toastr.error(messagesHelper.fail_operation);
                    }
                );
            }
        };

        /** find */
        $scope.loadPage = function (type) {
            $scope.page = {};
            Page.findOne({filter: {where: {type: type}}}, function (response) {
                $scope.page = response;
            }, function (errorResponse) {
                $scope.page.type = type;
            });
        };

        /** init */
        $scope.init = function (action) {
            if (action === 'contact' || action === 'about-us' || action === 'terms' || action === 'ods') {
                $scope.loadPage(action);
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.subscription')
        .controller('SubscriptionPageCtrl', SubscriptionPageCtrl);

    /** @ngInject */
    function SubscriptionPageCtrl($scope, $state, $stateParams, Subscription, toastr, $timeout, $q, confirmModal, paginateHelper, messagesHelper, validationUtils, nomenclator, LoopBackResource, LoopBackAuth, $uibModal, Upload) {

        $scope.subscription = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.statusList = nomenclator.subscriptionStatus;

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** email validation */
        $scope.validateEmail = function (email) {
            return validationUtils.isValidEmail(email);
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    Subscription.count({where: $scope.query.filter.where}).$promise,
                    Subscription.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadSubscription = function () {
            $scope.subscription = {};
            Subscription.findById({id: $stateParams.id}, function (response) {
                $scope.subscription = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                Subscription.create($scope.subscription,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.subscription.list');
                    }, function (errorResponse) {

                        toastr.clear();
                        if (validationUtils.hasUniquenessError(errorResponse, "email")) {
                            toastr.error(messagesHelper.email_already_exists);
                            return;
                        }

                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var subscriptionPatch = {
                    email: $scope.subscription.email,
                    name: $scope.subscription.email,
                    status: $scope.subscription.status
                };
                Subscription.prototype$patchAttributes({id: $scope.subscription.id}, subscriptionPatch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.subscription.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Subscription.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** resend activation email */
        $scope.resendActivation = function (id) {
            Subscription.resend({id: id}, function (response) {
                    toastr.clear();
                    toastr.success(messagesHelper.success_operation);
                }, function (errorResponse) {
                    validationUtils.processErrorResponse(errorResponse);
                }
            );
        };

        /** show dialog to import file */
        $scope.showImportDialog = function () {
            $scope.f = null;
            $scope.errFile = null;
            $scope.errorMsg = null;
            $scope.rowErrors = [];

            $scope.modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/subscription/filesModal.html',
                size: 'md',
                scope: $scope
            });
        };

        /** upload file */
        $scope.uploadFiles = function (file, errFiles) {
            $scope.f = file;
            $scope.errFile = errFiles && errFiles[0];
            if (file) {
                file.upload = Upload.upload({
                    url: LoopBackResource.getUrlBase() + '/subscription/import-excel?access_token=' + LoopBackAuth.accessTokenId,
                    data: {file: file}
                });
                file.upload.then(function (response) {

                    $timeout(function () {
                        if (response.data.success) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.f = null;
                            $scope.errFile = null;
                            $scope.reloadTable();
                            $scope.modalInstance.dismiss();
                        } else {
                            toastr.clear();
                            toastr.error(messagesHelper.fail_operation);
                            $scope.rowErrors = response.data.errors;
                        }
                    });

                }, function (response) {
                    if (response.status > 0) {
                        $scope.errorMsg = response.status + ': ' + response.message;
                        toastr.clear();
                        toastr.error(messagesHelper.fail_operation);
                    }
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
        };

        /** export */
        $scope.export = function () {
            window.location.href = LoopBackResource.getUrlBase() + "/subscription/export-excel?access_token=" + LoopBackAuth.accessTokenId;
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.user')
        .controller('UserPageCtrl', UserPageCtrl);

    /** @ngInject */
    function UserPageCtrl($scope, $state, $stateParams, UserEntity, toastr, $timeout, $q, confirmModal, paginateHelper, messagesHelper, validationUtils) {

        $scope.user = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** email validation */
        $scope.validateEmail = function (email) {
            return validationUtils.isValidEmail(email);
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    UserEntity.count({where: $scope.query.filter.where}).$promise,
                    UserEntity.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadUser = function () {
            $scope.user = {};
            UserEntity.findById({id: $stateParams.id}, function (response) {
                $scope.user = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                $scope.user.roles = ["admin"];
                $scope.user.username = $scope.user.email;
                $scope.user.emailVerified = true;
                UserEntity.create($scope.user,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.user.list');
                    }, function (errorResponse) {

                        toastr.clear();
                        if (validationUtils.hasUniquenessError(errorResponse, "email")) {
                            toastr.error(messagesHelper.email_already_exists);
                            return;
                        }

                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var userPatch = {
                    firstName: $scope.user.firstName,
                    lastName: $scope.user.lastName,
                    email: $scope.user.email,
                    username: $scope.user.email
                };
                if ($scope.user.password) {
                    userPatch.password = $scope.user.password;
                }
                UserEntity.prototype$patchAttributes({id: $scope.user.id}, userPatch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.user.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    UserEntity.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('csSelect', csSelect);

    /** @ngInject */
    function csSelect() {
        return {
            require: '^stTable',
            template: '<label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox"/><span></span></label>',
            scope: {
                row: '=csSelect'
            },
            link: function (scope, element, attr, ctrl) {
                element.bind('change', function (evt) {
                    scope.$apply(function () {
                        ctrl.select(scope.row, 'multiple');
                    });
                });
                scope.$watch('row.isSelected', function (newValue, oldValue) {
                    if (newValue === true) {
                        element.parent().addClass('st-selected');
                        // element.find('input').attr('checked', true);
                    } else {
                        element.parent().removeClass('st-selected');
                        // element.find('input').attr('checked', false);
                    }
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('csSelectAll', csSelectAll);

    /** @ngInject */
    function csSelectAll() {
        return {
            require: '^stTable',
            template: '<label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="isAllSelected"/><span></span></label>',
            scope: {
                results: '=csSelectAll'
            },
            link: function (scope, element, attr, ctrl) {
                element.bind('change', function (evt) {
                    scope.$apply(function () {
                        scope.results.forEach(function (val) {
                            val.isSelected = scope.isAllSelected;
                        });
                    });
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('currentDate', currentDate);

    /** @ngInject */
    function currentDate($filter) {
        return {
            link: function ($scope, $element, $attrs) {
                $element.text($filter('date')(new Date(), $attrs.currentDate));
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('equalizeHeight', equalizeHeight)
        .directive('equalizeHeightAdd', equalizeHeightAdd);

    /** @ngInject */
    function equalizeHeight($timeout, preloader, $q) {
        return {
            restrict: 'A',
            controller: function ($scope) {

                var ctrl = this;

                var elements = [];
                this.addElement = function (element) {
                    elements.push(element);
                };

                // reset height
                this.resetHeight = function () {
                    $timeout(function () {
                        angular.forEach(elements, function (el) {
                            el[0].style.height = 'auto';
                        });
                    }, 0);
                };

                // resize elements once the last element is found
                this.resize = function () {
                    ctrl.resetHeight();

                    $timeout(function () {
                        function calculateHeight() {
                            // find the tallest
                            var tallest = 0, height;
                            angular.forEach(elements, function (el) {
                                height = el[0].offsetHeight;
                                if (height > tallest)
                                    tallest = height;
                            });
                            // resize
                            angular.forEach(elements, function (el) {
                                el[0].style.height = tallest + 'px';
                            });
                        }

                        var promises = [];
                        angular.forEach(elements, function (el) {
                            el[0].querySelectorAll('img').forEach(function (img) {
                                promises.push(preloader.loadImg(img.src));
                            });
                        });

                        if (promises.length > 0) {
                            $q.all(promises).then(function (results) {
                                calculateHeight();
                            });
                        } else {
                            calculateHeight();
                        }
                    }, 0);
                };

                window.addEventListener("resize", ctrl.resize, false);
                $scope.$on('$destroy', function () {
                    window.removeEventListener("resize", ctrl.resize, false);
                });
            }
        };
    }

    function equalizeHeightAdd($timeout) {
        return {
            restrict: 'A',
            require: '^^equalizeHeight',
            link: function (scope, element, attrs, ctrl_for) {
                // add element to list of elements
                ctrl_for.addElement(element);
                if (scope.$last)
                    ctrl_for.resize();
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('fieldIf', fieldIf);

    /** @ngInject */
    function fieldIf($rootScope, projectFieldVisibility) {
        return {
            restrict: 'A',
            scope: {
                fieldName: '=fieldIf'
            },
            link: function (scope, element, attr, ctrl) {
                if ($rootScope.currentConfig.project &&
                    $rootScope.currentConfig.project[scope.fieldName] &&
                    ($rootScope.currentConfig.project[scope.fieldName].visibility === projectFieldVisibility.PRIVATE ||
                        $rootScope.currentConfig.project[scope.fieldName].visibility === projectFieldVisibility.PUBLIC)) {

                } else {
                    element[0].remove();
                }
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('fieldVisibility', fieldVisibility);

    /** @ngInject */
    function fieldVisibility($rootScope, projectFieldVisibility) {
        return {
            restrict: 'A',
            scope: {
                fieldName: '=fieldVisibility'
            },
            link: function (scope, element, attr, ctrl) {

                var elem = angular.element(element);

                if ($rootScope.currentConfig.project &&
                    $rootScope.currentConfig.project[scope.fieldName] &&
                    $rootScope.currentConfig.project[scope.fieldName].visibility === projectFieldVisibility.HIDDEN) {
                    element[0].remove();
                } else if ($rootScope.currentConfig.project &&
                    $rootScope.currentConfig.project[scope.fieldName] &&
                    $rootScope.currentConfig.project[scope.fieldName].visibility === projectFieldVisibility.PRIVATE) {
                    elem.addClass('invisible-item');
                } else if ($rootScope.currentConfig.project &&
                    $rootScope.currentConfig.project[scope.fieldName] &&
                    $rootScope.currentConfig.project[scope.fieldName].visibility === projectFieldVisibility.PUBLIC) {
                    // do nothing
                } else {
                    element[0].remove();
                }
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('fileSelect', fileSelect);

    /** @ngInject */
    function fileSelect() {
        return {
            link: function (scope, el) {
                el.bind('change', function (e) {
                    scope.$parent.file = (e.srcElement || e.target).files[0];
                    scope.$parent.getFile();
                });
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('onlyNaturalNumber', onlyNaturalNumber);

    /** @ngInject */
    function onlyNaturalNumber() {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    if (text) {
                        var transformedInput = text.replace(/[^0-9]/g, '');

                        if (transformedInput !== text) {
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        return transformedInput;
                    }
                    return undefined;
                }

                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('refreshable', refreshable);

    /** @ngInject */
    function refreshable($filter) {
        return {
            restrict: 'A',
            scope: {
                refresh: "=refreshable"
            },
            link: function (scope, element, attr) {
                var refreshMe = function () {
                    element.attr('src', element.attr('src'));
                };

                scope.$watch('refresh', function (newVal, oldVal) {
                    if (scope.refresh) {
                        scope.refresh = false;
                        refreshMe();
                    }
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectpicker', selectpicker);

    /** @ngInject */
    function selectpicker() {
        return {
            restrict: 'A',
            require: '?ngOptions',
            priority: 1500, // make priority bigger than ngOptions and ngRepeat
            link: {
                pre: function (scope, elem, attrs) {
                    elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
                },
                post: function (scope, elem, attrs) {
                    function refresh() {
                        elem.selectpicker('refresh');
                    }

                    if (attrs.ngModel) {
                        scope.$watch(attrs.ngModel, refresh);
                    }

                    if (attrs.ngDisabled) {
                        scope.$watch(attrs.ngDisabled, refresh);
                    }

                    elem.selectpicker({dropupAuto: false, hideDisabled: true});
                }
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('tagSelector', tagSelector);

    /** @ngInject */
    function tagSelector($timeout) {
        return {
            restrict: 'A',
            link: function ($scope, elem, attr) {
                $timeout(function () {
                    $(elem).tagsinput({
                        tagClass: 'label label-' + attr.tagSelector
                    });
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .filter('cut', cut);

    /** @ngInject */
    function cut() {
        return function (value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace !== -1) {
                    //Also remove . and , so its gives a cleaner result.
                    if (value.charAt(lastspace - 1) === '.' || value.charAt(lastspace - 1) === ',') {
                        lastspace = lastspace - 1;
                    }
                    value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .filter('htmlToPlainText', htmlToPlainText);

    /** @ngInject */
    function htmlToPlainText() {
        return function (input) {
            return input ? String(input).replace(/<[^>]+>/gm, '') : '';
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .filter('imageUrl', imageUrl);

    /** @ngInject */
    function imageUrl(pdConfig, assetPaths) {
        return function (input, container) {
            if (input && container) {
                return pdConfig.apiUrlBase + '/container/' + container + '/download/' + input;
            } else if (input) {
                return pdConfig.apiUrlBase + input;
            } else {
                if (container === 'userpics') {
                    return assetPaths.images.unknowUserImageUrl;
                }
                return assetPaths.images.noImageUrl;
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .filter('range', range);

    /** @ngInject */
    function range() {
        return function (total) {
            total = parseInt(total);
            var values = [];
            for (var i = 0; i < total; i++) {
                values.push(i);
            }
            return values;
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .filter('secondsToTime', secondsToTime);

    /** @ngInject */
    function secondsToTime() {
        function padTime(t) {
            return t < 10 ? "0" + t : t;
        }

        return function (_seconds) {

            _seconds = Number(_seconds);

            if (typeof _seconds !== "number" || _seconds < 0)
                return "00:00:00";

            var hours = Math.floor(_seconds / 3600),
                minutes = Math.floor((_seconds % 3600) / 60),
                seconds = Math.floor(_seconds % 60);

            return padTime(hours) + ":" + padTime(minutes) + ":" + padTime(seconds);
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .filter('url', url);

    /** @ngInject */
    function url(pdConfig, assetPaths) {
        return function (input) {
            if (input) {
                return pdConfig.apiUrlBase + input
            } else {
                return "no"
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .service('confirmModal', confirmModal);

    /** @ngInject */
    function confirmModal($uibModal) {

        return function (message, title) {

            var modal = $uibModal.open({
                size: 'sm',
                template: '<div class="modal-header">\
                            <h4 class="modal-title" ng-bind="title"></h4>\
                        </div>\
                        <div class="modal-body" ng-bind="message"></div>\
                        <div class="modal-footer">\
                            <button class="btn btn-default" ng-click="modal.dismiss()">Cancelar</button>\
                            <button class="btn btn-primary" ng-click="modal.close()">Aceptar</button>\
                        </div>',
                controller: function ($scope, $uibModalInstance) {

                    $scope.modal = $uibModalInstance;

                    if (angular.isObject(message)) {
                        angular.extend($scope, message);
                    } else {
                        $scope.message = message;
                        $scope.title = angular.isUndefined(title) ? 'Mensagem' : title;
                    }
                }
            });

            return modal.result;
        }
    }
})();

(function () {
  'use strict';

  angular.module('ProjectDirectory.resources')
      .service('fileReaderService', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api/v1";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }
  // need to use the urlBase as the base to handle multiple
  // loopback servers behind a proxy/gateway where the host
  // would be the same.
  var urlBaseHost = getHost(urlBase) ? urlBase : location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.UserEntity
 * @header lbServices.UserEntity
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserEntity` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserEntity",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/user/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use UserEntity.notificationCompanies.link() instead.
            "prototype$__link__notificationCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/user/:id/notificationCompanies/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use UserEntity.notificationCompanies.unlink() instead.
            "prototype$__unlink__notificationCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/user/:id/notificationCompanies/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use UserEntity.notificationCompanies() instead.
            "prototype$__get__notificationCompanies": {
              isArray: true,
              url: urlBase + "/user/:id/notificationCompanies",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#create
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/user",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#findById
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/user/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#replaceById
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/user/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#find
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#count
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/user/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#prototype$patchAttributes
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserEntity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/user/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#login
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * El cuerpo de respuesta contiene propiedades de la AccessToken creada durante el inicio de la sesión.
             * Dependiendo del valor del parámetro `include`, el cuerpo puede contener propiedades adicionales:
             *   - `user` - `U+007BUserU+007D` - Datos del usuario conectado actualmente. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/user/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#logout
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/user/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#prototype$verify
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Trigger user's identity verification with configured verifyOptions
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserEntity id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `verifyOptions` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$verify": {
              url: urlBase + "/user/:id/verify",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#resetPassword
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/user/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#changePassword
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Change a user's password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `oldPassword` – `{string}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePassword": {
              url: urlBase + "/user/change-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#setPassword
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Reset user's password via a password-reset token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "setPassword": {
              url: urlBase + "/user/reset-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#destroyMultiple
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/user",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#profile
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Update user profile.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "profile": {
              url: urlBase + "/user/profile",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#setReceiveNotificationFromAll
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Change user receive notification from all companies
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             *  - `enabled` – `{boolean}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "setReceiveNotificationFromAll": {
              url: urlBase + "/user/:id/notification-from-all",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#createMany
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/user",
              method: "POST",
            },

            // INTERNAL. Use Company.administrators.link() instead.
            "::link::Company::administrators": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/company/:id/administrators/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.administrators.unlink() instead.
            "::unlink::Company::administrators": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/company/:id/administrators/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.administrators() instead.
            "::get::Company::administrators": {
              isArray: true,
              url: urlBase + "/company/:id/administrators",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserEntity#getCurrent
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/user" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserEntity#prototype$updateAttributes
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserEntity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.UserEntity#getCachedCurrent
         * @methodOf lbServices.UserEntity
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.UserEntity#login} or
         * {@link lbServices.UserEntity#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A UserEntity instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.UserEntity#isAuthenticated
         * @methodOf lbServices.UserEntity
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.UserEntity#getCurrentId
         * @methodOf lbServices.UserEntity
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.UserEntity#modelName
        * @propertyOf lbServices.UserEntity
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserEntity`.
        */
        R.modelName = "UserEntity";

    /**
     * @ngdoc object
     * @name lbServices.UserEntity.notificationCompanies
     * @header lbServices.UserEntity.notificationCompanies
     * @object
     * @description
     *
     * The object `UserEntity.notificationCompanies` groups methods
     * manipulating `Company` instances related to `UserEntity`.
     *
     * Call {@link lbServices.UserEntity#notificationCompanies UserEntity.notificationCompanies()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.UserEntity#notificationCompanies
             * @methodOf lbServices.UserEntity
             *
             * @description
             *
             * notificationCompanies consultas de UserEntity.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserEntity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.notificationCompanies = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::UserEntity::notificationCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserEntity.notificationCompanies#link
             * @methodOf lbServices.UserEntity.notificationCompanies
             *
             * @description
             *
             * Añadir un elemento relacionado por id para notificationCompanies.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserEntity id
             *
             *  - `fk` – `{*}` - Clave foránea para notificationCompanies
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.notificationCompanies.link = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::link::UserEntity::notificationCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserEntity.notificationCompanies#unlink
             * @methodOf lbServices.UserEntity.notificationCompanies
             *
             * @description
             *
             * Eliminar la relación notificationCompanies con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserEntity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para notificationCompanies
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.notificationCompanies.unlink = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::unlink::UserEntity::notificationCompanies"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Analytic
 * @header lbServices.Analytic
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Analytic` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Analytic",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/analytic/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Analytic#connectedUsers
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find connected users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `filters` – `{string=}` - Filters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "connectedUsers": {
              url: urlBase + "/analytic/connected-users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#tokens
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find tokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "tokens": {
              url: urlBase + "/analytic/tokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#totalStatistic
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find total users by range date.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "totalStatistic": {
              url: urlBase + "/analytic/total-statistic",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#mainChannel
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find main channels traffic.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "mainChannel": {
              url: urlBase + "/analytic/main-channel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#countryUser
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find users by country.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "countryUser": {
              url: urlBase + "/analytic/country-user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#users
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find users by dates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "users": {
              url: urlBase + "/analytic/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#visitor
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find visitors.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "visitor": {
              url: urlBase + "/analytic/visitor",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#destinationPage
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find destination page.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "destinationPage": {
              url: urlBase + "/analytic/destination-page",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#exitPage
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find exit page.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "exitPage": {
              url: urlBase + "/analytic/exit-page",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#socialMedia
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find social media.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "socialMedia": {
              url: urlBase + "/analytic/social-media",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Analytic#device
             * @methodOf lbServices.Analytic
             *
             * @description
             *
             * Find devices usage.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `startDate` – `{string=}` - Start date
             *
             *  - `endDate` – `{string=}` - End date
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Analytic` object.)
             * </em>
             */
            "device": {
              url: urlBase + "/analytic/device",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Analytic#modelName
        * @propertyOf lbServices.Analytic
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Analytic`.
        */
        R.modelName = "Analytic";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Sector
 * @header lbServices.Sector
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Sector` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Sector",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/sector/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Sector.imageMarker() instead.
            "prototype$__get__imageMarker": {
              url: urlBase + "/sector/:id/imageMarker",
              method: "GET",
            },

            // INTERNAL. Use Sector.imageLogo() instead.
            "prototype$__get__imageLogo": {
              url: urlBase + "/sector/:id/imageLogo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#create
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/sector",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#findById
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/sector/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#find
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/sector",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#count
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/sector/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#prototype$patchAttributes
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sector id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/sector/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#destroyMultiple
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/sector",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sector#createMany
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/sector",
              method: "POST",
            },

            // INTERNAL. Use Article.sector() instead.
            "::get::Article::sector": {
              url: urlBase + "/article/:id/sector",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Sector#prototype$updateAttributes
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sector id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Sector#modelName
        * @propertyOf lbServices.Sector
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Sector`.
        */
        R.modelName = "Sector";


            /**
             * @ngdoc method
             * @name lbServices.Sector#imageMarker
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Capta la relación belongsTo imageMarker.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sector id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.imageMarker = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Sector::imageMarker"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sector#imageLogo
             * @methodOf lbServices.Sector
             *
             * @description
             *
             * Capta la relación belongsTo imageLogo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sector id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.imageLogo = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Sector::imageLogo"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Category
 * @header lbServices.Category
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Category` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Category",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/category/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Category.subcategories.findById() instead.
            "prototype$__findById__subcategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/category/:id/subcategories/:fk",
              method: "GET",
            },

            // INTERNAL. Use Category.subcategories.destroyById() instead.
            "prototype$__destroyById__subcategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/category/:id/subcategories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subcategories.updateById() instead.
            "prototype$__updateById__subcategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/category/:id/subcategories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Category.category() instead.
            "prototype$__get__category": {
              url: urlBase + "/category/:id/category",
              method: "GET",
            },

            // INTERNAL. Use Category.subcategories() instead.
            "prototype$__get__subcategories": {
              isArray: true,
              url: urlBase + "/category/:id/subcategories",
              method: "GET",
            },

            // INTERNAL. Use Category.subcategories.create() instead.
            "prototype$__create__subcategories": {
              url: urlBase + "/category/:id/subcategories",
              method: "POST",
            },

            // INTERNAL. Use Category.subcategories.destroyAll() instead.
            "prototype$__delete__subcategories": {
              url: urlBase + "/category/:id/subcategories",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subcategories.count() instead.
            "prototype$__count__subcategories": {
              url: urlBase + "/category/:id/subcategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#create
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/category",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#findById
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/category/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#find
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/category",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#count
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/category/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#prototype$patchAttributes
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/category/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#destroyMultiple
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/category",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Category#createMany
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/category",
              method: "POST",
            },

            // INTERNAL. Use Category.subcategories.findById() instead.
            "::findById::Category::subcategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/category/:id/subcategories/:fk",
              method: "GET",
            },

            // INTERNAL. Use Category.subcategories.destroyById() instead.
            "::destroyById::Category::subcategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/category/:id/subcategories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subcategories.updateById() instead.
            "::updateById::Category::subcategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/category/:id/subcategories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Category.category() instead.
            "::get::Category::category": {
              url: urlBase + "/category/:id/category",
              method: "GET",
            },

            // INTERNAL. Use Category.subcategories() instead.
            "::get::Category::subcategories": {
              isArray: true,
              url: urlBase + "/category/:id/subcategories",
              method: "GET",
            },

            // INTERNAL. Use Category.subcategories.create() instead.
            "::create::Category::subcategories": {
              url: urlBase + "/category/:id/subcategories",
              method: "POST",
            },

            // INTERNAL. Use Category.subcategories.createMany() instead.
            "::createMany::Category::subcategories": {
              isArray: true,
              url: urlBase + "/category/:id/subcategories",
              method: "POST",
            },

            // INTERNAL. Use Category.subcategories.destroyAll() instead.
            "::delete::Category::subcategories": {
              url: urlBase + "/category/:id/subcategories",
              method: "DELETE",
            },

            // INTERNAL. Use Category.subcategories.count() instead.
            "::count::Category::subcategories": {
              url: urlBase + "/category/:id/subcategories/count",
              method: "GET",
            },

            // INTERNAL. Use Project.categories.findById() instead.
            "::findById::Project::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.categories.destroyById() instead.
            "::destroyById::Project::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.categories.updateById() instead.
            "::updateById::Project::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.categories.link() instead.
            "::link::Project::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.categories.unlink() instead.
            "::unlink::Project::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.categories.exists() instead.
            "::exists::Project::categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.categories() instead.
            "::get::Project::categories": {
              isArray: true,
              url: urlBase + "/project/:id/categories",
              method: "GET",
            },

            // INTERNAL. Use Project.categories.create() instead.
            "::create::Project::categories": {
              url: urlBase + "/project/:id/categories",
              method: "POST",
            },

            // INTERNAL. Use Project.categories.createMany() instead.
            "::createMany::Project::categories": {
              isArray: true,
              url: urlBase + "/project/:id/categories",
              method: "POST",
            },

            // INTERNAL. Use Project.categories.destroyAll() instead.
            "::delete::Project::categories": {
              url: urlBase + "/project/:id/categories",
              method: "DELETE",
            },

            // INTERNAL. Use Project.categories.count() instead.
            "::count::Project::categories": {
              url: urlBase + "/project/:id/categories/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Category#prototype$updateAttributes
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Category#modelName
        * @propertyOf lbServices.Category
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Category`.
        */
        R.modelName = "Category";

    /**
     * @ngdoc object
     * @name lbServices.Category.subcategories
     * @header lbServices.Category.subcategories
     * @object
     * @description
     *
     * The object `Category.subcategories` groups methods
     * manipulating `Category` instances related to `Category`.
     *
     * Call {@link lbServices.Category#subcategories Category.subcategories()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Category#subcategories
             * @methodOf lbServices.Category
             *
             * @description
             *
             * subcategories consultas de Category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subcategories = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#count
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Recuentos subcategories de Category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.subcategories.count = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::count::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#create
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Crea una nueva instancia en subcategories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subcategories.create = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::create::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#createMany
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Crea una nueva instancia en subcategories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subcategories.createMany = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::createMany::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#destroyAll
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Suprime todos los subcategories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subcategories.destroyAll = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::delete::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#destroyById
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para subcategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para subcategories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subcategories.destroyById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::destroyById::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#findById
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Buscar un elemento relacionado por id para subcategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para subcategories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subcategories.findById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::findById::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category.subcategories#updateById
             * @methodOf lbServices.Category.subcategories
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para subcategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `fk` – `{*}` - Clave foránea para subcategories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.subcategories.updateById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::updateById::Category::subcategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Category#category
             * @methodOf lbServices.Category
             *
             * @description
             *
             * Capta la relación belongsTo category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Category id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.category = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Category::category"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Project
 * @header lbServices.Project
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Project` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Project",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/project/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Project.publishedVersion() instead.
            "prototype$__get__publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "GET",
            },

            // INTERNAL. Use Project.publishedVersion.create() instead.
            "prototype$__create__publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "POST",
            },

            // INTERNAL. Use Project.publishedVersion.update() instead.
            "prototype$__update__publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "PUT",
            },

            // INTERNAL. Use Project.publishedVersion.destroy() instead.
            "prototype$__destroy__publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.findById() instead.
            "prototype$__findById__activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.activities.destroyById() instead.
            "prototype$__destroyById__activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.updateById() instead.
            "prototype$__updateById__activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.activities.link() instead.
            "prototype$__link__activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.activities.unlink() instead.
            "prototype$__unlink__activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.exists() instead.
            "prototype$__exists__activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectActivities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectActivities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectActivities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectActivities/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectActivities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectActivities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectActivities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectActivities/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectActivities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectActivities
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectActivities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectActivities/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.alliances.findById() instead.
            "prototype$__findById__alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.alliances.destroyById() instead.
            "prototype$__destroyById__alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.alliances.updateById() instead.
            "prototype$__updateById__alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.alliances.link() instead.
            "prototype$__link__alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.alliances.unlink() instead.
            "prototype$__unlink__alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.alliances.exists() instead.
            "prototype$__exists__alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectAlliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectAlliances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectAlliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectAlliances/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectAlliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectAlliances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectAlliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectAlliances/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectAlliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectAlliances
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectAlliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectAlliances/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.beneficiaries.findById() instead.
            "prototype$__findById__beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.beneficiaries.destroyById() instead.
            "prototype$__destroyById__beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.beneficiaries.updateById() instead.
            "prototype$__updateById__beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.beneficiaries.link() instead.
            "prototype$__link__beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.beneficiaries.unlink() instead.
            "prototype$__unlink__beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.beneficiaries.exists() instead.
            "prototype$__exists__beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectBeneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectBeneficiaries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectBeneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectBeneficiaries/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectBeneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectBeneficiaries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectBeneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectBeneficiaries/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectBeneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectBeneficiaries
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectBeneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectBeneficiaries/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.diffusions.findById() instead.
            "prototype$__findById__diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.diffusions.destroyById() instead.
            "prototype$__destroyById__diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.diffusions.updateById() instead.
            "prototype$__updateById__diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.diffusions.link() instead.
            "prototype$__link__diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.diffusions.unlink() instead.
            "prototype$__unlink__diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.diffusions.exists() instead.
            "prototype$__exists__diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectDiffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectDiffusions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectDiffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectDiffusions/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectDiffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectDiffusions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectDiffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectDiffusions/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectDiffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectDiffusions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectDiffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectDiffusions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.financings.findById() instead.
            "prototype$__findById__financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.financings.destroyById() instead.
            "prototype$__destroyById__financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.financings.updateById() instead.
            "prototype$__updateById__financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.financings.link() instead.
            "prototype$__link__financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.financings.unlink() instead.
            "prototype$__unlink__financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.financings.exists() instead.
            "prototype$__exists__financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectFinancings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectFinancings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectFinancings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectFinancings/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectFinancings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectFinancings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectFinancings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectFinancings/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectFinancings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectFinancings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectFinancings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectFinancings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.objectives.findById() instead.
            "prototype$__findById__objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.objectives.destroyById() instead.
            "prototype$__destroyById__objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.objectives.updateById() instead.
            "prototype$__updateById__objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.objectives.link() instead.
            "prototype$__link__objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.objectives.unlink() instead.
            "prototype$__unlink__objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.objectives.exists() instead.
            "prototype$__exists__objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectObjectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectObjectives
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectObjectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectObjectives/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectObjectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectObjectives
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectObjectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectObjectives/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectObjectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectObjectives
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectObjectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectObjectives/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.informationBases.findById() instead.
            "prototype$__findById__informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.informationBases.destroyById() instead.
            "prototype$__destroyById__informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.informationBases.updateById() instead.
            "prototype$__updateById__informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.informationBases.link() instead.
            "prototype$__link__informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.informationBases.unlink() instead.
            "prototype$__unlink__informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.informationBases.exists() instead.
            "prototype$__exists__informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectInformationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectInformationBases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectInformationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectInformationBases/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectInformationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectInformationBases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectInformationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectInformationBases/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectInformationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectInformationBases
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectInformationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectInformationBases/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.categories.findById() instead.
            "prototype$__findById__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.categories.destroyById() instead.
            "prototype$__destroyById__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.categories.updateById() instead.
            "prototype$__updateById__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.categories.link() instead.
            "prototype$__link__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.categories.unlink() instead.
            "prototype$__unlink__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.categories.exists() instead.
            "prototype$__exists__categories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/categories/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectCategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectCategories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectCategories/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectCategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectCategories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectCategories/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectCategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectCategories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectCategories/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para projectImages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectImages
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__projectImages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectImages/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para projectImages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para projectImages
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__projectImages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectImages/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para projectImages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para projectImages
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__projectImages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/projectImages/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/project/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Project.images.findById() instead.
            "prototype$__findById__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.images.destroyById() instead.
            "prototype$__destroyById__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.images.updateById() instead.
            "prototype$__updateById__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.images.link() instead.
            "prototype$__link__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.images.unlink() instead.
            "prototype$__unlink__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.images.exists() instead.
            "prototype$__exists__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.avatar() instead.
            "prototype$__get__avatar": {
              url: urlBase + "/project/:id/avatar",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Buscar un elemento relacionado por id para locations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para locations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__locations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/locations/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para locations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para locations
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__locations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/locations/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para locations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para locations
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__locations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/locations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.updates.findById() instead.
            "prototype$__findById__updates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/updates/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.updates.destroyById() instead.
            "prototype$__destroyById__updates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/updates/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.updates.updateById() instead.
            "prototype$__updateById__updates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/updates/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.activities() instead.
            "prototype$__get__activities": {
              isArray: true,
              url: urlBase + "/project/:id/activities",
              method: "GET",
            },

            // INTERNAL. Use Project.activities.create() instead.
            "prototype$__create__activities": {
              url: urlBase + "/project/:id/activities",
              method: "POST",
            },

            // INTERNAL. Use Project.activities.destroyAll() instead.
            "prototype$__delete__activities": {
              url: urlBase + "/project/:id/activities",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.count() instead.
            "prototype$__count__activities": {
              url: urlBase + "/project/:id/activities/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectActivities consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectActivities": {
              isArray: true,
              url: urlBase + "/project/:id/projectActivities",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectActivities de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectActivities": {
              url: urlBase + "/project/:id/projectActivities",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectActivities de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectActivities": {
              url: urlBase + "/project/:id/projectActivities",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectActivities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectActivities de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectActivities": {
              url: urlBase + "/project/:id/projectActivities/count",
              method: "GET",
            },

            // INTERNAL. Use Project.alliances() instead.
            "prototype$__get__alliances": {
              isArray: true,
              url: urlBase + "/project/:id/alliances",
              method: "GET",
            },

            // INTERNAL. Use Project.alliances.create() instead.
            "prototype$__create__alliances": {
              url: urlBase + "/project/:id/alliances",
              method: "POST",
            },

            // INTERNAL. Use Project.alliances.destroyAll() instead.
            "prototype$__delete__alliances": {
              url: urlBase + "/project/:id/alliances",
              method: "DELETE",
            },

            // INTERNAL. Use Project.alliances.count() instead.
            "prototype$__count__alliances": {
              url: urlBase + "/project/:id/alliances/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectAlliances consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectAlliances": {
              isArray: true,
              url: urlBase + "/project/:id/projectAlliances",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectAlliances de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectAlliances": {
              url: urlBase + "/project/:id/projectAlliances",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectAlliances de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectAlliances": {
              url: urlBase + "/project/:id/projectAlliances",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectAlliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectAlliances de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectAlliances": {
              url: urlBase + "/project/:id/projectAlliances/count",
              method: "GET",
            },

            // INTERNAL. Use Project.beneficiaries() instead.
            "prototype$__get__beneficiaries": {
              isArray: true,
              url: urlBase + "/project/:id/beneficiaries",
              method: "GET",
            },

            // INTERNAL. Use Project.beneficiaries.create() instead.
            "prototype$__create__beneficiaries": {
              url: urlBase + "/project/:id/beneficiaries",
              method: "POST",
            },

            // INTERNAL. Use Project.beneficiaries.destroyAll() instead.
            "prototype$__delete__beneficiaries": {
              url: urlBase + "/project/:id/beneficiaries",
              method: "DELETE",
            },

            // INTERNAL. Use Project.beneficiaries.count() instead.
            "prototype$__count__beneficiaries": {
              url: urlBase + "/project/:id/beneficiaries/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectBeneficiaries consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectBeneficiaries": {
              isArray: true,
              url: urlBase + "/project/:id/projectBeneficiaries",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectBeneficiaries de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectBeneficiaries": {
              url: urlBase + "/project/:id/projectBeneficiaries",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectBeneficiaries de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectBeneficiaries": {
              url: urlBase + "/project/:id/projectBeneficiaries",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectBeneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectBeneficiaries de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectBeneficiaries": {
              url: urlBase + "/project/:id/projectBeneficiaries/count",
              method: "GET",
            },

            // INTERNAL. Use Project.diffusions() instead.
            "prototype$__get__diffusions": {
              isArray: true,
              url: urlBase + "/project/:id/diffusions",
              method: "GET",
            },

            // INTERNAL. Use Project.diffusions.create() instead.
            "prototype$__create__diffusions": {
              url: urlBase + "/project/:id/diffusions",
              method: "POST",
            },

            // INTERNAL. Use Project.diffusions.destroyAll() instead.
            "prototype$__delete__diffusions": {
              url: urlBase + "/project/:id/diffusions",
              method: "DELETE",
            },

            // INTERNAL. Use Project.diffusions.count() instead.
            "prototype$__count__diffusions": {
              url: urlBase + "/project/:id/diffusions/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectDiffusions consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectDiffusions": {
              isArray: true,
              url: urlBase + "/project/:id/projectDiffusions",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectDiffusions de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectDiffusions": {
              url: urlBase + "/project/:id/projectDiffusions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectDiffusions de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectDiffusions": {
              url: urlBase + "/project/:id/projectDiffusions",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectDiffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectDiffusions de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectDiffusions": {
              url: urlBase + "/project/:id/projectDiffusions/count",
              method: "GET",
            },

            // INTERNAL. Use Project.financings() instead.
            "prototype$__get__financings": {
              isArray: true,
              url: urlBase + "/project/:id/financings",
              method: "GET",
            },

            // INTERNAL. Use Project.financings.create() instead.
            "prototype$__create__financings": {
              url: urlBase + "/project/:id/financings",
              method: "POST",
            },

            // INTERNAL. Use Project.financings.destroyAll() instead.
            "prototype$__delete__financings": {
              url: urlBase + "/project/:id/financings",
              method: "DELETE",
            },

            // INTERNAL. Use Project.financings.count() instead.
            "prototype$__count__financings": {
              url: urlBase + "/project/:id/financings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectFinancings consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectFinancings": {
              isArray: true,
              url: urlBase + "/project/:id/projectFinancings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectFinancings de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectFinancings": {
              url: urlBase + "/project/:id/projectFinancings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectFinancings de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectFinancings": {
              url: urlBase + "/project/:id/projectFinancings",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectFinancings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectFinancings de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectFinancings": {
              url: urlBase + "/project/:id/projectFinancings/count",
              method: "GET",
            },

            // INTERNAL. Use Project.objectives() instead.
            "prototype$__get__objectives": {
              isArray: true,
              url: urlBase + "/project/:id/objectives",
              method: "GET",
            },

            // INTERNAL. Use Project.objectives.create() instead.
            "prototype$__create__objectives": {
              url: urlBase + "/project/:id/objectives",
              method: "POST",
            },

            // INTERNAL. Use Project.objectives.destroyAll() instead.
            "prototype$__delete__objectives": {
              url: urlBase + "/project/:id/objectives",
              method: "DELETE",
            },

            // INTERNAL. Use Project.objectives.count() instead.
            "prototype$__count__objectives": {
              url: urlBase + "/project/:id/objectives/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectObjectives consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectObjectives": {
              isArray: true,
              url: urlBase + "/project/:id/projectObjectives",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectObjectives de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectObjectives": {
              url: urlBase + "/project/:id/projectObjectives",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectObjectives de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectObjectives": {
              url: urlBase + "/project/:id/projectObjectives",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectObjectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectObjectives de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectObjectives": {
              url: urlBase + "/project/:id/projectObjectives/count",
              method: "GET",
            },

            // INTERNAL. Use Project.informationBases() instead.
            "prototype$__get__informationBases": {
              isArray: true,
              url: urlBase + "/project/:id/informationBases",
              method: "GET",
            },

            // INTERNAL. Use Project.informationBases.create() instead.
            "prototype$__create__informationBases": {
              url: urlBase + "/project/:id/informationBases",
              method: "POST",
            },

            // INTERNAL. Use Project.informationBases.destroyAll() instead.
            "prototype$__delete__informationBases": {
              url: urlBase + "/project/:id/informationBases",
              method: "DELETE",
            },

            // INTERNAL. Use Project.informationBases.count() instead.
            "prototype$__count__informationBases": {
              url: urlBase + "/project/:id/informationBases/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectInformationBases consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectInformationBases": {
              isArray: true,
              url: urlBase + "/project/:id/projectInformationBases",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectInformationBases de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectInformationBases": {
              url: urlBase + "/project/:id/projectInformationBases",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectInformationBases de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectInformationBases": {
              url: urlBase + "/project/:id/projectInformationBases",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectInformationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectInformationBases de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectInformationBases": {
              url: urlBase + "/project/:id/projectInformationBases/count",
              method: "GET",
            },

            // INTERNAL. Use Project.categories() instead.
            "prototype$__get__categories": {
              isArray: true,
              url: urlBase + "/project/:id/categories",
              method: "GET",
            },

            // INTERNAL. Use Project.categories.create() instead.
            "prototype$__create__categories": {
              url: urlBase + "/project/:id/categories",
              method: "POST",
            },

            // INTERNAL. Use Project.categories.destroyAll() instead.
            "prototype$__delete__categories": {
              url: urlBase + "/project/:id/categories",
              method: "DELETE",
            },

            // INTERNAL. Use Project.categories.count() instead.
            "prototype$__count__categories": {
              url: urlBase + "/project/:id/categories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectCategories consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectCategories": {
              isArray: true,
              url: urlBase + "/project/:id/projectCategories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectCategories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectCategories": {
              url: urlBase + "/project/:id/projectCategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectCategories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectCategories": {
              url: urlBase + "/project/:id/projectCategories",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectCategories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectCategories de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectCategories": {
              url: urlBase + "/project/:id/projectCategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * projectImages consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__projectImages": {
              isArray: true,
              url: urlBase + "/project/:id/projectImages",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en projectImages de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__projectImages": {
              url: urlBase + "/project/:id/projectImages",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los projectImages de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__projectImages": {
              url: urlBase + "/project/:id/projectImages",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__projectImages
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos projectImages de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__projectImages": {
              url: urlBase + "/project/:id/projectImages/count",
              method: "GET",
            },

            // INTERNAL. Use Project.images() instead.
            "prototype$__get__images": {
              isArray: true,
              url: urlBase + "/project/:id/images",
              method: "GET",
            },

            // INTERNAL. Use Project.images.create() instead.
            "prototype$__create__images": {
              url: urlBase + "/project/:id/images",
              method: "POST",
            },

            // INTERNAL. Use Project.images.destroyAll() instead.
            "prototype$__delete__images": {
              url: urlBase + "/project/:id/images",
              method: "DELETE",
            },

            // INTERNAL. Use Project.images.count() instead.
            "prototype$__count__images": {
              url: urlBase + "/project/:id/images/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * locations consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__locations": {
              isArray: true,
              url: urlBase + "/project/:id/locations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Crea una nueva instancia en locations de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__locations": {
              url: urlBase + "/project/:id/locations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Suprime todos los locations de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__locations": {
              url: urlBase + "/project/:id/locations",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__locations
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Recuentos locations de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__locations": {
              url: urlBase + "/project/:id/locations/count",
              method: "GET",
            },

            // INTERNAL. Use Project.updates() instead.
            "prototype$__get__updates": {
              isArray: true,
              url: urlBase + "/project/:id/updates",
              method: "GET",
            },

            // INTERNAL. Use Project.updates.create() instead.
            "prototype$__create__updates": {
              url: urlBase + "/project/:id/updates",
              method: "POST",
            },

            // INTERNAL. Use Project.updates.destroyAll() instead.
            "prototype$__delete__updates": {
              url: urlBase + "/project/:id/updates",
              method: "DELETE",
            },

            // INTERNAL. Use Project.updates.count() instead.
            "prototype$__count__updates": {
              url: urlBase + "/project/:id/updates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#create
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/project",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#patchOrCreate
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/project",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#replaceOrCreate
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/project/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#upsertWithWhere
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/project/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#exists
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/project/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#findById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/project/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#replaceById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/project/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#find
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/project",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#findOne
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/project/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#updateAll
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/project/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#deleteById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/project/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#count
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/project/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$patchAttributes
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/project/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#createChangeStream
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/project/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#createOrUpdate
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Create new project
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{ProjectModel=}` -
             *
             *  - `untouchable` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "createOrUpdate": {
              url: urlBase + "/project/createOrUpdate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#advancedSearch
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Get list of projects by filters
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "advancedSearch": {
              isArray: true,
              url: urlBase + "/project/advanced-search",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#advancedCount
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Count projects by filters
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{integer=}` -
             */
            "advancedCount": {
              url: urlBase + "/project/advanced-count",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#destroyMultiple
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/project",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#exportExcel
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Export excel file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `filter` – `{ProjectFilterParamsModel=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "exportExcel": {
              url: urlBase + "/project/export-excel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#lastPublished
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Get last published projects
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "lastPublished": {
              isArray: true,
              url: urlBase + "/project/last-published",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#compareWithPublished
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Compare with published and return changes
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "compareWithPublished": {
              isArray: true,
              url: urlBase + "/project/:id/compare-with-published",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#changeStatus
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Change project status
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             *  - `status` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changeStatus": {
              url: urlBase + "/project/:id/status",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#deletePublishedVersion
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete published version of project
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "deletePublishedVersion": {
              url: urlBase + "/project/:id/delete-published",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#findPublishedBySlug
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Find project by slug.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `slug` – `{string}` - Project slug.
             *
             *  - `filter` – `{object=}` - Project filter.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "findPublishedBySlug": {
              url: urlBase + "/project/find-published-by-slug/:slug",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#changePublishedDate
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Change project published date
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             *  - `publishedDate` – `{date}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePublishedDate": {
              url: urlBase + "/project/:id/published-date",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#getHtml
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Get html test
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "getHtml": {
              url: urlBase + "/project/get-html",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#createMany
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/project",
              method: "POST",
            },

            // INTERNAL. Use Project.publishedVersion() instead.
            "::get::Project::publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "GET",
            },

            // INTERNAL. Use Project.publishedVersion.create() instead.
            "::create::Project::publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "POST",
            },

            // INTERNAL. Use Project.publishedVersion.createMany() instead.
            "::createMany::Project::publishedVersion": {
              isArray: true,
              url: urlBase + "/project/:id/publishedVersion",
              method: "POST",
            },

            // INTERNAL. Use Project.publishedVersion.update() instead.
            "::update::Project::publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "PUT",
            },

            // INTERNAL. Use Project.publishedVersion.destroy() instead.
            "::destroy::Project::publishedVersion": {
              url: urlBase + "/project/:id/publishedVersion",
              method: "DELETE",
            },

            // INTERNAL. Use Update.project() instead.
            "::get::Update::project": {
              url: urlBase + "/update/:id/project",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Project#upsert
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Project#updateOrCreate
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Project#patchOrCreateWithWhere
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Project#update
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Project#destroyById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Project#removeById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$updateAttributes
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Project#modelName
        * @propertyOf lbServices.Project
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Project`.
        */
        R.modelName = "Project";

    /**
     * @ngdoc object
     * @name lbServices.Project.publishedVersion
     * @header lbServices.Project.publishedVersion
     * @object
     * @description
     *
     * The object `Project.publishedVersion` groups methods
     * manipulating `Project` instances related to `Project`.
     *
     * Call {@link lbServices.Project#publishedVersion Project.publishedVersion()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#publishedVersion
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Capta la relación hasOne publishedVersion.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.publishedVersion = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::get::Project::publishedVersion"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.publishedVersion#create
             * @methodOf lbServices.Project.publishedVersion
             *
             * @description
             *
             * Crea una nueva instancia en publishedVersion de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.publishedVersion.create = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::create::Project::publishedVersion"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.publishedVersion#createMany
             * @methodOf lbServices.Project.publishedVersion
             *
             * @description
             *
             * Crea una nueva instancia en publishedVersion de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.publishedVersion.createMany = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::createMany::Project::publishedVersion"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.publishedVersion#destroy
             * @methodOf lbServices.Project.publishedVersion
             *
             * @description
             *
             * Suprime publishedVersion de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.publishedVersion.destroy = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::destroy::Project::publishedVersion"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.publishedVersion#update
             * @methodOf lbServices.Project.publishedVersion
             *
             * @description
             *
             * Actualizar publishedVersion de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.publishedVersion.update = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::update::Project::publishedVersion"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.activities
     * @header lbServices.Project.activities
     * @object
     * @description
     *
     * The object `Project.activities` groups methods
     * manipulating `Activity` instances related to `Project`.
     *
     * Call {@link lbServices.Project#activities Project.activities()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#activities
             * @methodOf lbServices.Project
             *
             * @description
             *
             * activities consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::get::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#count
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Recuentos activities de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.activities.count = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::count::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#create
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Crea una nueva instancia en activities de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities.create = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::create::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#createMany
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Crea una nueva instancia en activities de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities.createMany = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::createMany::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#destroyAll
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Suprime todos los activities de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.activities.destroyAll = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::delete::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#destroyById
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para activities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para activities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.activities.destroyById = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::destroyById::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#exists
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Comprobar la existencia de la relación activities con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para activities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities.exists = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::exists::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#findById
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Buscar un elemento relacionado por id para activities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para activities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities.findById = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::findById::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#link
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Añadir un elemento relacionado por id para activities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para activities
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities.link = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::link::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#unlink
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Eliminar la relación activities con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para activities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.activities.unlink = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::unlink::Project::activities"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.activities#updateById
             * @methodOf lbServices.Project.activities
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para activities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para activities
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R.activities.updateById = function() {
          var TargetResource = $injector.get("Activity");
          var action = TargetResource["::updateById::Project::activities"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.alliances
     * @header lbServices.Project.alliances
     * @object
     * @description
     *
     * The object `Project.alliances` groups methods
     * manipulating `Alliance` instances related to `Project`.
     *
     * Call {@link lbServices.Project#alliances Project.alliances()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#alliances
             * @methodOf lbServices.Project
             *
             * @description
             *
             * alliances consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::get::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#count
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Recuentos alliances de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.alliances.count = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::count::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#create
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Crea una nueva instancia en alliances de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances.create = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::create::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#createMany
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Crea una nueva instancia en alliances de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances.createMany = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::createMany::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#destroyAll
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Suprime todos los alliances de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.alliances.destroyAll = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::delete::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#destroyById
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para alliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para alliances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.alliances.destroyById = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::destroyById::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#exists
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Comprobar la existencia de la relación alliances con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para alliances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances.exists = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::exists::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#findById
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Buscar un elemento relacionado por id para alliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para alliances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances.findById = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::findById::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#link
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Añadir un elemento relacionado por id para alliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para alliances
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances.link = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::link::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#unlink
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Eliminar la relación alliances con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para alliances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.alliances.unlink = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::unlink::Project::alliances"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.alliances#updateById
             * @methodOf lbServices.Project.alliances
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para alliances.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para alliances
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R.alliances.updateById = function() {
          var TargetResource = $injector.get("Alliance");
          var action = TargetResource["::updateById::Project::alliances"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.beneficiaries
     * @header lbServices.Project.beneficiaries
     * @object
     * @description
     *
     * The object `Project.beneficiaries` groups methods
     * manipulating `Beneficiary` instances related to `Project`.
     *
     * Call {@link lbServices.Project#beneficiaries Project.beneficiaries()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#beneficiaries
             * @methodOf lbServices.Project
             *
             * @description
             *
             * beneficiaries consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::get::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#count
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Recuentos beneficiaries de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.beneficiaries.count = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::count::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#create
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Crea una nueva instancia en beneficiaries de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries.create = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::create::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#createMany
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Crea una nueva instancia en beneficiaries de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries.createMany = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::createMany::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#destroyAll
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Suprime todos los beneficiaries de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.beneficiaries.destroyAll = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::delete::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#destroyById
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para beneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para beneficiaries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.beneficiaries.destroyById = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::destroyById::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#exists
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Comprobar la existencia de la relación beneficiaries con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para beneficiaries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries.exists = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::exists::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#findById
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Buscar un elemento relacionado por id para beneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para beneficiaries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries.findById = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::findById::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#link
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Añadir un elemento relacionado por id para beneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para beneficiaries
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries.link = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::link::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#unlink
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Eliminar la relación beneficiaries con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para beneficiaries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.beneficiaries.unlink = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::unlink::Project::beneficiaries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.beneficiaries#updateById
             * @methodOf lbServices.Project.beneficiaries
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para beneficiaries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para beneficiaries
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R.beneficiaries.updateById = function() {
          var TargetResource = $injector.get("Beneficiary");
          var action = TargetResource["::updateById::Project::beneficiaries"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.diffusions
     * @header lbServices.Project.diffusions
     * @object
     * @description
     *
     * The object `Project.diffusions` groups methods
     * manipulating `Diffusion` instances related to `Project`.
     *
     * Call {@link lbServices.Project#diffusions Project.diffusions()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#diffusions
             * @methodOf lbServices.Project
             *
             * @description
             *
             * diffusions consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::get::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#count
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Recuentos diffusions de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.diffusions.count = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::count::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#create
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Crea una nueva instancia en diffusions de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions.create = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::create::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#createMany
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Crea una nueva instancia en diffusions de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions.createMany = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::createMany::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#destroyAll
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Suprime todos los diffusions de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.diffusions.destroyAll = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::delete::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#destroyById
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para diffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para diffusions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.diffusions.destroyById = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::destroyById::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#exists
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Comprobar la existencia de la relación diffusions con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para diffusions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions.exists = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::exists::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#findById
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Buscar un elemento relacionado por id para diffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para diffusions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions.findById = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::findById::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#link
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Añadir un elemento relacionado por id para diffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para diffusions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions.link = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::link::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#unlink
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Eliminar la relación diffusions con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para diffusions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.diffusions.unlink = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::unlink::Project::diffusions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.diffusions#updateById
             * @methodOf lbServices.Project.diffusions
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para diffusions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para diffusions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R.diffusions.updateById = function() {
          var TargetResource = $injector.get("Diffusion");
          var action = TargetResource["::updateById::Project::diffusions"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.financings
     * @header lbServices.Project.financings
     * @object
     * @description
     *
     * The object `Project.financings` groups methods
     * manipulating `Financing` instances related to `Project`.
     *
     * Call {@link lbServices.Project#financings Project.financings()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#financings
             * @methodOf lbServices.Project
             *
             * @description
             *
             * financings consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::get::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#count
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Recuentos financings de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.financings.count = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::count::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#create
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Crea una nueva instancia en financings de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings.create = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::create::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#createMany
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Crea una nueva instancia en financings de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings.createMany = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::createMany::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#destroyAll
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Suprime todos los financings de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.financings.destroyAll = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::delete::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#destroyById
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para financings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para financings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.financings.destroyById = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::destroyById::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#exists
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Comprobar la existencia de la relación financings con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para financings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings.exists = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::exists::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#findById
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Buscar un elemento relacionado por id para financings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para financings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings.findById = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::findById::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#link
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Añadir un elemento relacionado por id para financings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para financings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings.link = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::link::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#unlink
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Eliminar la relación financings con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para financings
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.financings.unlink = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::unlink::Project::financings"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.financings#updateById
             * @methodOf lbServices.Project.financings
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para financings.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para financings
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R.financings.updateById = function() {
          var TargetResource = $injector.get("Financing");
          var action = TargetResource["::updateById::Project::financings"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.objectives
     * @header lbServices.Project.objectives
     * @object
     * @description
     *
     * The object `Project.objectives` groups methods
     * manipulating `Objective` instances related to `Project`.
     *
     * Call {@link lbServices.Project#objectives Project.objectives()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#objectives
             * @methodOf lbServices.Project
             *
             * @description
             *
             * objectives consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::get::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#count
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Recuentos objectives de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.objectives.count = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::count::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#create
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Crea una nueva instancia en objectives de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives.create = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::create::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#createMany
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Crea una nueva instancia en objectives de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives.createMany = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::createMany::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#destroyAll
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Suprime todos los objectives de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.objectives.destroyAll = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::delete::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#destroyById
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para objectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para objectives
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.objectives.destroyById = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::destroyById::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#exists
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Comprobar la existencia de la relación objectives con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para objectives
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives.exists = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::exists::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#findById
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Buscar un elemento relacionado por id para objectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para objectives
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives.findById = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::findById::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#link
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Añadir un elemento relacionado por id para objectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para objectives
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives.link = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::link::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#unlink
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Eliminar la relación objectives con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para objectives
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.objectives.unlink = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::unlink::Project::objectives"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.objectives#updateById
             * @methodOf lbServices.Project.objectives
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para objectives.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para objectives
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R.objectives.updateById = function() {
          var TargetResource = $injector.get("Objective");
          var action = TargetResource["::updateById::Project::objectives"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.informationBases
     * @header lbServices.Project.informationBases
     * @object
     * @description
     *
     * The object `Project.informationBases` groups methods
     * manipulating `InformationBase` instances related to `Project`.
     *
     * Call {@link lbServices.Project#informationBases Project.informationBases()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#informationBases
             * @methodOf lbServices.Project
             *
             * @description
             *
             * informationBases consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::get::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#count
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Recuentos informationBases de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.informationBases.count = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::count::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#create
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Crea una nueva instancia en informationBases de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases.create = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::create::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#createMany
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Crea una nueva instancia en informationBases de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases.createMany = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::createMany::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#destroyAll
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Suprime todos los informationBases de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.informationBases.destroyAll = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::delete::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#destroyById
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para informationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para informationBases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.informationBases.destroyById = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::destroyById::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#exists
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Comprobar la existencia de la relación informationBases con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para informationBases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases.exists = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::exists::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#findById
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Buscar un elemento relacionado por id para informationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para informationBases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases.findById = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::findById::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#link
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Añadir un elemento relacionado por id para informationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para informationBases
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases.link = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::link::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#unlink
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Eliminar la relación informationBases con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para informationBases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.informationBases.unlink = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::unlink::Project::informationBases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.informationBases#updateById
             * @methodOf lbServices.Project.informationBases
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para informationBases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para informationBases
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R.informationBases.updateById = function() {
          var TargetResource = $injector.get("InformationBase");
          var action = TargetResource["::updateById::Project::informationBases"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.categories
     * @header lbServices.Project.categories
     * @object
     * @description
     *
     * The object `Project.categories` groups methods
     * manipulating `Category` instances related to `Project`.
     *
     * Call {@link lbServices.Project#categories Project.categories()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#categories
             * @methodOf lbServices.Project
             *
             * @description
             *
             * categories consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::get::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#count
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Recuentos categories de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.categories.count = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::count::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#create
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Crea una nueva instancia en categories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.create = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::create::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#createMany
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Crea una nueva instancia en categories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.createMany = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::createMany::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#destroyAll
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Suprime todos los categories de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.categories.destroyAll = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::delete::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#destroyById
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.categories.destroyById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::destroyById::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#exists
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Comprobar la existencia de la relación categories con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.exists = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::exists::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#findById
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Buscar un elemento relacionado por id para categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.findById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::findById::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#link
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Añadir un elemento relacionado por id para categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para categories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.link = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::link::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#unlink
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Eliminar la relación categories con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para categories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.categories.unlink = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::unlink::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.categories#updateById
             * @methodOf lbServices.Project.categories
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para categories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para categories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Category` object.)
             * </em>
             */
        R.categories.updateById = function() {
          var TargetResource = $injector.get("Category");
          var action = TargetResource["::updateById::Project::categories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project#company
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Capta la relación belongsTo company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::Project::company"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.images
     * @header lbServices.Project.images
     * @object
     * @description
     *
     * The object `Project.images` groups methods
     * manipulating `Files` instances related to `Project`.
     *
     * Call {@link lbServices.Project#images Project.images()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#images
             * @methodOf lbServices.Project
             *
             * @description
             *
             * images consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#count
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Recuentos images de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.images.count = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::count::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#create
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Crea una nueva instancia en images de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.create = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::create::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#createMany
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Crea una nueva instancia en images de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.createMany = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::createMany::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#destroyAll
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Suprime todos los images de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.images.destroyAll = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::delete::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#destroyById
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.images.destroyById = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::destroyById::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#exists
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Comprobar la existencia de la relación images con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.exists = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::exists::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#findById
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Buscar un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.findById = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::findById::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#link
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Añadir un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.link = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::link::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#unlink
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Eliminar la relación images con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.images.unlink = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::unlink::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.images#updateById
             * @methodOf lbServices.Project.images
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.updateById = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::updateById::Project::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project#avatar
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Capta la relación belongsTo avatar.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.avatar = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Project::avatar"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.updates
     * @header lbServices.Project.updates
     * @object
     * @description
     *
     * The object `Project.updates` groups methods
     * manipulating `Update` instances related to `Project`.
     *
     * Call {@link lbServices.Project#updates Project.updates()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#updates
             * @methodOf lbServices.Project
             *
             * @description
             *
             * updates consultas de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
        R.updates = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::get::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#count
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Recuentos updates de Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.updates.count = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::count::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#create
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Crea una nueva instancia en updates de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
        R.updates.create = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::create::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#createMany
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Crea una nueva instancia en updates de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
        R.updates.createMany = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::createMany::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#destroyAll
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Suprime todos los updates de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.updates.destroyAll = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::delete::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#destroyById
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para updates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para updates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.updates.destroyById = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::destroyById::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#findById
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Buscar un elemento relacionado por id para updates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para updates
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
        R.updates.findById = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::findById::Project::updates"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.updates#updateById
             * @methodOf lbServices.Project.updates
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para updates.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Project id
             *
             *  - `fk` – `{*}` - Clave foránea para updates
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
        R.updates.updateById = function() {
          var TargetResource = $injector.get("Update");
          var action = TargetResource["::updateById::Project::updates"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Region
 * @header lbServices.Region
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Region` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Region",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/region/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Region.provinces.findById() instead.
            "prototype$__findById__provinces": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/region/:id/provinces/:fk",
              method: "GET",
            },

            // INTERNAL. Use Region.provinces.destroyById() instead.
            "prototype$__destroyById__provinces": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/region/:id/provinces/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Region.provinces.updateById() instead.
            "prototype$__updateById__provinces": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/region/:id/provinces/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Region.provinces() instead.
            "prototype$__get__provinces": {
              isArray: true,
              url: urlBase + "/region/:id/provinces",
              method: "GET",
            },

            // INTERNAL. Use Region.provinces.create() instead.
            "prototype$__create__provinces": {
              url: urlBase + "/region/:id/provinces",
              method: "POST",
            },

            // INTERNAL. Use Region.provinces.destroyAll() instead.
            "prototype$__delete__provinces": {
              url: urlBase + "/region/:id/provinces",
              method: "DELETE",
            },

            // INTERNAL. Use Region.provinces.count() instead.
            "prototype$__count__provinces": {
              url: urlBase + "/region/:id/provinces/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#create
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/region",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#findById
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/region/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#find
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/region",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#count
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/region/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#prototype$patchAttributes
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/region/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#destroyMultiple
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/region",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Region#createMany
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/region",
              method: "POST",
            },

            // INTERNAL. Use Province.region() instead.
            "::get::Province::region": {
              url: urlBase + "/province/:id/region",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Region#prototype$updateAttributes
             * @methodOf lbServices.Region
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Region#modelName
        * @propertyOf lbServices.Region
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Region`.
        */
        R.modelName = "Region";

    /**
     * @ngdoc object
     * @name lbServices.Region.provinces
     * @header lbServices.Region.provinces
     * @object
     * @description
     *
     * The object `Region.provinces` groups methods
     * manipulating `Province` instances related to `Region`.
     *
     * Call {@link lbServices.Region#provinces Region.provinces()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Region#provinces
             * @methodOf lbServices.Region
             *
             * @description
             *
             * provinces consultas de Region.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.provinces = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::get::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#count
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Recuentos provinces de Region.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.provinces.count = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::count::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#create
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Crea una nueva instancia en provinces de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.provinces.create = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::create::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#createMany
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Crea una nueva instancia en provinces de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.provinces.createMany = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::createMany::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#destroyAll
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Suprime todos los provinces de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.provinces.destroyAll = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::delete::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#destroyById
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para provinces.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para provinces
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.provinces.destroyById = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::destroyById::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#findById
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Buscar un elemento relacionado por id para provinces.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para provinces
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.provinces.findById = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::findById::Region::provinces"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Region.provinces#updateById
             * @methodOf lbServices.Region.provinces
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para provinces.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Region id
             *
             *  - `fk` – `{*}` - Clave foránea para provinces
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.provinces.updateById = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::updateById::Region::provinces"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Province
 * @header lbServices.Province
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Province` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Province",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/province/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Province.region() instead.
            "prototype$__get__region": {
              url: urlBase + "/province/:id/region",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#create
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/province",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#findById
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/province/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#find
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/province",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#count
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/province/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#prototype$patchAttributes
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Province id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/province/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#destroyMultiple
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/province",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Province#createMany
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/province",
              method: "POST",
            },

            // INTERNAL. Use Region.provinces.findById() instead.
            "::findById::Region::provinces": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/region/:id/provinces/:fk",
              method: "GET",
            },

            // INTERNAL. Use Region.provinces.destroyById() instead.
            "::destroyById::Region::provinces": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/region/:id/provinces/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Region.provinces.updateById() instead.
            "::updateById::Region::provinces": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/region/:id/provinces/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Region.provinces() instead.
            "::get::Region::provinces": {
              isArray: true,
              url: urlBase + "/region/:id/provinces",
              method: "GET",
            },

            // INTERNAL. Use Region.provinces.create() instead.
            "::create::Region::provinces": {
              url: urlBase + "/region/:id/provinces",
              method: "POST",
            },

            // INTERNAL. Use Region.provinces.createMany() instead.
            "::createMany::Region::provinces": {
              isArray: true,
              url: urlBase + "/region/:id/provinces",
              method: "POST",
            },

            // INTERNAL. Use Region.provinces.destroyAll() instead.
            "::delete::Region::provinces": {
              url: urlBase + "/region/:id/provinces",
              method: "DELETE",
            },

            // INTERNAL. Use Region.provinces.count() instead.
            "::count::Region::provinces": {
              url: urlBase + "/region/:id/provinces/count",
              method: "GET",
            },

            // INTERNAL. Use District.province() instead.
            "::get::District::province": {
              url: urlBase + "/district/:id/province",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Province#prototype$updateAttributes
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Province id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Province#modelName
        * @propertyOf lbServices.Province
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Province`.
        */
        R.modelName = "Province";


            /**
             * @ngdoc method
             * @name lbServices.Province#region
             * @methodOf lbServices.Province
             *
             * @description
             *
             * Capta la relación belongsTo region.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Province id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Region` object.)
             * </em>
             */
        R.region = function() {
          var TargetResource = $injector.get("Region");
          var action = TargetResource["::get::Province::region"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Objective
 * @header lbServices.Objective
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Objective` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Objective",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/objective/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Objective.image() instead.
            "prototype$__get__image": {
              url: urlBase + "/objective/:id/image",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#create
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/objective",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#findById
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/objective/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#find
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/objective",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#count
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/objective/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#prototype$patchAttributes
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Objective id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/objective/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#destroyMultiple
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/objective",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Objective#createMany
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/objective",
              method: "POST",
            },

            // INTERNAL. Use Project.objectives.findById() instead.
            "::findById::Project::objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.objectives.destroyById() instead.
            "::destroyById::Project::objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.objectives.updateById() instead.
            "::updateById::Project::objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.objectives.link() instead.
            "::link::Project::objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.objectives.unlink() instead.
            "::unlink::Project::objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.objectives.exists() instead.
            "::exists::Project::objectives": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/objectives/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.objectives() instead.
            "::get::Project::objectives": {
              isArray: true,
              url: urlBase + "/project/:id/objectives",
              method: "GET",
            },

            // INTERNAL. Use Project.objectives.create() instead.
            "::create::Project::objectives": {
              url: urlBase + "/project/:id/objectives",
              method: "POST",
            },

            // INTERNAL. Use Project.objectives.createMany() instead.
            "::createMany::Project::objectives": {
              isArray: true,
              url: urlBase + "/project/:id/objectives",
              method: "POST",
            },

            // INTERNAL. Use Project.objectives.destroyAll() instead.
            "::delete::Project::objectives": {
              url: urlBase + "/project/:id/objectives",
              method: "DELETE",
            },

            // INTERNAL. Use Project.objectives.count() instead.
            "::count::Project::objectives": {
              url: urlBase + "/project/:id/objectives/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Objective#prototype$updateAttributes
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Objective id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Objective` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Objective#modelName
        * @propertyOf lbServices.Objective
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Objective`.
        */
        R.modelName = "Objective";


            /**
             * @ngdoc method
             * @name lbServices.Objective#image
             * @methodOf lbServices.Objective
             *
             * @description
             *
             * Capta la relación belongsTo image.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Objective id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.image = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Objective::image"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Activity
 * @header lbServices.Activity
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Activity` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Activity",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/activity/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Activity#create
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/activity",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity#findById
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/activity/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity#find
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/activity",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity#count
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/activity/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity#prototype$patchAttributes
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Activity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/activity/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity#destroyMultiple
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/activity",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Activity#createMany
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/activity",
              method: "POST",
            },

            // INTERNAL. Use Project.activities.findById() instead.
            "::findById::Project::activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.activities.destroyById() instead.
            "::destroyById::Project::activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.updateById() instead.
            "::updateById::Project::activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.activities.link() instead.
            "::link::Project::activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.activities.unlink() instead.
            "::unlink::Project::activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.exists() instead.
            "::exists::Project::activities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/activities/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.activities() instead.
            "::get::Project::activities": {
              isArray: true,
              url: urlBase + "/project/:id/activities",
              method: "GET",
            },

            // INTERNAL. Use Project.activities.create() instead.
            "::create::Project::activities": {
              url: urlBase + "/project/:id/activities",
              method: "POST",
            },

            // INTERNAL. Use Project.activities.createMany() instead.
            "::createMany::Project::activities": {
              isArray: true,
              url: urlBase + "/project/:id/activities",
              method: "POST",
            },

            // INTERNAL. Use Project.activities.destroyAll() instead.
            "::delete::Project::activities": {
              url: urlBase + "/project/:id/activities",
              method: "DELETE",
            },

            // INTERNAL. Use Project.activities.count() instead.
            "::count::Project::activities": {
              url: urlBase + "/project/:id/activities/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Activity#prototype$updateAttributes
             * @methodOf lbServices.Activity
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Activity id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Activity` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Activity#modelName
        * @propertyOf lbServices.Activity
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Activity`.
        */
        R.modelName = "Activity";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.InformationBase
 * @header lbServices.InformationBase
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `InformationBase` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "InformationBase",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/information-base/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#create
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/information-base",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#findById
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/information-base/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#find
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/information-base",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#count
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/information-base/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#prototype$patchAttributes
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InformationBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/information-base/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#destroyMultiple
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/information-base",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.InformationBase#createMany
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/information-base",
              method: "POST",
            },

            // INTERNAL. Use Project.informationBases.findById() instead.
            "::findById::Project::informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.informationBases.destroyById() instead.
            "::destroyById::Project::informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.informationBases.updateById() instead.
            "::updateById::Project::informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.informationBases.link() instead.
            "::link::Project::informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.informationBases.unlink() instead.
            "::unlink::Project::informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.informationBases.exists() instead.
            "::exists::Project::informationBases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/informationBases/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.informationBases() instead.
            "::get::Project::informationBases": {
              isArray: true,
              url: urlBase + "/project/:id/informationBases",
              method: "GET",
            },

            // INTERNAL. Use Project.informationBases.create() instead.
            "::create::Project::informationBases": {
              url: urlBase + "/project/:id/informationBases",
              method: "POST",
            },

            // INTERNAL. Use Project.informationBases.createMany() instead.
            "::createMany::Project::informationBases": {
              isArray: true,
              url: urlBase + "/project/:id/informationBases",
              method: "POST",
            },

            // INTERNAL. Use Project.informationBases.destroyAll() instead.
            "::delete::Project::informationBases": {
              url: urlBase + "/project/:id/informationBases",
              method: "DELETE",
            },

            // INTERNAL. Use Project.informationBases.count() instead.
            "::count::Project::informationBases": {
              url: urlBase + "/project/:id/informationBases/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.InformationBase#prototype$updateAttributes
             * @methodOf lbServices.InformationBase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - InformationBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InformationBase` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.InformationBase#modelName
        * @propertyOf lbServices.InformationBase
        * @description
        * The name of the model represented by this $resource,
        * i.e. `InformationBase`.
        */
        R.modelName = "InformationBase";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Alliance
 * @header lbServices.Alliance
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Alliance` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Alliance",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/alliance/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Alliance#create
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/alliance",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Alliance#findById
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/alliance/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Alliance#find
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/alliance",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Alliance#count
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/alliance/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Alliance#prototype$patchAttributes
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Alliance id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/alliance/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Alliance#destroyMultiple
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/alliance",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Alliance#createMany
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/alliance",
              method: "POST",
            },

            // INTERNAL. Use Project.alliances.findById() instead.
            "::findById::Project::alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.alliances.destroyById() instead.
            "::destroyById::Project::alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.alliances.updateById() instead.
            "::updateById::Project::alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.alliances.link() instead.
            "::link::Project::alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.alliances.unlink() instead.
            "::unlink::Project::alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.alliances.exists() instead.
            "::exists::Project::alliances": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/alliances/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.alliances() instead.
            "::get::Project::alliances": {
              isArray: true,
              url: urlBase + "/project/:id/alliances",
              method: "GET",
            },

            // INTERNAL. Use Project.alliances.create() instead.
            "::create::Project::alliances": {
              url: urlBase + "/project/:id/alliances",
              method: "POST",
            },

            // INTERNAL. Use Project.alliances.createMany() instead.
            "::createMany::Project::alliances": {
              isArray: true,
              url: urlBase + "/project/:id/alliances",
              method: "POST",
            },

            // INTERNAL. Use Project.alliances.destroyAll() instead.
            "::delete::Project::alliances": {
              url: urlBase + "/project/:id/alliances",
              method: "DELETE",
            },

            // INTERNAL. Use Project.alliances.count() instead.
            "::count::Project::alliances": {
              url: urlBase + "/project/:id/alliances/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Alliance#prototype$updateAttributes
             * @methodOf lbServices.Alliance
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Alliance id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Alliance` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Alliance#modelName
        * @propertyOf lbServices.Alliance
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Alliance`.
        */
        R.modelName = "Alliance";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Financing
 * @header lbServices.Financing
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Financing` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Financing",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/financing/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Financing#create
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/financing",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Financing#findById
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/financing/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Financing#find
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/financing",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Financing#count
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/financing/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Financing#prototype$patchAttributes
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Financing id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/financing/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Financing#destroyMultiple
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/financing",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Financing#createMany
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/financing",
              method: "POST",
            },

            // INTERNAL. Use Project.financings.findById() instead.
            "::findById::Project::financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.financings.destroyById() instead.
            "::destroyById::Project::financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.financings.updateById() instead.
            "::updateById::Project::financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.financings.link() instead.
            "::link::Project::financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.financings.unlink() instead.
            "::unlink::Project::financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.financings.exists() instead.
            "::exists::Project::financings": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/financings/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.financings() instead.
            "::get::Project::financings": {
              isArray: true,
              url: urlBase + "/project/:id/financings",
              method: "GET",
            },

            // INTERNAL. Use Project.financings.create() instead.
            "::create::Project::financings": {
              url: urlBase + "/project/:id/financings",
              method: "POST",
            },

            // INTERNAL. Use Project.financings.createMany() instead.
            "::createMany::Project::financings": {
              isArray: true,
              url: urlBase + "/project/:id/financings",
              method: "POST",
            },

            // INTERNAL. Use Project.financings.destroyAll() instead.
            "::delete::Project::financings": {
              url: urlBase + "/project/:id/financings",
              method: "DELETE",
            },

            // INTERNAL. Use Project.financings.count() instead.
            "::count::Project::financings": {
              url: urlBase + "/project/:id/financings/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Financing#prototype$updateAttributes
             * @methodOf lbServices.Financing
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Financing id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Financing` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Financing#modelName
        * @propertyOf lbServices.Financing
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Financing`.
        */
        R.modelName = "Financing";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Beneficiary
 * @header lbServices.Beneficiary
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Beneficiary` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Beneficiary",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/beneficiary/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#create
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/beneficiary",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#findById
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/beneficiary/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#find
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/beneficiary",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#count
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/beneficiary/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#prototype$patchAttributes
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Beneficiary id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/beneficiary/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#destroyMultiple
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/beneficiary",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#createMany
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/beneficiary",
              method: "POST",
            },

            // INTERNAL. Use Project.beneficiaries.findById() instead.
            "::findById::Project::beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.beneficiaries.destroyById() instead.
            "::destroyById::Project::beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.beneficiaries.updateById() instead.
            "::updateById::Project::beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.beneficiaries.link() instead.
            "::link::Project::beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.beneficiaries.unlink() instead.
            "::unlink::Project::beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.beneficiaries.exists() instead.
            "::exists::Project::beneficiaries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/beneficiaries/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.beneficiaries() instead.
            "::get::Project::beneficiaries": {
              isArray: true,
              url: urlBase + "/project/:id/beneficiaries",
              method: "GET",
            },

            // INTERNAL. Use Project.beneficiaries.create() instead.
            "::create::Project::beneficiaries": {
              url: urlBase + "/project/:id/beneficiaries",
              method: "POST",
            },

            // INTERNAL. Use Project.beneficiaries.createMany() instead.
            "::createMany::Project::beneficiaries": {
              isArray: true,
              url: urlBase + "/project/:id/beneficiaries",
              method: "POST",
            },

            // INTERNAL. Use Project.beneficiaries.destroyAll() instead.
            "::delete::Project::beneficiaries": {
              url: urlBase + "/project/:id/beneficiaries",
              method: "DELETE",
            },

            // INTERNAL. Use Project.beneficiaries.count() instead.
            "::count::Project::beneficiaries": {
              url: urlBase + "/project/:id/beneficiaries/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Beneficiary#prototype$updateAttributes
             * @methodOf lbServices.Beneficiary
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Beneficiary id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Beneficiary` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Beneficiary#modelName
        * @propertyOf lbServices.Beneficiary
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Beneficiary`.
        */
        R.modelName = "Beneficiary";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Diffusion
 * @header lbServices.Diffusion
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Diffusion` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Diffusion",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/diffusion/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#create
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/diffusion",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#findById
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/diffusion/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#find
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/diffusion",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#count
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/diffusion/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#prototype$patchAttributes
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Diffusion id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/diffusion/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#destroyMultiple
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/diffusion",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Diffusion#createMany
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/diffusion",
              method: "POST",
            },

            // INTERNAL. Use Project.diffusions.findById() instead.
            "::findById::Project::diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.diffusions.destroyById() instead.
            "::destroyById::Project::diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.diffusions.updateById() instead.
            "::updateById::Project::diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.diffusions.link() instead.
            "::link::Project::diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.diffusions.unlink() instead.
            "::unlink::Project::diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.diffusions.exists() instead.
            "::exists::Project::diffusions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/diffusions/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.diffusions() instead.
            "::get::Project::diffusions": {
              isArray: true,
              url: urlBase + "/project/:id/diffusions",
              method: "GET",
            },

            // INTERNAL. Use Project.diffusions.create() instead.
            "::create::Project::diffusions": {
              url: urlBase + "/project/:id/diffusions",
              method: "POST",
            },

            // INTERNAL. Use Project.diffusions.createMany() instead.
            "::createMany::Project::diffusions": {
              isArray: true,
              url: urlBase + "/project/:id/diffusions",
              method: "POST",
            },

            // INTERNAL. Use Project.diffusions.destroyAll() instead.
            "::delete::Project::diffusions": {
              url: urlBase + "/project/:id/diffusions",
              method: "DELETE",
            },

            // INTERNAL. Use Project.diffusions.count() instead.
            "::count::Project::diffusions": {
              url: urlBase + "/project/:id/diffusions/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Diffusion#prototype$updateAttributes
             * @methodOf lbServices.Diffusion
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Diffusion id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Diffusion` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Diffusion#modelName
        * @propertyOf lbServices.Diffusion
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Diffusion`.
        */
        R.modelName = "Diffusion";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Synchronization
 * @header lbServices.Synchronization
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Synchronization` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Synchronization",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/synchronization/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Synchronization#find
             * @methodOf lbServices.Synchronization
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Synchronization` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/synchronization",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Synchronization#count
             * @methodOf lbServices.Synchronization
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/synchronization/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Synchronization#destroyMultiple
             * @methodOf lbServices.Synchronization
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Synchronization` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/synchronization",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Synchronization#syncUsers
             * @methodOf lbServices.Synchronization
             *
             * @description
             *
             * Sync associated users
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Synchronization` object.)
             * </em>
             */
            "syncUsers": {
              url: urlBase + "/synchronization/syncUsers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Synchronization#getDataToSync
             * @methodOf lbServices.Synchronization
             *
             * @description
             *
             * Get remote data to sync
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Synchronization` object.)
             * </em>
             */
            "getDataToSync": {
              isArray: true,
              url: urlBase + "/synchronization/getDataToSync",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Synchronization#modelName
        * @propertyOf lbServices.Synchronization
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Synchronization`.
        */
        R.modelName = "Synchronization";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Page
 * @header lbServices.Page
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Page` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Page",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/page/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Page#create
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/page",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#patchOrCreate
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/page",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#replaceOrCreate
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/page/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#upsertWithWhere
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/page/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#exists
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/page/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#findById
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/page/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#replaceById
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/page/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#find
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/page",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#findOne
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/page/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#updateAll
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/page/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#deleteById
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/page/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#count
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/page/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#prototype$patchAttributes
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Page id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/page/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#createChangeStream
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/page/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#contact
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Contact with us.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "contact": {
              url: urlBase + "/page/contact",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Page#createMany
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/page",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Page#upsert
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Page#updateOrCreate
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Page#patchOrCreateWithWhere
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Page#update
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Page#destroyById
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Page#removeById
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Page#prototype$updateAttributes
             * @methodOf lbServices.Page
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Page id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Page` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Page#modelName
        * @propertyOf lbServices.Page
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Page`.
        */
        R.modelName = "Page";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Configuration
 * @header lbServices.Configuration
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Configuration` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Configuration",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/configuration/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Configuration#create
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/configuration",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#patchOrCreate
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/configuration",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#replaceOrCreate
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/configuration/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#upsertWithWhere
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/configuration/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#exists
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/configuration/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#findById
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/configuration/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#replaceById
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/configuration/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#find
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/configuration",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#findOne
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/configuration/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#updateAll
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/configuration/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#deleteById
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/configuration/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#count
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/configuration/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#prototype$patchAttributes
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Configuration id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/configuration/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#createChangeStream
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/configuration/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Configuration#createMany
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/configuration",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Configuration#upsert
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Configuration#updateOrCreate
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Configuration#patchOrCreateWithWhere
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Configuration#update
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Configuration#destroyById
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Configuration#removeById
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Configuration#prototype$updateAttributes
             * @methodOf lbServices.Configuration
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Configuration id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Configuration` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Configuration#modelName
        * @propertyOf lbServices.Configuration
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Configuration`.
        */
        R.modelName = "Configuration";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RemoteFiscalData
 * @header lbServices.RemoteFiscalData
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RemoteFiscalData` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RemoteFiscalData",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/RemoteFiscalData/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.RemoteFiscalData#find
             * @methodOf lbServices.RemoteFiscalData
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteFiscalData` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/RemoteFiscalData",
              method: "GET",
            },

            // INTERNAL. Use RemoteCompany.datosFiscales() instead.
            "::get::RemoteCompany::datosFiscales": {
              url: urlBase + "/RemoteCompanies/:id/datosFiscales",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.RemoteFiscalData#modelName
        * @propertyOf lbServices.RemoteFiscalData
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RemoteFiscalData`.
        */
        R.modelName = "RemoteFiscalData";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RemoteCompany
 * @header lbServices.RemoteCompany
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RemoteCompany` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RemoteCompany",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/RemoteCompanies/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use RemoteCompany.datosFiscales() instead.
            "prototype$__get__datosFiscales": {
              url: urlBase + "/RemoteCompanies/:id/datosFiscales",
              method: "GET",
            },

            // INTERNAL. Use RemoteCompany.tipoInstitucion() instead.
            "prototype$__get__tipoInstitucion": {
              url: urlBase + "/RemoteCompanies/:id/tipoInstitucion",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RemoteCompany#find
             * @methodOf lbServices.RemoteCompany
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteCompany` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/RemoteCompanies",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.RemoteCompany#modelName
        * @propertyOf lbServices.RemoteCompany
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RemoteCompany`.
        */
        R.modelName = "RemoteCompany";


            /**
             * @ngdoc method
             * @name lbServices.RemoteCompany#datosFiscales
             * @methodOf lbServices.RemoteCompany
             *
             * @description
             *
             * Capta la relación belongsTo datosFiscales.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RemoteCompany id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteFiscalData` object.)
             * </em>
             */
        R.datosFiscales = function() {
          var TargetResource = $injector.get("RemoteFiscalData");
          var action = TargetResource["::get::RemoteCompany::datosFiscales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RemoteCompany#tipoInstitucion
             * @methodOf lbServices.RemoteCompany
             *
             * @description
             *
             * Capta la relación belongsTo tipoInstitucion.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RemoteCompany id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteInstitutionKind` object.)
             * </em>
             */
        R.tipoInstitucion = function() {
          var TargetResource = $injector.get("RemoteInstitutionKind");
          var action = TargetResource["::get::RemoteCompany::tipoInstitucion"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RemoteSubSector
 * @header lbServices.RemoteSubSector
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RemoteSubSector` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RemoteSubSector",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/RemoteSubSectors/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.RemoteSubSector#find
             * @methodOf lbServices.RemoteSubSector
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteSubSector` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/RemoteSubSectors",
              method: "GET",
            },

            // INTERNAL. Use RemoteInstitutionKind.subsector() instead.
            "::get::RemoteInstitutionKind::subsector": {
              url: urlBase + "/RemoteInstitutionKinds/:id/subsector",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.RemoteSubSector#modelName
        * @propertyOf lbServices.RemoteSubSector
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RemoteSubSector`.
        */
        R.modelName = "RemoteSubSector";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RemoteSector
 * @header lbServices.RemoteSector
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RemoteSector` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RemoteSector",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/RemoteSectors/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.RemoteSector#find
             * @methodOf lbServices.RemoteSector
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteSector` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/RemoteSectors",
              method: "GET",
            },

            // INTERNAL. Use RemoteInstitutionKind.sector() instead.
            "::get::RemoteInstitutionKind::sector": {
              url: urlBase + "/RemoteInstitutionKinds/:id/sector",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.RemoteSector#modelName
        * @propertyOf lbServices.RemoteSector
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RemoteSector`.
        */
        R.modelName = "RemoteSector";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RemoteInstitutionKind
 * @header lbServices.RemoteInstitutionKind
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RemoteInstitutionKind` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RemoteInstitutionKind",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/RemoteInstitutionKinds/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use RemoteInstitutionKind.subsector() instead.
            "prototype$__get__subsector": {
              url: urlBase + "/RemoteInstitutionKinds/:id/subsector",
              method: "GET",
            },

            // INTERNAL. Use RemoteInstitutionKind.sector() instead.
            "prototype$__get__sector": {
              url: urlBase + "/RemoteInstitutionKinds/:id/sector",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RemoteInstitutionKind#find
             * @methodOf lbServices.RemoteInstitutionKind
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteInstitutionKind` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/RemoteInstitutionKinds",
              method: "GET",
            },

            // INTERNAL. Use RemoteCompany.tipoInstitucion() instead.
            "::get::RemoteCompany::tipoInstitucion": {
              url: urlBase + "/RemoteCompanies/:id/tipoInstitucion",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.RemoteInstitutionKind#modelName
        * @propertyOf lbServices.RemoteInstitutionKind
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RemoteInstitutionKind`.
        */
        R.modelName = "RemoteInstitutionKind";


            /**
             * @ngdoc method
             * @name lbServices.RemoteInstitutionKind#subsector
             * @methodOf lbServices.RemoteInstitutionKind
             *
             * @description
             *
             * Capta la relación belongsTo subsector.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RemoteInstitutionKind id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteSubSector` object.)
             * </em>
             */
        R.subsector = function() {
          var TargetResource = $injector.get("RemoteSubSector");
          var action = TargetResource["::get::RemoteInstitutionKind::subsector"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RemoteInstitutionKind#sector
             * @methodOf lbServices.RemoteInstitutionKind
             *
             * @description
             *
             * Capta la relación belongsTo sector.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RemoteInstitutionKind id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RemoteSector` object.)
             * </em>
             */
        R.sector = function() {
          var TargetResource = $injector.get("RemoteSector");
          var action = TargetResource["::get::RemoteInstitutionKind::sector"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Company
 * @header lbServices.Company
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Company` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Company",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/company/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Company.administrators.link() instead.
            "prototype$__link__administrators": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/company/:id/administrators/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.administrators.unlink() instead.
            "prototype$__unlink__administrators": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/company/:id/administrators/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.administrators() instead.
            "prototype$__get__administrators": {
              isArray: true,
              url: urlBase + "/company/:id/administrators",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#findById
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/company/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#find
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/company",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#count
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/company/count",
              method: "GET",
            },

            // INTERNAL. Use UserEntity.notificationCompanies.link() instead.
            "::link::UserEntity::notificationCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/user/:id/notificationCompanies/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use UserEntity.notificationCompanies.unlink() instead.
            "::unlink::UserEntity::notificationCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/user/:id/notificationCompanies/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use UserEntity.notificationCompanies() instead.
            "::get::UserEntity::notificationCompanies": {
              isArray: true,
              url: urlBase + "/user/:id/notificationCompanies",
              method: "GET",
            },

            // INTERNAL. Use Project.company() instead.
            "::get::Project::company": {
              url: urlBase + "/project/:id/company",
              method: "GET",
            },

            // INTERNAL. Use UserAssociated.company() instead.
            "::get::UserAssociated::company": {
              url: urlBase + "/user-associated/:id/company",
              method: "GET",
            },

            // INTERNAL. Use UserAssociated.company.create() instead.
            "::create::UserAssociated::company": {
              url: urlBase + "/user-associated/:id/company",
              method: "POST",
            },

            // INTERNAL. Use UserAssociated.company.createMany() instead.
            "::createMany::UserAssociated::company": {
              isArray: true,
              url: urlBase + "/user-associated/:id/company",
              method: "POST",
            },

            // INTERNAL. Use UserAssociated.company.update() instead.
            "::update::UserAssociated::company": {
              url: urlBase + "/user-associated/:id/company",
              method: "PUT",
            },

            // INTERNAL. Use Article.company() instead.
            "::get::Article::company": {
              url: urlBase + "/article/:id/company",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Company#modelName
        * @propertyOf lbServices.Company
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Company`.
        */
        R.modelName = "Company";

    /**
     * @ngdoc object
     * @name lbServices.Company.administrators
     * @header lbServices.Company.administrators
     * @object
     * @description
     *
     * The object `Company.administrators` groups methods
     * manipulating `UserEntity` instances related to `Company`.
     *
     * Call {@link lbServices.Company#administrators Company.administrators()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Company#administrators
             * @methodOf lbServices.Company
             *
             * @description
             *
             * administrators consultas de Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
        R.administrators = function() {
          var TargetResource = $injector.get("UserEntity");
          var action = TargetResource["::get::Company::administrators"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.administrators#link
             * @methodOf lbServices.Company.administrators
             *
             * @description
             *
             * Añadir un elemento relacionado por id para administrators.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `fk` – `{*}` - Clave foránea para administrators
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserEntity` object.)
             * </em>
             */
        R.administrators.link = function() {
          var TargetResource = $injector.get("UserEntity");
          var action = TargetResource["::link::Company::administrators"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.administrators#unlink
             * @methodOf lbServices.Company.administrators
             *
             * @description
             *
             * Eliminar la relación administrators con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para administrators
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.administrators.unlink = function() {
          var TargetResource = $injector.get("UserEntity");
          var action = TargetResource["::unlink::Company::administrators"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserAssociated
 * @header lbServices.UserAssociated
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserAssociated` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserAssociated",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/user-associated/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use UserAssociated.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/user-associated/:id/company",
              method: "GET",
            },

            // INTERNAL. Use UserAssociated.company.create() instead.
            "prototype$__create__company": {
              url: urlBase + "/user-associated/:id/company",
              method: "POST",
            },

            // INTERNAL. Use UserAssociated.company.update() instead.
            "prototype$__update__company": {
              url: urlBase + "/user-associated/:id/company",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#create
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/user-associated",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#findById
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/user-associated/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#replaceById
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/user-associated/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#find
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/user-associated",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#count
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/user-associated/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#prototype$patchAttributes
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserAssociated id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/user-associated/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#login
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * El cuerpo de respuesta contiene propiedades de la AccessToken creada durante el inicio de la sesión.
             * Dependiendo del valor del parámetro `include`, el cuerpo puede contener propiedades adicionales:
             *   - `user` - `U+007BUserU+007D` - Datos del usuario conectado actualmente. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/user-associated/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#logout
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/user-associated/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#destroyMultiple
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/user-associated",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#sendNewPassword
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Generate new password and send by email
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "sendNewPassword": {
              url: urlBase + "/user-associated/:id/send-new-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#showPassword
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Show user associated plain password
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `password` – `{string=}` -
             */
            "showPassword": {
              url: urlBase + "/user-associated/:id/show-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#exportExcel
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Export excel file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "exportExcel": {
              url: urlBase + "/user-associated/export-excel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#getProjects
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Get projects of user
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{number}` -
             *
             *  - `search` – `{string=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "getProjects": {
              isArray: true,
              url: urlBase + "/user-associated/:id/projects",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#sendPassword
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Send password
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `username` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "sendPassword": {
              url: urlBase + "/user-associated/send-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#advancedSearch
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Get list of user associated by filters
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "advancedSearch": {
              isArray: true,
              url: urlBase + "/user-associated/advanced-search",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#advancedCount
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Count user associated by filters
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{integer=}` -
             */
            "advancedCount": {
              url: urlBase + "/user-associated/advanced-count",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#createMany
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/user-associated",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#getCurrent
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/user-associated" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#prototype$updateAttributes
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserAssociated id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UserAssociated` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.UserAssociated#getCachedCurrent
         * @methodOf lbServices.UserAssociated
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.UserAssociated#login} or
         * {@link lbServices.UserAssociated#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A UserAssociated instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.UserAssociated#isAuthenticated
         * @methodOf lbServices.UserAssociated
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.UserAssociated#getCurrentId
         * @methodOf lbServices.UserAssociated
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.UserAssociated#modelName
        * @propertyOf lbServices.UserAssociated
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserAssociated`.
        */
        R.modelName = "UserAssociated";

    /**
     * @ngdoc object
     * @name lbServices.UserAssociated.company
     * @header lbServices.UserAssociated.company
     * @object
     * @description
     *
     * The object `UserAssociated.company` groups methods
     * manipulating `Company` instances related to `UserAssociated`.
     *
     * Call {@link lbServices.UserAssociated#company UserAssociated.company()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.UserAssociated#company
             * @methodOf lbServices.UserAssociated
             *
             * @description
             *
             * Capta la relación hasOne company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserAssociated id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::UserAssociated::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated.company#create
             * @methodOf lbServices.UserAssociated.company
             *
             * @description
             *
             * Crea una nueva instancia en company de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserAssociated id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company.create = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::create::UserAssociated::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated.company#createMany
             * @methodOf lbServices.UserAssociated.company
             *
             * @description
             *
             * Crea una nueva instancia en company de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserAssociated id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company.createMany = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::createMany::UserAssociated::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.UserAssociated.company#update
             * @methodOf lbServices.UserAssociated.company
             *
             * @description
             *
             * Actualizar company de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UserAssociated id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company.update = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::update::UserAssociated::company"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Container
 * @header lbServices.Container
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Container` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Container",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/container/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Container#getContainers
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "getContainers": {
              isArray: true,
              url: urlBase + "/container",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#download
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "download": {
              url: urlBase + "/container/:container/download/:file",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Container#modelName
        * @propertyOf lbServices.Container
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Container`.
        */
        R.modelName = "Container";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Files
 * @header lbServices.Files
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Files` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Files",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/files/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Files#find
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Files#deleteById
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/files/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Files#count
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/files/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Files#prototype$patchAttributes
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Files id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/files/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Files#upload
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Upload files.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `options` – `{object=}` -
             *
             *  - `container` – `{string}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
            "upload": {
              url: urlBase + "/files/:container/upload",
              method: "POST",
            },

            // INTERNAL. Use Sector.imageMarker() instead.
            "::get::Sector::imageMarker": {
              url: urlBase + "/sector/:id/imageMarker",
              method: "GET",
            },

            // INTERNAL. Use Sector.imageLogo() instead.
            "::get::Sector::imageLogo": {
              url: urlBase + "/sector/:id/imageLogo",
              method: "GET",
            },

            // INTERNAL. Use Project.images.findById() instead.
            "::findById::Project::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.images.destroyById() instead.
            "::destroyById::Project::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.images.updateById() instead.
            "::updateById::Project::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.images.link() instead.
            "::link::Project::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.images.unlink() instead.
            "::unlink::Project::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.images.exists() instead.
            "::exists::Project::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/images/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.avatar() instead.
            "::get::Project::avatar": {
              url: urlBase + "/project/:id/avatar",
              method: "GET",
            },

            // INTERNAL. Use Project.images() instead.
            "::get::Project::images": {
              isArray: true,
              url: urlBase + "/project/:id/images",
              method: "GET",
            },

            // INTERNAL. Use Project.images.create() instead.
            "::create::Project::images": {
              url: urlBase + "/project/:id/images",
              method: "POST",
            },

            // INTERNAL. Use Project.images.createMany() instead.
            "::createMany::Project::images": {
              isArray: true,
              url: urlBase + "/project/:id/images",
              method: "POST",
            },

            // INTERNAL. Use Project.images.destroyAll() instead.
            "::delete::Project::images": {
              url: urlBase + "/project/:id/images",
              method: "DELETE",
            },

            // INTERNAL. Use Project.images.count() instead.
            "::count::Project::images": {
              url: urlBase + "/project/:id/images/count",
              method: "GET",
            },

            // INTERNAL. Use Objective.image() instead.
            "::get::Objective::image": {
              url: urlBase + "/objective/:id/image",
              method: "GET",
            },

            // INTERNAL. Use Banner.imageWeb() instead.
            "::get::Banner::imageWeb": {
              url: urlBase + "/banner/:id/imageWeb",
              method: "GET",
            },

            // INTERNAL. Use Banner.imageMobile() instead.
            "::get::Banner::imageMobile": {
              url: urlBase + "/banner/:id/imageMobile",
              method: "GET",
            },

            // INTERNAL. Use Image.imageWeb() instead.
            "::get::Image::imageWeb": {
              url: urlBase + "/image/:id/imageWeb",
              method: "GET",
            },

            // INTERNAL. Use Image.imageMobile() instead.
            "::get::Image::imageMobile": {
              url: urlBase + "/image/:id/imageMobile",
              method: "GET",
            },

            // INTERNAL. Use Article.avatar() instead.
            "::get::Article::avatar": {
              url: urlBase + "/article/:id/avatar",
              method: "GET",
            },

            // INTERNAL. Use Article.images.findById() instead.
            "::findById::Article::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/:fk",
              method: "GET",
            },

            // INTERNAL. Use Article.images.destroyById() instead.
            "::destroyById::Article::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Article.images.updateById() instead.
            "::updateById::Article::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Article.images.link() instead.
            "::link::Article::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Article.images.unlink() instead.
            "::unlink::Article::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Article.images.exists() instead.
            "::exists::Article::images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Article.images() instead.
            "::get::Article::images": {
              isArray: true,
              url: urlBase + "/article/:id/images",
              method: "GET",
            },

            // INTERNAL. Use Article.images.create() instead.
            "::create::Article::images": {
              url: urlBase + "/article/:id/images",
              method: "POST",
            },

            // INTERNAL. Use Article.images.createMany() instead.
            "::createMany::Article::images": {
              isArray: true,
              url: urlBase + "/article/:id/images",
              method: "POST",
            },

            // INTERNAL. Use Article.images.destroyAll() instead.
            "::delete::Article::images": {
              url: urlBase + "/article/:id/images",
              method: "DELETE",
            },

            // INTERNAL. Use Article.images.count() instead.
            "::count::Article::images": {
              url: urlBase + "/article/:id/images/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Files#destroyById
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Files#removeById
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Files#prototype$updateAttributes
             * @methodOf lbServices.Files
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Files id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Files#modelName
        * @propertyOf lbServices.Files
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Files`.
        */
        R.modelName = "Files";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Subscription
 * @header lbServices.Subscription
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Subscription` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Subscription",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/subscription/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Subscription#create
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/subscription",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#findById
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/subscription/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#find
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/subscription",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#count
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/subscription/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$patchAttributes
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/subscription/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#destroyMultiple
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/subscription",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#resend
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Resend subscription confirmation email
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "resend": {
              url: urlBase + "/subscription/:id/resend",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#exportExcel
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Export excel file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "exportExcel": {
              url: urlBase + "/subscription/export-excel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#importExcel
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Import excel file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `options` – `{object=}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "importExcel": {
              url: urlBase + "/subscription/import-excel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#confirm
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Confirm subscription
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `token` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/subscription/confirm/:token",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#createSubscription
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Create subscription
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "createSubscription": {
              url: urlBase + "/subscription/create-subscription",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Subscription#createMany
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/subscription",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Subscription#prototype$updateAttributes
             * @methodOf lbServices.Subscription
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Subscription id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Subscription` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Subscription#modelName
        * @propertyOf lbServices.Subscription
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Subscription`.
        */
        R.modelName = "Subscription";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Email
 * @header lbServices.Email
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Email` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Email",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Emails/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Email#modelName
        * @propertyOf lbServices.Email
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Email`.
        */
        R.modelName = "Email";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Bulletin
 * @header lbServices.Bulletin
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Bulletin` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Bulletin",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/bulletin/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#create
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/bulletin",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#patchOrCreate
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/bulletin",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#replaceOrCreate
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/bulletin/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#upsertWithWhere
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/bulletin/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#exists
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/bulletin/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#findById
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/bulletin/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#replaceById
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/bulletin/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#find
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/bulletin",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#findOne
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/bulletin/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#updateAll
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/bulletin/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#deleteById
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/bulletin/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#count
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/bulletin/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#prototype$patchAttributes
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bulletin id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/bulletin/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#createChangeStream
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/bulletin/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#destroyMultiple
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/bulletin",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#preview
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Get preview of bulletin.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `projects` – `{*=}` - Bulletin project ids.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "preview": {
              url: urlBase + "/bulletin/preview",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#getStatus
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Get delivery status.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `id` – `{string}` - bulletin Id.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "getStatus": {
              url: urlBase + "/bulletin/:id/status",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#createMany
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/bulletin",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Bulletin#upsert
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#updateOrCreate
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#patchOrCreateWithWhere
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#update
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#destroyById
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#removeById
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Bulletin#prototype$updateAttributes
             * @methodOf lbServices.Bulletin
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bulletin id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bulletin` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Bulletin#modelName
        * @propertyOf lbServices.Bulletin
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Bulletin`.
        */
        R.modelName = "Bulletin";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.District
 * @header lbServices.District
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `District` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "District",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/district/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use District.province() instead.
            "prototype$__get__province": {
              url: urlBase + "/district/:id/province",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#create
             * @methodOf lbServices.District
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/district",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#findById
             * @methodOf lbServices.District
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/district/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#find
             * @methodOf lbServices.District
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/district",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#count
             * @methodOf lbServices.District
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/district/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#prototype$patchAttributes
             * @methodOf lbServices.District
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - District id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/district/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#destroyMultiple
             * @methodOf lbServices.District
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/district",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.District#createMany
             * @methodOf lbServices.District
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/district",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.District#prototype$updateAttributes
             * @methodOf lbServices.District
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - District id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `District` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.District#modelName
        * @propertyOf lbServices.District
        * @description
        * The name of the model represented by this $resource,
        * i.e. `District`.
        */
        R.modelName = "District";


            /**
             * @ngdoc method
             * @name lbServices.District#province
             * @methodOf lbServices.District
             *
             * @description
             *
             * Capta la relación belongsTo province.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - District id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Province` object.)
             * </em>
             */
        R.province = function() {
          var TargetResource = $injector.get("Province");
          var action = TargetResource["::get::District::province"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ProjectModel
 * @header lbServices.ProjectModel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ProjectModel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ProjectModel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ProjectModels/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.ProjectModel#modelName
        * @propertyOf lbServices.ProjectModel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ProjectModel`.
        */
        R.modelName = "ProjectModel";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Banner
 * @header lbServices.Banner
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Banner` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Banner",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/banner/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Banner.imageWeb() instead.
            "prototype$__get__imageWeb": {
              url: urlBase + "/banner/:id/imageWeb",
              method: "GET",
            },

            // INTERNAL. Use Banner.imageMobile() instead.
            "prototype$__get__imageMobile": {
              url: urlBase + "/banner/:id/imageMobile",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#create
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/banner",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#patchOrCreate
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/banner",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#replaceOrCreate
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/banner/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#upsertWithWhere
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/banner/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#exists
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/banner/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#findById
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/banner/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#replaceById
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/banner/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#find
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/banner",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#findOne
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/banner/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#updateAll
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/banner/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#deleteById
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/banner/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#count
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/banner/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#prototype$patchAttributes
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Banner id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/banner/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#createChangeStream
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/banner/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#destroyMultiple
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/banner",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Banner#createMany
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/banner",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Banner#upsert
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Banner#updateOrCreate
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Banner#patchOrCreateWithWhere
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Banner#update
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Banner#destroyById
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Banner#removeById
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Banner#prototype$updateAttributes
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Banner id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Banner` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Banner#modelName
        * @propertyOf lbServices.Banner
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Banner`.
        */
        R.modelName = "Banner";


            /**
             * @ngdoc method
             * @name lbServices.Banner#imageWeb
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Capta la relación belongsTo imageWeb.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Banner id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.imageWeb = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Banner::imageWeb"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Banner#imageMobile
             * @methodOf lbServices.Banner
             *
             * @description
             *
             * Capta la relación belongsTo imageMobile.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Banner id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.imageMobile = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Banner::imageMobile"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Image
 * @header lbServices.Image
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Image` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Image",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/image/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Image.imageWeb() instead.
            "prototype$__get__imageWeb": {
              url: urlBase + "/image/:id/imageWeb",
              method: "GET",
            },

            // INTERNAL. Use Image.imageMobile() instead.
            "prototype$__get__imageMobile": {
              url: urlBase + "/image/:id/imageMobile",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#create
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/image",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#patchOrCreate
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/image",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#replaceOrCreate
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/image/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#upsertWithWhere
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/image/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#exists
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/image/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#findById
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/image/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#replaceById
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/image/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#find
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/image",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#findOne
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/image/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#updateAll
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/image/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#deleteById
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/image/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#count
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/image/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#prototype$patchAttributes
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Image id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/image/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#createChangeStream
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/image/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#destroyMultiple
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/image",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Image#createMany
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/image",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Image#upsert
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Image#updateOrCreate
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Image#patchOrCreateWithWhere
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Image#update
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Image#destroyById
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Image#removeById
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Image#prototype$updateAttributes
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Image id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Image` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Image#modelName
        * @propertyOf lbServices.Image
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Image`.
        */
        R.modelName = "Image";


            /**
             * @ngdoc method
             * @name lbServices.Image#imageWeb
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Capta la relación belongsTo imageWeb.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Image id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.imageWeb = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Image::imageWeb"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Image#imageMobile
             * @methodOf lbServices.Image
             *
             * @description
             *
             * Capta la relación belongsTo imageMobile.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Image id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.imageMobile = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Image::imageMobile"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ProjectFilterParamsModel
 * @header lbServices.ProjectFilterParamsModel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ProjectFilterParamsModel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ProjectFilterParamsModel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ProjectFilterParamsModels/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.ProjectFilterParamsModel#modelName
        * @propertyOf lbServices.ProjectFilterParamsModel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ProjectFilterParamsModel`.
        */
        R.modelName = "ProjectFilterParamsModel";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Update
 * @header lbServices.Update
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Update` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Update",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/update/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Update.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/update/:id/project",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#create
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#findById
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/update/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#find
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/update",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#count
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/update/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#prototype$patchAttributes
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Update id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/update/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#destroyMultiple
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/update",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Update#createMany
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/update",
              method: "POST",
            },

            // INTERNAL. Use Project.updates.findById() instead.
            "::findById::Project::updates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/updates/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.updates.destroyById() instead.
            "::destroyById::Project::updates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/updates/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.updates.updateById() instead.
            "::updateById::Project::updates": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/project/:id/updates/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.updates() instead.
            "::get::Project::updates": {
              isArray: true,
              url: urlBase + "/project/:id/updates",
              method: "GET",
            },

            // INTERNAL. Use Project.updates.create() instead.
            "::create::Project::updates": {
              url: urlBase + "/project/:id/updates",
              method: "POST",
            },

            // INTERNAL. Use Project.updates.createMany() instead.
            "::createMany::Project::updates": {
              isArray: true,
              url: urlBase + "/project/:id/updates",
              method: "POST",
            },

            // INTERNAL. Use Project.updates.destroyAll() instead.
            "::delete::Project::updates": {
              url: urlBase + "/project/:id/updates",
              method: "DELETE",
            },

            // INTERNAL. Use Project.updates.count() instead.
            "::count::Project::updates": {
              url: urlBase + "/project/:id/updates/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Update#prototype$updateAttributes
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Update id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Update` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Update#modelName
        * @propertyOf lbServices.Update
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Update`.
        */
        R.modelName = "Update";


            /**
             * @ngdoc method
             * @name lbServices.Update#project
             * @methodOf lbServices.Update
             *
             * @description
             *
             * Capta la relación belongsTo project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Update id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::get::Update::project"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ContactFormModel
 * @header lbServices.ContactFormModel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ContactFormModel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ContactFormModel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ContactFormModels/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.ContactFormModel#modelName
        * @propertyOf lbServices.ContactFormModel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ContactFormModel`.
        */
        R.modelName = "ContactFormModel";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UserAssociatedFilterParamsModel
 * @header lbServices.UserAssociatedFilterParamsModel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UserAssociatedFilterParamsModel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UserAssociatedFilterParamsModel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/UserAssociatedFilterParamsModels/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.UserAssociatedFilterParamsModel#modelName
        * @propertyOf lbServices.UserAssociatedFilterParamsModel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UserAssociatedFilterParamsModel`.
        */
        R.modelName = "UserAssociatedFilterParamsModel";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Article
 * @header lbServices.Article
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Article` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Article",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/article/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Article.avatar() instead.
            "prototype$__get__avatar": {
              url: urlBase + "/article/:id/avatar",
              method: "GET",
            },

            // INTERNAL. Use Article.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/article/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Article.sector() instead.
            "prototype$__get__sector": {
              url: urlBase + "/article/:id/sector",
              method: "GET",
            },

            // INTERNAL. Use Article.images.findById() instead.
            "prototype$__findById__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/:fk",
              method: "GET",
            },

            // INTERNAL. Use Article.images.destroyById() instead.
            "prototype$__destroyById__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Article.images.updateById() instead.
            "prototype$__updateById__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Article.images.link() instead.
            "prototype$__link__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Article.images.unlink() instead.
            "prototype$__unlink__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Article.images.exists() instead.
            "prototype$__exists__images": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/images/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__findById__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Buscar un elemento relacionado por id para articleImages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para articleImages
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "prototype$__findById__articleImages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/articleImages/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__destroyById__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para articleImages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para articleImages
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__articleImages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/articleImages/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__updateById__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para articleImages.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `fk` – `{*}` - Clave foránea para articleImages
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "prototype$__updateById__articleImages": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/article/:id/articleImages/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Article.images() instead.
            "prototype$__get__images": {
              isArray: true,
              url: urlBase + "/article/:id/images",
              method: "GET",
            },

            // INTERNAL. Use Article.images.create() instead.
            "prototype$__create__images": {
              url: urlBase + "/article/:id/images",
              method: "POST",
            },

            // INTERNAL. Use Article.images.destroyAll() instead.
            "prototype$__delete__images": {
              url: urlBase + "/article/:id/images",
              method: "DELETE",
            },

            // INTERNAL. Use Article.images.count() instead.
            "prototype$__count__images": {
              url: urlBase + "/article/:id/images/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__get__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * articleImages consultas de Article.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "prototype$__get__articleImages": {
              isArray: true,
              url: urlBase + "/article/:id/articleImages",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__create__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Crea una nueva instancia en articleImages de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "prototype$__create__articleImages": {
              url: urlBase + "/article/:id/articleImages",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__delete__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Suprime todos los articleImages de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__articleImages": {
              url: urlBase + "/article/:id/articleImages",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$__count__articleImages
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Recuentos articleImages de Article.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__articleImages": {
              url: urlBase + "/article/:id/articleImages/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#create
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/article",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#findById
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/article/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#find
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/article",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#count
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/article/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$patchAttributes
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/article/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#changePublishedDate
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Change article published date
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{number}` -
             *
             *  - `publishedDate` – `{date}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePublishedDate": {
              url: urlBase + "/article/:id/published-date",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#findPublishedBySlug
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Find article by slug.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `slug` – `{string}` - Article slug.
             *
             *  - `filter` – `{object=}` - Article filter.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "findPublishedBySlug": {
              url: urlBase + "/article/find-published-by-slug/:slug",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#destroyMultiple
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Delete multiple records using an array of ids
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "destroyMultiple": {
              url: urlBase + "/article",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Article#createMany
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/article",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Article#prototype$updateAttributes
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Article` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Article#modelName
        * @propertyOf lbServices.Article
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Article`.
        */
        R.modelName = "Article";


            /**
             * @ngdoc method
             * @name lbServices.Article#avatar
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Capta la relación belongsTo avatar.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.avatar = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Article::avatar"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article#company
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Capta la relación belongsTo company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::Article::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article#sector
             * @methodOf lbServices.Article
             *
             * @description
             *
             * Capta la relación belongsTo sector.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sector` object.)
             * </em>
             */
        R.sector = function() {
          var TargetResource = $injector.get("Sector");
          var action = TargetResource["::get::Article::sector"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Article.images
     * @header lbServices.Article.images
     * @object
     * @description
     *
     * The object `Article.images` groups methods
     * manipulating `Files` instances related to `Article`.
     *
     * Call {@link lbServices.Article#images Article.images()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Article#images
             * @methodOf lbServices.Article
             *
             * @description
             *
             * images consultas de Article.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::get::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#count
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Recuentos images de Article.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.images.count = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::count::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#create
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Crea una nueva instancia en images de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.create = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::create::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#createMany
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Crea una nueva instancia en images de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.createMany = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::createMany::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#destroyAll
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Suprime todos los images de este modelo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.images.destroyAll = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::delete::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#destroyById
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Suprimir un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.images.destroyById = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::destroyById::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#exists
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Comprobar la existencia de la relación images con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.exists = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::exists::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#findById
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Buscar un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.findById = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::findById::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#link
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Añadir un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.link = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::link::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#unlink
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Eliminar la relación images con un elemento por id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.images.unlink = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::unlink::Article::images"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Article.images#updateById
             * @methodOf lbServices.Article.images
             *
             * @description
             *
             * Actualizar un elemento relacionado por id para images.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Article id
             *
             *  - `fk` – `{*}` - Clave foránea para images
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Files` object.)
             * </em>
             */
        R.images.updateById = function() {
          var TargetResource = $injector.get("Files");
          var action = TargetResource["::updateById::Article::images"];
          return action.apply(R, arguments);
        };


        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && config.url.indexOf(urlBaseHost) === -1) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .service('projectFieldUtils', projectFieldUtils);

    /** @ngInject */
    function projectFieldUtils($rootScope, projectFieldVisibility, projectFieldValidation, LoopBackAuth, UserAssociated) {
        this.isVisible = function (fieldName) {
            return !!(this.isPublic(fieldName) || (this.isPrivate(fieldName) && UserAssociated.isAuthenticated()));
        };
        this.isVisibleSomeItem = function (fieldNames) {
            if (Array.isArray(fieldNames)) {
                for (var i = 0; i < fieldNames.length; i++) {
                    if (this.isVisible(fieldNames[i])) {
                        return true;
                    }
                }
            } else {
                console.log('Fieldnames array expected.');
            }
            return false;
        };
        this.isPrivate = function (fieldName) {
            return this.getVisibility(fieldName) === projectFieldVisibility.PRIVATE;
        };
        this.isPublic = function (fieldName) {
            return this.getVisibility(fieldName) === projectFieldVisibility.PUBLIC;
        };
        this.isHidden = function (fieldName) {
            return this.getVisibility(fieldName) === projectFieldVisibility.HIDDEN;
        };
        this.getVisibility = function (fieldName) {
            return ($rootScope.currentConfig &&
                $rootScope.currentConfig.project &&
                $rootScope.currentConfig.project[fieldName] &&
                $rootScope.currentConfig.project[fieldName].visibility) ?
                $rootScope.currentConfig.project[fieldName].visibility :
                undefined;
        };
        this.getValidation = function (fieldName) {
            return ($rootScope.currentConfig &&
                $rootScope.currentConfig.project &&
                $rootScope.currentConfig.project[fieldName] &&
                $rootScope.currentConfig.project[fieldName].validation) ?
                $rootScope.currentConfig.project[fieldName].validation :
                undefined;
        };
        this.isRequired = function (fieldName) {
            return this.getValidation(fieldName) === projectFieldValidation.REQUIRED;
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .factory('PubSub', PubSub);

    /** @ngInject */
    function PubSub(socket) {
        var container = [];
        return {
            subscribe: function (options, callback) {
                if (options) {
                    var collectionName = options.collectionName;
                    var modelId = options.modelId;
                    var method = options.method;
                    if (method === 'POST') {
                        var name = '/' + collectionName + '/' + method;
                        socket.on(name, callback);
                    }
                    else {
                        var name = '/' + collectionName + '/' + modelId + '/' + method;
                        socket.on(name, callback);
                    }
                    //Push the container..
                    this.pushContainer(name);
                } else {
                    throw 'Error: Option must be an object';
                }
            }, //end subscribe

            pushContainer: function (subscriptionName) {
                container.push(subscriptionName);
            },

            //Unsubscribe all containers..
            unSubscribeAll: function () {
                for (var i = 0; i < container.length; i++) {
                    socket.removeAllListeners(container[i]);
                }
                //Now reset the container..
                container = [];
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .factory('socket', socket);

    /** @ngInject */
    function socket(LoopBackAuth, pdConfig) {

        var socket = io(pdConfig.apiWsBase, {
            'reconnection': true,
            'reconnectionDelay': 500,
            'forceNew': true,
            'transports': ['websocket'],
        });

        var id = LoopBackAuth.accessTokenId;
        var userId = LoopBackAuth.currentUserId;
        socket.on('connect', function () {

            console.log('Socket connected');

            socket.emit('authentication', {id: id, userId: userId});
            socket.on('authenticated', function () {
                console.log('User is authenticated');
            });
        });
        socket.on('disconnect', function () {
            console.log('Socket disconnected');
        });
        socket.on('reconnecting', function (attemptNumber) {
            console.log('Socket reconnecting, attempt:', attemptNumber);
        });
        return socket;
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .service('validationUtils', validationUtils);

    /** @ngInject */
    function validationUtils(toastr, messagesHelper, errorCodes) {

        this.isValidEmail = function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        };

        this.hasUniquenessError = function (errorResponse, fieldName) {
            return errorResponse &&
                errorResponse.data &&
                errorResponse.data.error &&
                errorResponse.data.error.details &&
                errorResponse.data.error.details.codes &&
                errorResponse.data.error.details.codes[fieldName] &&
                errorResponse.data.error.details.codes[fieldName].indexOf('uniqueness') !== 1;

        };

        this.processErrorResponse = function (errorResponse) {
            var code = errorResponse &&
            errorResponse.data &&
            errorResponse.data.error &&
            errorResponse.data.error.code
                ? errorResponse.data.error.code : null;

            toastr.clear();
            switch (code) {
                case errorCodes.AVOID_SELF_DELETION:
                    toastr.error(messagesHelper.not_allowed_self_deletion);
                    break;
                case errorCodes.MODEL_NOT_FOUND:
                    toastr.error(messagesHelper.resource_does_not_exists);
                    break;
                case errorCodes.INVALID_TOKEN:
                    toastr.error(messagesHelper.invalid_token);
                    break;
                case errorCodes.EMPTY_SUBSCRIPTION_ADDRESSES:
                    toastr.error(messagesHelper.empty_subscription_addresses);
                    break;
                case errorCodes.INVALID_PROJECT:
                    toastr.error(messagesHelper.invalid_project);
                    break;
                default:
                    toastr.error(messagesHelper.fail_operation);
            }

        };

        this.inRange = function (min, number, max) {
            return !isNaN(number) && (number >= min) && (number <= max);
        };

        this.isValidLatitude = function (value) {
            if (value === null) {
                return false;
            }
            return this.inRange(-90, value, 90);
        };

        this.isValidLongitude = function (value) {
            if (value === null) {
                return false;
            }
            return this.inRange(-180, value, 180)
        };
    }
})();

/*!
 * html2canvas 1.0.0-rc.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2019 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
!function(A,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.html2canvas=e():A.html2canvas=e()}(window,function(){return function(A){var e={};function t(r){if(e[r])return e[r].exports;var n=e[r]={i:r,l:!1,exports:{}};return A[r].call(n.exports,n,n.exports,t),n.l=!0,n.exports}return t.m=A,t.c=e,t.d=function(A,e,r){t.o(A,e)||Object.defineProperty(A,e,{enumerable:!0,get:r})},t.r=function(A){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(A,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(A,"__esModule",{value:!0})},t.t=function(A,e){if(1&e&&(A=t(A)),8&e)return A;if(4&e&&"object"==typeof A&&A&&A.__esModule)return A;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:A}),2&e&&"string"!=typeof A)for(var n in A)t.d(r,n,function(e){return A[e]}.bind(null,n));return r},t.n=function(A){var e=A&&A.__esModule?function(){return A.default}:function(){return A};return t.d(e,"a",e),e},t.o=function(A,e){return Object.prototype.hasOwnProperty.call(A,e)},t.p="",t(t.s=5)}([function(A,e,t){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=t(1);Object.defineProperty(e,"toCodePoints",{enumerable:!0,get:function(){return r.toCodePoints}}),Object.defineProperty(e,"fromCodePoint",{enumerable:!0,get:function(){return r.fromCodePoint}});var n=t(2);Object.defineProperty(e,"LineBreaker",{enumerable:!0,get:function(){return n.LineBreaker}})},function(A,e,t){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.toCodePoints=function(A){for(var e=[],t=0,r=A.length;t<r;){var n=A.charCodeAt(t++);if(n>=55296&&n<=56319&&t<r){var B=A.charCodeAt(t++);56320==(64512&B)?e.push(((1023&n)<<10)+(1023&B)+65536):(e.push(n),t--)}else e.push(n)}return e},e.fromCodePoint=function(){if(String.fromCodePoint)return String.fromCodePoint.apply(String,arguments);var A=arguments.length;if(!A)return"";for(var e=[],t=-1,r="";++t<A;){var n=arguments.length<=t?void 0:arguments[t];n<=65535?e.push(n):(n-=65536,e.push(55296+(n>>10),n%1024+56320)),(t+1===A||e.length>16384)&&(r+=String.fromCharCode.apply(String,e),e.length=0)}return r};for(var r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",n="undefined"==typeof Uint8Array?[]:new Uint8Array(256),B=0;B<r.length;B++)n[r.charCodeAt(B)]=B;e.decode=function(A){var e=.75*A.length,t=A.length,r=void 0,B=0,s=void 0,o=void 0,a=void 0,i=void 0;"="===A[A.length-1]&&(e--,"="===A[A.length-2]&&e--);var c="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array&&void 0!==Uint8Array.prototype.slice?new ArrayBuffer(e):new Array(e),Q=Array.isArray(c)?c:new Uint8Array(c);for(r=0;r<t;r+=4)s=n[A.charCodeAt(r)],o=n[A.charCodeAt(r+1)],a=n[A.charCodeAt(r+2)],i=n[A.charCodeAt(r+3)],Q[B++]=s<<2|o>>4,Q[B++]=(15&o)<<4|a>>2,Q[B++]=(3&a)<<6|63&i;return c},e.polyUint16Array=function(A){for(var e=A.length,t=[],r=0;r<e;r+=2)t.push(A[r+1]<<8|A[r]);return t},e.polyUint32Array=function(A){for(var e=A.length,t=[],r=0;r<e;r+=4)t.push(A[r+3]<<24|A[r+2]<<16|A[r+1]<<8|A[r]);return t}},function(A,e,t){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.LineBreaker=e.inlineBreakOpportunities=e.lineBreakAtIndex=e.codePointsToCharacterClasses=e.UnicodeTrie=e.BREAK_ALLOWED=e.BREAK_NOT_ALLOWED=e.BREAK_MANDATORY=e.classes=e.LETTER_NUMBER_MODIFIER=void 0;var r=function(){function A(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}return function(e,t,r){return t&&A(e.prototype,t),r&&A(e,r),e}}(),n=function(A,e){if(Array.isArray(A))return A;if(Symbol.iterator in Object(A))return function(A,e){var t=[],r=!0,n=!1,B=void 0;try{for(var s,o=A[Symbol.iterator]();!(r=(s=o.next()).done)&&(t.push(s.value),!e||t.length!==e);r=!0);}catch(A){n=!0,B=A}finally{try{!r&&o.return&&o.return()}finally{if(n)throw B}}return t}(A,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")},B=t(3),s=function(A){return A&&A.__esModule?A:{default:A}}(t(4)),o=t(1),a=e.LETTER_NUMBER_MODIFIER=50,i=10,c=13,Q=15,l=17,w=18,u=19,U=20,g=21,F=22,C=24,h=25,d=26,H=27,f=28,E=30,p=32,K=33,m=34,b=35,N=37,y=38,v=39,I=40,D=42,M=(e.classes={BK:1,CR:2,LF:3,CM:4,NL:5,SG:6,WJ:7,ZW:8,GL:9,SP:i,ZWJ:11,B2:12,BA:c,BB:14,HY:Q,CB:16,CL:l,CP:w,EX:u,IN:U,NS:g,OP:F,QU:23,IS:C,NU:h,PO:d,PR:H,SY:f,AI:29,AL:E,CJ:31,EB:p,EM:K,H2:m,H3:b,HL:36,ID:N,JL:y,JV:v,JT:I,RI:41,SA:D,XX:43},e.BREAK_MANDATORY="!"),T=e.BREAK_NOT_ALLOWED="×",S=e.BREAK_ALLOWED="÷",X=e.UnicodeTrie=(0,B.createTrieFromBase64)(s.default),z=[E,36],L=[1,2,3,5],O=[i,8],x=[H,d],V=L.concat(O),k=[y,v,I,m,b],J=[Q,c],R=e.codePointsToCharacterClasses=function(A){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"strict",t=[],r=[],n=[];return A.forEach(function(A,B){var s=X.get(A);if(s>a?(n.push(!0),s-=a):n.push(!1),-1!==["normal","auto","loose"].indexOf(e)&&-1!==[8208,8211,12316,12448].indexOf(A))return r.push(B),t.push(16);if(4===s||11===s){if(0===B)return r.push(B),t.push(E);var o=t[B-1];return-1===V.indexOf(o)?(r.push(r[B-1]),t.push(o)):(r.push(B),t.push(E))}return r.push(B),31===s?t.push("strict"===e?g:N):s===D?t.push(E):29===s?t.push(E):43===s?A>=131072&&A<=196605||A>=196608&&A<=262141?t.push(N):t.push(E):void t.push(s)}),[r,t,n]},_=function(A,e,t,r){var n=r[t];if(Array.isArray(A)?-1!==A.indexOf(n):A===n)for(var B=t;B<=r.length;){var s=r[++B];if(s===e)return!0;if(s!==i)break}if(n===i)for(var o=t;o>0;){var a=r[--o];if(Array.isArray(A)?-1!==A.indexOf(a):A===a)for(var c=t;c<=r.length;){var Q=r[++c];if(Q===e)return!0;if(Q!==i)break}if(a!==i)break}return!1},P=function(A,e){for(var t=A;t>=0;){var r=e[t];if(r!==i)return r;t--}return 0},G=function(A,e,t,r,n){if(0===t[r])return T;var B=r-1;if(Array.isArray(n)&&!0===n[B])return T;var s=B-1,o=B+1,a=e[B],E=s>=0?e[s]:0,D=e[o];if(2===a&&3===D)return T;if(-1!==L.indexOf(a))return M;if(-1!==L.indexOf(D))return T;if(-1!==O.indexOf(D))return T;if(8===P(B,e))return S;if(11===X.get(A[B])&&(D===N||D===p||D===K))return T;if(7===a||7===D)return T;if(9===a)return T;if(-1===[i,c,Q].indexOf(a)&&9===D)return T;if(-1!==[l,w,u,C,f].indexOf(D))return T;if(P(B,e)===F)return T;if(_(23,F,B,e))return T;if(_([l,w],g,B,e))return T;if(_(12,12,B,e))return T;if(a===i)return S;if(23===a||23===D)return T;if(16===D||16===a)return S;if(-1!==[c,Q,g].indexOf(D)||14===a)return T;if(36===E&&-1!==J.indexOf(a))return T;if(a===f&&36===D)return T;if(D===U&&-1!==z.concat(U,u,h,N,p,K).indexOf(a))return T;if(-1!==z.indexOf(D)&&a===h||-1!==z.indexOf(a)&&D===h)return T;if(a===H&&-1!==[N,p,K].indexOf(D)||-1!==[N,p,K].indexOf(a)&&D===d)return T;if(-1!==z.indexOf(a)&&-1!==x.indexOf(D)||-1!==x.indexOf(a)&&-1!==z.indexOf(D))return T;if(-1!==[H,d].indexOf(a)&&(D===h||-1!==[F,Q].indexOf(D)&&e[o+1]===h)||-1!==[F,Q].indexOf(a)&&D===h||a===h&&-1!==[h,f,C].indexOf(D))return T;if(-1!==[h,f,C,l,w].indexOf(D))for(var V=B;V>=0;){var R=e[V];if(R===h)return T;if(-1===[f,C].indexOf(R))break;V--}if(-1!==[H,d].indexOf(D))for(var G=-1!==[l,w].indexOf(a)?s:B;G>=0;){var W=e[G];if(W===h)return T;if(-1===[f,C].indexOf(W))break;G--}if(y===a&&-1!==[y,v,m,b].indexOf(D)||-1!==[v,m].indexOf(a)&&-1!==[v,I].indexOf(D)||-1!==[I,b].indexOf(a)&&D===I)return T;if(-1!==k.indexOf(a)&&-1!==[U,d].indexOf(D)||-1!==k.indexOf(D)&&a===H)return T;if(-1!==z.indexOf(a)&&-1!==z.indexOf(D))return T;if(a===C&&-1!==z.indexOf(D))return T;if(-1!==z.concat(h).indexOf(a)&&D===F||-1!==z.concat(h).indexOf(D)&&a===w)return T;if(41===a&&41===D){for(var Y=t[B],q=1;Y>0&&41===e[--Y];)q++;if(q%2!=0)return T}return a===p&&D===K?T:S},W=(e.lineBreakAtIndex=function(A,e){if(0===e)return T;if(e>=A.length)return M;var t=R(A),r=n(t,2),B=r[0],s=r[1];return G(A,s,B,e)},function(A,e){e||(e={lineBreak:"normal",wordBreak:"normal"});var t=R(A,e.lineBreak),r=n(t,3),B=r[0],s=r[1],o=r[2];return"break-all"!==e.wordBreak&&"break-word"!==e.wordBreak||(s=s.map(function(A){return-1!==[h,E,D].indexOf(A)?N:A})),[B,s,"keep-all"===e.wordBreak?o.map(function(e,t){return e&&A[t]>=19968&&A[t]<=40959}):null]}),Y=(e.inlineBreakOpportunities=function(A,e){var t=(0,o.toCodePoints)(A),r=T,B=W(t,e),s=n(B,3),a=s[0],i=s[1],c=s[2];return t.forEach(function(A,e){r+=(0,o.fromCodePoint)(A)+(e>=t.length-1?M:G(t,i,a,e+1,c))}),r},function(){function A(e,t,r,n){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this._codePoints=e,this.required=t===M,this.start=r,this.end=n}return r(A,[{key:"slice",value:function(){return o.fromCodePoint.apply(void 0,function(A){if(Array.isArray(A)){for(var e=0,t=Array(A.length);e<A.length;e++)t[e]=A[e];return t}return Array.from(A)}(this._codePoints.slice(this.start,this.end)))}}]),A}());e.LineBreaker=function(A,e){var t=(0,o.toCodePoints)(A),r=W(t,e),B=n(r,3),s=B[0],a=B[1],i=B[2],c=t.length,Q=0,l=0;return{next:function(){if(l>=c)return{done:!0};for(var A=T;l<c&&(A=G(t,a,s,++l,i))===T;);if(A!==T||l===c){var e=new Y(t,A,Q,l);return Q=l,{value:e,done:!1}}return{done:!0}}}}},function(A,e,t){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.Trie=e.createTrieFromBase64=e.UTRIE2_INDEX_2_MASK=e.UTRIE2_INDEX_2_BLOCK_LENGTH=e.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH=e.UTRIE2_INDEX_1_OFFSET=e.UTRIE2_UTF8_2B_INDEX_2_LENGTH=e.UTRIE2_UTF8_2B_INDEX_2_OFFSET=e.UTRIE2_INDEX_2_BMP_LENGTH=e.UTRIE2_LSCP_INDEX_2_LENGTH=e.UTRIE2_DATA_MASK=e.UTRIE2_DATA_BLOCK_LENGTH=e.UTRIE2_LSCP_INDEX_2_OFFSET=e.UTRIE2_SHIFT_1_2=e.UTRIE2_INDEX_SHIFT=e.UTRIE2_SHIFT_1=e.UTRIE2_SHIFT_2=void 0;var r=function(){function A(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}return function(e,t,r){return t&&A(e.prototype,t),r&&A(e,r),e}}(),n=t(1),B=e.UTRIE2_SHIFT_2=5,s=e.UTRIE2_SHIFT_1=11,o=e.UTRIE2_INDEX_SHIFT=2,a=e.UTRIE2_SHIFT_1_2=s-B,i=e.UTRIE2_LSCP_INDEX_2_OFFSET=65536>>B,c=e.UTRIE2_DATA_BLOCK_LENGTH=1<<B,Q=e.UTRIE2_DATA_MASK=c-1,l=e.UTRIE2_LSCP_INDEX_2_LENGTH=1024>>B,w=e.UTRIE2_INDEX_2_BMP_LENGTH=i+l,u=e.UTRIE2_UTF8_2B_INDEX_2_OFFSET=w,U=e.UTRIE2_UTF8_2B_INDEX_2_LENGTH=32,g=e.UTRIE2_INDEX_1_OFFSET=u+U,F=e.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH=65536>>s,C=e.UTRIE2_INDEX_2_BLOCK_LENGTH=1<<a,h=e.UTRIE2_INDEX_2_MASK=C-1,d=(e.createTrieFromBase64=function(A){var e=(0,n.decode)(A),t=Array.isArray(e)?(0,n.polyUint32Array)(e):new Uint32Array(e),r=Array.isArray(e)?(0,n.polyUint16Array)(e):new Uint16Array(e),B=r.slice(12,t[4]/2),s=2===t[5]?r.slice((24+t[4])/2):t.slice(Math.ceil((24+t[4])/4));return new d(t[0],t[1],t[2],t[3],B,s)},e.Trie=function(){function A(e,t,r,n,B,s){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.initialValue=e,this.errorValue=t,this.highStart=r,this.highValueIndex=n,this.index=B,this.data=s}return r(A,[{key:"get",value:function(A){var e=void 0;if(A>=0){if(A<55296||A>56319&&A<=65535)return e=((e=this.index[A>>B])<<o)+(A&Q),this.data[e];if(A<=65535)return e=((e=this.index[i+(A-55296>>B)])<<o)+(A&Q),this.data[e];if(A<this.highStart)return e=g-F+(A>>s),e=this.index[e],e+=A>>B&h,e=((e=this.index[e])<<o)+(A&Q),this.data[e];if(A<=1114111)return this.data[this.highValueIndex]}return this.errorValue}}]),A}())},function(A,e,t){"use strict";A.exports="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"},function(A,e,t){"use strict";t.r(e);var r={VECTOR:0,BEZIER_CURVE:1,CIRCLE:2};function n(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}var B=/^#([a-f0-9]{3})$/i,s=function(A){var e=A.match(B);return!!e&&[parseInt(e[1][0]+e[1][0],16),parseInt(e[1][1]+e[1][1],16),parseInt(e[1][2]+e[1][2],16),null]},o=/^#([a-f0-9]{6})$/i,a=function(A){var e=A.match(o);return!!e&&[parseInt(e[1].substring(0,2),16),parseInt(e[1].substring(2,4),16),parseInt(e[1].substring(4,6),16),null]},i=/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,c=function(A){var e=A.match(i);return!!e&&[Number(e[1]),Number(e[2]),Number(e[3]),null]},Q=/^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/,l=function(A){var e=A.match(Q);return!!(e&&e.length>4)&&[Number(e[1]),Number(e[2]),Number(e[3]),Number(e[4])]},w=function(A){return[Math.min(A[0],255),Math.min(A[1],255),Math.min(A[2],255),A.length>3?A[3]:null]},u=function(A){return g[A.toLowerCase()]||!1},U=function(){function A(e){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A);var t=function(A,e){return function(A){if(Array.isArray(A))return A}(A)||function(A,e){var t=[],r=!0,n=!1,B=void 0;try{for(var s,o=A[Symbol.iterator]();!(r=(s=o.next()).done)&&(t.push(s.value),!e||t.length!==e);r=!0);}catch(A){n=!0,B=A}finally{try{r||null==o.return||o.return()}finally{if(n)throw B}}return t}(A,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}(Array.isArray(e)?w(e):s(e)||c(e)||l(e)||u(e)||a(e)||[0,0,0,null],4),r=t[0],n=t[1],B=t[2],o=t[3];this.r=r,this.g=n,this.b=B,this.a=o}return function(A,e,t){e&&n(A.prototype,e)}(A,[{key:"isTransparent",value:function(){return 0===this.a}},{key:"toString",value:function(){return null!==this.a&&1!==this.a?"rgba(".concat(this.r,",").concat(this.g,",").concat(this.b,",").concat(this.a,")"):"rgb(".concat(this.r,",").concat(this.g,",").concat(this.b,")")}}]),A}(),g={transparent:[0,0,0,0],aliceblue:[240,248,255,null],antiquewhite:[250,235,215,null],aqua:[0,255,255,null],aquamarine:[127,255,212,null],azure:[240,255,255,null],beige:[245,245,220,null],bisque:[255,228,196,null],black:[0,0,0,null],blanchedalmond:[255,235,205,null],blue:[0,0,255,null],blueviolet:[138,43,226,null],brown:[165,42,42,null],burlywood:[222,184,135,null],cadetblue:[95,158,160,null],chartreuse:[127,255,0,null],chocolate:[210,105,30,null],coral:[255,127,80,null],cornflowerblue:[100,149,237,null],cornsilk:[255,248,220,null],crimson:[220,20,60,null],cyan:[0,255,255,null],darkblue:[0,0,139,null],darkcyan:[0,139,139,null],darkgoldenrod:[184,134,11,null],darkgray:[169,169,169,null],darkgreen:[0,100,0,null],darkgrey:[169,169,169,null],darkkhaki:[189,183,107,null],darkmagenta:[139,0,139,null],darkolivegreen:[85,107,47,null],darkorange:[255,140,0,null],darkorchid:[153,50,204,null],darkred:[139,0,0,null],darksalmon:[233,150,122,null],darkseagreen:[143,188,143,null],darkslateblue:[72,61,139,null],darkslategray:[47,79,79,null],darkslategrey:[47,79,79,null],darkturquoise:[0,206,209,null],darkviolet:[148,0,211,null],deeppink:[255,20,147,null],deepskyblue:[0,191,255,null],dimgray:[105,105,105,null],dimgrey:[105,105,105,null],dodgerblue:[30,144,255,null],firebrick:[178,34,34,null],floralwhite:[255,250,240,null],forestgreen:[34,139,34,null],fuchsia:[255,0,255,null],gainsboro:[220,220,220,null],ghostwhite:[248,248,255,null],gold:[255,215,0,null],goldenrod:[218,165,32,null],gray:[128,128,128,null],green:[0,128,0,null],greenyellow:[173,255,47,null],grey:[128,128,128,null],honeydew:[240,255,240,null],hotpink:[255,105,180,null],indianred:[205,92,92,null],indigo:[75,0,130,null],ivory:[255,255,240,null],khaki:[240,230,140,null],lavender:[230,230,250,null],lavenderblush:[255,240,245,null],lawngreen:[124,252,0,null],lemonchiffon:[255,250,205,null],lightblue:[173,216,230,null],lightcoral:[240,128,128,null],lightcyan:[224,255,255,null],lightgoldenrodyellow:[250,250,210,null],lightgray:[211,211,211,null],lightgreen:[144,238,144,null],lightgrey:[211,211,211,null],lightpink:[255,182,193,null],lightsalmon:[255,160,122,null],lightseagreen:[32,178,170,null],lightskyblue:[135,206,250,null],lightslategray:[119,136,153,null],lightslategrey:[119,136,153,null],lightsteelblue:[176,196,222,null],lightyellow:[255,255,224,null],lime:[0,255,0,null],limegreen:[50,205,50,null],linen:[250,240,230,null],magenta:[255,0,255,null],maroon:[128,0,0,null],mediumaquamarine:[102,205,170,null],mediumblue:[0,0,205,null],mediumorchid:[186,85,211,null],mediumpurple:[147,112,219,null],mediumseagreen:[60,179,113,null],mediumslateblue:[123,104,238,null],mediumspringgreen:[0,250,154,null],mediumturquoise:[72,209,204,null],mediumvioletred:[199,21,133,null],midnightblue:[25,25,112,null],mintcream:[245,255,250,null],mistyrose:[255,228,225,null],moccasin:[255,228,181,null],navajowhite:[255,222,173,null],navy:[0,0,128,null],oldlace:[253,245,230,null],olive:[128,128,0,null],olivedrab:[107,142,35,null],orange:[255,165,0,null],orangered:[255,69,0,null],orchid:[218,112,214,null],palegoldenrod:[238,232,170,null],palegreen:[152,251,152,null],paleturquoise:[175,238,238,null],palevioletred:[219,112,147,null],papayawhip:[255,239,213,null],peachpuff:[255,218,185,null],peru:[205,133,63,null],pink:[255,192,203,null],plum:[221,160,221,null],powderblue:[176,224,230,null],purple:[128,0,128,null],rebeccapurple:[102,51,153,null],red:[255,0,0,null],rosybrown:[188,143,143,null],royalblue:[65,105,225,null],saddlebrown:[139,69,19,null],salmon:[250,128,114,null],sandybrown:[244,164,96,null],seagreen:[46,139,87,null],seashell:[255,245,238,null],sienna:[160,82,45,null],silver:[192,192,192,null],skyblue:[135,206,235,null],slateblue:[106,90,205,null],slategray:[112,128,144,null],slategrey:[112,128,144,null],snow:[255,250,250,null],springgreen:[0,255,127,null],steelblue:[70,130,180,null],tan:[210,180,140,null],teal:[0,128,128,null],thistle:[216,191,216,null],tomato:[255,99,71,null],turquoise:[64,224,208,null],violet:[238,130,238,null],wheat:[245,222,179,null],white:[255,255,255,null],whitesmoke:[245,245,245,null],yellow:[255,255,0,null],yellowgreen:[154,205,50,null]},F=new U([0,0,0,0]),C=function(A){switch(A){case"underline":return 1;case"overline":return 2;case"line-through":return 3}return 4},h=function(A){var e=function(A){return"none"===A?null:A.split(" ").map(C)}(A.textDecorationLine?A.textDecorationLine:A.textDecoration);return null===e?null:{textDecorationLine:e,textDecorationColor:A.textDecorationColor?new U(A.textDecorationColor):null,textDecorationStyle:function(A){switch(A){case"double":return 1;case"dotted":return 2;case"dashed":return 3;case"wavy":return 4}return 0}(A.textDecorationStyle)}};function d(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}var H=function(A,e){var t=Math.max.apply(null,A.colorStops.map(function(A){return A.stop})),r=1/Math.max(1,t);A.colorStops.forEach(function(A){e.addColorStop(Math.floor(Math.max(0,r*A.stop)),A.color.toString())})},f=function(){function A(e){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.canvas=e||document.createElement("canvas")}return function(A,e,t){e&&d(A.prototype,e)}(A,[{key:"render",value:function(A){this.ctx=this.canvas.getContext("2d"),this.options=A,this.canvas.width=Math.floor(A.width*A.scale),this.canvas.height=Math.floor(A.height*A.scale),this.canvas.style.width="".concat(A.width,"px"),this.canvas.style.height="".concat(A.height,"px"),this.ctx.scale(this.options.scale,this.options.scale),this.ctx.translate(-A.x,-A.y),this.ctx.textBaseline="bottom",A.logger.log("Canvas renderer initialized (".concat(A.width,"x").concat(A.height," at ").concat(A.x,",").concat(A.y,") with scale ").concat(this.options.scale))}},{key:"clip",value:function(A,e){var t=this;A.length&&(this.ctx.save(),A.forEach(function(A){t.path(A),t.ctx.clip()})),e(),A.length&&this.ctx.restore()}},{key:"drawImage",value:function(A,e,t){this.ctx.drawImage(A,e.left,e.top,e.width,e.height,t.left,t.top,t.width,t.height)}},{key:"drawShape",value:function(A,e){this.path(A),this.ctx.fillStyle=e.toString(),this.ctx.fill()}},{key:"fill",value:function(A){this.ctx.fillStyle=A.toString(),this.ctx.fill()}},{key:"getTarget",value:function(){return this.canvas.getContext("2d").setTransform(1,0,0,1,0,0),Promise.resolve(this.canvas)}},{key:"path",value:function(A){var e=this;this.ctx.beginPath(),Array.isArray(A)?A.forEach(function(A,t){var n=A.type===r.VECTOR?A:A.start;0===t?e.ctx.moveTo(n.x,n.y):e.ctx.lineTo(n.x,n.y),A.type===r.BEZIER_CURVE&&e.ctx.bezierCurveTo(A.startControl.x,A.startControl.y,A.endControl.x,A.endControl.y,A.end.x,A.end.y)}):this.ctx.arc(A.x+A.radius,A.y+A.radius,A.radius,0,2*Math.PI,!0),this.ctx.closePath()}},{key:"rectangle",value:function(A,e,t,r,n){this.ctx.fillStyle=n.toString(),this.ctx.fillRect(A,e,t,r)}},{key:"renderLinearGradient",value:function(A,e){var t=this.ctx.createLinearGradient(A.left+e.direction.x1,A.top+e.direction.y1,A.left+e.direction.x0,A.top+e.direction.y0);H(e,t),this.ctx.fillStyle=t,this.ctx.fillRect(A.left,A.top,A.width,A.height)}},{key:"renderRadialGradient",value:function(A,e){var t=this,r=A.left+e.center.x,n=A.top+e.center.y,B=this.ctx.createRadialGradient(r,n,0,r,n,e.radius.x);if(B)if(H(e,B),this.ctx.fillStyle=B,e.radius.x!==e.radius.y){var s=A.left+.5*A.width,o=A.top+.5*A.height,a=e.radius.y/e.radius.x,i=1/a;this.transform(s,o,[1,0,0,a,0,0],function(){return t.ctx.fillRect(A.left,i*(A.top-o)+o,A.width,A.height*i)})}else this.ctx.fillRect(A.left,A.top,A.width,A.height)}},{key:"renderRepeat",value:function(A,e,t,r,n){this.path(A),this.ctx.fillStyle=this.ctx.createPattern(this.resizeImage(e,t),"repeat"),this.ctx.translate(r,n),this.ctx.fill(),this.ctx.translate(-r,-n)}},{key:"renderTextNode",value:function(A,e,t,r,n){var B=this;this.ctx.font=[t.fontStyle,t.fontVariant,t.fontWeight,t.fontSize,t.fontFamily].join(" "),A.forEach(function(A){if(B.ctx.fillStyle=e.toString(),n&&A.text.trim().length?(n.slice(0).reverse().forEach(function(e){B.ctx.shadowColor=e.color.toString(),B.ctx.shadowOffsetX=e.offsetX*B.options.scale,B.ctx.shadowOffsetY=e.offsetY*B.options.scale,B.ctx.shadowBlur=e.blur,B.ctx.fillText(A.text,A.bounds.left,A.bounds.top+A.bounds.height)}),B.ctx.shadowColor="",B.ctx.shadowOffsetX=0,B.ctx.shadowOffsetY=0,B.ctx.shadowBlur=0):B.ctx.fillText(A.text,A.bounds.left,A.bounds.top+A.bounds.height),null!==r){var s=r.textDecorationColor||e;r.textDecorationLine.forEach(function(e){switch(e){case 1:var r=B.options.fontMetrics.getMetrics(t).baseline;B.rectangle(A.bounds.left,Math.round(A.bounds.top+r),A.bounds.width,1,s);break;case 2:B.rectangle(A.bounds.left,Math.round(A.bounds.top),A.bounds.width,1,s);break;case 3:var n=B.options.fontMetrics.getMetrics(t).middle;B.rectangle(A.bounds.left,Math.ceil(A.bounds.top+n),A.bounds.width,1,s)}})}})}},{key:"resizeImage",value:function(A,e){if(A.width===e.width&&A.height===e.height)return A;var t=this.canvas.ownerDocument.createElement("canvas");return t.width=e.width,t.height=e.height,t.getContext("2d").drawImage(A,0,0,A.width,A.height,0,0,e.width,e.height),t}},{key:"setOpacity",value:function(A){this.ctx.globalAlpha=A}},{key:"transform",value:function(A,e,t,r){this.ctx.save(),this.ctx.translate(A,e),this.ctx.transform(t[0],t[1],t[2],t[3],t[4],t[5]),this.ctx.translate(-A,-e),r(),this.ctx.restore()}}]),A}();function E(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}var p=function(){function A(e,t,r){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.enabled="undefined"!=typeof window&&e,this.start=r||Date.now(),this.id=t}return function(A,e,t){e&&E(A.prototype,e)}(A,[{key:"child",value:function(e){return new A(this.enabled,e,this.start)}},{key:"log",value:function(){if(this.enabled&&window.console&&window.console.log){for(var A=arguments.length,e=new Array(A),t=0;t<A;t++)e[t]=arguments[t];Function.prototype.bind.call(window.console.log,window.console).apply(window.console,[Date.now()-this.start+"ms",this.id?"html2canvas (".concat(this.id,"):"):"html2canvas:"].concat([].slice.call(e,0)))}}},{key:"error",value:function(){if(this.enabled&&window.console&&window.console.error){for(var A=arguments.length,e=new Array(A),t=0;t<A;t++)e[t]=arguments[t];Function.prototype.bind.call(window.console.error,window.console).apply(window.console,[Date.now()-this.start+"ms",this.id?"html2canvas (".concat(this.id,"):"):"html2canvas:"].concat([].slice.call(e,0)))}}}]),A}(),K=function(A,e){return 0!=(A&e)},m=function(A,e){return Math.sqrt(A*A+e*e)},b=function(A,e){for(var t=A.length-1;t>=0;t--){var r=A.item(t);"content"!==r&&e.style.setProperty(r,A.getPropertyValue(r))}return e};function N(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}var y={PX:0,PERCENTAGE:1},v=function(){function A(e){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.type="%"===e.substr(e.length-1)?y.PERCENTAGE:y.PX;var t=parseFloat(e);this.value=isNaN(t)?0:t}return function(A,e,t){e&&N(A.prototype,e),t&&N(A,t)}(A,[{key:"isPercentage",value:function(){return this.type===y.PERCENTAGE}},{key:"getAbsoluteValue",value:function(A){return this.isPercentage()?A*(this.value/100):this.value}}],[{key:"create",value:function(e){return new A(e)}}]),A}(),I=function(A,e,t){switch(t){case"px":case"%":return new v(e+t);case"em":case"rem":var r=new v(e);return r.value*="em"===t?parseFloat(A.style.font.fontSize):function A(e){var t=e.parent;return t?A(t):parseFloat(e.style.font.fontSize)}(A),r;default:return new v("0")}},D=function A(e,t){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.width=e,this.height=t},M=function A(e,t){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.type=r.VECTOR,this.x=e,this.y=t};function T(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}var S=function(A,e,t){return new M(A.x+(e.x-A.x)*t,A.y+(e.y-A.y)*t)},X=function(){function A(e,t,n,B){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.type=r.BEZIER_CURVE,this.start=e,this.startControl=t,this.endControl=n,this.end=B}return function(A,e,t){e&&T(A.prototype,e)}(A,[{key:"subdivide",value:function(e,t){var r=S(this.start,this.startControl,e),n=S(this.startControl,this.endControl,e),B=S(this.endControl,this.end,e),s=S(r,n,e),o=S(n,B,e),a=S(s,o,e);return t?new A(this.start,r,s,a):new A(a,o,B,this.end)}},{key:"reverse",value:function(){return new A(this.end,this.endControl,this.startControl,this.start)}}]),A}();function z(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}var L=function(){function A(e,t,r,n){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.left=e,this.top=t,this.width=r,this.height=n}return function(A,e,t){t&&z(A,t)}(A,0,[{key:"fromClientRect",value:function(e,t,r){return new A(e.left+t,e.top+r,e.width,e.height)}}]),A}(),O=function(A,e,t){return L.fromClientRect(A.getBoundingClientRect(),e,t)},x=function(A){var e=A.body,t=A.documentElement;if(!e||!t)throw new Error("");var r=Math.max(Math.max(e.scrollWidth,t.scrollWidth),Math.max(e.offsetWidth,t.offsetWidth),Math.max(e.clientWidth,t.clientWidth)),n=Math.max(Math.max(e.scrollHeight,t.scrollHeight),Math.max(e.offsetHeight,t.offsetHeight),Math.max(e.clientHeight,t.clientHeight));return new L(0,0,r,n)},V=function(A,e,t,r){var n=[];return A instanceof X?n.push(A.subdivide(.5,!1)):n.push(A),t instanceof X?n.push(t.subdivide(.5,!0)):n.push(t),r instanceof X?n.push(r.subdivide(.5,!0).reverse()):n.push(r),e instanceof X?n.push(e.subdivide(.5,!1).reverse()):n.push(e),n},k=function(A){return[A.topLeftInner,A.topRightInner,A.bottomRightInner,A.bottomLeftInner]},J=function(A,e,t){var r=t[R.TOP_LEFT][0].getAbsoluteValue(A.width),n=t[R.TOP_LEFT][1].getAbsoluteValue(A.height),B=t[R.TOP_RIGHT][0].getAbsoluteValue(A.width),s=t[R.TOP_RIGHT][1].getAbsoluteValue(A.height),o=t[R.BOTTOM_RIGHT][0].getAbsoluteValue(A.width),a=t[R.BOTTOM_RIGHT][1].getAbsoluteValue(A.height),i=t[R.BOTTOM_LEFT][0].getAbsoluteValue(A.width),c=t[R.BOTTOM_LEFT][1].getAbsoluteValue(A.height),Q=[];Q.push((r+B)/A.width),Q.push((i+o)/A.width),Q.push((n+c)/A.height),Q.push((s+a)/A.height);var l=Math.max.apply(Math,Q);l>1&&(r/=l,n/=l,B/=l,s/=l,o/=l,a/=l,i/=l,c/=l);var w=A.width-B,u=A.height-a,U=A.width-o,g=A.height-c;return{topLeftOuter:r>0||n>0?_(A.left,A.top,r,n,R.TOP_LEFT):new M(A.left,A.top),topLeftInner:r>0||n>0?_(A.left+e[3].borderWidth,A.top+e[0].borderWidth,Math.max(0,r-e[3].borderWidth),Math.max(0,n-e[0].borderWidth),R.TOP_LEFT):new M(A.left+e[3].borderWidth,A.top+e[0].borderWidth),topRightOuter:B>0||s>0?_(A.left+w,A.top,B,s,R.TOP_RIGHT):new M(A.left+A.width,A.top),topRightInner:B>0||s>0?_(A.left+Math.min(w,A.width+e[3].borderWidth),A.top+e[0].borderWidth,w>A.width+e[3].borderWidth?0:B-e[3].borderWidth,s-e[0].borderWidth,R.TOP_RIGHT):new M(A.left+A.width-e[1].borderWidth,A.top+e[0].borderWidth),bottomRightOuter:o>0||a>0?_(A.left+U,A.top+u,o,a,R.BOTTOM_RIGHT):new M(A.left+A.width,A.top+A.height),bottomRightInner:o>0||a>0?_(A.left+Math.min(U,A.width-e[3].borderWidth),A.top+Math.min(u,A.height+e[0].borderWidth),Math.max(0,o-e[1].borderWidth),a-e[2].borderWidth,R.BOTTOM_RIGHT):new M(A.left+A.width-e[1].borderWidth,A.top+A.height-e[2].borderWidth),bottomLeftOuter:i>0||c>0?_(A.left,A.top+g,i,c,R.BOTTOM_LEFT):new M(A.left,A.top+A.height),bottomLeftInner:i>0||c>0?_(A.left+e[3].borderWidth,A.top+g,Math.max(0,i-e[3].borderWidth),c-e[2].borderWidth,R.BOTTOM_LEFT):new M(A.left+e[3].borderWidth,A.top+A.height-e[2].borderWidth)}},R={TOP_LEFT:0,TOP_RIGHT:1,BOTTOM_RIGHT:2,BOTTOM_LEFT:3},_=function(A,e,t,r,n){var B=(Math.sqrt(2)-1)/3*4,s=t*B,o=r*B,a=A+t,i=e+r;switch(n){case R.TOP_LEFT:return new X(new M(A,i),new M(A,i-o),new M(a-s,e),new M(a,e));case R.TOP_RIGHT:return new X(new M(A,e),new M(A+s,e),new M(a,i-o),new M(a,i));case R.BOTTOM_RIGHT:return new X(new M(a,e),new M(a,e+o),new M(A+s,i),new M(A,i));case R.BOTTOM_LEFT:default:return new X(new M(a,i),new M(a-s,i),new M(A,e+o),new M(A,e))}},P=["top","right","bottom","left"],G=function(A){return P.map(function(e){return new v(A.getPropertyValue("padding-".concat(e)))})},W={BORDER_BOX:0,PADDING_BOX:1,CONTENT_BOX:2},Y=W,q=function A(e){switch(function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),e){case"contain":this.size=1;break;case"cover":this.size=2;break;case"auto":this.size=0;break;default:this.value=new v(e)}},j=new q("auto"),Z=function(A,e,t,r){var n=function(A,e){return new L(A.left+e[3].borderWidth,A.top+e[0].borderWidth,A.width-(e[1].borderWidth+e[3].borderWidth),A.height-(e[0].borderWidth+e[2].borderWidth))}(e,r);switch(A){case Y.BORDER_BOX:return e;case Y.CONTENT_BOX:var B=t[3].getAbsoluteValue(e.width),s=t[1].getAbsoluteValue(e.width),o=t[0].getAbsoluteValue(e.width),a=t[2].getAbsoluteValue(e.width);return new L(n.left+B,n.top+o,n.width-B-s,n.height-o-a);case Y.PADDING_BOX:default:return n}},$=function(A,e,t){return new M(A[0].getAbsoluteValue(t.width-e.width),A[1].getAbsoluteValue(t.height-e.height))},AA=function(A,e){return{backgroundColor:new U(A.backgroundColor),backgroundImage:rA(A,e),backgroundClip:eA(A.backgroundClip),backgroundOrigin:tA(A.backgroundOrigin)}},eA=function(A){switch(A){case"padding-box":return W.PADDING_BOX;case"content-box":return W.CONTENT_BOX}return W.BORDER_BOX},tA=function(A){switch(A){case"padding-box":return Y.PADDING_BOX;case"content-box":return Y.CONTENT_BOX}return Y.BORDER_BOX},rA=function(A,e){var t=sA(A.backgroundImage).map(function(A){if("url"===A.method){var t=e.loadImage(A.args[0]);A.args=t?[t]:[]}return A}),r=A.backgroundPosition.split(","),n=A.backgroundRepeat.split(","),B=A.backgroundSize.split(",");return t.map(function(A,e){var t=(B[e]||"auto").trim().split(" ").map(nA),s=(r[e]||"auto").trim().split(" ").map(BA);return{source:A,repeat:function(A){switch(("string"==typeof n[e]?n[e]:n[0]).trim()){case"no-repeat":return 1;case"repeat-x":case"repeat no-repeat":return 2;case"repeat-y":case"no-repeat repeat":return 3;case"repeat":return 0}return 0}(),size:t.length<2?[t[0],j]:[t[0],t[1]],position:s.length<2?[s[0],s[0]]:[s[0],s[1]]}})},nA=function(A){return"auto"===A?j:new q(A)},BA=function(A){switch(A){case"bottom":case"right":return new v("100%");case"left":case"top":return new v("0%");case"auto":return new v("0")}return new v(A)},sA=function(A){var e=/^\s$/,t=[],r=[],n="",B=null,s="",o=0,a=0,i=function(){var A="";if(n){'"'===s.substr(0,1)&&(s=s.substr(1,s.length-2)),s&&r.push(s.trim());var e=n.indexOf("-",1)+1;"-"===n.substr(0,1)&&e>0&&(A=n.substr(0,e).toLowerCase(),n=n.substr(e)),"none"!==(n=n.toLowerCase())&&t.push({prefix:A,method:n,args:r})}r=[],n=s=""};return A.split("").forEach(function(A){if(0!==o||!e.test(A)){switch(A){case'"':B?B===A&&(B=null):B=A;break;case"(":if(B)break;if(0===o)return void(o=1);a++;break;case")":if(B)break;if(1===o){if(0===a)return o=0,void i();a--}break;case",":if(B)break;if(0===o)return void i();if(1===o&&0===a&&!n.match(/^url$/i))return r.push(s.trim()),void(s="")}0===o?n+=A:s+=A}}),i(),t},oA=Object.keys({TOP:0,RIGHT:1,BOTTOM:2,LEFT:3}).map(function(A){return A.toLowerCase()}),aA=function(A){return oA.map(function(e){var t=new U(A.getPropertyValue("border-".concat(e,"-color"))),r=function(A){switch(A){case"none":return 0}return 1}(A.getPropertyValue("border-".concat(e,"-style"))),n=parseFloat(A.getPropertyValue("border-".concat(e,"-width")));return{borderColor:t,borderStyle:r,borderWidth:isNaN(n)?0:n}})};var iA=["top-left","top-right","bottom-right","bottom-left"],cA=function(A){return iA.map(function(e){var t=function(A,e){return function(A){if(Array.isArray(A))return A}(A)||function(A,e){var t=[],r=!0,n=!1,B=void 0;try{for(var s,o=A[Symbol.iterator]();!(r=(s=o.next()).done)&&(t.push(s.value),!e||t.length!==e);r=!0);}catch(A){n=!0,B=A}finally{try{r||null==o.return||o.return()}finally{if(n)throw B}}return t}(A,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}(A.getPropertyValue("border-".concat(e,"-radius")).split(" ").map(v.create),2),r=t[0],n=t[1];return void 0===n?[r,r]:[r,n]})},QA={NONE:1,BLOCK:2,INLINE:4,RUN_IN:8,FLOW:16,FLOW_ROOT:32,TABLE:64,FLEX:128,GRID:256,RUBY:512,SUBGRID:1024,LIST_ITEM:2048,TABLE_ROW_GROUP:4096,TABLE_HEADER_GROUP:8192,TABLE_FOOTER_GROUP:16384,TABLE_ROW:32768,TABLE_CELL:65536,TABLE_COLUMN_GROUP:1<<17,TABLE_COLUMN:1<<18,TABLE_CAPTION:1<<19,RUBY_BASE:1<<20,RUBY_TEXT:1<<21,RUBY_BASE_CONTAINER:1<<22,RUBY_TEXT_CONTAINER:1<<23,CONTENTS:1<<24,INLINE_BLOCK:1<<25,INLINE_LIST_ITEM:1<<26,INLINE_TABLE:1<<27,INLINE_FLEX:1<<28,INLINE_GRID:1<<29},lA=function(A,e){return A|function(A){switch(e){case"block":return QA.BLOCK;case"inline":return QA.INLINE;case"run-in":return QA.RUN_IN;case"flow":return QA.FLOW;case"flow-root":return QA.FLOW_ROOT;case"table":return QA.TABLE;case"flex":return QA.FLEX;case"grid":return QA.GRID;case"ruby":return QA.RUBY;case"subgrid":return QA.SUBGRID;case"list-item":return QA.LIST_ITEM;case"table-row-group":return QA.TABLE_ROW_GROUP;case"table-header-group":return QA.TABLE_HEADER_GROUP;case"table-footer-group":return QA.TABLE_FOOTER_GROUP;case"table-row":return QA.TABLE_ROW;case"table-cell":return QA.TABLE_CELL;case"table-column-group":return QA.TABLE_COLUMN_GROUP;case"table-column":return QA.TABLE_COLUMN;case"table-caption":return QA.TABLE_CAPTION;case"ruby-base":return QA.RUBY_BASE;case"ruby-text":return QA.RUBY_TEXT;case"ruby-base-container":return QA.RUBY_BASE_CONTAINER;case"ruby-text-container":return QA.RUBY_TEXT_CONTAINER;case"contents":return QA.CONTENTS;case"inline-block":return QA.INLINE_BLOCK;case"inline-list-item":return QA.INLINE_LIST_ITEM;case"inline-table":return QA.INLINE_TABLE;case"inline-flex":return QA.INLINE_FLEX;case"inline-grid":return QA.INLINE_GRID}return QA.NONE}()},wA=function(A){return A.split(" ").reduce(lA,0)},uA=function(A){switch(A){case"left":return 1;case"right":return 2;case"inline-start":return 3;case"inline-end":return 4}return 0},UA=function(A){return{fontFamily:A.fontFamily,fontSize:A.fontSize,fontStyle:A.fontStyle,fontVariant:A.fontVariant,fontWeight:function(A){switch(A){case"normal":return 400;case"bold":return 700}var e=parseInt(A,10);return isNaN(e)?400:e}(A.fontWeight)}},gA=function(A){if("normal"===A)return 0;var e=parseFloat(A);return isNaN(e)?0:e},FA=function(A){switch(A){case"strict":return"strict";case"normal":default:return"normal"}},CA=function(A){switch(A){case"disc":return 0;case"circle":return 1;case"square":return 2;case"decimal":return 3;case"cjk-decimal":return 4;case"decimal-leading-zero":return 5;case"lower-roman":return 6;case"upper-roman":return 7;case"lower-greek":return 8;case"lower-alpha":return 9;case"upper-alpha":return 10;case"arabic-indic":return 11;case"armenian":return 12;case"bengali":return 13;case"cambodian":return 14;case"cjk-earthly-branch":return 15;case"cjk-heavenly-stem":return 16;case"cjk-ideographic":return 17;case"devanagari":return 18;case"ethiopic-numeric":return 19;case"georgian":return 20;case"gujarati":return 21;case"gurmukhi":case"hebrew":return 22;case"hiragana":return 23;case"hiragana-iroha":return 24;case"japanese-formal":return 25;case"japanese-informal":return 26;case"kannada":return 27;case"katakana":return 28;case"katakana-iroha":return 29;case"khmer":return 30;case"korean-hangul-formal":return 31;case"korean-hanja-formal":return 32;case"korean-hanja-informal":return 33;case"lao":return 34;case"lower-armenian":return 35;case"malayalam":return 36;case"mongolian":return 37;case"myanmar":return 38;case"oriya":return 39;case"persian":return 40;case"simp-chinese-formal":return 41;case"simp-chinese-informal":return 42;case"tamil":return 43;case"telugu":return 44;case"thai":return 45;case"tibetan":return 46;case"trad-chinese-formal":return 47;case"trad-chinese-informal":return 48;case"upper-armenian":return 49;case"disclosure-open":return 50;case"disclosure-closed":return 51;case"none":default:return-1}},hA=function(A){var e=sA(A.getPropertyValue("list-style-image"));return{listStyleType:CA(A.getPropertyValue("list-style-type")),listStyleImage:e.length?e[0]:null,listStylePosition:dA(A.getPropertyValue("list-style-position"))}},dA=function(A){switch(A){case"inside":return 0;case"outside":default:return 1}},HA=["top","right","bottom","left"],fA=function(A){return HA.map(function(e){return new v(A.getPropertyValue("margin-".concat(e)))})},EA={VISIBLE:0,HIDDEN:1,SCROLL:2,AUTO:3},pA=function(A){switch(A){case"hidden":return EA.HIDDEN;case"scroll":return EA.SCROLL;case"auto":return EA.AUTO;case"visible":default:return EA.VISIBLE}},KA=function(A){switch(A){case"break-word":return 1;case"normal":default:return 0}},mA={STATIC:0,RELATIVE:1,ABSOLUTE:2,FIXED:3,STICKY:4},bA=function(A){switch(A){case"relative":return mA.RELATIVE;case"absolute":return mA.ABSOLUTE;case"fixed":return mA.FIXED;case"sticky":return mA.STICKY}return mA.STATIC},NA=/^([+-]|\d|\.)$/i,yA=function(A){if("none"===A||"string"!=typeof A)return null;for(var e="",t=!1,r=[],n=[],B=0,s=null,o=function(){e.length&&(t?r.push(parseFloat(e)):s=new U(e)),t=!1,e=""},a=function(){r.length&&null!==s&&n.push({color:s,offsetX:r[0]||0,offsetY:r[1]||0,blur:r[2]||0}),r.splice(0,r.length),s=null},i=0;i<A.length;i++){var c=A[i];switch(c){case"(":e+=c,B++;break;case")":e+=c,B--;break;case",":0===B?(o(),a()):e+=c;break;case" ":0===B?o():e+=c;break;default:0===e.length&&NA.test(c)&&(t=!0),e+=c}}return o(),a(),0===n.length?null:n},vA=function(A){switch(A){case"uppercase":return 2;case"lowercase":return 1;case"capitalize":return 3}return 0},IA=function(A){return parseFloat(A.trim())},DA=/(matrix|matrix3d)\((.+)\)/,MA=function(A){var e=SA(A.transform||A.webkitTransform||A.mozTransform||A.msTransform||A.oTransform);return null===e?null:{transform:e,transformOrigin:TA(A.transformOrigin||A.webkitTransformOrigin||A.mozTransformOrigin||A.msTransformOrigin||A.oTransformOrigin)}},TA=function(A){if("string"!=typeof A){var e=new v("0");return[e,e]}var t=A.split(" ").map(v.create);return[t[0],t[1]]},SA=function(A){if("none"===A||"string"!=typeof A)return null;var e=A.match(DA);if(e){if("matrix"===e[1]){var t=e[2].split(",").map(IA);return[t[0],t[1],t[2],t[3],t[4],t[5]]}var r=e[2].split(",").map(IA);return[r[0],r[1],r[4],r[5],r[12],r[13]]}return null},XA=function(A){switch(A){case"hidden":return 1;case"collapse":return 2;case"visible":default:return 0}},zA=function(A){switch(A){case"break-all":return"break-all";case"keep-all":return"keep-all";case"normal":default:return"normal"}},LA=function(A){var e="auto"===A;return{auto:e,order:e?0:parseInt(A,10)}};function OA(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}var xA=function(){function A(e){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.element=e}return function(A,e,t){e&&OA(A.prototype,e)}(A,[{key:"render",value:function(A){var e=this;this.options=A,this.canvas=document.createElement("canvas"),this.ctx=this.canvas.getContext("2d"),this.canvas.width=Math.floor(A.width)*A.scale,this.canvas.height=Math.floor(A.height)*A.scale,this.canvas.style.width="".concat(A.width,"px"),this.canvas.style.height="".concat(A.height,"px"),this.ctx.scale(A.scale,A.scale),A.logger.log("ForeignObject renderer initialized (".concat(A.width,"x").concat(A.height," at ").concat(A.x,",").concat(A.y,") with scale ").concat(A.scale));var t=VA(Math.max(A.windowWidth,A.width)*A.scale,Math.max(A.windowHeight,A.height)*A.scale,A.scrollX*A.scale,A.scrollY*A.scale,this.element);return kA(t).then(function(t){return A.backgroundColor&&(e.ctx.fillStyle=A.backgroundColor.toString(),e.ctx.fillRect(0,0,A.width*A.scale,A.height*A.scale)),e.ctx.drawImage(t,-A.x*A.scale,-A.y*A.scale),e.canvas})}}]),A}(),VA=function(A,e,t,r,n){var B="http://www.w3.org/2000/svg",s=document.createElementNS(B,"svg"),o=document.createElementNS(B,"foreignObject");return s.setAttributeNS(null,"width",A),s.setAttributeNS(null,"height",e),o.setAttributeNS(null,"width","100%"),o.setAttributeNS(null,"height","100%"),o.setAttributeNS(null,"x",t),o.setAttributeNS(null,"y",r),o.setAttributeNS(null,"externalResourcesRequired","true"),s.appendChild(o),o.appendChild(n),s},kA=function(A){return new Promise(function(e,t){var r=new Image;r.onload=function(){return e(r)},r.onerror=t,r.src="data:image/svg+xml;charset=utf-8,".concat(encodeURIComponent((new XMLSerializer).serializeToString(A)))})},JA=function(A){return 0===A[0]&&255===A[1]&&0===A[2]&&255===A[3]},RA={get SUPPORT_RANGE_BOUNDS(){var A=function(A){if(A.createRange){var e=A.createRange();if(e.getBoundingClientRect){var t=A.createElement("boundtest");t.style.height="".concat(123,"px"),t.style.display="block",A.body.appendChild(t),e.selectNode(t);var r=e.getBoundingClientRect(),n=Math.round(r.height);if(A.body.removeChild(t),123===n)return!0}}return!1}(document);return Object.defineProperty(RA,"SUPPORT_RANGE_BOUNDS",{value:A}),A},get SUPPORT_SVG_DRAWING(){var A=function(A){var e=new Image,t=A.createElement("canvas"),r=t.getContext("2d");e.src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";try{r.drawImage(e,0,0),t.toDataURL()}catch(A){return!1}return!0}(document);return Object.defineProperty(RA,"SUPPORT_SVG_DRAWING",{value:A}),A},get SUPPORT_FOREIGNOBJECT_DRAWING(){var A="function"==typeof Array.from&&"function"==typeof window.fetch?function(A){var e=A.createElement("canvas");e.width=100,e.height=100;var t=e.getContext("2d");t.fillStyle="rgb(0, 255, 0)",t.fillRect(0,0,100,100);var r=new Image,n=e.toDataURL();r.src=n;var B=VA(100,100,0,0,r);return t.fillStyle="red",t.fillRect(0,0,100,100),kA(B).then(function(e){t.drawImage(e,0,0);var r=t.getImageData(0,0,100,100).data;t.fillStyle="red",t.fillRect(0,0,100,100);var B=A.createElement("div");return B.style.backgroundImage="url(".concat(n,")"),B.style.height="".concat(100,"px"),JA(r)?kA(VA(100,100,0,0,B)):Promise.reject(!1)}).then(function(A){return t.drawImage(A,0,0),JA(t.getImageData(0,0,100,100).data)}).catch(function(A){return!1})}(document):Promise.resolve(!1);return Object.defineProperty(RA,"SUPPORT_FOREIGNOBJECT_DRAWING",{value:A}),A},get SUPPORT_CORS_IMAGES(){var A=void 0!==(new Image).crossOrigin;return Object.defineProperty(RA,"SUPPORT_CORS_IMAGES",{value:A}),A},get SUPPORT_RESPONSE_TYPE(){var A="string"==typeof(new XMLHttpRequest).responseType;return Object.defineProperty(RA,"SUPPORT_RESPONSE_TYPE",{value:A}),A},get SUPPORT_CORS_XHR(){var A="withCredentials"in new XMLHttpRequest;return Object.defineProperty(RA,"SUPPORT_CORS_XHR",{value:A}),A}},_A=RA,PA=t(0),GA=function A(e,t){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.text=e,this.bounds=t},WA=function(A,e,t){var r=A.ownerDocument.createElement("html2canvaswrapper");r.appendChild(A.cloneNode(!0));var n=A.parentNode;if(n){n.replaceChild(r,A);var B=O(r,e,t);return r.firstChild&&n.replaceChild(r.firstChild,r),B}return new L(0,0,0,0)},YA=function(A,e,t,r,n){var B=A.ownerDocument.createRange();return B.setStart(A,e),B.setEnd(A,e+t),L.fromClientRect(B.getBoundingClientRect(),r,n)};function qA(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}var jA=function(){function A(e,t,r){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.text=e,this.parent=t,this.bounds=r}return function(A,e,t){t&&qA(A,t)}(A,0,[{key:"fromTextNode",value:function(e,t){var r=$A(e.data,t.style.textTransform);return new A(r,t,function(A,e,t){for(var r=0!==e.style.letterSpacing?Object(PA.toCodePoints)(A).map(function(A){return Object(PA.fromCodePoint)(A)}):function(A,e){for(var t,r=Object(PA.LineBreaker)(A,{lineBreak:e.style.lineBreak,wordBreak:1===e.style.overflowWrap?"break-word":e.style.wordBreak}),n=[];!(t=r.next()).done;)n.push(t.value.slice());return n}(A,e),n=r.length,B=t.parentNode?t.parentNode.ownerDocument.defaultView:null,s=B?B.pageXOffset:0,o=B?B.pageYOffset:0,a=[],i=0,c=0;c<n;c++){var Q=r[c];if(null!==e.style.textDecoration||Q.trim().length>0)if(_A.SUPPORT_RANGE_BOUNDS)a.push(new GA(Q,YA(t,i,Q.length,s,o)));else{var l=t.splitText(Q.length);a.push(new GA(Q,WA(t,s,o))),t=l}else _A.SUPPORT_RANGE_BOUNDS||(t=t.splitText(Q.length));i+=Q.length}return a}(r,t,e))}}]),A}(),ZA=/(^|\s|:|-|\(|\))([a-z])/g,$A=function(A,e){switch(e){case 1:return A.toLowerCase();case 3:return A.replace(ZA,Ae);case 2:return A.toUpperCase();default:return A}};function Ae(A,e,t){return A.length>0?e+t.toUpperCase():A}var ee=function A(e,t,n){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.type=r.CIRCLE,this.x=e,this.y=t,this.radius=n},te=new U([42,42,42]),re=new U([165,165,165]),ne=new U([222,222,222]),Be={borderWidth:1,borderColor:re,borderStyle:1},se=[Be,Be,Be,Be],oe={backgroundColor:ne,backgroundImage:[],backgroundClip:W.PADDING_BOX,backgroundOrigin:Y.PADDING_BOX},ae=new v("50%"),ie=[ae,ae],ce=[ie,ie,ie,ie],Qe=new v("3px"),le=[Qe,Qe],we=[le,le,le,le],ue=function(A){return"radio"===A.type?ce:we},Ue=function(A,e){if("radio"===A.type||"checkbox"===A.type){if(A.checked){var t=Math.min(e.bounds.width,e.bounds.height);e.childNodes.push("checkbox"===A.type?[new M(e.bounds.left+.39363*t,e.bounds.top+.79*t),new M(e.bounds.left+.16*t,e.bounds.top+.5549*t),new M(e.bounds.left+.27347*t,e.bounds.top+.44071*t),new M(e.bounds.left+.39694*t,e.bounds.top+.5649*t),new M(e.bounds.left+.72983*t,e.bounds.top+.23*t),new M(e.bounds.left+.84*t,e.bounds.top+.34085*t),new M(e.bounds.left+.39363*t,e.bounds.top+.79*t)]:new ee(e.bounds.left+t/4,e.bounds.top+t/4,t/4))}}else he(de(A),A,e,!1)},ge=function(A,e){he(A.value,A,e,!0)},Fe=function(A,e){var t=A.options[A.selectedIndex||0];he(t&&t.text||"",A,e,!1)},Ce=function(A){return A.width>A.height?(A.left+=(A.width-A.height)/2,A.width=A.height):A.width<A.height&&(A.top+=(A.height-A.width)/2,A.height=A.width),A},he=function(A,e,t,r){var n=e.ownerDocument.body;if(A.length>0&&n){var B=e.ownerDocument.createElement("html2canvaswrapper");b(e.ownerDocument.defaultView.getComputedStyle(e,null),B),B.style.position="absolute",B.style.left="".concat(t.bounds.left,"px"),B.style.top="".concat(t.bounds.top,"px"),r||(B.style.whiteSpace="nowrap");var s=e.ownerDocument.createTextNode(A);B.appendChild(s),n.appendChild(B),t.childNodes.push(jA.fromTextNode(s,t)),n.removeChild(B)}},de=function(A){var e="password"===A.type?new Array(A.value.length+1).join("•"):A.value;return 0===e.length?A.placeholder||"":e},He=["OL","UL","MENU"],fe=function(A){var e=A.parent;if(!e)return null;do{if(-1!==He.indexOf(e.tagName))return e;e=e.parent}while(e);return A.parent},Ee=function(A,e,t){var r=e.style.listStyle;if(r){var n,B=A.ownerDocument.defaultView.getComputedStyle(A,null),s=A.ownerDocument.createElement("html2canvaswrapper");switch(b(B,s),s.style.position="absolute",s.style.bottom="auto",s.style.display="block",s.style.letterSpacing="normal",r.listStylePosition){case 1:s.style.left="auto",s.style.right="".concat(A.ownerDocument.defaultView.innerWidth-e.bounds.left-e.style.margin[1].getAbsoluteValue(e.bounds.width)+7,"px"),s.style.textAlign="right";break;case 0:s.style.left="".concat(e.bounds.left-e.style.margin[3].getAbsoluteValue(e.bounds.width),"px"),s.style.right="auto",s.style.textAlign="left"}var o=e.style.margin[0].getAbsoluteValue(e.bounds.width),a=r.listStyleImage;if(a)if("url"===a.method){var i=A.ownerDocument.createElement("img");i.src=a.args[0],s.style.top="".concat(e.bounds.top-o,"px"),s.style.width="auto",s.style.height="auto",s.appendChild(i)}else{var c=.5*parseFloat(e.style.font.fontSize);s.style.top="".concat(e.bounds.top-o+e.bounds.height-1.5*c,"px"),s.style.width="".concat(c,"px"),s.style.height="".concat(c,"px"),s.style.backgroundImage=B.listStyleImage}else"number"==typeof e.listIndex&&(n=A.ownerDocument.createTextNode(Me(e.listIndex,r.listStyleType,!0)),s.appendChild(n),s.style.top="".concat(e.bounds.top-o,"px"));var Q=A.ownerDocument.body;Q.appendChild(s),n?(e.childNodes.push(jA.fromTextNode(n,e)),Q.removeChild(s)):e.childNodes.push(new Xe(s,e,t,0))}},pe={integers:[1e3,900,500,400,100,90,50,40,10,9,5,4,1],values:["M","CM","D","CD","C","XC","L","XL","X","IX","V","IV","I"]},Ke={integers:[9e3,8e3,7e3,6e3,5e3,4e3,3e3,2e3,1e3,900,800,700,600,500,400,300,200,100,90,80,70,60,50,40,30,20,10,9,8,7,6,5,4,3,2,1],values:["Ք","Փ","Ւ","Ց","Ր","Տ","Վ","Ս","Ռ","Ջ","Պ","Չ","Ո","Շ","Ն","Յ","Մ","Ճ","Ղ","Ձ","Հ","Կ","Ծ","Խ","Լ","Ի","Ժ","Թ","Ը","Է","Զ","Ե","Դ","Գ","Բ","Ա"]},me={integers:[1e4,9e3,8e3,7e3,6e3,5e3,4e3,3e3,2e3,1e3,400,300,200,100,90,80,70,60,50,40,30,20,19,18,17,16,15,10,9,8,7,6,5,4,3,2,1],values:["י׳","ט׳","ח׳","ז׳","ו׳","ה׳","ד׳","ג׳","ב׳","א׳","ת","ש","ר","ק","צ","פ","ע","ס","נ","מ","ל","כ","יט","יח","יז","טז","טו","י","ט","ח","ז","ו","ה","ד","ג","ב","א"]},be={integers:[1e4,9e3,8e3,7e3,6e3,5e3,4e3,3e3,2e3,1e3,900,800,700,600,500,400,300,200,100,90,80,70,60,50,40,30,20,10,9,8,7,6,5,4,3,2,1],values:["ჵ","ჰ","ჯ","ჴ","ხ","ჭ","წ","ძ","ც","ჩ","შ","ყ","ღ","ქ","ფ","ჳ","ტ","ს","რ","ჟ","პ","ო","ჲ","ნ","მ","ლ","კ","ი","თ","ჱ","ზ","ვ","ე","დ","გ","ბ","ა"]},Ne=function(A,e,t,r,n,B){return A<e||A>t?Me(A,n,B.length>0):r.integers.reduce(function(e,t,n){for(;A>=t;)A-=t,e+=r.values[n];return e},"")+B},ye=function(A,e,t,r){var n="";do{t||A--,n=r(A)+n,A/=e}while(A*e>=e);return n},ve=function(A,e,t,r,n){var B=t-e+1;return(A<0?"-":"")+(ye(Math.abs(A),B,r,function(A){return Object(PA.fromCodePoint)(Math.floor(A%B)+e)})+n)},Ie=function(A,e){var t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:". ",r=e.length;return ye(Math.abs(A),r,!1,function(A){return e[Math.floor(A%r)]})+t},De=function(A,e,t,r,n,B){if(A<-9999||A>9999)return Me(A,4,n.length>0);var s=Math.abs(A),o=n;if(0===s)return e[0]+o;for(var a=0;s>0&&a<=4;a++){var i=s%10;0===i&&K(B,1)&&""!==o?o=e[i]+o:i>1||1===i&&0===a||1===i&&1===a&&K(B,2)||1===i&&1===a&&K(B,4)&&A>100||1===i&&a>1&&K(B,8)?o=e[i]+(a>0?t[a-1]:"")+o:1===i&&a>0&&(o=t[a-1]+o),s=Math.floor(s/10)}return(A<0?r:"")+o},Me=function(A,e,t){var r=t?". ":"",n=t?"、":"",B=t?", ":"";switch(e){case 0:return"•";case 1:return"◦";case 2:return"◾";case 5:var s=ve(A,48,57,!0,r);return s.length<4?"0".concat(s):s;case 4:return Ie(A,"〇一二三四五六七八九",n);case 6:return Ne(A,1,3999,pe,3,r).toLowerCase();case 7:return Ne(A,1,3999,pe,3,r);case 8:return ve(A,945,969,!1,r);case 9:return ve(A,97,122,!1,r);case 10:return ve(A,65,90,!1,r);case 11:return ve(A,1632,1641,!0,r);case 12:case 49:return Ne(A,1,9999,Ke,3,r);case 35:return Ne(A,1,9999,Ke,3,r).toLowerCase();case 13:return ve(A,2534,2543,!0,r);case 14:case 30:return ve(A,6112,6121,!0,r);case 15:return Ie(A,"子丑寅卯辰巳午未申酉戌亥",n);case 16:return Ie(A,"甲乙丙丁戊己庚辛壬癸",n);case 17:case 48:return De(A,"零一二三四五六七八九","十百千萬","負",n,14);case 47:return De(A,"零壹貳參肆伍陸柒捌玖","拾佰仟萬","負",n,15);case 42:return De(A,"零一二三四五六七八九","十百千萬","负",n,14);case 41:return De(A,"零壹贰叁肆伍陆柒捌玖","拾佰仟萬","负",n,15);case 26:return De(A,"〇一二三四五六七八九","十百千万","マイナス",n,0);case 25:return De(A,"零壱弐参四伍六七八九","拾百千万","マイナス",n,7);case 31:return De(A,"영일이삼사오육칠팔구","십백천만","마이너스",B,7);case 33:return De(A,"零一二三四五六七八九","十百千萬","마이너스",B,0);case 32:return De(A,"零壹貳參四五六七八九","拾百千","마이너스",B,7);case 18:return ve(A,2406,2415,!0,r);case 20:return Ne(A,1,19999,be,3,r);case 21:return ve(A,2790,2799,!0,r);case 22:return ve(A,2662,2671,!0,r);case 22:return Ne(A,1,10999,me,3,r);case 23:return Ie(A,"あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");case 24:return Ie(A,"いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");case 27:return ve(A,3302,3311,!0,r);case 28:return Ie(A,"アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン",n);case 29:return Ie(A,"イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス",n);case 34:return ve(A,3792,3801,!0,r);case 37:return ve(A,6160,6169,!0,r);case 38:return ve(A,4160,4169,!0,r);case 39:return ve(A,2918,2927,!0,r);case 40:return ve(A,1776,1785,!0,r);case 43:return ve(A,3046,3055,!0,r);case 44:return ve(A,3174,3183,!0,r);case 45:return ve(A,3664,3673,!0,r);case 46:return ve(A,3872,3881,!0,r);case 3:default:return ve(A,48,57,!0,r)}};function Te(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}var Se=["INPUT","TEXTAREA","SELECT"],Xe=function(){function A(e,t,r,n){var B=this;!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.parent=t,this.tagName=e.tagName,this.index=n,this.childNodes=[],this.listItems=[],"number"==typeof e.start&&(this.listStart=e.start);var s=e.ownerDocument.defaultView,o=s.pageXOffset,a=s.pageYOffset,i=s.getComputedStyle(e,null),c=wA(i.display),Q="radio"===e.type||"checkbox"===e.type,l=bA(i.position);if(this.style={background:Q?oe:AA(i,r),border:Q?se:aA(i),borderRadius:(e instanceof s.HTMLInputElement||e instanceof HTMLInputElement)&&Q?ue(e):cA(i),color:Q?te:new U(i.color),display:c,float:uA(i.float),font:UA(i),letterSpacing:gA(i.letterSpacing),listStyle:c===QA.LIST_ITEM?hA(i):null,lineBreak:FA(i.lineBreak),margin:fA(i),opacity:parseFloat(i.opacity),overflow:-1===Se.indexOf(e.tagName)?pA(i.overflow):EA.HIDDEN,overflowWrap:KA(i.overflowWrap?i.overflowWrap:i.wordWrap),padding:G(i),position:l,textDecoration:h(i),textShadow:yA(i.textShadow),textTransform:vA(i.textTransform),transform:MA(i),visibility:XA(i.visibility),wordBreak:zA(i.wordBreak),zIndex:LA(l!==mA.STATIC?i.zIndex:"auto")},this.isTransformed()&&(e.style.transform="matrix(1,0,0,1,0,0)"),c===QA.LIST_ITEM){var w=fe(this);if(w){var u=w.listItems.length;w.listItems.push(this),this.listIndex=e.hasAttribute("value")&&"number"==typeof e.value?e.value:0===u?"number"==typeof w.listStart?w.listStart:1:w.listItems[u-1].listIndex+1}}"IMG"===e.tagName&&e.addEventListener("load",function(){B.bounds=O(e,o,a),B.curvedBounds=J(B.bounds,B.style.border,B.style.borderRadius)}),this.image=ze(e,r),this.bounds=Q?Ce(O(e,o,a)):O(e,o,a),this.curvedBounds=J(this.bounds,this.style.border,this.style.borderRadius)}return function(A,e,t){e&&Te(A.prototype,e)}(A,[{key:"getClipPaths",value:function(){var A=this.parent?this.parent.getClipPaths():[];return this.style.overflow!==EA.VISIBLE?A.concat([k(this.curvedBounds)]):A}},{key:"isInFlow",value:function(){return this.isRootElement()&&!this.isFloating()&&!this.isAbsolutelyPositioned()}},{key:"isVisible",value:function(){return!K(this.style.display,QA.NONE)&&this.style.opacity>0&&0===this.style.visibility}},{key:"isAbsolutelyPositioned",value:function(){return this.style.position!==mA.STATIC&&this.style.position!==mA.RELATIVE}},{key:"isPositioned",value:function(){return this.style.position!==mA.STATIC}},{key:"isFloating",value:function(){return 0!==this.style.float}},{key:"isRootElement",value:function(){return null===this.parent}},{key:"isTransformed",value:function(){return null!==this.style.transform}},{key:"isPositionedWithZIndex",value:function(){return this.isPositioned()&&!this.style.zIndex.auto}},{key:"isInlineLevel",value:function(){return K(this.style.display,QA.INLINE)||K(this.style.display,QA.INLINE_BLOCK)||K(this.style.display,QA.INLINE_FLEX)||K(this.style.display,QA.INLINE_GRID)||K(this.style.display,QA.INLINE_LIST_ITEM)||K(this.style.display,QA.INLINE_TABLE)}},{key:"isInlineBlockOrInlineTable",value:function(){return K(this.style.display,QA.INLINE_BLOCK)||K(this.style.display,QA.INLINE_TABLE)}}]),A}(),ze=function(A,e){if(A instanceof A.ownerDocument.defaultView.SVGSVGElement||A instanceof SVGSVGElement){var t=new XMLSerializer;return e.loadImage("data:image/svg+xml,".concat(encodeURIComponent(t.serializeToString(A))))}switch(A.tagName){case"IMG":var r=A;return e.loadImage(r.currentSrc||r.src);case"CANVAS":var n=A;return e.loadCanvas(n);case"IFRAME":var B=A.getAttribute("data-html2canvas-internal-iframe-key");if(B)return B}return null};function Le(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}var Oe=function(){function A(e,t,r){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.container=e,this.parent=t,this.contexts=[],this.children=[],this.treatAsRealStackingContext=r}return function(A,e,t){e&&Le(A.prototype,e)}(A,[{key:"getOpacity",value:function(){return this.parent?this.container.style.opacity*this.parent.getOpacity():this.container.style.opacity}},{key:"getRealParentStackingContext",value:function(){return!this.parent||this.treatAsRealStackingContext?this:this.parent.getRealParentStackingContext()}}]),A}(),xe=["SCRIPT","HEAD","TITLE","OBJECT","BR","OPTION"],Ve=function(A,e){return A.isRootElement()||A.isPositionedWithZIndex()||A.style.opacity<1||A.isTransformed()||Je(A,e)},ke=function(A){return A.isPositioned()||A.isFloating()},Je=function(A,e){return"BODY"===e.nodeName&&A.parent instanceof Xe&&A.parent.style.background.backgroundColor.isTransparent()};function Re(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}var _e=function(){function A(e){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this._data={},this._document=e}return function(A,e,t){e&&Re(A.prototype,e)}(A,[{key:"_parseMetrics",value:function(A){var e=this._document.createElement("div"),t=this._document.createElement("img"),r=this._document.createElement("span"),n=this._document.body;if(!n)throw new Error("");e.style.visibility="hidden",e.style.fontFamily=A.fontFamily,e.style.fontSize=A.fontSize,e.style.margin="0",e.style.padding="0",n.appendChild(e),t.src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",t.width=1,t.height=1,t.style.margin="0",t.style.padding="0",t.style.verticalAlign="baseline",r.style.fontFamily=A.fontFamily,r.style.fontSize=A.fontSize,r.style.margin="0",r.style.padding="0",r.appendChild(this._document.createTextNode("Hidden Text")),e.appendChild(r),e.appendChild(t);var B=t.offsetTop-r.offsetTop+2;e.removeChild(r),e.appendChild(this._document.createTextNode("Hidden Text")),e.style.lineHeight="normal",t.style.verticalAlign="super";var s=t.offsetTop-e.offsetTop+2;return n.removeChild(e),{baseline:B,middle:s}}},{key:"getMetrics",value:function(A){var e="".concat(A.fontFamily," ").concat(A.fontSize);return void 0===this._data[e]&&(this._data[e]=this._parseMetrics(A)),this._data[e]}}]),A}(),Pe=/([+-]?\d*\.?\d+)(deg|grad|rad|turn)/i;function Ge(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}var We=/^(to )?(left|top|right|bottom)( (left|top|right|bottom))?$/i,Ye=/^([+-]?\d*\.?\d+)% ([+-]?\d*\.?\d+)%$/i,qe=/(px)|%|( 0)$/i,je=/^(from|to|color-stop)\((?:([\d.]+)(%)?,\s*)?(.+?)\)$/i,Ze=/^\s*(circle|ellipse)?\s*((?:([\d.]+)(px|r?em|%)\s*(?:([\d.]+)(px|r?em|%))?)|closest-side|closest-corner|farthest-side|farthest-corner)?\s*(?:at\s*(?:(left|center|right)|([\d.]+)(px|r?em|%))\s+(?:(top|center|bottom)|([\d.]+)(px|r?em|%)))?(?:\s|$)/i,$e={left:new v("0%"),top:new v("0%"),center:new v("50%"),right:new v("100%"),bottom:new v("100%")},At=function(A,e,t){for(var r=[],n=e;n<A.length;n++){var B=A[n],s=qe.test(B),o=B.lastIndexOf(" "),a=new U(s?B.substring(0,o):B),i=s?new v(B.substring(o+1)):n===e?new v("0%"):n===A.length-1?new v("100%"):null;r.push({color:a,stop:i})}for(var c=r.map(function(A){var e=A.color,r=A.stop;return{color:e,stop:0===t?0:r?r.getAbsoluteValue(t)/t:null}}),Q=c[0].stop,l=0;l<c.length;l++)if(null!==Q){var w=c[l].stop;if(null===w){for(var u=l;null===c[u].stop;)u++;for(var g=u-l+1,F=(c[u].stop-Q)/g;l<u;l++)Q=c[l].stop=Q+F}else Q=w}return c},et=function(A,e,t){var r=function(A){var e=A.match(Pe);if(e){var t=parseFloat(e[1]);switch(e[2].toLowerCase()){case"deg":return Math.PI*t/180;case"grad":return Math.PI/200*t;case"rad":return t;case"turn":return 2*Math.PI*t}}return null}(A[0]),n=We.test(A[0]),B=n||null!==r||Ye.test(A[0]),s=B?null!==r?rt(t?r-.5*Math.PI:r,e):n?Bt(A[0],e):st(A[0],e):rt(Math.PI,e),o=B?1:0,a=Math.min(m(Math.abs(s.x0)+Math.abs(s.x1),Math.abs(s.y0)+Math.abs(s.y1)),2*e.width,2*e.height);return new function A(e,t){Ge(this,A),this.type=0,this.colorStops=e,this.direction=t}(At(A,o,a),s)},tt=function(A,e,t){var r=e[0].match(Ze),n=r&&("circle"===r[1]||void 0!==r[3]&&void 0===r[5])?0:1,B={},s={};r&&(void 0!==r[3]&&(B.x=I(A,r[3],r[4]).getAbsoluteValue(t.width)),void 0!==r[5]&&(B.y=I(A,r[5],r[6]).getAbsoluteValue(t.height)),r[7]?s.x=$e[r[7].toLowerCase()]:void 0!==r[8]&&(s.x=I(A,r[8],r[9])),r[10]?s.y=$e[r[10].toLowerCase()]:void 0!==r[11]&&(s.y=I(A,r[11],r[12])));var o={x:void 0===s.x?t.width/2:s.x.getAbsoluteValue(t.width),y:void 0===s.y?t.height/2:s.y.getAbsoluteValue(t.height)},a=at(r&&r[2]||"farthest-corner",n,o,B,t);return new function A(e,t,r,n){Ge(this,A),this.type=1,this.colorStops=e,this.shape=t,this.center=r,this.radius=n}(At(e,r?1:0,Math.min(a.x,a.y)),n,o,a)},rt=function(A,e){var t=e.width,r=e.height,n=.5*t,B=.5*r,s=(Math.abs(t*Math.sin(A))+Math.abs(r*Math.cos(A)))/2,o=n+Math.sin(A)*s,a=B-Math.cos(A)*s;return{x0:o,x1:t-o,y0:a,y1:r-a}},nt=function(A){return Math.acos(A.width/2/(m(A.width,A.height)/2))},Bt=function(A,e){switch(A){case"bottom":case"to top":return rt(0,e);case"left":case"to right":return rt(Math.PI/2,e);case"right":case"to left":return rt(3*Math.PI/2,e);case"top right":case"right top":case"to bottom left":case"to left bottom":return rt(Math.PI+nt(e),e);case"top left":case"left top":case"to bottom right":case"to right bottom":return rt(Math.PI-nt(e),e);case"bottom left":case"left bottom":case"to top right":case"to right top":return rt(nt(e),e);case"bottom right":case"right bottom":case"to top left":case"to left top":return rt(2*Math.PI-nt(e),e);case"top":case"to bottom":default:return rt(Math.PI,e)}},st=function(A,e){var t=function(A,e){return function(A){if(Array.isArray(A))return A}(A)||function(A,e){var t=[],r=!0,n=!1,B=void 0;try{for(var s,o=A[Symbol.iterator]();!(r=(s=o.next()).done)&&(t.push(s.value),!e||t.length!==e);r=!0);}catch(A){n=!0,B=A}finally{try{r||null==o.return||o.return()}finally{if(n)throw B}}return t}(A,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}(A.split(" ").map(parseFloat),2),r=t[0],n=t[1],B=r/100*e.width/(n/100*e.height);return rt(Math.atan(isNaN(B)?1:B)+Math.PI/2,e)},ot=function(A,e,t,r){return[{x:0,y:0},{x:0,y:A.height},{x:A.width,y:0},{x:A.width,y:A.height}].reduce(function(A,n){var B=m(e-n.x,t-n.y);return(r?B<A.optimumDistance:B>A.optimumDistance)?{optimumCorner:n,optimumDistance:B}:A},{optimumDistance:r?1/0:-1/0,optimumCorner:null}).optimumCorner},at=function(A,e,t,r,n){var B=t.x,s=t.y,o=0,a=0;switch(A){case"closest-side":0===e?o=a=Math.min(Math.abs(B),Math.abs(B-n.width),Math.abs(s),Math.abs(s-n.height)):1===e&&(o=Math.min(Math.abs(B),Math.abs(B-n.width)),a=Math.min(Math.abs(s),Math.abs(s-n.height)));break;case"closest-corner":if(0===e)o=a=Math.min(m(B,s),m(B,s-n.height),m(B-n.width,s),m(B-n.width,s-n.height));else if(1===e){var i=Math.min(Math.abs(s),Math.abs(s-n.height))/Math.min(Math.abs(B),Math.abs(B-n.width)),c=ot(n,B,s,!0);a=i*(o=m(c.x-B,(c.y-s)/i))}break;case"farthest-side":0===e?o=a=Math.max(Math.abs(B),Math.abs(B-n.width),Math.abs(s),Math.abs(s-n.height)):1===e&&(o=Math.max(Math.abs(B),Math.abs(B-n.width)),a=Math.max(Math.abs(s),Math.abs(s-n.height)));break;case"farthest-corner":if(0===e)o=a=Math.max(m(B,s),m(B,s-n.height),m(B-n.width,s),m(B-n.width,s-n.height));else if(1===e){var Q=Math.max(Math.abs(s),Math.abs(s-n.height))/Math.max(Math.abs(B),Math.abs(B-n.width)),l=ot(n,B,s,!1);a=Q*(o=m(l.x-B,(l.y-s)/Q))}break;default:o=r.x||0,a=void 0!==r.y?r.y:o}return{x:o,y:a}},it=function(A){var e="",t="",r="",n="",B=0,s=/^(left|center|right|\d+(?:px|r?em|%)?)(?:\s+(top|center|bottom|\d+(?:px|r?em|%)?))?$/i,o=/^\d+(px|r?em|%)?(?:\s+\d+(px|r?em|%)?)?$/i,a=A[B].match(s);a&&B++;var i=A[B].match(/^(circle|ellipse)?\s*(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)?$/i);i&&(e=i[1]||"","contain"===(r=i[2]||"")?r="closest-side":"cover"===r&&(r="farthest-corner"),B++);var c=A[B].match(o);c&&B++;var Q=A[B].match(s);Q&&B++;var l=A[B].match(o);l&&B++;var w=Q||a;w&&w[1]&&(n=w[1]+(/^\d+$/.test(w[1])?"px":""),w[2]&&(n+=" "+w[2]+(/^\d+$/.test(w[2])?"px":"")));var u=l||c;return u&&(t=u[0],u[1]||(t+="px")),!n||e||t||r||(t=n,n=""),n&&(n="at ".concat(n)),[[e,r,t,n].filter(function(A){return!!A}).join(" ")].concat(A.slice(B))},ct=function(A){return A.map(function(A){return A.match(je)}).map(function(e,t){if(!e)return A[t];switch(e[1]){case"from":return"".concat(e[4]," 0%");case"to":return"".concat(e[4]," 100%");case"color-stop":return"%"===e[3]?"".concat(e[4]," ").concat(e[2]):"".concat(e[4]," ").concat(100*parseFloat(e[2]),"%")}})};function Qt(A,e){return function(A){if(Array.isArray(A))return A}(A)||function(A,e){var t=[],r=!0,n=!1,B=void 0;try{for(var s,o=A[Symbol.iterator]();!(r=(s=o.next()).done)&&(t.push(s.value),!e||t.length!==e);r=!0);}catch(A){n=!0,B=A}finally{try{r||null==o.return||o.return()}finally{if(n)throw B}}return t}(A,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function lt(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}var wt=function(){function A(e,t){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.target=e,this.options=t,e.render(t)}return function(A,e,t){e&&lt(A.prototype,e)}(A,[{key:"renderNode",value:function(A){A.isVisible()&&(this.renderNodeBackgroundAndBorders(A),this.renderNodeContent(A))}},{key:"renderNodeContent",value:function(A){var e=this,t=function(){if(A.childNodes.length&&A.childNodes.forEach(function(t){if(t instanceof jA){var r=t.parent.style;e.target.renderTextNode(t.bounds,r.color,r.font,r.textDecoration,r.textShadow)}else e.target.drawShape(t,A.style.color)}),A.image){var t=e.options.imageStore.get(A.image);if(t){var r=function(A,e,t){var r=e[0].value,n=e[1].value,B=e[2].value,s=e[3].value;return new L(A.left+s+t[3].borderWidth,A.top+r+t[0].borderWidth,A.width-(t[1].borderWidth+t[3].borderWidth+s+n),A.height-(t[0].borderWidth+t[2].borderWidth+r+B))}(A.bounds,A.style.padding,A.style.border),n="number"==typeof t.width&&t.width>0?t.width:r.width,B="number"==typeof t.height&&t.height>0?t.height:r.height;n>0&&B>0&&e.target.clip([k(A.curvedBounds)],function(){e.target.drawImage(t,new L(0,0,n,B),r)})}}},r=A.getClipPaths();r.length?this.target.clip(r,t):t()}},{key:"renderNodeBackgroundAndBorders",value:function(A){var e=this,t=!A.style.background.backgroundColor.isTransparent()||A.style.background.backgroundImage.length,r=A.style.border.some(function(A){return 0!==A.borderStyle&&!A.borderColor.isTransparent()}),n=function(){var r=function(A,e){switch(e){case W.BORDER_BOX:return function(A){return[A.topLeftOuter,A.topRightOuter,A.bottomRightOuter,A.bottomLeftOuter]}(A);case W.PADDING_BOX:default:return k(A)}}(A.curvedBounds,A.style.background.backgroundClip);t&&e.target.clip([r],function(){A.style.background.backgroundColor.isTransparent()||e.target.fill(A.style.background.backgroundColor),e.renderBackgroundImage(A)}),A.style.border.forEach(function(t,r){0===t.borderStyle||t.borderColor.isTransparent()||e.renderBorder(t,r,A.curvedBounds)})};if(t||r){var B=A.parent?A.parent.getClipPaths():[];B.length?this.target.clip(B,n):n()}}},{key:"renderBackgroundImage",value:function(A){var e=this;A.style.background.backgroundImage.slice(0).reverse().forEach(function(t){"url"===t.source.method&&t.source.args.length?e.renderBackgroundRepeat(A,t):/gradient/i.test(t.source.method)&&e.renderBackgroundGradient(A,t)})}},{key:"renderBackgroundRepeat",value:function(A,e){var t=this.options.imageStore.get(e.source.args[0]);if(t){var r=Z(A.style.background.backgroundOrigin,A.bounds,A.style.padding,A.style.border),n=function(A,e,t){var r=0,n=0,B=A.size;if(1===B[0].size||2===B[0].size){var s=t.width/t.height,o=e.width/e.height;return s<o!=(2===B[0].size)?new D(t.width,t.width/o):new D(t.height*o,t.height)}return B[0].value&&(r=B[0].value.getAbsoluteValue(t.width)),0===B[0].size&&0===B[1].size?n=e.height:0===B[1].size?n=r/e.width*e.height:B[1].value&&(n=B[1].value.getAbsoluteValue(t.height)),0===B[0].size&&(r=n/e.height*e.width),new D(r,n)}(e,t,r),B=$(e.position,n,r),s=function(A,e,t,r,n){switch(A.repeat){case 2:return[new M(Math.round(n.left),Math.round(r.top+e.y)),new M(Math.round(n.left+n.width),Math.round(r.top+e.y)),new M(Math.round(n.left+n.width),Math.round(t.height+r.top+e.y)),new M(Math.round(n.left),Math.round(t.height+r.top+e.y))];case 3:return[new M(Math.round(r.left+e.x),Math.round(n.top)),new M(Math.round(r.left+e.x+t.width),Math.round(n.top)),new M(Math.round(r.left+e.x+t.width),Math.round(n.height+n.top)),new M(Math.round(r.left+e.x),Math.round(n.height+n.top))];case 1:return[new M(Math.round(r.left+e.x),Math.round(r.top+e.y)),new M(Math.round(r.left+e.x+t.width),Math.round(r.top+e.y)),new M(Math.round(r.left+e.x+t.width),Math.round(r.top+e.y+t.height)),new M(Math.round(r.left+e.x),Math.round(r.top+e.y+t.height))];default:return[new M(Math.round(n.left),Math.round(n.top)),new M(Math.round(n.left+n.width),Math.round(n.top)),new M(Math.round(n.left+n.width),Math.round(n.height+n.top)),new M(Math.round(n.left),Math.round(n.height+n.top))]}}(e,B,n,r,A.bounds),o=Math.round(r.left+B.x),a=Math.round(r.top+B.y);this.target.renderRepeat(s,t,n,o,a)}}},{key:"renderBackgroundGradient",value:function(A,e){var t=Z(A.style.background.backgroundOrigin,A.bounds,A.style.padding,A.style.border),r=function(A,e){var t=A.size,r=t[0].value?t[0].value.getAbsoluteValue(e.width):e.width,n=t[1].value?t[1].value.getAbsoluteValue(e.height):t[0].value?r:e.height;return new D(r,n)}(e,t),n=$(e.position,r,t),B=new L(Math.round(t.left+n.x),Math.round(t.top+n.y),r.width,r.height),s=function(A,e,t){var r=e.args,n=e.method,B=e.prefix;return"linear-gradient"===n?et(r,t,!!B):"gradient"===n&&"linear"===r[0]?et(["to bottom"].concat(ct(r.slice(3))),t,!!B):"radial-gradient"===n?tt(A,"-webkit-"===B?it(r):r,t):"gradient"===n&&"radial"===r[0]?tt(A,ct(it(r.slice(1))),t):void 0}(A,e.source,B);if(s)switch(s.type){case 0:this.target.renderLinearGradient(B,s);break;case 1:this.target.renderRadialGradient(B,s)}}},{key:"renderBorder",value:function(A,e,t){this.target.drawShape(function(A,e){switch(e){case 0:return V(A.topLeftOuter,A.topLeftInner,A.topRightOuter,A.topRightInner);case 1:return V(A.topRightOuter,A.topRightInner,A.bottomRightOuter,A.bottomRightInner);case 2:return V(A.bottomRightOuter,A.bottomRightInner,A.bottomLeftOuter,A.bottomLeftInner);case 3:default:return V(A.bottomLeftOuter,A.bottomLeftInner,A.topLeftOuter,A.topLeftInner)}}(t,e),A.borderColor)}},{key:"renderStack",value:function(A){var e=this;if(A.container.isVisible()){var t=A.getOpacity();t!==this._opacity&&(this.target.setOpacity(A.getOpacity()),this._opacity=t);var r=A.container.style.transform;null!==r?this.target.transform(A.container.bounds.left+r.transformOrigin[0].value,A.container.bounds.top+r.transformOrigin[1].value,r.transform,function(){return e.renderStackContent(A)}):this.renderStackContent(A)}}},{key:"renderStackContent",value:function(A){var e=Qt(Ut(A),5),t=e[0],r=e[1],n=e[2],B=e[3],s=e[4],o=Qt(ut(A),2),a=o[0],i=o[1];this.renderNodeBackgroundAndBorders(A.container),t.sort(gt).forEach(this.renderStack,this),this.renderNodeContent(A.container),i.forEach(this.renderNode,this),B.forEach(this.renderStack,this),s.forEach(this.renderStack,this),a.forEach(this.renderNode,this),r.forEach(this.renderStack,this),n.sort(gt).forEach(this.renderStack,this)}},{key:"render",value:function(A){return this.options.backgroundColor&&this.target.rectangle(this.options.x,this.options.y,this.options.width,this.options.height,this.options.backgroundColor),this.renderStack(A),this.target.getTarget()}}]),A}(),ut=function(A){for(var e=[],t=[],r=A.children.length,n=0;n<r;n++){var B=A.children[n];B.isInlineLevel()?e.push(B):t.push(B)}return[e,t]},Ut=function(A){for(var e=[],t=[],r=[],n=[],B=[],s=A.contexts.length,o=0;o<s;o++){var a=A.contexts[o];a.container.isPositioned()||a.container.style.opacity<1||a.container.isTransformed()?a.container.style.zIndex.order<0?e.push(a):a.container.style.zIndex.order>0?r.push(a):t.push(a):a.container.isFloating()?n.push(a):B.push(a)}return[e,t,r,n,B]},gt=function(A,e){return A.container.style.zIndex.order>e.container.style.zIndex.order?1:A.container.style.zIndex.order<e.container.style.zIndex.order?-1:A.container.index>e.container.index?1:-1},Ft=function(A,e){if(!e.proxy)return Promise.reject(null);var t=e.proxy;return new Promise(function(r,n){var B=_A.SUPPORT_CORS_XHR&&_A.SUPPORT_RESPONSE_TYPE?"blob":"text",s=_A.SUPPORT_CORS_XHR?new XMLHttpRequest:new XDomainRequest;if(s.onload=function(){if(s instanceof XMLHttpRequest)if(200===s.status)if("text"===B)r(s.response);else{var A=new FileReader;A.addEventListener("load",function(){return r(A.result)},!1),A.addEventListener("error",function(A){return n(A)},!1),A.readAsDataURL(s.response)}else n("");else r(s.responseText)},s.onerror=n,s.open("GET","".concat(t,"?url=").concat(encodeURIComponent(A),"&responseType=").concat(B)),"text"!==B&&s instanceof XMLHttpRequest&&(s.responseType=B),e.imageTimeout){var o=e.imageTimeout;s.timeout=o,s.ontimeout=function(){return n("")}}s.send()})};function Ct(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}function ht(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}function dt(A,e,t){return e&&ht(A.prototype,e),t&&ht(A,t),A}var Ht=function(){function A(e,t,r){Ct(this,A),this.options=e,this._window=r,this.origin=this.getOrigin(r.location.href),this.cache={},this.logger=t,this._index=0}return dt(A,[{key:"loadImage",value:function(A){var e=this;if(this.hasResourceInCache(A))return A;if(Nt(A))return this.cache[A]=vt(A,this.options.imageTimeout||0),A;if(!yt(A)||_A.SUPPORT_SVG_DRAWING){if(!0===this.options.allowTaint||mt(A)||this.isSameOrigin(A))return this.addImage(A,A,!1);if(!this.isSameOrigin(A)){if("string"==typeof this.options.proxy)return this.cache[A]=Ft(A,this.options).then(function(A){return vt(A,e.options.imageTimeout||0)}),A;if(!0===this.options.useCORS&&_A.SUPPORT_CORS_IMAGES)return this.addImage(A,A,!0)}}}},{key:"inlineImage",value:function(A){var e=this;return mt(A)?vt(A,this.options.imageTimeout||0):this.hasResourceInCache(A)?this.cache[A]:this.isSameOrigin(A)||"string"!=typeof this.options.proxy?this.xhrImage(A):this.cache[A]=Ft(A,this.options).then(function(A){return vt(A,e.options.imageTimeout||0)})}},{key:"xhrImage",value:function(A){var e=this;return this.cache[A]=new Promise(function(t,r){var n=new XMLHttpRequest;if(n.onreadystatechange=function(){if(4===n.readyState)if(200!==n.status)r("Failed to fetch image ".concat(A.substring(0,256)," with status code ").concat(n.status));else{var e=new FileReader;e.addEventListener("load",function(){var A=e.result;t(A)},!1),e.addEventListener("error",function(A){return r(A)},!1),e.readAsDataURL(n.response)}},n.responseType="blob",e.options.imageTimeout){var B=e.options.imageTimeout;n.timeout=B,n.ontimeout=function(){return r("")}}n.open("GET",A,!0),n.send()}).then(function(A){return vt(A,e.options.imageTimeout||0)}),this.cache[A]}},{key:"loadCanvas",value:function(A){var e=String(this._index++);return this.cache[e]=Promise.resolve(A),e}},{key:"hasResourceInCache",value:function(A){return void 0!==this.cache[A]}},{key:"addImage",value:function(A,e,t){var r=this;return this.cache[A]=new Promise(function(A,n){var B=new Image;if(B.onload=function(){return A(B)},(bt(e)||t)&&(B.crossOrigin="anonymous"),B.onerror=n,B.src=e,!0===B.complete&&setTimeout(function(){A(B)},500),r.options.imageTimeout){var s=r.options.imageTimeout;setTimeout(function(){return n("")},s)}}),A}},{key:"isSameOrigin",value:function(A){return this.getOrigin(A)===this.origin}},{key:"getOrigin",value:function(A){var e=this._link||(this._link=this._window.document.createElement("a"));return e.href=A,e.href=e.href,e.protocol+e.hostname+e.port}},{key:"ready",value:function(){var A=this,e=Object.keys(this.cache),t=e.map(function(e){return A.cache[e].catch(function(A){return null})});return Promise.all(t).then(function(A){return new ft(e,A)})}}]),A}(),ft=function(){function A(e,t){Ct(this,A),this._keys=e,this._resources=t}return dt(A,[{key:"get",value:function(A){var e=this._keys.indexOf(A);return-1===e?null:this._resources[e]}}]),A}(),Et=/^data:image\/svg\+xml/i,pt=/^data:image\/.*;base64,/i,Kt=/^data:image\/.*/i,mt=function(A){return Kt.test(A)},bt=function(A){return pt.test(A)},Nt=function(A){return"blob"===A.substr(0,4)},yt=function(A){return"svg"===A.substr(-3).toLowerCase()||Et.test(A)},vt=function(A,e){return new Promise(function(t,r){var n=new Image;n.onload=function(){return t(n)},n.onerror=r,n.src=A,!0===n.complete&&setTimeout(function(){t(n)},500),e&&setTimeout(function(){return r("")},e)})};function It(A,e){return function(A){if(Array.isArray(A))return A}(A)||function(A,e){var t=[],r=!0,n=!1,B=void 0;try{for(var s,o=A[Symbol.iterator]();!(r=(s=o.next()).done)&&(t.push(s.value),!e||t.length!==e);r=!0);}catch(A){n=!0,B=A}finally{try{r||null==o.return||o.return()}finally{if(n)throw B}}return t}(A,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}var Dt=function(A,e,t){if(!e||!e.content||"none"===e.content||"-moz-alt-content"===e.content||"none"===e.display)return null;var r=Mt(e.content),n=r.length,B=[],s="",o=e.counterIncrement;if(o&&"none"!==o){var a=It(o.split(/\s+/),2),i=a[0],c=a[1],Q=t.counters[i];Q&&(Q[Q.length-1]+=void 0===c?1:parseInt(c,10))}for(var l=0;l<n;l++){var w=r[l];switch(w.type){case 0:s+=w.value||"";break;case 1:A instanceof HTMLElement&&w.value&&(s+=A.getAttribute(w.value)||"");break;case 3:var u=t.counters[w.name||""];u&&(s+=Xt([u[u.length-1]],"",w.format));break;case 4:var U=t.counters[w.name||""];U&&(s+=Xt(U,w.glue,w.format));break;case 5:s+=St(e,!0,t.quoteDepth),t.quoteDepth++;break;case 6:t.quoteDepth--,s+=St(e,!1,t.quoteDepth);break;case 2:s&&(B.push({type:0,value:s}),s=""),B.push({type:1,value:w.value||""})}}return s&&B.push({type:0,value:s}),B},Mt=function(A,e){if(e&&e[A])return e[A];for(var t=[],r=A.length,n=!1,B=!1,s=!1,o="",a="",i=[],c=0;c<r;c++){var Q=A.charAt(c);switch(Q){case"'":case'"':B?o+=Q:(n=!n,s||n||(t.push({type:0,value:o}),o=""));break;case"\\":B?(o+=Q,B=!1):B=!0;break;case"(":n?o+=Q:(s=!0,a=o,o="",i=[]);break;case")":if(n)o+=Q;else if(s){switch(o&&i.push(o),a){case"attr":i.length>0&&t.push({type:1,value:i[0]});break;case"counter":if(i.length>0){var l={type:3,name:i[0]};i.length>1&&(l.format=i[1]),t.push(l)}break;case"counters":if(i.length>0){var w={type:4,name:i[0]};i.length>1&&(w.glue=i[1]),i.length>2&&(w.format=i[2]),t.push(w)}break;case"url":i.length>0&&t.push({type:2,value:i[0]})}s=!1,o=""}break;case",":n?o+=Q:s&&(i.push(o),o="");break;case" ":case"\t":n?o+=Q:o&&(Tt(t,o),o="");break;default:o+=Q}"\\"!==Q&&(B=!1)}return o&&Tt(t,o),e&&(e[A]=t),t},Tt=function(A,e){switch(e){case"open-quote":A.push({type:5});break;case"close-quote":A.push({type:6})}},St=function(A,e,t){var r=A.quotes?A.quotes.split(/\s+/):["'\"'","'\"'"],n=2*t;return n>=r.length&&(n=r.length-2),e||++n,r[n].replace(/^["']|["']$/g,"")},Xt=function(A,e,t){for(var r=A.length,n="",B=0;B<r;B++)B>0&&(n+=e||""),n+=Me(A[B],CA(t||"decimal"),!1);return n};function zt(A,e){for(var t=0;t<e.length;t++){var r=e[t];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(A,r.key,r)}}var Lt=function(){function A(e,t,r,n,B){!function(A,e){if(!(A instanceof e))throw new TypeError("Cannot call a class as a function")}(this,A),this.referenceElement=e,this.scrolledElements=[],this.copyStyles=n,this.inlineImages=n,this.logger=r,this.options=t,this.renderer=B,this.resourceLoader=new Ht(t,r,window),this.pseudoContentData={counters:{},quoteDepth:0},this.documentElement=this.cloneNode(e.ownerDocument.documentElement)}return function(A,e,t){e&&zt(A.prototype,e)}(A,[{key:"inlineAllImages",value:function(A){var e=this;if(this.inlineImages&&A){var t=A.style;Promise.all(sA(t.backgroundImage).map(function(A){return"url"===A.method?e.resourceLoader.inlineImage(A.args[0]).then(function(A){return A&&"string"==typeof A.src?'url("'.concat(A.src,'")'):"none"}).catch(function(A){}):Promise.resolve("".concat(A.prefix).concat(A.method,"(").concat(A.args.join(","),")"))})).then(function(A){A.length>1&&(t.backgroundColor=""),t.backgroundImage=A.join(",")}),A instanceof HTMLImageElement&&this.resourceLoader.inlineImage(A.src).then(function(e){if(e&&A instanceof HTMLImageElement&&A.parentNode){var t=A.parentNode,r=b(A.style,e.cloneNode(!1));t.replaceChild(r,A)}}).catch(function(A){})}}},{key:"inlineFonts",value:function(A){var e=this;return Promise.all(Array.from(A.styleSheets).map(function(e){return e.href?fetch(e.href).then(function(A){return A.text()}).then(function(A){return xt(A,e.href)}).catch(function(A){return[]}):Ot(e,A)})).then(function(A){return A.reduce(function(A,e){return A.concat(e)},[])}).then(function(A){return Promise.all(A.map(function(A){return fetch(A.formats[0].src).then(function(A){return A.blob()}).then(function(A){return new Promise(function(e,t){var r=new FileReader;r.onerror=t,r.onload=function(){var A=r.result;e(A)},r.readAsDataURL(A)})}).then(function(e){return A.fontFace.setProperty("src",'url("'.concat(e,'")')),"@font-face {".concat(A.fontFace.cssText," ")})}))}).then(function(t){var r=A.createElement("style");r.textContent=t.join("\n"),e.documentElement.appendChild(r)})}},{key:"createElementClone",value:function(A){var e=this;if(this.copyStyles&&A instanceof HTMLCanvasElement){var t=A.ownerDocument.createElement("img");try{return t.src=A.toDataURL(),t}catch(A){}}if(A instanceof HTMLIFrameElement){var r=A.cloneNode(!1),n=qt();r.setAttribute("data-html2canvas-internal-iframe-key",n);var B=O(A,0,0),s=B.width,o=B.height;return this.resourceLoader.cache[n]=Zt(A,this.options).then(function(A){return e.renderer(A,{allowTaint:e.options.allowTaint,backgroundColor:"#ffffff",canvas:null,imageTimeout:e.options.imageTimeout,logging:e.options.logging,proxy:e.options.proxy,removeContainer:e.options.removeContainer,scale:e.options.scale,foreignObjectRendering:e.options.foreignObjectRendering,useCORS:e.options.useCORS,target:new f,width:s,height:o,x:0,y:0,windowWidth:A.ownerDocument.defaultView.innerWidth,windowHeight:A.ownerDocument.defaultView.innerHeight,scrollX:A.ownerDocument.defaultView.pageXOffset,scrollY:A.ownerDocument.defaultView.pageYOffset},e.logger.child(n))}).then(function(e){return new Promise(function(t,n){var B=document.createElement("img");B.onload=function(){return t(e)},B.onerror=function(A){"data:,"==B.src?t(e):n(A)},B.src=e.toDataURL(),r.parentNode&&r.parentNode.replaceChild(b(A.ownerDocument.defaultView.getComputedStyle(A),B),r)})}),r}try{if(A instanceof HTMLStyleElement&&A.sheet&&A.sheet.cssRules){var a=[].slice.call(A.sheet.cssRules,0).reduce(function(A,e){return e&&e.cssText?A+e.cssText:A},""),i=A.cloneNode(!1);return i.textContent=a,i}}catch(A){if(this.logger.log("Unable to access cssRules property"),"SecurityError"!==A.name)throw this.logger.log(A),A}return A.cloneNode(!1)}},{key:"cloneNode",value:function(A){var e=A.nodeType===Node.TEXT_NODE?document.createTextNode(A.nodeValue):this.createElementClone(A),t=A.ownerDocument.defaultView,r=A instanceof t.HTMLElement?t.getComputedStyle(A):null,n=A instanceof t.HTMLElement?t.getComputedStyle(A,":before"):null,B=A instanceof t.HTMLElement?t.getComputedStyle(A,":after"):null;this.referenceElement===A&&e instanceof t.HTMLElement&&(this.clonedReferenceElement=e),e instanceof t.HTMLBodyElement&&Gt(e);for(var s=function(A,e){if(!A||!A.counterReset||"none"===A.counterReset)return[];for(var t=[],r=A.counterReset.split(/\s*,\s*/),n=r.length,B=0;B<n;B++){var s=It(r[B].split(/\s+/),2),o=s[0],a=s[1];t.push(o);var i=e.counters[o];i||(i=e.counters[o]=[]),i.push(parseInt(a||0,10))}return t}(r,this.pseudoContentData),o=Dt(A,n,this.pseudoContentData),a=A.firstChild;a;a=a.nextSibling)a.nodeType===Node.ELEMENT_NODE&&("SCRIPT"===a.nodeName||a.hasAttribute("data-html2canvas-ignore")||"function"==typeof this.options.ignoreElements&&this.options.ignoreElements(a))||this.copyStyles&&"STYLE"===a.nodeName||e.appendChild(this.cloneNode(a));var i=Dt(A,B,this.pseudoContentData);if(function(A,e){for(var t=A.length,r=0;r<t;r++)e.counters[A[r]].pop()}(s,this.pseudoContentData),A instanceof t.HTMLElement&&e instanceof t.HTMLElement)switch(n&&this.inlineAllImages(kt(A,e,n,o,Jt)),B&&this.inlineAllImages(kt(A,e,B,i,Rt)),!r||!this.copyStyles||A instanceof HTMLIFrameElement||b(r,e),this.inlineAllImages(e),0===A.scrollTop&&0===A.scrollLeft||this.scrolledElements.push([e,A.scrollLeft,A.scrollTop]),A.nodeName){case"CANVAS":this.copyStyles||Vt(A,e);break;case"TEXTAREA":case"SELECT":e.value=A.value}return e}}]),A}(),Ot=function(A,e){return(A.cssRules?Array.from(A.cssRules):[]).filter(function(A){return A.type===CSSRule.FONT_FACE_RULE}).map(function(A){for(var t=sA(A.style.getPropertyValue("src")),r=[],n=0;n<t.length;n++)if("url"===t[n].method&&t[n+1]&&"format"===t[n+1].method){var B=e.createElement("a");B.href=t[n].args[0],e.body&&e.body.appendChild(B);var s={src:B.href,format:t[n+1].args[0]};r.push(s)}return{formats:r.filter(function(A){return/^woff/i.test(A.format)}),fontFace:A.style}}).filter(function(A){return A.formats.length})},xt=function(A,e){var t=document.implementation.createHTMLDocument(""),r=document.createElement("base");r.href=e;var n=document.createElement("style");return n.textContent=A,t.head&&t.head.appendChild(r),t.body&&t.body.appendChild(n),n.sheet?Ot(n.sheet,t):[]},Vt=function(A,e){try{if(e){e.width=A.width,e.height=A.height;var t=A.getContext("2d"),r=e.getContext("2d");t?r.putImageData(t.getImageData(0,0,A.width,A.height),0,0):r.drawImage(A,0,0)}}catch(A){}},kt=function(A,e,t,r,n){if(t&&t.content&&"none"!==t.content&&"-moz-alt-content"!==t.content&&"none"!==t.display){var B=e.ownerDocument.createElement("html2canvaspseudoelement");if(b(t,B),r)for(var s=r.length,o=0;o<s;o++){var a=r[o];switch(a.type){case 1:var i=e.ownerDocument.createElement("img");i.src=sA("url(".concat(a.value,")"))[0].args[0],i.style.opacity="1",B.appendChild(i);break;case 0:B.appendChild(e.ownerDocument.createTextNode(a.value))}}return B.className="".concat(_t," ").concat(Pt),e.className+=" ".concat(n===Jt?_t:Pt),n===Jt?e.insertBefore(B,e.firstChild):e.appendChild(B),B}},Jt=":before",Rt=":after",_t="___html2canvas___pseudoelement_before",Pt="___html2canvas___pseudoelement_after",Gt=function(A){Wt(A,".".concat(_t).concat(Jt).concat('{\n    content: "" !important;\n    display: none !important;\n}',"\n         .").concat(Pt).concat(Rt).concat('{\n    content: "" !important;\n    display: none !important;\n}'))},Wt=function(A,e){var t=A.ownerDocument.createElement("style");t.innerHTML=e,A.appendChild(t)},Yt=function(A){var e=function(A,e){return function(A){if(Array.isArray(A))return A}(A)||function(A,e){var t=[],r=!0,n=!1,B=void 0;try{for(var s,o=A[Symbol.iterator]();!(r=(s=o.next()).done)&&(t.push(s.value),!e||t.length!==e);r=!0);}catch(A){n=!0,B=A}finally{try{r||null==o.return||o.return()}finally{if(n)throw B}}return t}(A,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}(A,3),t=e[0],r=e[1],n=e[2];t.scrollLeft=r,t.scrollTop=n},qt=function(){return Math.ceil(Date.now()+1e7*Math.random()).toString(16)},jt=/^data:text\/(.+);(base64)?,(.*)$/i,Zt=function(A,e){try{return Promise.resolve(A.contentWindow.document.documentElement)}catch(t){return e.proxy?Ft(A.src,e).then(function(A){var e=A.match(jt);return e?"base64"===e[2]?window.atob(decodeURIComponent(e[3])):decodeURIComponent(e[3]):Promise.reject()}).then(function(e){return $t(A.ownerDocument,O(A,0,0)).then(function(A){var t=A.contentWindow.document;t.open(),t.write(e);var r=Ar(A).then(function(){return t.documentElement});return t.close(),r})}):Promise.reject()}},$t=function(A,e){var t=A.createElement("iframe");return t.className="html2canvas-container",t.style.visibility="hidden",t.style.position="fixed",t.style.left="-10000px",t.style.top="0px",t.style.border="0",t.width=e.width.toString(),t.height=e.height.toString(),t.scrolling="no",t.setAttribute("data-html2canvas-ignore","true"),A.body?(A.body.appendChild(t),Promise.resolve(t)):Promise.reject("")},Ar=function(A){var e=A.contentWindow,t=e.document;return new Promise(function(r,n){e.onload=A.onload=t.onreadystatechange=function(){var e=setInterval(function(){t.body.childNodes.length>0&&"complete"===t.readyState&&(clearInterval(e),r(A))},50)}})};var er=function A(e,t,r){var n=e.ownerDocument,B=new L(t.scrollX,t.scrollY,t.windowWidth,t.windowHeight),s=n.documentElement?new U(getComputedStyle(n.documentElement).backgroundColor):F,o=n.body?new U(getComputedStyle(n.body).backgroundColor):F,a=e===n.documentElement?s.isTransparent()?o.isTransparent()?t.backgroundColor?new U(t.backgroundColor):null:o:s:t.backgroundColor?new U(t.backgroundColor):null;return(t.foreignObjectRendering?_A.SUPPORT_FOREIGNOBJECT_DRAWING:Promise.resolve(!1)).then(function(s){return s?function(A){return A.inlineFonts(n).then(function(){return A.resourceLoader.ready()}).then(function(){var B=new xA(A.documentElement),s=n.defaultView,o=s.pageXOffset,i=s.pageYOffset,c="HTML"===e.tagName||"BODY"===e.tagName?x(n):O(e,o,i),Q=c.width,l=c.height,w=c.left,u=c.top;return B.render({backgroundColor:a,logger:r,scale:t.scale,x:"number"==typeof t.x?t.x:w,y:"number"==typeof t.y?t.y:u,width:"number"==typeof t.width?t.width:Math.ceil(Q),height:"number"==typeof t.height?t.height:Math.ceil(l),windowWidth:t.windowWidth,windowHeight:t.windowHeight,scrollX:t.scrollX,scrollY:t.scrollY})})}(new Lt(e,t,r,!0,A)):function(A,e,t,r,n,B){var s=new Lt(t,r,n,!1,B),o=A.defaultView.pageXOffset,a=A.defaultView.pageYOffset;return $t(A,e).then(function(n){var B=n.contentWindow,i=B.document,c=Ar(n).then(function(){s.scrolledElements.forEach(Yt),B.scrollTo(e.left,e.top),!/(iPad|iPhone|iPod)/g.test(navigator.userAgent)||B.scrollY===e.top&&B.scrollX===e.left||(i.documentElement.style.top=-e.top+"px",i.documentElement.style.left=-e.left+"px",i.documentElement.style.position="absolute");var t=Promise.resolve([n,s.clonedReferenceElement,s.resourceLoader]),o=r.onclone;return s.clonedReferenceElement instanceof B.HTMLElement||s.clonedReferenceElement instanceof A.defaultView.HTMLElement||s.clonedReferenceElement instanceof HTMLElement?"function"==typeof o?Promise.resolve().then(function(){return o(i)}).then(function(){return t}):t:Promise.reject("")});return i.open(),i.write("".concat(function(A){var e="";return A&&(e+="<!DOCTYPE ",A.name&&(e+=A.name),A.internalSubset&&(e+=A.internalSubset),A.publicId&&(e+='"'.concat(A.publicId,'"')),A.systemId&&(e+='"'.concat(A.systemId,'"')),e+=">"),e}(document.doctype),"<html></html>")),function(A,e,t){!A.defaultView||e===A.defaultView.pageXOffset&&t===A.defaultView.pageYOffset||A.defaultView.scrollTo(e,t)}(t.ownerDocument,o,a),i.replaceChild(i.adoptNode(s.documentElement),i.documentElement),i.close(),c})}(n,B,e,t,r,A).then(function(A){var e=function(A,e){return function(A){if(Array.isArray(A))return A}(A)||function(A,e){var t=[],r=!0,n=!1,B=void 0;try{for(var s,o=A[Symbol.iterator]();!(r=(s=o.next()).done)&&(t.push(s.value),!e||t.length!==e);r=!0);}catch(A){n=!0,B=A}finally{try{r||null==o.return||o.return()}finally{if(n)throw B}}return t}(A,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}(A,3),B=e[0],s=e[1],o=e[2],i=function(A,e,t){var r=0,n=new Xe(A,null,e,r++),B=new Oe(n,null,!0);return function A(e,t,r,n,B){for(var s,o=e.firstChild;o;o=s){s=o.nextSibling;var a=o.ownerDocument.defaultView;if(o instanceof a.Text||o instanceof Text||a.parent&&o instanceof a.parent.Text)o.data.trim().length>0&&t.childNodes.push(jA.fromTextNode(o,t));else if(o instanceof a.HTMLElement||o instanceof HTMLElement||a.parent&&o instanceof a.parent.HTMLElement){if(-1===xe.indexOf(o.nodeName)){var i=new Xe(o,t,n,B++);if(i.isVisible()){"INPUT"===o.tagName?Ue(o,i):"TEXTAREA"===o.tagName?ge(o,i):"SELECT"===o.tagName?Fe(o,i):i.style.listStyle&&-1!==i.style.listStyle.listStyleType&&Ee(o,i,n);var c="TEXTAREA"!==o.tagName,Q=Ve(i,o);if(Q||ke(i)){var l=Q||i.isPositioned()?r.getRealParentStackingContext():r,w=new Oe(i,l,Q);l.contexts.push(w),c&&A(o,i,w,n,B)}else r.children.push(i),c&&A(o,i,r,n,B)}}}else if(o instanceof a.SVGSVGElement||o instanceof SVGSVGElement||a.parent&&o instanceof a.parent.SVGSVGElement){var u=new Xe(o,t,n,B++),U=Ve(u,o);if(U||ke(u)){var g=U||u.isPositioned()?r.getRealParentStackingContext():r,F=new Oe(u,g,U);g.contexts.push(F)}else r.children.push(u)}}}(A,n,B,e,1),B}(s,o),c=s.ownerDocument;return a===i.container.style.background.backgroundColor&&(i.container.style.background.backgroundColor=F),o.ready().then(function(A){var e=new _e(c),o=c.defaultView,Q=o.pageXOffset,l=o.pageYOffset,w="HTML"===s.tagName||"BODY"===s.tagName?x(n):O(s,Q,l),u=w.width,U=w.height,g=w.left,F=w.top,C={backgroundColor:a,fontMetrics:e,imageStore:A,logger:r,scale:t.scale,x:"number"==typeof t.x?t.x:g,y:"number"==typeof t.y?t.y:F,width:"number"==typeof t.width?t.width:Math.ceil(u),height:"number"==typeof t.height?t.height:Math.ceil(U)};if(Array.isArray(t.target))return Promise.all(t.target.map(function(A){return new wt(A,C).render(i)}));var h=new wt(t.target,C).render(i);return!0===t.removeContainer&&B.parentNode&&B.parentNode.removeChild(B),h})})})};function tr(A,e,t){return e in A?Object.defineProperty(A,e,{value:t,enumerable:!0,configurable:!0,writable:!0}):A[e]=t,A}var rr=function(A,e){var t=e||{},r=new p("boolean"!=typeof t.logging||t.logging);r.log("html2canvas ".concat("1.0.0-rc.1"));var n=A.ownerDocument;if(!n)return Promise.reject("Provided element is not within a Document");var B=n.defaultView,s={allowTaint:!1,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,scale:B.devicePixelRatio||1,target:new f(t.canvas),useCORS:!1,windowWidth:B.innerWidth,windowHeight:B.innerHeight,scrollX:B.pageXOffset,scrollY:B.pageYOffset};return er(A,function(A){for(var e=1;e<arguments.length;e++){var t=null!=arguments[e]?arguments[e]:{},r=Object.keys(t);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(t).filter(function(A){return Object.getOwnPropertyDescriptor(t,A).enumerable}))),r.forEach(function(e){tr(A,e,t[e])})}return A}({},s,t),r)};rr.CanvasRenderer=f,e.default=rr}]).default});
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .config(toastrLibConfig);

    /** @ngInject */
    function toastrLibConfig(toastrConfig) {
        angular.extend(toastrConfig, {
            closeButton: false,
            closeHtml: '<button>&times;</button>',
            timeOut: 3000,
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 3,
            newestOnTop: true,
            positionClass: 'toast-bottom-center',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body'
        });
    }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('ngFileSelect', ngFileSelect);

    /** @ngInject */
    function ngFileSelect() {
        return {
            link: function ($scope, el) {
                el.bind('change', function (e) {
                    $scope.file = (e.srcElement || e.target).files[0];
                    console.log('EN DIRECTIVA ', $scope.file);
                    $scope.getFile();
                });
            }
        }
    }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .service('ScreenLoader', ScreenLoader);

    /** @ngInject */
    function ScreenLoader($rootScope, $timeout) {
        return {
            show: function () {
                $timeout(function () {
                    if ($rootScope.$currentEdition) {
                        $('#loading').find('i').css('color', $rootScope.$currentEdition.color1);
                    }
                    $('#loading').fadeIn();
                });
            },
            hide: function () {
                $timeout(function () {
                    $('#loading').fadeOut();
                });
            }
        }
    }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.associated.company')
        .controller('AssociatedCompanyPageCtrl', AssociatedCompanyPageCtrl);

    /** @ngInject */
    function AssociatedCompanyPageCtrl($scope, $rootScope, $state, $stateParams, toastr, $q, ScreenLoader, UserAssociated, LoopBackAuth, messagesHelper, validationUtils, Sector, entityType) {

        $scope.company = {};
        $scope.sectors = [];

        /** load user company */
        $scope.loadCompany = function () {
            ScreenLoader.show();
            UserAssociated.prototype$__get__company({id: $stateParams.id}, function (response) {
                ScreenLoader.hide();
                $scope.company = response;
            }, function (errorResponse) {
                ScreenLoader.hide();
            });
        };

        /** create or update user company */
        $scope.createOrUpdate = function (isValid) {
            if (isValid) {
                ScreenLoader.show();
                if ($scope.company.id) {
                    UserAssociated.prototype$__update__company({id: $stateParams.id}, $scope.company,
                        function (response) {
                            ScreenLoader.hide();
                            $scope.company = response;
                            $rootScope.userLogged.company = angular.copy(response);
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $state.go('main.associated.list');
                        }, function (errorResponse) {
                            ScreenLoader.hide();
                            toastr.clear();
                            validationUtils.processErrorResponse(errorResponse);
                        }
                    );
                } else {
                    $scope.company.type = entityType.LOCAL;
                    UserAssociated.prototype$__create__company({id: $stateParams.id}, $scope.company,
                        function (response) {
                            ScreenLoader.hide();
                            $scope.company = response;
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $state.go('main.associated.list');
                        }, function (errorResponse) {
                            ScreenLoader.hide();
                            toastr.clear();
                            validationUtils.processErrorResponse(errorResponse);
                        }
                    );
                }
            }
        };

        /** load sectors */
        $scope.loadSectors = function () {
            Sector.find({}, function (response) {
                $scope.sectors = response;
            }, function (errorResponse) {
                console.log('load sectors error.', errorResponse)
            });
        };

        /** init */
        $scope.loadCompany();
        $scope.loadSectors();
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.project.updates')
        .controller('ProjectUpdatesPageCtrl', ProjectUpdatesPageCtrl);

    /** @ngInject */
    function ProjectUpdatesPageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, confirmModal, paginateHelper, Project, Update, ScreenLoader, validationUtils, messagesHelper, updateStatus, projectStatus, LoopBackAuth, textAngularManager) {

        $scope.update = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.taToolbar = [
            [/*'h1', 'h2', 'h3', 'h4', 'h5', 'h6',*/ 'p', 'pre', 'quote', 'fontSize'],
            ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
            ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount'],
        ];

        $scope.projects = [];
        $scope.statusList = [{
            key: updateStatus.PENDING,
            name: 'Pendiente'
        }, {
            key: updateStatus.PUBLISHED,
            name: 'Publicado'
        }];

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order,
                include: ['project'],
            };

            $timeout(function () {
                $q.all([
                    Update.count({where: $scope.query.filter.where}).$promise,
                    Update.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadUpdate = function () {
            $scope.update = {};
            Update.findById({id: $stateParams.id, filter: {include: ["project"]}}, function (response) {
                $scope.update = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {

                if (!$scope.update.content || $scope.getCharCount() === 0) {
                    toastr.clear();
                    toastr.error(messagesHelper.complete_all_fields);
                    return;
                }

                ScreenLoader.show();
                $scope.update.date = Date.now();
                Update.create($scope.update,
                    function (response) {
                        ScreenLoader.hide();
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.project.updates.list');
                    }, function (errorResponse) {
                        ScreenLoader.hide();
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.updateChanges = function (isValid) {
            if (isValid) {

                if (!$scope.update.content || $scope.getCharCount() === 0) {
                    toastr.clear();
                    toastr.error(messagesHelper.complete_all_fields);
                    return;
                }

                var patch = {
                    idProject: $scope.update.idProject,
                    content: $scope.update.content,
                    status: $scope.update.status,
                    date: Date.now(),
                };
                Update.prototype$patchAttributes({id: $scope.update.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.project.updates.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Update.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** change status */
        $scope.changeStatus = function (id, status) {
            var patch = {
                status: status,
            };
            ScreenLoader.show();
            Update.prototype$patchAttributes({id: id}, patch,
                function (response) {
                    ScreenLoader.hide();
                    toastr.clear();
                    toastr.success(messagesHelper.success_operation);
                }, function (errorResponse) {
                    ScreenLoader.hide();
                    validationUtils.processErrorResponse(errorResponse);
                }
            );
        };

        /** find projects */
        $scope.loadProjects = function () {
            Project.find({
                filter: {
                    where: {
                        idProject: {eq: null}
                    },
                    order: "nameToPublish ASC"
                }
            }, function (response) {
                $scope.projects = response;
            }, function (errorResponse) {
                console.log('Projects load error.', errorResponse)
            });
        };

        $scope.getCharCount = function () {
            return textAngularManager.retrieveEditor('ta-project-update').scope.charcount;
        };

        /** init */
        $scope.loadProjects();

    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.alliance')
        .controller('AlliancePageCtrl', AlliancePageCtrl);

    /** @ngInject */
    function AlliancePageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, $uibModal, confirmModal, paginateHelper, Alliance, messagesHelper, validationUtils) {

        $scope.alliance = {
            order: 1,
        };
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.selectedCategories = [];

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order,
            };

            $timeout(function () {
                $q.all([
                    Alliance.count({where: $scope.query.filter.where}).$promise,
                    Alliance.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadAlliance = function () {
            $scope.alliance = {};
            Alliance.findById({id: $stateParams.id}, function (response) {
                $scope.alliance = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                Alliance.create($scope.alliance,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.alliance.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var patch = {
                    name: $scope.alliance.name,
                    custom: !!$scope.alliance.custom
                };
                Alliance.prototype$patchAttributes({id: $scope.alliance.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.alliance.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Alliance.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.activity')
        .controller('ActivityPageCtrl', ActivityPageCtrl);

    /** @ngInject */
    function ActivityPageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, confirmModal, paginateHelper, Activity, messagesHelper, validationUtils) {

        $scope.activity = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        if (property === 'enabled') {
                            where[property] = predicateObject[property]
                        } else {
                            where[property] = {like: '%' + predicateObject[property] + '%'}
                        }
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    Activity.count({where: $scope.query.filter.where}).$promise,
                    Activity.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadActivity = function () {
            $scope.activity = {};
            Activity.findById({id: $stateParams.id}, function (response) {
                $scope.activity = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                Activity.create($scope.activity,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.activity.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var patch = {
                    name: $scope.activity.name,
                    custom: !!$scope.activity.custom
                };
                Activity.prototype$patchAttributes({id: $scope.activity.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.activity.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Activity.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.beneficiary')
        .controller('BeneficiaryPageCtrl', BeneficiaryPageCtrl);

    /** @ngInject */
    function BeneficiaryPageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, $uibModal, confirmModal, paginateHelper, Beneficiary, messagesHelper, validationUtils) {

        $scope.beneficiary = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.selectedCategories = [];

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order,
            };

            $timeout(function () {
                $q.all([
                    Beneficiary.count({where: $scope.query.filter.where}).$promise,
                    Beneficiary.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadBeneficiary = function () {
            $scope.beneficiary = {};
            Beneficiary.findById({id: $stateParams.id}, function (response) {
                $scope.beneficiary = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                Beneficiary.create($scope.beneficiary,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.beneficiary.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var patch = {
                    name: $scope.beneficiary.name,
                    custom: !!$scope.beneficiary.custom,
                };
                Beneficiary.prototype$patchAttributes({id: $scope.beneficiary.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.beneficiary.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Beneficiary.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.category')
        .controller('CategoryPageCtrl', CategoryPageCtrl);

    /** @ngInject */
    function CategoryPageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, confirmModal, paginateHelper, Category, messagesHelper, validationUtils) {

        $scope.category = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.selectedCategories = [];
        $scope.rootCategories = [];

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        if (property === 'enabled') {
                            where[property] = predicateObject[property]
                        } else {
                            where[property] = {like: '%' + predicateObject[property] + '%'}
                        }
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    Category.count({where: $scope.query.filter.where}).$promise,
                    Category.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadCategory = function () {
            $scope.category = {};
            Category.findById({id: $stateParams.id}, function (response) {
                $scope.category = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
            $scope.loadRootCategories();
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                Category.create($scope.category,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.category.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var patch = {
                    name: $scope.category.name,
                    mainMenu: !!$scope.category.mainMenu,
                    custom: !!$scope.category.custom,
                    idCategory: $scope.category.idCategory
                };
                Category.prototype$patchAttributes({id: $scope.category.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.category.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Category.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** load root categories */
        $scope.loadRootCategories = function () {
            $scope.rootCategories = [];
            Category.find({filter: {where: {idCategory: null}}}, function (response) {
                $scope.rootCategories = response;
            }, function (errorResponse) {
                console.log(errorResponse);
            });
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.diffusion')
        .controller('DiffusionPageCtrl', DiffusionPageCtrl);

    /** @ngInject */
    function DiffusionPageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, confirmModal, paginateHelper, Diffusion, messagesHelper, validationUtils) {

        $scope.diffusion = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        if (property === 'enabled') {
                            where[property] = predicateObject[property]
                        } else {
                            where[property] = {like: '%' + predicateObject[property] + '%'}
                        }
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    Diffusion.count({where: $scope.query.filter.where}).$promise,
                    Diffusion.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadDiffusion = function () {
            $scope.diffusion = {};
            Diffusion.findById({id: $stateParams.id}, function (response) {
                $scope.diffusion = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                Diffusion.create($scope.diffusion,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.diffusion.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var patch = {
                    name: $scope.diffusion.name,
                    custom: !!$scope.diffusion.custom
                };
                Diffusion.prototype$patchAttributes({id: $scope.diffusion.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.diffusion.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Diffusion.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.district')
        .controller('DistrictPageCtrl', DistrictPageCtrl);

    /** @ngInject */
    function DistrictPageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, confirmModal, paginateHelper, District, messagesHelper, validationUtils, Region, Province) {

        $scope.district = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.regions = [];
        $scope.provinces = [];

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order,
                include: ["province"],
            };

            $timeout(function () {
                $q.all([
                    District.count({where: $scope.query.filter.where}).$promise,
                    District.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadDistrict = function () {
            $scope.district = {};
            var filter = {include: ['province']};
            District.findById({id: $stateParams.id, filter: filter}, function (response) {
                $scope.district = response;

                /** load provinces by region */
                if (response.province && response.province.idRegion) {
                    $scope.loadProvinces(response.province.idRegion);
                }
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                District.create($scope.district,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.district.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var patch = {
                    name: $scope.district.name,
                    idProvince: $scope.district.idProvince
                };
                District.prototype$patchAttributes({id: $scope.district.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.district.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    District.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** find regions */
        $scope.loadRegions = function () {
            Region.find({}, function (response) {
                $scope.regions = response;
            }, function (errorResponse) {
            });
        };

        /** find provinces */
        $scope.loadProvinces = function (idRegion) {
            Province.find({filter: {where: {idRegion: idRegion}}}, function (response) {
                $scope.provinces = response;
            }, function (errorResponse) {
            });
        };

        /** init */
        $scope.init = function (action) {
            $scope.loadRegions();
            if (action === 'edit') {
                $scope.loadDistrict();
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.financing')
        .controller('FinancingPageCtrl', FinancingPageCtrl);

    /** @ngInject */
    function FinancingPageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, confirmModal, paginateHelper, Financing, messagesHelper, validationUtils) {

        $scope.financing = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        if (property === 'enabled') {
                            where[property] = predicateObject[property]
                        } else {
                            where[property] = {like: '%' + predicateObject[property] + '%'}
                        }
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    Financing.count({where: $scope.query.filter.where}).$promise,
                    Financing.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadFinancing = function () {
            $scope.financing = {};
            Financing.findById({id: $stateParams.id}, function (response) {
                $scope.financing = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                Financing.create($scope.financing,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.financing.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var patch = {
                    name: $scope.financing.name,
                    custom: !!$scope.financing.custom
                };
                Financing.prototype$patchAttributes({id: $scope.financing.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.financing.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Financing.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.information_base')
        .controller('InformationBasePageCtrl', InformationBasePageCtrl);

    /** @ngInject */
    function InformationBasePageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, $uibModal, confirmModal, paginateHelper, InformationBase, messagesHelper, validationUtils) {

        $scope.informationBase = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order,
            };

            $timeout(function () {
                $q.all([
                    InformationBase.count({where: $scope.query.filter.where}).$promise,
                    InformationBase.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadInformationBase = function () {
            $scope.informationBase = {};
            InformationBase.findById({id: $stateParams.id}, function (response) {
                $scope.informationBase = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {

                var informationBase = $scope.informationBase;
                delete informationBase.image;

                InformationBase.create(informationBase,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.information_base.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var patch = {
                    name: $scope.informationBase.name,
                    custom: !!$scope.informationBase.custom
                };
                InformationBase.prototype$patchAttributes({id: $scope.informationBase.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.information_base.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    InformationBase.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.objective')
        .controller('ObjectivePageCtrl', ObjectivePageCtrl);

    /** @ngInject */
    function ObjectivePageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, $uibModal, confirmModal, paginateHelper, Objective, Files, Upload, pdConfig, LoopBackAuth, validationUtils, messagesHelper) {

        $scope.objective = {
            order: 1,
        };
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.selectedCategories = [];

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order,
                include: ["image"],
            };

            $timeout(function () {
                $q.all([
                    Objective.count({where: $scope.query.filter.where}).$promise,
                    Objective.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadObjective = function () {
            $scope.objective = {};
            Objective.findById({id: $stateParams.id, filter: {include: ["image"]}}, function (response) {
                $scope.objective = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {

                var objective = $scope.objective;
                delete objective.image;

                Objective.create(objective,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.objective.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var patch = {
                    name: $scope.objective.name,
                    idFile: $scope.objective.idFile,
                };
                Objective.prototype$patchAttributes({id: $scope.objective.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.objective.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Objective.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };


        /** ************************** */
        /** objective image management */
        /** ************************** */

        $scope.modalInstance = null;

        /** show file dialog */
        $scope.showFileDialog = function () {
            $scope.modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/resources/objective/filesModal.html',
                size: 'md',
                scope: $scope
            });
        };

        /** file list */
        $scope.callLogoFilesServer = function callServer(tableState, tableCtrl) {
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;
            var number = pagination.number || 10;

            var where = {container: 'ODS'};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    Files.count({where: $scope.query.filter.where}).$promise,
                    Files.find({filter: $scope.query.filter}).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** upload file */
        $scope.uploadFile = function (file, errFiles) {
            $scope.f = file;
            $scope.errFile = errFiles && errFiles[0];
            if (file) {
                file.upload = Upload.upload({
                    url: pdConfig.apiUrlBase + '/files/ODS/upload?access_token=' + LoopBackAuth.accessTokenId,
                    data: {file: file}
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        file.result = response.data;
                        $scope.setObjectiveImage(response.data[0]);
                    });
                }, function (response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
        };

        /** attach image to objective */
        $scope.setObjectiveImage = function (file) {
            $scope.objective.idFile = file.id;
            if ($scope.objective.image) {
                $scope.objective.image.name = file.name;
            } else {
                $scope.objective.image = {name: file.name};
            }

            $scope.f = null;
            $scope.errFile = null;
            $scope.modalInstance.dismiss();
        };

        /** remove image */
        $scope.removeFile = function () {
            $scope.objective.idFile = null;
            $scope.objective.image = null;
        };

    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.province')
        .controller('ProvincePageCtrl', ProvincePageCtrl);

    /** @ngInject */
    function ProvincePageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, confirmModal, paginateHelper, Province, messagesHelper, validationUtils, Region, ScreenLoader) {

        $scope.province = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.regions = [];

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order,
                include: ["region"],
            };

            $timeout(function () {
                $q.all([
                    Province.count({where: $scope.query.filter.where}).$promise,
                    Province.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadProvince = function () {
            $scope.province = {};
            Province.findById({id: $stateParams.id}, function (response) {
                $scope.province = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                Province.create($scope.province,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.province.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var patch = {
                    name: $scope.province.name,
                    idRegion: $scope.province.idRegion
                };
                Province.prototype$patchAttributes({id: $scope.province.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.province.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Province.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** find regions */
        $scope.loadRegions = function () {
            Region.find({}, function (response) {
                $scope.regions = response;
            }, function (errorResponse) {
            });
        };

        /** init */
        $scope.loadRegions();

    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.region')
        .controller('RegionPageCtrl', RegionPageCtrl);

    /** @ngInject */
    function RegionPageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, confirmModal, paginateHelper, Region, messagesHelper, validationUtils) {

        $scope.region = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.selectedCategories = [];

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    Region.count({where: $scope.query.filter.where}).$promise,
                    Region.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadRegion = function () {
            $scope.region = {};
            Region.findById({id: $stateParams.id}, function (response) {
                $scope.region = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {
                Region.create($scope.region,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.region.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {
                var patch = {
                    name: $scope.region.name
                };
                Region.prototype$patchAttributes({id: $scope.region.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.region.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Region.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.pages.resources.sector')
        .controller('SectorPageCtrl', SectorPageCtrl);

    /** @ngInject */
    function SectorPageCtrl($scope, $state, $stateParams, toastr, $timeout, $q, confirmModal, paginateHelper, Sector, messagesHelper, validationUtils, $uibModal, Files, Upload, pdConfig, LoopBackAuth, sectorImageType, recommendedSizes) {

        $scope.sector = {};
        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        $scope.selectedSectors = [];
        $scope.markerIcon = recommendedSizes.markerIcon;
        $scope.sectorIcon = recommendedSizes.sectorIcon;

        /** reload results table */
        $scope.reloadTable = function () {
            $scope.tableCtrl.pipe($scope.tableCtrl.tableState());
        };

        /** obtain results */
        $scope.callServer = function callServer(tableState, tableCtrl) {

            $scope.tableCtrl = tableCtrl;
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        if (property === 'enabled') {
                            where[property] = predicateObject[property]
                        } else {
                            where[property] = {like: '%' + predicateObject[property] + '%'}
                        }
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    Sector.count({where: $scope.query.filter.where}).$promise,
                    Sector.find($scope.query).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** find */
        $scope.loadSector = function () {
            $scope.sector = {};
            Sector.findById({
                id: $stateParams.id,
                filter: {include: ["imageMarker", "imageLogo"]}
            }, function (response) {
                $scope.sector = response;
            }, function (errorResponse) {
                validationUtils.processErrorResponse(errorResponse);
            });
        };

        /** create */
        $scope.create = function (isValid) {
            if (isValid) {

                if (!$scope.sector.idFileMarker || !$scope.sector.idFileLogo) {
                    toastr.error('Debe seleccionar la imagen del marcador del mapa y el logo.');
                    return;
                }

                Sector.create($scope.sector,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.sector.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** update */
        $scope.update = function (isValid) {
            if (isValid) {

                if (!$scope.sector.idFileMarker || !$scope.sector.idFileLogo) {
                    toastr.error('Debe seleccionar la imagen del marcador del mapa y el logo.');
                    return;
                }

                var patch = {
                    name: $scope.sector.name,
                    mainMenu: !!$scope.sector.mainMenu,
                    mainMenuOrder: $scope.sector.mainMenuOrder,
                    idFileMarker: $scope.sector.idFileMarker,
                    idFileLogo: $scope.sector.idFileLogo
                };
                Sector.prototype$patchAttributes({id: $scope.sector.id}, patch,
                    function (response) {
                        toastr.clear();
                        toastr.success(messagesHelper.success_operation);
                        $state.go('main.res.sector.list');
                    }, function (errorResponse) {
                        validationUtils.processErrorResponse(errorResponse);
                    }
                );
            }
        };

        /** remove */
        $scope.remove = function (ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }
            if (ids.length === 0) {
                toastr.clear();
                toastr.info(messagesHelper.not_selected_elements);
            } else {
                confirmModal(messagesHelper.confirm_operation, 'Confirmación').then(function (result) {
                    Sector.destroyMultiple({id: ids}, function (response) {
                            toastr.clear();
                            toastr.success(messagesHelper.success_operation);
                            $scope.reloadTable();
                        }, function (errorResponse) {

                            validationUtils.processErrorResponse(errorResponse);
                            $scope.reloadTable();
                        }
                    );
                });
            }
        };

        /** remove selected items */
        $scope.removeSelectedItems = function () {
            var selectedRows = $scope.results.filter(function (element) {
                return element.isSelected;
            });
            var selectedIds = selectedRows.map(function (element) {
                return element.id;
            });
            $scope.remove(selectedIds);
        };

        /** ************************** */
        /** sector image management */
        /** ************************** */

        $scope.modalInstance = null;

        /** show file dialog */
        $scope.showFileDialog = function (imageType) {
            $scope.imageType = imageType;
            $scope.modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/resources/sector/filesModal.html',
                size: 'md',
                scope: $scope
            });
        };

        /** file list */
        $scope.callLogoFilesServer = function callServer(tableState, tableCtrl) {
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;
            var number = pagination.number || 10;

            var where = {container: 'Sectors'};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            $timeout(function () {
                $q.all([
                    Files.count({where: $scope.query.filter.where}).$promise,
                    Files.find({filter: $scope.query.filter}).$promise
                ]).then(function (results) {

                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** upload file */
        $scope.uploadFile = function (file, errFiles, imageType) {
            $scope.f = file;
            $scope.errFile = errFiles && errFiles[0];
            if (file) {
                file.upload = Upload.upload({
                    url: pdConfig.apiUrlBase + '/files/Sectors/upload?access_token=' + LoopBackAuth.accessTokenId,
                    data: {file: file}
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        file.result = response.data;
                        $scope.setSectorImage(response.data[0], imageType);
                    });
                }, function (response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
        };

        /** attach image to sector */
        $scope.setSectorImage = function (file, imageType) {

            if (imageType === sectorImageType.MARKER) {

                $scope.sector.idFileMarker = file.id;
                $scope.sector.imageMarker = file;

            } else if (imageType === sectorImageType.LOGO) {

                $scope.sector.idFileLogo = file.id;
                $scope.sector.imageLogo = file;

            } else {
                console.log("Image type not allowed");
            }

            $scope.f = null;
            $scope.errFile = null;
            $scope.modalInstance.dismiss();
        };

        /** remove image */
        $scope.removeFile = function (imageType) {

            if (imageType === sectorImageType.MARKER) {

                $scope.sector.idFileMarker = null;
                $scope.sector.imageMarker = null;

            } else if (imageType === sectorImageType.LOGO) {

                $scope.sector.idFileLogo = null;
                $scope.sector.imageLogo = null;

            } else {
                console.log("Image type not allowed");
            }

        };
    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .controller('UploadArticleImageCtrl', UploadArticleImageCtrl);

    /** @ngInject */
    function UploadArticleImageCtrl($scope, toastr, $timeout, $q, messagesHelper, Upload, $uibModal, Files, pdConfig, paginateHelper, LoopBackAuth, $uibModalInstance, ScreenLoader) {

        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        /** obtain results */
        $scope.callFilesServer = function callServer(tableState, tableCtrl) {
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {container: 'Articles'};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            ScreenLoader.show();
            $timeout(function () {
                $q.all([
                    Files.count({where: $scope.query.filter.where}).$promise,
                    Files.find({filter: $scope.query.filter}).$promise
                ]).then(function (results) {

                    ScreenLoader.hide();
                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {

                    ScreenLoader.hide();
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** upload file */
        $scope.uploadFiles = function (file, errFiles) {
            $scope.f = file;
            $scope.errFile = errFiles && errFiles[0];
            if (file) {
                file.upload = Upload.upload({
                    url: pdConfig.apiUrlBase + '/files/Articles/upload?access_token=' + LoopBackAuth.accessTokenId,
                    data: {file: file}
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        file.result = response.data;
                        $scope.setImage(response.data[0].name);
                    });
                }, function (response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
        };

        /** set image */
        $scope.setImage = function (image) {
            $scope.f = null;
            $scope.errFile = null;

            var imageUrl = pdConfig.apiUrlBase + '/container/Articles/download/' + image;
            $uibModalInstance.close(imageUrl);
        };

    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .controller('UploadImageCtrl', UploadImageCtrl);

    /** @ngInject */
    function UploadImageCtrl($scope, toastr, $timeout, $q, messagesHelper, Upload, $uibModal, Files, pdConfig, paginateHelper, LoopBackAuth, $uibModalInstance, ScreenLoader) {

        $scope.results = [];
        $scope.isLoading = false;
        $scope.query = {};
        $scope.tableCtrl = {};
        $scope.pageSizeOptions = paginateHelper.pageSizeOptions;
        $scope.pageSize = paginateHelper.pageSize;

        /** obtain results */
        $scope.callFilesServer = function callServer(tableState, tableCtrl) {
            $scope.isLoading = true;

            var pagination = tableState.pagination;
            var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
            var number = pagination.number || 10;  // Number of entries showed per page.

            var where = {container: 'Pages'};
            var predicateObject = tableState.search.predicateObject;
            if (predicateObject) {
                for (var property in predicateObject) {
                    if (predicateObject.hasOwnProperty(property)) {
                        where[property] = {like: '%' + predicateObject[property] + '%'}
                    }
                }
            }

            var order = "";
            if (tableState.sort && tableState.sort.predicate) {
                order = tableState.sort.predicate + ' ' + (tableState.sort.reverse ? 'DESC' : 'ASC');
            }

            $scope.query.filter = {
                limit: number,
                offset: start,
                where: where,
                order: order
            };

            ScreenLoader.show();
            $timeout(function () {
                $q.all([
                    Files.count({where: $scope.query.filter.where}).$promise,
                    Files.find({filter: $scope.query.filter}).$promise
                ]).then(function (results) {

                    ScreenLoader.hide();
                    $scope.isLoading = false;
                    $scope.results = results[1];

                    tableState.pagination.totalItemCount = results[0].count;
                    tableState.pagination.numberOfPages = Math.ceil(results[0].count / number);//set the number of pages so the pagination can update

                }, function (error) {

                    ScreenLoader.hide();
                    $scope.isLoading = false;
                });
            }, 500);
        };

        /** upload file */
        $scope.uploadFiles = function (file, errFiles) {
            $scope.f = file;
            $scope.errFile = errFiles && errFiles[0];
            if (file) {
                file.upload = Upload.upload({
                    url: pdConfig.apiUrlBase + '/files/Pages/upload?access_token=' + LoopBackAuth.accessTokenId,
                    data: {file: file}
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        file.result = response.data;
                        $scope.setImage(response.data[0].name);
                    });
                }, function (response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
        };

        /** set image */
        $scope.setImage = function (image) {
            $scope.f = null;
            $scope.errFile = null;

            var imageUrl = pdConfig.apiUrlBase + '/container/Pages/download/' + image;
            $uibModalInstance.close(imageUrl);
        };

    }
})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('advancedAssociatedFilters', advancedAssociatedFilters);

    /** @ngInject */
    function advancedAssociatedFilters() {
        return {
            restrict: 'AE',
            scope: {
                sectors: "<sectors",
                username: "<username",
                companyName: "<companyName",
                fixedFilters: "=fixedFilters",

                showCompanyNameFilter: "=showCompanyNameFilter",
                showUsernameFilter: "=showUsernameFilter",

                resetIcon: "@resetIcon",
                applyIcon: "@applyIcon",
                resetText: "@resetText",
                applyText: "@applyText",
                showReset: "=showReset",
                reset: "&reset",
                apply: "&apply"
            },
            templateUrl: 'app/resources/directives/advancedAssociatedFilters/advancedAssociatedFilters.html',
            controller: function ($scope, $element, $attrs) {

                $scope.filters = {
                    sectors: [],
                    username: '',
                    companyName: ''
                };

                $scope.sectorLabels = {
                    itemsSelected: "SECTORES",
                    select: "SECTOR",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.applyFilters = function () {
                    var filters = {
                        sectors: $scope.filters.sectors.map(function (item) {
                            return item.id
                        }),
                        username: $scope.filters.username,
                        companyName: $scope.filters.companyName
                    };
                    $scope.apply({
                        newPageNumber: 1,
                        newPageFilters: Object.assign(filters, $scope.fixedFilters)
                    });
                };

                $scope.resetFilters = function () {
                    $scope.filters = {
                        sectors: [],
                        username: "",
                        companyName: ""
                    };
                    if ($scope.reset) {
                        $scope.reset({
                            newPageNumber: 1,
                            newPageFilters: Object.assign($scope.filters, $scope.fixedFilters)
                        });
                    }
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('advancedFilters', advancedFilters);

    /** @ngInject */
    function advancedFilters() {
        return {
            restrict: 'AE',
            scope: {
                sectors: "<sectors",
                regions: "<regions",
                provinces: "<provinces",
                districts: "<districts",
                categories: "<categories",
                companies: "<companies",
                objectives: "<objectives",
                status: "<status",
                fixedFilters: "=fixedFilters",
                showNameFilter: "=showNameFilter",

                resetIcon: "@resetIcon",
                applyIcon: "@applyIcon",
                resetText: "@resetText",
                applyText: "@applyText",
                showReset: "=showReset",
                reset: "&reset",
                apply: "&apply"
            },
            templateUrl: 'app/resources/directives/advancedFilters/advancedFilters.html',
            controller: function ($scope, $element, $attrs) {

                $scope.filters = {
                    sectors: [],
                    regions: [],
                    provinces: [],
                    districts: [],
                    categories: [],
                    companies: [],
                    objectives: [],
                    status: [],
                    rangeDates: {},
                };

                $scope.startDatePicker = {
                    date: ''
                };
                $scope.endDatePicker = {
                    date: ''
                };
                $scope.options = {
                    singleDatePicker: true,
                    showDropdowns: true,
                    // timePicker: true,
                    applyClass: 'btn-primary',
                    cancelClass: 'btn',

                    pickerClasses: 'custom-display', //angular-daterangepicker extra
                    buttonClasses: 'btn',
                    applyButtonClasses: 'btn-primary',
                    cancelButtonClasses: 'btn-danger',

                    locale: {
                        applyLabel: "Aplicar",
                        cancelLabel: 'Cancelar',
                        format: 'DD/MM/YYYY'
                    },
                    eventHandlers: {
                        'apply.daterangepicker': function (ev, picker) {

                            var startDate = moment($scope.startDatePicker.date);
                            var endDate = moment($scope.endDatePicker.date);

                            $scope.filters.rangeDates.startDate = startDate.isValid() ? startDate.format() : '';
                            $scope.filters.rangeDates.endDate = endDate.isValid() ? endDate.format() : '';
                        }
                    },
                };

                $scope.regionLabels = {
                    itemsSelected: "REGIONES",
                    select: "REGIÓN",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.provinceLabels = {
                    itemsSelected: "PROVINCIAS",
                    select: "PROVINCIA",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.districtLabels = {
                    itemsSelected: "DISTRITOS",
                    select: "DISTRITO",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.sectorLabels = {
                    itemsSelected: "SECTORES",
                    select: "SECTOR",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.categoryLabels = {
                    itemsSelected: "TEMAS",
                    select: "TEMA",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.companyLabels = {
                    itemsSelected: "EMPRESAS",
                    select: "EMPRESA",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.objectiveLabels = {
                    itemsSelected: "ODS",
                    select: "ODS",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.statusLabels = {
                    itemsSelected: "ESTADOS",
                    select: "ESTADO",
                    selectAll: "Seleccionar todo",
                    unselectAll: "Limpiar selección",
                    search: "Buscar"
                };

                $scope.clearStartDate = function () {
                    $scope.startDatePicker.date = '';
                    $scope.filters.rangeDates.startDate = '';
                };

                $scope.clearEndDate = function () {
                    $scope.endDatePicker.date = '';
                    $scope.filters.rangeDates.endDate = '';
                };

                $scope.applyFilters = function () {
                    var filters = {
                        sectors: $scope.filters.sectors.map(function (item) {
                            return item.id
                        }),
                        regions: $scope.filters.regions.map(function (item) {
                            return item.id
                        }),
                        provinces: $scope.filters.provinces.map(function (item) {
                            return item.id
                        }),
                        districts: $scope.filters.districts.map(function (item) {
                            return item.id
                        }),
                        categories: $scope.filters.categories.map(function (item) {
                            return item.id
                        }),
                        companies: $scope.filters.companies.map(function (item) {
                            return item.id
                        }),
                        objectives: $scope.filters.objectives.map(function (item) {
                            return item.id
                        }),
                        status: $scope.filters.status.map(function (item) {
                            return item.id
                        }),
                        projectName: $scope.filters.projectName,
                        rangeDates: $scope.filters.rangeDates
                    };
                    $scope.apply({
                        newPageNumber: 1,
                        newPageFilters: Object.assign(filters, $scope.fixedFilters)
                    });
                };

                $scope.resetFilters = function () {
                    $scope.filters = {
                        sectors: [],
                        regions: [],
                        provinces: [],
                        districts: [],
                        categories: [],
                        companies: [],
                        objectives: [],
                        status: [],
                        projectName: "",
                        rangeDates: {
                            startDate: '',
                            endDate: ''
                        }
                    };

                    $scope.startDatePicker.date = '';
                    $scope.endDatePicker.date = '';

                    if ($scope.reset) {
                        $scope.reset({
                            newPageNumber: 1,
                            newPageFilters: Object.assign($scope.filters, $scope.fixedFilters)
                        });
                    }
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });

                /** init */
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('charCounter', charCounter);

    /** @ngInject */
    function charCounter() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                limit: "=limit",
            },
            templateUrl: 'app/resources/directives/charCounter/charCounter.html',
            controller: function ($scope, $rootScope, $element, $attrs) {

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('dashboardAreaChart', dashboardAreaChart);

    /** @ngInject */
    function dashboardAreaChart(layoutPaths, pdConfig) {
        return {
            restrict: 'EA',
            scope: {
                data: "=data"
            },
            templateUrl: 'app/resources/directives/dashboardAreaChart/dashboardAreaChart.html',
            link: function (scope, element, attr) {

                var layoutColors = pdConfig.colors;
                scope.$watch('data', function (newVal, oldVal) {

                    var areaChart = AmCharts.makeChart('areaChart', {
                        type: 'serial',
                        theme: 'blur',
                        color: layoutColors.defaultText,
                        dataProvider: scope.data,
                        balloon: {
                            cornerRadius: 6,
                            horizontalPadding: 15,
                            verticalPadding: 10
                        },
                        // valueAxes: [
                        //   {
                        //     duration: 'mm',
                        //     durationUnits: {
                        //       hh: 'h ',
                        //       mm: 'min'
                        //     },
                        //     gridAlpha: 0.5,
                        //     gridColor: layoutColors.border,
                        //   }
                        // ],
                        graphs: [
                            {
                                bullet: 'circle',
                                bulletBorderAlpha: 1,
                                bulletBorderThickness: 1,
                                fillAlphas: 0.5,
                                fillColorsField: 'lineColor',
                                legendValueText: '[[value]]',
                                lineColorField: 'lineColor',
                                title: 'users',
                                valueField: 'users'
                            }
                        ],

                        chartCursor: {
                            categoryBalloonDateFormat: 'DD MMM YYYY',
                            cursorAlpha: 0,
                            fullWidth: true
                        },
                        dataDateFormat: 'YYYYMMDD',
                        categoryField: 'date',
                        categoryAxis: {
                            dateFormats: [
                                {
                                    period: 'DD',
                                    format: 'DD'
                                },
                                {
                                    period: 'WW',
                                    format: 'MMM DD'
                                },
                                {
                                    period: 'MM',
                                    format: 'MMM'
                                },
                                {
                                    period: 'YYYY',
                                    format: 'YYYY'
                                }
                            ],
                            parseDates: true,
                            autoGridCount: false,
                            gridCount: 50,
                            gridAlpha: 0.5,
                            gridColor: layoutColors.border,
                        },
                        export: {
                            enabled: true
                        },
                        pathToImages: layoutPaths.images.amChart
                    });

                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('dashboardMap', dashboardMap);

    /** @ngInject */
    function dashboardMap(layoutPaths, baConfig, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                data: "=data"
            },
            templateUrl: 'app/resources/directives/dashboardMap/dashboardMap.html',
            link: function (scope, element, attr) {

                var layoutColors = baConfig.colors;
                scope.$watch('data', function (newVal, oldVal) {

                    AmCharts.makeChart('amChartMap', {
                        type: 'map',
                        theme: 'blur',
                        mouseWheelZoomEnabled: true,
                        zoomControl: {zoomControlEnabled: false, panControlEnabled: false},

                        dataProvider: {
                            map: 'worldLow',
                            "zoomLevel": 1,
                            "zoomLongitude": 10,
                            "zoomLatitude": 52,
                            areas: scope.data
                        },

                        areasSettings: {
                            rollOverOutlineColor: layoutColors.border,
                            rollOverColor: layoutColors.primaryDark,
                            alpha: 0.8,
                            unlistedAreasAlpha: 0.2,
                            unlistedAreasColor: layoutColors.defaultText,
                            balloonText: '[[title]]: [[customData]] Usuarios'
                        },

                        export: {
                            enabled: true
                        },
                        creditsPosition: 'bottom-right',
                        pathToImages: layoutPaths.images.amChart
                    });
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('dashboardPieChart', dashboardPieChart);

    /** @ngInject */
    function dashboardPieChart(baConfig, layoutPaths) {
        return {
            restrict: 'EA',
            scope: {
                id: "=id",
                data: "=data",
                height: "=height"
            },
            templateUrl: 'app/resources/directives/dashboardPieChart/dashboardPieChart.html',
            link: function (scope, element, attr) {

                scope.style = {};
                if (scope.height) {
                    scope.style.height = scope.height;
                }
                var layoutColors = baConfig.colors;
                scope.$watch('data', function (newVal, oldVal) {

                    var pieChart = AmCharts.makeChart(scope.id, {
                        type: 'pie',
                        startDuration: 0,
                        theme: 'blur',
                        addClassNames: true,
                        color: layoutColors.defaultText,
                        labelTickColor: layoutColors.borderDark,
                        legend: {
                            enabled: true,
                            position: 'bottom',
                            marginRight: 100,
                            autoMargins: true
                        },
                        innerRadius: '40%',
                        defs: {
                            filter: [
                                {
                                    id: 'shadow',
                                    width: '200%',
                                    height: '200%',
                                    feOffset: {
                                        result: 'offOut',
                                        in: 'SourceAlpha',
                                        dx: 0,
                                        dy: 0
                                    },
                                    feGaussianBlur: {
                                        result: 'blurOut',
                                        in: 'offOut',
                                        stdDeviation: 5
                                    },
                                    feBlend: {
                                        in: 'SourceGraphic',
                                        in2: 'blurOut',
                                        mode: 'normal'
                                    }
                                }
                            ]
                        },
                        dataProvider: scope.data,
                        valueField: 'value',
                        titleField: 'dimension',
                        colorField: "color",
                        export: {
                            enabled: true
                        },
                        creditsPosition: 'bottom-left',

                        autoMargins: false,
                        alpha: 0.8,
                        marginTop: 20,
                        marginBottom: 20,
                        marginLeft: 20,
                        marginRight: 20,
                        pullOutRadius: 0,
                        pathToImages: layoutPaths.images.amChart,
                        labelsEnabled: false,
                    });

                    pieChart.addListener('init', handleInit);

                    pieChart.addListener('rollOverSlice', function (e) {
                        handleRollOver(e);
                    });

                    function handleInit() {
                        pieChart.legend.addListener('rollOverItem', handleRollOver);
                    }

                    function handleRollOver(e) {
                        var wedge = e.dataItem.wedge.node;
                        wedge.parentNode.appendChild(wedge);
                    }

                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('recommendedSizes', recommendedSizes);

    /** @ngInject */
    function recommendedSizes() {
        return {
            restrict: 'EA',
            scope: {
                width: "=width",
                height: "=height",
                unit: "@unit",
                type: "@type",
            },
            templateUrl: 'app/resources/directives/recommendedSizes/recommendedSizes.html',
            controller: function ($scope, $rootScope, $element, $attrs) {
            }
        };
    }
})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              $evt.originalEvent &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: ((s.name.match(/\./g) || []).length - 1),
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('articleLink', articleLink);

    /** @ngInject */
    function articleLink() {
        return {
            restrict: 'EA',
            scope: {
                items: "=ngModel",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/article/articleLink/articleLink.html',
            controller: function ($scope, $element, $attrs, messagesHelper, toastr) {

                $scope.newItem = {
                    title: "",
                    url: ""
                };
                if (!$scope.items || !Array.isArray($scope.items)) {
                    $scope.items = [];
                }

                $scope.addItem = function () {
                    if (!$scope.newItem || !$scope.newItem.title || !$scope.newItem.url) {
                        toastr.clear();
                        toastr.error(messagesHelper.complete_the_field);
                        return;
                    }
                    if (!Array.isArray($scope.items)) {
                        $scope.items = [];
                    }
                    $scope.items.push($scope.newItem);
                    $scope.newItem = {
                        title: "",
                        url: ""
                    };
                };

                $scope.removeItem = function (index) {
                    if (Array.isArray($scope.items)) {
                        $scope.items.splice(index, 1);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('imageUpload', imageUpload);

    /** @ngInject */
    function imageUpload() {
        return {
            restrict: 'EA',
            scope: {
                idFile: "=ngModel",
                fileModel: "=fileModel",
                container: "=container",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/article/imageUpload/imageUpload.html',
            controller: function ($scope, $element, $attrs, pdConfig, Upload, LoopBackAuth, $timeout, ScreenLoader, toastr, messagesHelper, validationUtils, assetPaths, projectFieldVisibility, recommendedSizes) {

                $scope.noImageUrl = assetPaths.images.noImageUrl;
                $scope.recommendedSizes = recommendedSizes.articleImage;

                /** remove item */
                $scope.removeItem = function () {
                    $scope.idFile = null;
                    $scope.fileModel = null;
                };

                /** upload file */
                $scope.uploadFile = function (file, index) {
                    ScreenLoader.show();
                    if (file) {
                        file.upload = Upload.upload({
                            url: pdConfig.apiUrlBase + '/files/' + $scope.container + '/upload?access_token=' + LoopBackAuth.accessTokenId,
                            data: {file: file}
                        });
                        file.upload.then(function (response) {
                            $timeout(function () {
                                ScreenLoader.hide();
                                toastr.clear();
                                toastr.success(messagesHelper.success_upload);
                                $scope.fileModel = response.data[0];
                                $scope.idFile = response.data[0].id;

                                $scope.file = null;
                            });
                        }, function (response) {
                            ScreenLoader.hide();
                            if (response.status > 0) {
                                $scope.errorMsg = response.status + ': ' + response.data;
                                console.log($scope.errorMsg);
                                validationUtils.processErrorResponse(response);
                            }
                        }, function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('errorMessage', errorMessage);

    /** @ngInject */
    function errorMessage() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                limit: "=limit",
            },
            templateUrl: 'app/resources/directives/manageProjects/errorMessage/errorMessage.html',
            controller: function ($scope, $rootScope, $element, $attrs) {

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                });

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .controller('GmapsCtrl', GmapsCtrl);

    /** @ngInject */
    function GmapsCtrl($scope, $rootScope, toastr, $state, ScreenLoader, uiGmapGoogleMapApi, uiGmapIsReady, Project, assetPaths) {

        $scope.markers = [];
        $scope.windowOptions = {
            boxClass: "gmap-infobox",
        };
        $scope.defaultMapCenter = {latitude: -12.046374, longitude: -77.042793};
        $scope.mapControl = {};
        $scope.options = {
            minZoom: 2,
            maxZoom: 11,
            scrollwheel: false,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true
        };

        $scope.events = {
            // idle: function (map) {
            //     if (map.getZoom() > 6) {
            //         map.setZoom(6);
            //     }
            // }
        };

        uiGmapGoogleMapApi.then(function (maps) {
            $scope.map = {
                center: $scope.defaultMapCenter,
                zoom: 6,
                bounds: {
                    northeast: {
                        latitude: -12,
                        longitude: -77
                    },
                    southwest: {
                        latitude: -12.046374,
                        longitude: -77.042793
                    }
                }
            };
        });

        /** get marker image */
        $scope.getMarkerImage = function (project) {
            return assetPaths.symbols["M"];
            return assetPaths.symbols[project.sector.name.charAt(0).toUpperCase()];
        };

        /** create marker */
        $scope.createMarker = function (id, latitude, longitude, isDraggable) {
            return {
                id: id,
                latitude: latitude,
                longitude: longitude,
                options: {
                    draggable: isDraggable
                },
                // icon: {
                //     url: $scope.getMarkerImage(location)
                // }
            }
        };

        /** calculate center of map */
        $scope.recalculateMapCenter = function () {
            if ($scope.markers.length) {
                var bounds = new google.maps.LatLngBounds();
                $scope.markers.forEach(function (marker) {
                    bounds.extend(new google.maps.LatLng(marker.latitude, marker.longitude));
                });

                $scope.mapControl.getGMap().fitBounds(bounds);
            }
        };

        /** refresh markers in map */
        $scope.updateMap = function () {
            uiGmapIsReady.promise()
                .then(function (instances) {
                    var markers = [];
                    $scope.locations.forEach(function (location, index) {
                        markers.push($scope.createMarker('marker_' + index, location.latitude, location.longitude, false));
                    });

                    $scope.markers = markers;
                    $scope.recalculateMapCenter();
                });
        };

        /** watch location changes */
        var unregisterWatch = $scope.$watch('locations', function (newValues, oldValues) {
            $scope.updateMap();
        }, true);

        $scope.$on('$destroy', function () {
            unregisterWatch();
        });
    }

})();

(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('gmaps', gmaps);

    /** @ngInject */
    function gmaps() {
        return {
            restrict: 'EA',
            scope: {
                locations: "=locations",
            },
            templateUrl: 'app/resources/directives/manageProjects/gmaps/gmaps.html',
            controller: 'GmapsCtrl'
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputAction', inputAction);

    /** @ngInject */
    function inputAction() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputAction/inputAction.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.taToolbar = [
                    [/*'h1', 'h2', 'h3', 'h4', 'h5', 'h6',*/ 'p', 'pre', 'quote', 'fontSize'],
                    ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
                    ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount'],
                    ['uploadImage'],
                ];

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-actions').scope.charcount;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputGoals', inputGoals);

    /** @ngInject */
    function inputGoals() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputGoals/inputGoals.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.taToolbar = [
                    [/*'h1', 'h2', 'h3', 'h4', 'h5', 'h6',*/ 'p', 'pre', 'quote', 'fontSize'],
                    ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
                    ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount'],
                    ['uploadImage'],
                ];

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-goals').scope.charcount;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputHistory', inputHistory);

    /** @ngInject */
    function inputHistory() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputHistory/inputHistory.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.taToolbar = [
                    [/*'h1', 'h2', 'h3', 'h4', 'h5', 'h6',*/ 'p', 'pre', 'quote', 'fontSize'],
                    ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
                    ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount'],
                    ['uploadImage'],
                ];

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-history').scope.charcount;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputImpact', inputImpact);

    /** @ngInject */
    function inputImpact() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputImpact/inputImpact.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.taToolbar = [
                    [/*'h1', 'h2', 'h3', 'h4', 'h5', 'h6',*/ 'p', 'pre', 'quote', 'fontSize'],
                    ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
                    ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount'],
                    ['uploadImage'],
                ];

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-impact').scope.charcount;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputMonitoring', inputMonitoring);

    /** @ngInject */
    function inputMonitoring() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputMonitoring/inputMonitoring.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.taToolbar = [
                    [/*'h1', 'h2', 'h3', 'h4', 'h5', 'h6',*/ 'p', 'pre', 'quote', 'fontSize'],
                    ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
                    ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount'],
                    ['uploadImage'],
                ];

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-monitoring').scope.charcount;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputObjective', inputObjective);

    /** @ngInject */
    function inputObjective() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputObjective/inputObjective.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility) {

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputReferred', inputReferred);

    /** @ngInject */
    function inputReferred() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputReferred/inputReferred.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility) {

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputResults', inputResults);

    /** @ngInject */
    function inputResults() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputResults/inputResults.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.taToolbar = [
                    [/*'h1', 'h2', 'h3', 'h4', 'h5', 'h6',*/ 'p', 'pre', 'quote', 'fontSize'],
                    ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
                    ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount'],
                    ['uploadImage'],
                ];

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-results').scope.charcount;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputSatisfactionIndicator', inputSatisfactionIndicator);

    /** @ngInject */
    function inputSatisfactionIndicator() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputSatisfactionIndicator/inputSatisfactionIndicator.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility) {

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('inputSummary', inputSummary);

    /** @ngInject */
    function inputSummary() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                limit: "=limit",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/inputSummary/inputSummary.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility, textAngularManager) {

                $scope.taToolbar = [
                    [/*'h1', 'h2', 'h3', 'h4', 'h5', 'h6',*/ 'p', 'pre', 'quote', 'fontSize'],
                    ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
                    ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount'],
                    ['uploadImage'],
                ];

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });

                $scope.getCharCount = function () {
                    return textAngularManager.retrieveEditor('ta-summary').scope.charcount;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorActivity', selectorActivity);

    /** @ngInject */
    function selectorActivity() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorActivity/selectorActivity.html',
            controller: function ($scope, $rootScope, $element, $attrs, Activity, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.activities = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    Activity.find({filter: {include: []}}, function (response) {
                        $scope.activities = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);
                    }, function (errorResponse) {
                        console.log("Activities load resources error.", errorResponse);
                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.activities.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.activities.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id && item.custom === true;
                            });
                            if (selected) {
                                item.customValue = selected.customValue;
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorAlliance', selectorAlliance);

    /** @ngInject */
    function selectorAlliance() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorAlliance/selectorAlliance.html',
            controller: function ($scope, $element, $attrs, Alliance, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.alliances = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    Alliance.find({filter: {include: []}}, function (response) {
                        $scope.alliances = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);


                    }, function (errorResponse) {

                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.alliances.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.alliances.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id && item.custom === true;
                            });
                            if (selected) {
                                item.customValue = selected.customValue;
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorAward', selectorAward);

    /** @ngInject */
    function selectorAward() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                limit: "=limit",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorAward/selectorAward.html',
            controller: function ($scope, $element, $attrs, Financing, messagesHelper, toastr, projectFieldVisibility) {

                $scope.newItem = "";
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.addItem = function () {
                    if (!$scope.newItem) {
                        toastr.clear();
                        toastr.error(messagesHelper.complete_the_field);
                        return;
                    }
                    $scope.selected.push($scope.newItem);
                    $scope.newItem = "";
                };

                $scope.removeItem = function (index) {
                    $scope.selected.splice(index, 1);
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorBeneficiary', selectorBeneficiary);

    /** @ngInject */
    function selectorBeneficiary() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorBeneficiary/selectorBeneficiary.html',
            controller: function ($scope, $element, $attrs, Beneficiary, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.beneficiaries = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.loadResources = function () {
                    Beneficiary.find({}, function (response) {
                        $scope.beneficiaries = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);
                    }, function (errorResponse) {
                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.beneficiaries.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.beneficiaries.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id;
                            });
                            if (selected) {
                                item.customAmount = selected.customAmount;
                                if (item.custom === true) {
                                    item.customValue = selected.customValue;
                                }
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, amount, value) {
                    var idx = $scope.selected.findIndex(function (el) {
                        return el.id === item.id;
                    });
                    if (idx > -1) {
                        if (item.custom && !amount) {
                            value = undefined;
                        }
                        if (!amount && !value) {
                            $scope.selected.splice(idx, 1);
                        } else {
                            $scope.selected[idx].customAmount = amount;
                            $scope.selected[idx].customValue = value;
                        }
                    } else {
                        $scope.selected.push({
                            id: item.id,
                            custom: item.custom,
                            customValue: value,
                            customAmount: amount
                        })
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.selected = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorCategory', selectorCategory);

    /** @ngInject */
    function selectorCategory() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorCategory/selectorCategory.html',
            controller: function ($scope, $element, $attrs, Category, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.categories = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    Category.find({
                        filter: {
                            include: ["subcategories"],
                            where: {idCategory: null}
                        }
                    }, function (response) {
                        $scope.categories = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);


                    }, function (errorResponse) {

                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.categories.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.categories.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id && item.custom === true;
                            });
                            if (selected) {
                                item.customValue = selected.customValue;
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorCompany', selectorCompany);

    /** @ngInject */
    function selectorCompany() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorCompany/selectorCompany.html',
            controller: function ($scope, $rootScope, $element, $attrs, Company, projectFieldVisibility) {

                $scope.companies = [];

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                /** find companies */
                $scope.loadCompanies = function () {
                    Company.find({filter: {order: "name ASC"}}, function (response) {
                        $scope.companies = response;
                    }, function (errorResponse) {
                        console.log(errorResponse);
                    })
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadCompanies();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadCompanies();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorDiffusion', selectorDiffusion);

    /** @ngInject */
    function selectorDiffusion() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorDiffusion/selectorDiffusion.html',
            controller: function ($scope, $element, $attrs, Diffusion, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.diffusions = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    Diffusion.find({filter: {include: []}}, function (response) {
                        $scope.diffusions = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);


                    }, function (errorResponse) {

                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.diffusions.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.diffusions.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id && item.custom === true;
                            });
                            if (selected) {
                                item.customValue = selected.customValue;
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorFinancing', selectorFinancing);

    /** @ngInject */
    function selectorFinancing() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorFinancing/selectorFinancing.html',
            controller: function ($scope, $element, $attrs, Financing, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.financing = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    Financing.find({filter: {include: []}}, function (response) {
                        $scope.financing = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);


                    }, function (errorResponse) {

                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.financing.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.financing.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id && item.custom === true;
                            });
                            if (selected) {
                                item.customValue = selected.customValue;
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorImageUpload', selectorImageUpload);

    /** @ngInject */
    function selectorImageUpload() {
        return {
            restrict: 'EA',
            scope: {
                // selected: "=ngModel",
                visibility: "=visibility",
                visibilityAvatar: "=visibilityAvatar",
                isRequired: "=isRequired",
                isRequiredAvatar: "=isRequiredAvatar",
                files: "=files",
                container: "=container",
                idAvatar: "=idAvatar",
                errors: "=errors",
                errorsAvatar: "=errorsAvatar"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorImageUpload/selectorImageUpload.html',
            controller: function ($scope, $element, $attrs, pdConfig, Upload, LoopBackAuth, $timeout, ScreenLoader, toastr, messagesHelper, validationUtils, assetPaths, projectFieldVisibility, recommendedSizes) {

                $scope.recommendedSizes = recommendedSizes.projectSlide;

                // $scope.files = [];
                $scope.uFiles = [null];
                $scope.noImageUrl = assetPaths.images.noImageUrl;

                $scope.itemsPerColumn = 0;
                $scope.objectives = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                /** add upload item */
                $scope.addUploadItem = function () {
                    // if (!$scope.newItem) {
                    //     toastr.clear();
                    //     toastr.error(messagesHelper.complete_the_field);
                    //     return;
                    // }
                    $scope.uFiles.push(null);
                };

                /** remove item */
                $scope.removeItem = function (index) {
                    if ($scope.files[index].id === $scope.idAvatar) {
                        $scope.idAvatar = null;
                    }
                    $scope.files.splice(index, 1);
                };

                /** remove upload item */
                $scope.removeUploadItem = function (index) {
                    $scope.uFiles.splice(index, 1);
                };

                /** upload file */
                $scope.uploadFile = function (file, index) {
                    ScreenLoader.show();
                    if (file) {
                        file.upload = Upload.upload({
                            url: pdConfig.apiUrlBase + '/files/' + $scope.container + '/upload?access_token=' + LoopBackAuth.accessTokenId,
                            data: {file: file}
                        });
                        file.upload.then(function (response) {
                            $timeout(function () {
                                ScreenLoader.hide();
                                toastr.clear();
                                toastr.success(messagesHelper.success_upload);
                                $scope.files.push(response.data[0]);

                                // $scope.removeUploadItem(index);
                                $scope.file = null;
                            });
                        }, function (response) {
                            ScreenLoader.hide();
                            if (response.status > 0) {
                                $scope.errorMsg = response.status + ': ' + response.data;
                                console.log($scope.errorMsg);
                                validationUtils.processErrorResponse(response);
                            }
                        }, function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });
                    }
                };

                /** set as avatar */
                $scope.setAsAvatar = function (index, checked) {
                    for (var i = 0; i < $scope.files.length; i++) {
                        if (i !== index) {
                            $scope.files[i].checked = false;
                        } else {
                            $scope.files[i].checked = checked;
                        }
                    }
                    $scope.idAvatar = checked ? $scope.files[index].id : null;
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE ||
                        $scope.visibilityAvatar === projectFieldVisibility.PUBLIC ||
                        $scope.visibilityAvatar === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('files', function (newValue, oldValue) {
                    $scope.files = newValue || [];

                    for (var i = 0; i < $scope.files.length; i++) {
                        $scope.files[i].checked = $scope.files[i].id === $scope.idAvatar;
                    }

                }, true);

                var unregisterVisibilityWatch = $scope.$watchGroup(['visibility', 'visibilityAvatar'], function (newValues, oldValues) {

                    var visibility = newValues[0];
                    var visibilityAvatar = newValues[1];

                    if (visibility === projectFieldVisibility.PUBLIC || visibilityAvatar === projectFieldVisibility.PUBLIC) {
                        angular.element($element).removeClass('private-item');
                        angular.element($element).addClass('public-item');
                    }

                    if (visibility === projectFieldVisibility.PRIVATE || visibilityAvatar === projectFieldVisibility.PRIVATE) {
                        angular.element($element).removeClass('public-item');
                        angular.element($element).addClass('private-item');
                    }

                }, true);


                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });

            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorInformationBase', selectorInformationBase);

    /** @ngInject */
    function selectorInformationBase() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorInformationBase/selectorInformationBase.html',
            controller: function ($scope, $element, $attrs, InformationBase, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.informationBases = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    InformationBase.find({filter: {include: []}}, function (response) {
                        $scope.informationBases = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);
                    }, function (errorResponse) {
                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.informationBases.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.informationBases.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {

                            /** set custom value in edit form */
                            var selected = $scope.selected.find(function (el) {
                                return el.id === item.id && item.custom === true;
                            });
                            if (selected) {
                                item.customValue = selected.customValue;
                            }
                            /** /set custom value in edit form */

                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorLink', selectorLink);

    /** @ngInject */
    function selectorLink() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorLink/selectorLink.html',
            controller: function ($scope, $element, $attrs, Financing, messagesHelper, toastr, projectFieldVisibility) {

                $scope.newItem = {
                    title: "",
                    url: ""
                };
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.addItem = function () {
                    if (!$scope.newItem || !$scope.newItem.title || !$scope.newItem.url) {
                        toastr.clear();
                        toastr.error(messagesHelper.complete_the_field);
                        return;
                    }
                    $scope.selected.push($scope.newItem);
                    $scope.newItem = {
                        title: "",
                        url: ""
                    };
                };

                $scope.removeItem = function (index) {
                    $scope.selected.splice(index, 1);
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorLocation', selectorLocation);

    /** @ngInject */
    function selectorLocation() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors",
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorLocation/selectorLocation.html',
            controller: function ($scope, $rootScope, $element, $attrs, Region, Province, District, ScreenLoader, pdConfig, $http, $httpParamSerializer, $q, toastr, messagesHelper, validationUtils, projectFieldUtils, projectFieldVisibility) {

                $scope.regions = [];
                $scope.provinces = [];
                $scope.districts = [];

                $scope.isEdition = false;
                $scope.currentIndex = 0;
                $scope.location = {
                    idRegion: null,
                    idProvince: null,
                    idDistrict: null,
                    populatedCenter: null,
                    latitude: null,
                    longitude: null,
                };

                /** find regions */
                $scope.loadRegions = function () {
                    ScreenLoader.show();
                    Region.find({}, function (response) {
                        ScreenLoader.hide();
                        $scope.regions = response;
                        $scope.provinces = [];
                        $scope.districts = [];
                    }, function (errorResponse) {
                        ScreenLoader.hide();
                    })
                };

                /** find provinces */
                $scope.loadProvinces = function (idRegion) {
                    ScreenLoader.show();
                    Province.find({filter: {where: {idRegion: idRegion}}}, function (response) {
                        ScreenLoader.hide();
                        $scope.provinces = response;
                        $scope.districts = [];
                    }, function (errorResponse) {
                        ScreenLoader.hide();
                    })
                };

                /** find districts */
                $scope.loadDistricts = function (idProvince) {
                    ScreenLoader.show();
                    District.find({filter: {where: {idProvince: idProvince}}}, function (response) {
                        ScreenLoader.hide();
                        $scope.districts = response;
                    }, function (errorResponse) {
                        ScreenLoader.hide();
                    })
                };

                /** calculate coordinates */
                $scope.calculateCoords = function () {
                    var key = pdConfig.geocodeApiKey;
                    var address = ['Perú'];
                    var params = {
                        key: key,
                        address: '',
                        components: {
                            country: 'PE'
                        }
                    };

                    if ($scope.location.idRegion) {
                        var region = $scope.regions.find(function (item) {
                            return item.id === $scope.location.idRegion;
                        });
                        if (region) {
                            address.unshift(region.name);
                        }
                    }
                    if ($scope.location.idProvince) {
                        var province = $scope.provinces.find(function (item) {
                            return item.id === $scope.location.idProvince;
                        });
                        if (province) {
                            address.unshift(province.name);
                        }
                    }
                    if ($scope.location.idDistrict) {
                        var district = $scope.districts.find(function (item) {
                            return item.id === $scope.location.idDistrict;
                        });
                        if (district) {
                            address.unshift(district.name);
                        }
                    }
                    if ($scope.location.populatedCenter) {
                        address.unshift($scope.location.populatedCenter);
                    }

                    params.address = address.join(', ');

                    var url = "https://maps.googleapis.com/maps/api/geocode/json?" + $httpParamSerializer(params);
                    ScreenLoader.show();
                    $http.post(url).then(function (response) {
                        ScreenLoader.hide();

                        if (response.data &&
                            response.data.status &&
                            response.data.status === 'OK' &&
                            response.data.results &&
                            response.data.results.length) {

                            var result = response.data.results[0];
                            var coordinates = result.geometry.location;

                            $scope.location.latitude = coordinates.lat;
                            $scope.location.longitude = coordinates.lng;
                        } else {
                            $scope.location.latitude = null;
                            $scope.location.longitude = null;
                        }
                    }, function (errorResponse) {
                        ScreenLoader.hide();
                        $scope.location.latitude = null;
                        $scope.location.longitude = null;
                    });
                };

                /** create or update location */
                $scope.createOrUpdateLocation = function () {
                    if (!$scope.isValidLocation($scope.location)) {
                        toastr.error(messagesHelper.complete_all_location_fields);
                        return;
                    }
                    if (!$scope.isValidCoordinates($scope.location)) {
                        toastr.error(messagesHelper.invalid_coordinates);
                        return;
                    }
                    if ($scope.isEdition && $scope.model[$scope.currentIndex]) {
                        $scope.model[$scope.currentIndex] = angular.copy($scope.location);
                    } else {
                        $scope.model.push(angular.copy($scope.location));
                    }
                    $scope.resetLocation();
                };

                /** reset location */
                $scope.resetLocation = function () {
                    $scope.location = {
                        idRegion: null,
                        idProvince: null,
                        idDistrict: null,
                        populatedCenter: null,
                        latitude: null,
                        longitude: null,
                    };
                    $scope.provinces = [];
                    $scope.districts = [];
                    $scope.isEdition = false;
                };

                /** remove location */
                $scope.removeLocation = function (index) {
                    if ($scope.currentIndex === index) {
                        $scope.model.splice(index, 1);
                        $scope.resetLocation();
                    }
                };

                /** select location */
                $scope.selectLocation = function (location, index) {
                    $scope.currentIndex = index;
                    $scope.location = angular.copy(location);
                    $scope.reloadResources(location.idRegion, location.idProvince);
                    $scope.isEdition = true;
                };

                /** reload resources */
                $scope.reloadResources = function (idRegion, idProvince) {
                    ScreenLoader.show();
                    $q.all([
                        Province.find({filter: {where: {idRegion: idRegion}}}).$promise,
                        District.find({filter: {where: {idProvince: idProvince}}}).$promise,
                    ]).then(function (results) {
                        ScreenLoader.hide();

                        $scope.provinces = results[0];
                        $scope.districts = results[1];

                    }, function (error) {
                        ScreenLoader.hide();
                        toastr.error(messagesHelper.fail_operation);
                    });
                };

                /** valid location check */
                $scope.isValidLocation = function (location) {
                    return location.idRegion
                        && location.idProvince
                        && location.idDistrict
                        // && location.populatedCenter
                        && location.latitude
                        && location.longitude;
                };

                /** coordinates validation */
                $scope.isValidCoordinates = function (location) {
                    return validationUtils.isValidLatitude(location.latitude)
                        && validationUtils.isValidLongitude(location.longitude);
                };

                /** check visibility */
                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadRegions();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadRegions();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterVisibilityWatch();
                });

                /** init */
                if (!$scope.model || !Array.isArray($scope.model)) {
                    $scope.model = [];
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorOds', selectorOds);

    /** @ngInject */
    function selectorOds() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                columns: "=columns",
                errors: "=errors",
                viewMode: "@viewMode"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorODS/selectorODS.html',
            controller: function ($scope, $element, $attrs, Objective, projectFieldVisibility) {

                $scope.itemsPerColumn = 0;
                $scope.objectives = [];
                $scope.selection = {};
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.setSelection = function (selected) {
                    selected.forEach(function (item) {
                        $scope.selection[item.id] = true;
                    });
                };

                $scope.loadResources = function () {
                    Objective.find({filter: {include: ["image"]}}, function (response) {
                        $scope.objectives = response;
                        $scope.itemsPerColumn = Math.ceil(response.length / $scope.columns);


                    }, function (errorResponse) {

                    });
                };

                $scope.getItemsByColumn = function (column) {
                    if (!$scope.objectives.length) {
                        return [];
                    }
                    var begin = column * $scope.itemsPerColumn;
                    var end = begin + $scope.itemsPerColumn;
                    var items = [];

                    $scope.objectives.forEach(function (item, pos) {
                        if (pos >= begin && pos < end) {
                            items.push(item);
                        }
                    });
                    return items;
                };

                $scope.changeSelection = function (item, isChecked) {
                    if (isChecked) {
                        $scope.selected.push(item);
                    } else {
                        for (var i = 0; i < $scope.selected.length; i++) {
                            if ($scope.selected[i].id === item.id) {
                                $scope.selected.splice(i, 1);
                            }
                        }
                    }
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('selected', function (newValue, oldValue) {
                    $scope.setSelection(newValue);
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            $scope.loadResources();
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            $scope.loadResources();
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorProjectStatus', selectorProjectStatus);

    /** @ngInject */
    function selectorProjectStatus() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorProjectStatus/selectorProjectStatus.html',
            controller: function ($scope, $rootScope, $element, $attrs, projectStatus, projectStatusName, projectFieldVisibility) {

                $scope.associateds = [];
                $scope.statusList = [{
                    id: projectStatus.DRAFT,
                    name: projectStatusName[projectStatus.DRAFT],
                }, {
                    id: projectStatus.PENDING,
                    name: projectStatusName[projectStatus.PENDING]
                }, {
                    id: projectStatus.PUBLISHED,
                    name: projectStatusName[projectStatus.PUBLISHED]
                }];

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorVideo', selectorVideo);

    /** @ngInject */
    function selectorVideo() {
        return {
            restrict: 'EA',
            scope: {
                selected: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorVideo/selectorVideo.html',
            controller: function ($scope, $element, $attrs, Financing, messagesHelper, toastr, projectFieldVisibility) {

                $scope.newItem = "";
                if (!$scope.selected || !Array.isArray($scope.selected)) {
                    $scope.selected = [];
                }

                $scope.addItem = function () {
                    if (!$scope.newItem) {
                        toastr.clear();
                        toastr.error(messagesHelper.complete_the_field);
                        return;
                    }
                    $scope.selected.push($scope.newItem);
                    $scope.newItem = "";
                };

                $scope.removeItem = function (index) {
                    $scope.selected.splice(index, 1);
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('ProjectDirectory.resources')
        .directive('selectorWomanEmpowerment', selectorWomanEmpowerment);

    /** @ngInject */
    function selectorWomanEmpowerment() {
        return {
            restrict: 'EA',
            scope: {
                model: "=ngModel",
                visibility: "=visibility",
                isRequired: "=isRequired",
                errors: "=errors"
            },
            templateUrl: 'app/resources/directives/manageProjects/selectorWomanEmpowerment/selectorWomanEmpowerment.html',
            controller: function ($scope, $element, $attrs, projectFieldVisibility) {

                $scope.toggleSelection = function () {
                    $scope.model = !$scope.model;
                };

                $scope.isVisible = function () {
                    return $scope.visibility === projectFieldVisibility.PUBLIC ||
                        $scope.visibility === projectFieldVisibility.PRIVATE;
                };

                var unregisterWatch = $scope.$watch('model', function (newValue, oldValue) {
                    $scope.model = newValue;
                }, true);

                var unregisterVisibilityWatch = $scope.$watch('visibility', function (newValue, oldValue) {

                    switch (newValue) {

                        case projectFieldVisibility.PUBLIC:
                            angular.element($element).removeClass('private-item');
                            angular.element($element).addClass('public-item');
                            break;

                        case projectFieldVisibility.PRIVATE:
                            angular.element($element).removeClass('public-item');
                            angular.element($element).addClass('private-item');
                            break;

                        default:
                            break;
                    }

                }, true);

                $scope.$on('$destroy', function () {
                    unregisterWatch();
                    unregisterVisibilityWatch();
                });
            }
        };
    }
})();
/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/article/configuration.html','<div class="widgets" ng-init="loadConfiguration()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Configuraci\xF3n de Art\xEDculos"><form class="form-horizontal" id="articleForm" name="articleForm" angular-validator-submit="updateArticleSettings(articleForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="menuName">Nombre del Men\xFA <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="menuName" id="menuName" class="form-control col-md-7 col-xs-12" ng-model="configurationArticle.menuName" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="sectionName">Nombre de la Secci\xF3n <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="sectionName" id="sectionName" class="form-control col-md-7 col-xs-12" ng-model="configurationArticle.sectionName" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3"><button type="submit" class="btn btn-primary">Guardar</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/article/create.html','<div class="widgets" ng-init="init(\'create\')"><div class="row" style="padding-bottom: 60px;"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del Art\xEDculo" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="title">Imagen del Art\xEDculo <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12 no-padding"><image-upload ng-model="article.idAvatar" file-model="article.avatar" container="\'Articles\'" errors="avatarErrors"></image-upload></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="title">T\xEDtulo <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="title" id="title" class="form-control col-md-7 col-xs-12" ng-model="article.title" validate-on="blur" required-message="\'El campo es requerido.\'" maxlength="{{charLimits.title}}" required=""><char-counter ng-model="article.title" limit="charLimits.title"></char-counter></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="idCompany">Empresa <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="idCompany" id="idCompany" ng-model="article.idCompany" ng-options="company.id as (company.name) for company in companies" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" value=""></option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="idSector">Sector <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="idSector" id="idSector" ng-model="article.idSector" ng-options="sector.id as (sector.name) for sector in sectors" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" value=""></option></select></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="tag">Etiqueta</label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="tag" id="tag" class="form-control col-md-7 col-xs-12" ng-model="article.tag" maxlength="{{charLimits.tag}}"><char-counter ng-model="article.tag" limit="charLimits.tag"></char-counter></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="location">Ubicaci\xF3n</label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="location" id="location" class="form-control col-md-7 col-xs-12" ng-model="article.location" maxlength="{{charLimits.location}}"><char-counter ng-model="article.location" limit="charLimits.location"></char-counter></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="publishedAt">Fecha de Publicaci\xF3n <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="publishedAt" id="publishedAt" placeholder="(d\xEDa/mes/a\xF1o)" class="form-control col-md-7 col-xs-12 date-picker" date-range-picker="" readonly="readonly" ng-model="article.publishedAt" options="optionsFormDatepicker" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="publicUpdatedAt">Fecha de Actualizaci\xF3n <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="publicUpdatedAt" id="publicUpdatedAt" placeholder="(d\xEDa/mes/a\xF1o)" class="form-control col-md-7 col-xs-12 date-picker" date-range-picker="" readonly="readonly" ng-model="article.publicUpdatedAt" options="optionsFormDatepicker" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="summary">Descripci\xF3n para Redes Sociales <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><textarea name="summary" id="summary" class="form-control col-md-7 col-xs-12" ng-model="article.summary" validate-on="blur" required-message="\'El campo es requerido.\'" maxlength="{{charLimits.summary}}" required="" rows="4">\n                        </textarea><char-counter ng-model="article.summary" limit="charLimits.summary"></char-counter></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="summary">Galer\xEDa del Art\xEDculo</label><div class="col-md-6 col-sm-6 col-xs-12 no-padding"><div class="col-md-3 gallery-item-wrapper" ng-repeat="image in article.images"><div class="gallery-item"><img ng-src="{{image.url|imageUrl}}" alt=""> <button type="button" class="btn btn-xs btn-danger" ng-click="removeGalleryImage($index)"><i class="fa fa-times"></i></button></div></div><image-upload ng-model="galleryItem.id" file-model="galleryItem.file" container="\'Articles\'"></image-upload></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Enlaces</label><div class="col-xs-12 col-md-6 col-sm-6"><article-link ng-model="article.links"></article-link></div></div><div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3" style="position: absolute; bottom: 20px; z-index: 1;"><button type="submit" class="btn btn-primary">Guardar</button> <button class="btn" type="button" ui-sref="main.article.list">Ir al listado</button></div></form><div class="form-group clearfix" style="padding-bottom: 60px;"><div class="col-md-10 col-xs-12 col-md-offset-1"><div text-angular="" ng-model="article.content" name="ta-article-content" ta-toolbar="taToolbar" placeholder="" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div></div></div></div></div></div>');
$templateCache.put('app/pages/article/edit.html','<div class="widgets" ng-init="init(\'edit\')"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del Art\xEDculo" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="title">Imagen del Art\xEDculo <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12 no-padding"><image-upload ng-model="article.idAvatar" file-model="article.avatar" container="\'Articles\'" errors="avatarErrors"></image-upload></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="title">T\xEDtulo <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="title" id="title" class="form-control col-md-7 col-xs-12" ng-model="article.title" validate-on="blur" required-message="\'El campo es requerido.\'" maxlength="{{charLimits.title}}" required=""><char-counter ng-model="article.title" limit="charLimits.title"></char-counter></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="idCompany">Empresa <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="idCompany" id="idCompany" ng-model="article.idCompany" ng-options="company.id as (company.name) for company in companies" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" value=""></option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="idSector">Sector <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="idSector" id="idSector" ng-model="article.idSector" ng-options="sector.id as (sector.name) for sector in sectors" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" value=""></option></select></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="tag">Etiqueta</label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="tag" id="tag" class="form-control col-md-7 col-xs-12" ng-model="article.tag" maxlength="{{charLimits.tag}}"><char-counter ng-model="article.tag" limit="charLimits.tag"></char-counter></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="location">Ubicaci\xF3n</label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="location" id="location" class="form-control col-md-7 col-xs-12" ng-model="article.location" maxlength="{{charLimits.location}}"><char-counter ng-model="article.location" limit="charLimits.location"></char-counter></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="publishedAt">Fecha de Publicaci\xF3n <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="publishedAt" id="publishedAt" placeholder="(d\xEDa/mes/a\xF1o)" class="form-control col-md-7 col-xs-12 date-picker" date-range-picker="" readonly="readonly" ng-model="article.publishedAt" options="optionsFormDatepicker" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="publicUpdatedAt">Fecha de Actualizaci\xF3n <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="publicUpdatedAt" id="publicUpdatedAt" placeholder="(d\xEDa/mes/a\xF1o)" class="form-control col-md-7 col-xs-12 date-picker" date-range-picker="" readonly="readonly" ng-model="article.publicUpdatedAt" options="optionsFormDatepicker" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="summary">Descripci\xF3n para Redes Sociales <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><textarea name="summary" id="summary" class="form-control col-md-7 col-xs-12" ng-model="article.summary" validate-on="blur" required-message="\'El campo es requerido.\'" maxlength="{{charLimits.summary}}" required="" rows="4">\n                        </textarea><char-counter ng-model="article.summary" limit="charLimits.summary"></char-counter></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="summary">Galer\xEDa del Art\xEDculo</label><div class="col-md-6 col-sm-6 col-xs-12 no-padding"><div class="col-md-3 gallery-item-wrapper" ng-repeat="image in article.images"><div class="gallery-item"><img ng-src="{{image.url|imageUrl}}" alt=""> <button type="button" class="btn btn-xs btn-danger" ng-click="removeGalleryImage($index)"><i class="fa fa-times"></i></button></div></div><image-upload ng-model="galleryItem.id" file-model="galleryItem.file" container="\'Articles\'"></image-upload></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Enlaces</label><div class="col-xs-12 col-md-6 col-sm-6"><article-link ng-model="article.links"></article-link></div></div><div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3" style="position: absolute; bottom: 20px; z-index: 1;"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.article.list">Ir al listado</button></div></form><div class="form-group clearfix" style="padding-bottom: 60px;"><div class="col-md-10 col-xs-12 col-md-offset-1"><div text-angular="" ng-model="article.content" name="ta-article-content" ta-toolbar="taToolbar" placeholder="" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div></div></div></div></div></div>');
$templateCache.put('app/pages/article/list.html','<div class="widgets" ng-init="init(\'list\')"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover projects-table" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="title" width="30%">T\xEDtulo</th><th st-sort="idCompany" width="20%">Empresa</th><th st-sort="sector" width="20%">Sector</th><th st-sort="publishedAt">Orden Pub. <i class="fa fa-info-circle" uib-tooltip="La fecha de publicaci\xF3n se emplea para el orden y visibilidad de los art\xEDculos."></i></th><th>Acciones</th></tr><tr><th></th><th><input st-search="title" class="input-sm form-control search-input"></th><th><select class="form-control" title="Empresa" st-search="idCompany" ng-model="query.idCompany" ng-options="company.id as (company.name) for company in companies"><option selected="" value=""></option></select></th><th><select class="form-control" title="Sector" st-search="idSector" ng-model="query.idSector" ng-options="sector.id as (sector.name) for sector in sectors"><option selected="" value=""></option></select></th><th></th><th><a ui-sref="main.article.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.title}}</td><td>{{getCompanyName(row.company)}}</td><td>{{getSectorName(row.sector)}}</td><td><input type="text" name="dp_{{row.id}}" id="dp_{{row.id}}" placeholder="(d\xEDa/mes/a\xF1o)" class="form-control date-picker input-sm text-center" date-range-picker="" readonly="readonly" ng-model="rowsDatePickers[row.id].date" options="optionsDatepickerRow"></td><td><a ui-sref="main.article.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="6" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="6"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/associated/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del Asociado" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="username">Usuario <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="username" id="username" class="form-control col-md-7 col-xs-12" ng-model="associated.username" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="password">Contrase\xF1a <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="password" name="password" id="password" class="form-control col-md-7 col-xs-12" ng-model="associated.password" validate-on="blur" ng-pattern="/^(?=^.{6,72}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[a-zA-Z]).*$/" invalid-message="\'Debe contener letras y n\xFAmeros y no menos de 6 caracteres.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="retypePassword">Confirmaci\xF3n <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="password" name="retypePassword" id="retypePassword" validate-on="blur" class="form-control col-md-7 col-xs-12" ng-model="associated.retypePassword" validator="associated.password === associated.retypePassword" invalid-message="\'Las claves no coinciden.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.associated.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/associated/edit.html','<div class="widgets" ng-init="loadAssociated()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del Asociado" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="username">Usuario <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="username" id="username" class="form-control col-md-7 col-xs-12" ng-model="associated.username" validate-on="blur" required-message="\'El campo es requerido.\'" ng-disabled="associated.type === \'remote\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="password">Contrase\xF1a <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="password" name="password" id="password" class="form-control col-md-7 col-xs-12" ng-model="associated.password" validate-on="blur" ng-pattern="/^(?=^.{6,72}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[a-zA-Z]).*$/" invalid-message="\'Debe contener letras y n\xFAmeros y no menos de 6 caracteres.\'"></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="retypePassword">Confirmaci\xF3n <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="password" name="retypePassword" id="retypePassword" validate-on="blur" class="form-control col-md-7 col-xs-12" ng-model="associated.retypePassword" validator="associated.password === associated.retypePassword" invalid-message="\'Las claves no coinciden.\'"></div></div><div class="form-group"><div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.associated.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/associated/list.html','<div class="widgets" ng-init="init(\'list\')"><div class="row"><div class="col-md-8"><div ba-panel="" ba-panel-title="Filtros" ba-panel-class="z-1"><div class="clearfix"><advanced-associated-filters sectors="sectors" show-company-name-filter="true" show-username-filter="true" apply="applyFilters(newPageNumber, newPageFilters)" reset="applyFilters(newPageNumber, newPageFilters)" show-reset="true" reset-icon="fa fa-ban" apply-icon="fa fa-filter" reset-text="Limpiar Filtros" apply-text="Aplicar Filtros"></advanced-associated-filters></div></div></div><div class="col-md-2" ba-panel=""><div class="chart-total-panel"><h3>Encontrados</h3>{{filteredTotal}}</div></div><div class="col-md-2" ba-panel=""><div class="chart-total-panel"><h3>Total General</h3>{{total}}</div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="text-right p-r-15"><button type="button" class="btn btn-sm btn-primary" ng-click="export()"><i class="fa fa-download"></i> Exportar Listado</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover projects-table" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th>Usuario</th><th width="20%">Compa\xF1\xEDa</th><th>Tipo</th><th>Registro</th><th>\xDAltima sesi\xF3n</th><th>Contrase\xF1a</th><th>Acciones</th></tr><tr><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th><a ui-sref="main.associated.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.username}}</td><td><a ui-sref="main.associated.company({id: row.id})">{{row.company && row.company.name ? row.company.name : \'Sin Definir\'}}</a></td><td>{{row.type === \'remote\' ? \'Remoto\' : \'Local\'}}</td><td><span class="label label-default">{{row.created_at | date: \'dd-MM-yyyy HH:mm\'}}</span></td><td><span class="label label-default">{{row.lastLogin ? (row.lastLogin | date: \'dd-MM-yyyy HH:mm\') : \'No ha iniciado sesi\xF3n.\'}}</span></td><td><button class="btn btn-primary btn-xs" ng-click="generatePassword(row.id, $index)"><i class="fa fa-envelope"></i> Generar</button> <button class="btn btn-xs" ng-click="row.plainPassword ? hidePassword($index) : showPassword(row.id, $index)"><i class="fa fa-eye {{row.plainPassword ? \'fa-eye-slash\':\'fa-eye\'}}"></i> {{row.plainPassword}}</button> <button class="btn btn-xs" ng-if="row.plainPassword" ngclipboard="" ngclipboard-success="onSuccess(e);" ngclipboard-error="onError(e);" data-clipboard-text="{{row.plainPassword}}"><i class="fa fa-clipboard"></i></button></td><td><a ui-sref="main.associated.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="8" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="8" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="8"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/associated/sync.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover projects-table" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="date">Fecha</th><th st-sort="usersAdded">Usuarios nuevos</th><th st-sort="usersUpdated">Actualizados</th><th st-sort="type">Tipo</th><th st-sort="status">Estado</th><th st-sort="errorDetail">Error</th><th>Acciones</th></tr><tr><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th><a href="javascript:;" ng-click="syncUsers()" class="btn btn-primary btn-xs"><i class="fa fa-refresh"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td><span class="label label-default">{{row.date | date: \'dd-MM-yyyy HH:mm\'}}</span></td><td>{{row.usersAdded}}</td><td>{{row.usersUpdated}}</td><td>{{row.type}}</td><td>{{row.status}}</td><td>{{row.errorDetail}}</td><td><button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="8" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="8" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="8"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/banner/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del Banner Publicitario" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="banner.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="title">T\xEDtulo</label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="title" id="title" class="form-control col-xs-12 col-md-7" ng-model="banner.title"></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="url">Url</label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="url" id="url" class="form-control col-xs-12 col-md-7" ng-model="banner.url" validate-on="blur"></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="status">Estado</label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="status" id="status" ng-model="banner.status" ng-options="status.key as status.name for status in statusList" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" value="">{{\'Estado\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Imagen Web <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><recommended-sizes width="recommendedSizes.desktop.width" height="recommendedSizes.desktop.height" unit="px"></recommended-sizes><div class="userpic banner-web-pic"><div class="userpic-wrapper" ng-click="showFileDialog(\'web\')"><span ng-if="!banner.imageWeb" class="fa fa-plus fa-2x"></span> <img ng-if="banner.imageWeb" ng-src="{{ banner.imageWeb.url | imageUrl }}"></div><i class="ion-ios-close-outline" ng-click="removeFile(\'web\')" ng-if="banner.imageWeb"></i></div></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Imagen M\xF3vil <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><recommended-sizes width="recommendedSizes.mobile.width" height="recommendedSizes.mobile.height" unit="px"></recommended-sizes><div class="userpic"><div class="userpic-wrapper" ng-click="showFileDialog(\'mobile\')"><span ng-if="!banner.imageMobile" class="fa fa-plus fa-2x"></span> <img ng-if="banner.imageMobile" ng-src="{{ banner.imageMobile.url | imageUrl }}"></div><i class="ion-ios-close-outline" ng-click="removeFile(\'mobile\')" ng-if="banner.imageMobile"></i></div></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.banner.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/banner/edit.html','<div class="widgets" ng-init="loadBanner()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del Banner Publicitario" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="update(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="banner.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="title">T\xEDtulo</label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="title" id="title" class="form-control col-xs-12 col-md-7" ng-model="banner.title"></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="url">Url</label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="url" id="url" class="form-control col-xs-12 col-md-7" ng-model="banner.url" validate-on="blur"></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="status">Estado</label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="status" id="status" ng-model="banner.status" ng-options="status.key as status.name for status in statusList" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" value="">{{\'Estado\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Imagen Web <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><recommended-sizes width="recommendedSizes.desktop.width" height="recommendedSizes.desktop.height" unit="px"></recommended-sizes><div class="userpic banner-web-pic"><div class="userpic-wrapper" ng-click="showFileDialog(\'web\')"><span ng-if="!banner.imageWeb" class="fa fa-plus fa-2x"></span> <img ng-if="banner.imageWeb" ng-src="{{ banner.imageWeb.url | imageUrl }}"></div><i class="ion-ios-close-outline" ng-click="removeFile(\'web\')" ng-if="banner.imageWeb"></i></div></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Imagen M\xF3vil <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><recommended-sizes width="recommendedSizes.mobile.width" height="recommendedSizes.mobile.height" unit="px"></recommended-sizes><div class="userpic"><div class="userpic-wrapper" ng-click="showFileDialog(\'mobile\')"><span ng-if="!banner.imageMobile" class="fa fa-plus fa-2x"></span> <img ng-if="banner.imageMobile" ng-src="{{ banner.imageMobile.url | imageUrl }}"></div><i class="ion-ios-close-outline" ng-click="removeFile(\'mobile\')" ng-if="banner.imageMobile"></i></div></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.banner.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/banner/filesModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Im\xE1genes de banners</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="alert alert-info">El tama\xF1o m\xE1ximo permitido para cada archivo es 10 MB.</div><div ngf-drop="uploadFile($file, $invalidFiles, imageType)" ngf-select="uploadFile($file, $invalidFiles, imageType)" ng-model="picFile" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="false" accept="image/*" ngf-pattern="\'image/*\'" name="picFile" ngf-max-size="10MB" ngf-model-invalid="errorFile">Arrastre el logo aqu\xED o haga click para subir uno.</div><div><span class="control-label has-error validationMessage">{{f.name}} {{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}}</span> <span class="progress pull-right" ng-show="f.progress >= 0"><div style="width:{{f.progress}}%" ng-bind="f.progress + \'%\'"></div></span></div><span class="control-label has-error validationMessage">{{errorMsg}}</span></div></div><br><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callLogoFilesServer" st-table="results"><thead><tr class="sortable"><th></th><th st-sort="originalFilename">Nombre del archivo</th><th st-sort="size">Tama\xF1o</th><th></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td><div class="image-wrapper"><img ng-src="{{row.name|imageUrl:row.container}}" alt="row.originalFilename"></div></td><td><span style="word-break: break-all;">{{row.originalFilename}}</span></td><td>{{row.size/1024/1024 | number: 2}} MB</td><td><button ng-click="setBannerImage(row, imageType)" class="btn btn-primary btn-xs"><i class="fa fa-check"></i> Seleccionar</button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/banner/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><td width="120"></td><th st-sort="name">Nombre Referencia</th><th st-sort="title">T\xEDtulo</th><th st-sort="status">Estado</th><th>Acciones</th></tr><tr><th></th><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th><input st-search="title" class="input-sm form-control search-input"></th><th><select st-search="status" class="form-control" name="status" id="status"><option selected="" value=""></option><option value="{{status.key}}" ng-repeat="status in statusList">{{status.name}}</option></select></th><th><a ui-sref="main.banner.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td><div class="image-wrapper" ng-if="row.imageMobile"><img ng-src="{{row.imageMobile.url | imageUrl}}"></div></td><td>{{row.name}}</td><td>{{row.title}}</td><td><select class="m-t-1" name="status" ng-change="changeStatus(row.id, row.status)" ng-model="row.status"><option value="{{status.key}}" ng-repeat="status in statusList">{{status.name}}</option></select></td><td><a ui-sref="main.banner.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="6" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="6"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/bulletin/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del env\xEDo"><form name="createForm" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="col-md-4"><div class="form-group"><label for="subject">Asunto <span class="required">*</span></label> <input type="text" name="subject" id="subject" class="form-control" maxlength="255" ng-model="bulletin.subject" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><div class="text-right"><span class="label label-info">{{bulletin.subject.length || 0}} / 255</span></div></div><div class="form-group"><label class="control-label">Especificar remitente</label><div><ba-switcher switcher-style="primary" switcher-value="bulletin.changeFrom"></ba-switcher></div></div><div class="form-group" ng-show="bulletin.changeFrom"><label for="fromName">Nombre del remitente <span class="required">*</span></label> <input type="text" name="fromName" id="fromName" class="form-control" maxlength="255" ng-model="bulletin.fromName" ng-required="bulletin.changeFrom" validate-on="blur" required-message="\'El campo es requerido.\'"><div class="text-right"><span class="label label-info">{{bulletin.fromName.length || 0}} / 255</span></div></div><div class="form-group" ng-show="bulletin.changeFrom"><label for="from">Email del remitente <span class="required">*</span></label> <input type="email" name="from" id="from" class="form-control" maxlength="255" ng-model="bulletin.from" ng-required="bulletin.changeFrom" validate-on="blur" invalid-message="\'El email es incorrecto.\'" required-message="\'El campo es requerido.\'"><div class="text-right"><span class="label label-info">{{bulletin.from.length || 0}} / 255</span></div></div></div><div class="col-md-6"><div class="alert alert-info">En el selector de proyectos inicialmente se muestran los \xFAltimos proyectos publicados para buscar alguno en espec\xEDfico introduzca el nombre o parte del mismo.</div><div class="form-group"><label for="bulletin_projects">Proyectos <span class="required">*</span></label><tags-input id="bulletin_projects" ng-model="selectedProjects" placeholder="Adicionar proyecto" key-property="id" display-property="nameToPublish" replace-spaces-with-dashes="false" add-from-autocomplete-only="true"><auto-complete source="loadProjects($query)" load-on-empty="true" load-on-focus="true" template="app/pages/bulletin/item.tpl.html"></auto-complete></tags-input></div><uib-accordion close-others="false" ng-if="selectedProjects.length>0"><div uib-accordion-group="" class="panel-default" is-open="status.open" ng-repeat="project in selectedProjects"><uib-accordion-heading>{{project.nameToPublish | cut : false : 35 }} <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}"></i><div class="pull-right" ng-if="selectedProjects.length > 1" style="margin-right: 3px;"><button type="button" class="btn btn-xs" ng-click="changeProjectOrder($event, $index, \'up\')" ng-if="!$first"><i class="fa fa-arrow-up"></i></button> <button type="button" class="btn btn-xs" ng-click="changeProjectOrder($event, $index, \'down\')" ng-if="!$last"><i class="fa fa-arrow-down"></i></button></div></uib-accordion-heading><strong>{{project.nameToPublish}}</strong><p>{{project.summary}}</p></div></uib-accordion></div><div class="col-md-2"><button type="submit" class="btn btn-primary btn-block">Crear</button> <button class="btn btn-block" type="button" ui-sref="main.bulletin.list">Ir al listado</button></div><div class="col-md-12" ng-if="previewUrl"><div><h4>Previsualizaci\xF3n del cuerpo del correo</h4></div><iframe ng-src="{{trustSrc(previewUrl)}}" refreshable="refreshIframe" width="100%" height="400px" frameborder="0" style="border:0" allowfullscreen=""></iframe></div></form></div></div></div>');
$templateCache.put('app/pages/bulletin/create_custom.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del env\xEDo"><form name="createForm" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="col-md-10 no-padding"><div class="col-md-12"><div class="form-group"><div class="btn-group" uib-dropdown="" is-open="status.isopen"><button id="single-button" type="button" class="btn btn-primary" uib-dropdown-toggle="">Cargar direcciones <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="single-button"><li role="menuitem"><a href="javascript:;" ng-click="loadAssociates()">Asociados</a></li><li role="menuitem"><a href="javascript:;" ng-click="loadSubscribers()">Suscriptores</a></li></ul></div></div><div class="form-group"><label for="to">Direcciones de correo <span class="required">*</span></label><tags-input ng-model="bulletin.to" id="to" placeholder="Adicionar direcci\xF3n" use-strings="true"></tags-input></div></div><div class="col-md-12"><div class="form-group"><label class="control-label">Especificar remitente</label><div><ba-switcher switcher-style="primary" switcher-value="bulletin.changeFrom"></ba-switcher></div></div></div><div class="col-md-6" ng-show="bulletin.changeFrom"><div class="form-group"><label for="fromName">Nombre del remitente <span class="required">*</span></label> <input type="text" name="fromName" id="fromName" class="form-control" maxlength="255" ng-model="bulletin.fromName" ng-required="bulletin.changeFrom" validate-on="blur" required-message="\'El campo es requerido.\'"><div class="text-right"><span class="label label-info">{{bulletin.fromName.length || 0}} / 255</span></div></div></div><div class="col-md-6" ng-show="bulletin.changeFrom"><div class="form-group"><label for="from">Email del remitente <span class="required">*</span></label> <input type="email" name="from" id="from" class="form-control" maxlength="255" ng-model="bulletin.from" ng-required="bulletin.changeFrom" validate-on="blur" invalid-message="\'El email es incorrecto.\'" required-message="\'El campo es requerido.\'"><div class="text-right"><span class="label label-info">{{bulletin.from.length || 0}} / 255</span></div></div></div><div class="col-md-12"><div class="form-group"><label for="subject">Asunto <span class="required">*</span></label> <input type="text" name="subject" id="subject" class="form-control" maxlength="255" ng-model="bulletin.subject" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><div class="text-right"><span class="label label-info">{{bulletin.subject.length || 0}} / 255</span></div></div></div></div><div class="col-md-2"><button type="submit" class="btn btn-primary btn-block">Crear</button> <button class="btn btn-block" type="button" ui-sref="main.bulletin.list">Ir al listado</button></div></form><div class="col-md-10" text-angular="" id="summary" ng-model="bulletin.body" name="ta-summary" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div></div></div></div>');
$templateCache.put('app/pages/bulletin/item.tpl.html','<div class="left-panel"></div><span ng-bind-html="$highlight($getDisplayText())"></span>');
$templateCache.put('app/pages/bulletin/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="subject">Asunto</th><th st-sort="from">Remitente</th><th st-sort="created_at">Fecha env\xEDo</th><th st-sort="status">Estado</th><th>Estad\xEDsticas</th><th>Acciones</th></tr><tr><th></th><th><input st-search="subject" class="input-sm form-control search-input"></th><th><input st-search="from" class="input-sm form-control search-input"></th><th></th><th></th><th></th><th><a ui-sref="main.bulletin.create_custom" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.subject}}</td><td>{{row.from}}</td><td><span class="label label-default">{{row.created_at | date: \'dd-MM-yyyy HH:mm\'}}</span></td><td><span class="label label-default">{{row.status}}</span></td><td><a ui-sref="main.bulletin.show({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-bar-chart-o"></i> Estad\xEDsticas</a></td><td><button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="7" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="7" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="7"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/bulletin/show.html','<div class="widgets" ng-init="loadStatistics()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Estad\xEDsticas" ba-panel-class="with-scroll"><div class="row" ng-show="!isLoadingStatistics"><div class="col-md-6"><div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">{{statistics.recipientscount}} <span>Total</span></div></div></div></div></div><div class="col-md-6"><table class="table table-striped"><thead><tr><th><strong>Clasificaci\xF3n</strong></th><th><strong>Cantidad</strong></th></tr></thead><tbody><tr><td>Entregados</td><td><span class="badge">{{statistics.deliveredcount}}</span></td></tr><tr><td>Pendientes</td><td><span class="badge">{{statistics.pendingcount}}</span></td></tr><tr><td>Fallos</td><td><span class="badge">{{statistics.failedcount}}</span></td></tr><tr><td>Abiertos</td><td><span class="badge">{{statistics.openedcount}}</span></td></tr><tr><td>Clicks</td><td><span class="badge">{{statistics.clickedcount}}</span></td></tr><tr><td>Total de destinatarios</td><td><span class="badge">{{statistics.recipientscount}}</span></td></tr></tbody></table></div></div><div class="row"><div class="col-md-12"><button class="btn btn-primary" type="button" ui-sref="main.bulletin.list">Ir al listado</button></div></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Desglose de destinatarios" ba-panel-class="with-scroll"><div class="row" ng-show="!isLoadingStatistics"><div class="col-md-12"><uib-tabset active="active"><uib-tab index="0" heading="Entregados"><table class="table table-striped"><tbody><tr ng-repeat="email in statistics.delivered"><td width="30px">{{$index+1}}</td><td>{{email}}</td></tr></tbody></table></uib-tab><uib-tab index="1" heading="Pendientes"><table class="table table-striped"><tbody><tr ng-repeat="email in statistics.pending"><td width="30px">{{$index+1}}</td><td>{{email}}</td></tr></tbody></table></uib-tab><uib-tab index="2" heading="Fallos"><table class="table table-striped"><tbody><tr ng-repeat="item in statistics.failed"><td width="30px">{{$index+1}}</td><td>{{item.address}}</td><td>{{item.error}}</td></tr></tbody></table></uib-tab><uib-tab index="3" heading="Abiertos"><table class="table table-striped"><tbody><tr ng-repeat="email in statistics.opened"><td width="30px">{{$index+1}}</td><td>{{email}}</td></tr></tbody></table></uib-tab><uib-tab index="4" heading="Clicks"><table class="table table-striped"><tbody><tr ng-repeat="email in statistics.clicked"><td width="30px">{{$index+1}}</td><td>{{email}}</td></tr></tbody></table></uib-tab></uib-tabset></div></div></div></div></div></div>');
$templateCache.put('app/pages/configuration/configuration.html','<div class="widgets" ng-init="init()"><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Redes sociales"><form class="form-horizontal" name="socialForm" id="socialForm" angular-validator-submit="updateSocials(socialForm.$valid)" angular-validator="" novalidate=""><div class="form-group" ng-repeat="item in socialNetworks"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="{{item.id}}">{{item.name}}</label><div class="col-md-6 col-sm-6 col-xs-8"><input type="text" name="{{item.id}}" id="{{item.id}}" class="form-control" ng-model="configurationSocial[item.id].url" ng-required="configurationSocial[item.id].enabled" validate-on="blur" ng-pattern="/^https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)$/" invalid-message="\'La url es incorrecta.\'" required-message="\'El campo es requerido.\'"></div><div class="col-md-3 col-sm-3 col-xs-4"><ba-switcher switcher-style="primary" switcher-value="configurationSocial[item.id].enabled"></ba-switcher></div></div><div class="col-md-offset-9 col-md-3 col-sm-3 col-xs-12"><button type="submit" class="btn btn-primary btn-block"><i class="fa fa-save"></i> Guardar</button></div></form></div><div class="col-md-6" ba-panel="" ba-panel-title="Enlaces aplicaciones m\xF3viles"><form class="form-horizontal" name="appForm" id="appForm" angular-validator-submit="updateApps(appForm.$valid)" angular-validator="" novalidate=""><div class="form-group" ng-repeat="item in appPlatforms"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="{{item.id}}">{{item.name}}</label><div class="col-md-6 col-sm-6 col-xs-8"><input type="text" name="{{item.id}}" id="{{item.id}}" class="form-control" ng-model="configurationApp[item.id].url" ng-required="configurationApp[item.id].enabled" validate-on="blur" ng-pattern="/^https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)$/" invalid-message="\'La url es incorrecta.\'" required-message="\'El campo es requerido.\'"></div><div class="col-md-3 col-sm-3 col-xs-4"><ba-switcher switcher-style="primary" switcher-value="configurationApp[item.id].enabled"></ba-switcher></div></div><div class="col-md-offset-9 col-md-3 col-sm-3 col-xs-12"><button type="submit" class="btn btn-primary btn-block"><i class="fa fa-save"></i> Guardar</button></div></form></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Metas del sitio"><form class="form-horizontal" name="metaForm" id="metaForm" angular-validator-submit="updateMetas(metaForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="meta_description">Meta Description</label><div class="col-md-9 col-sm-9 col-xs-12"><textarea name="meta_description" id="meta_description" class="form-control" maxlength="230" ng-model="configuration.meta.description"></textarea><div class="text-right"><span class="label label-info">{{configuration.meta.description.length || 0}} / 230</span></div></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="meta_keywords">Meta Keywords</label><div class="col-md-9 col-sm-9 col-xs-12"><textarea name="meta_keywords" id="meta_keywords" class="form-control" ng-model="configuration.meta.keywords"></textarea></div></div><div class="col-md-offset-9 col-md-3 col-sm-3 col-xs-12"><button type="submit" class="btn btn-primary btn-block"><i class="fa fa-save"></i> Guardar</button></div></form></div><div class="col-md-6" ba-panel="" ba-panel-title="Mensaje vista m\xF3vil"><form class="form-horizontal" name="appMessageForm" id="appMessageForm" angular-validator-submit="updateMessage(appMessageForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="app_message">Mensaje</label><div class="col-md-9 col-sm-9 col-xs-12"><textarea name="app_message" id="app_message" class="form-control" maxlength="500" ng-model="configuration.message"></textarea><div class="text-right"><span class="label label-info">{{configuration.message.length || 0}} / 500</span></div></div></div><div class="col-md-offset-9 col-md-3 col-sm-3 col-xs-12"><button type="submit" class="btn btn-primary btn-block"><i class="fa fa-save"></i> Guardar</button></div></form></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="\xDAltimos usuarios registrados" ba-panel-class="medium-panel traffic-panel"><div class="horizontal-scroll"><table class="table table-striped"><thead><tr><th style="text-align: left;">Nombre y Apellidos</th><th>Email</th><th>Fecha de Registro</th><th>\xDAltima Sesi\xF3n</th></tr></thead><tbody><tr ng-repeat="row in lastRegisteredUsers"><td style="text-align: left;">{{row.firstName + \' \' + row.lastName}}</td><td>{{row.email}}</td><td><span class="label label-info">{{row.created_at | date: \'dd-MM-yyyy HH:mm\'}}</span></td><td><span class="label label-info" ng-if="row.lastLogin">{{row.lastLogin | date: \'dd-MM-yyyy HH:mm\'}}</span> <span class="label label-default" ng-if="!row.lastLogin">No ha iniciado sesi\xF3n</span></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Usuarios (\xFAltimos 7 d\xEDas)" ba-panel-class="medium-panel traffic-panel"><div id="chart-users-container"></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Sesiones por pa\xEDses (\xDAltimos 30 d\xEDas)" ba-panel-class="medium-panel traffic-panel"><div id="chart-map-container"></div></div></div><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Canales principales (\xDAltimos 30 d\xEDas)" ba-panel-class="medium-panel traffic-panel"><div id="chart-channel-container"></div></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Visitas nuevas/recurrentes (\xDAltimos 30 d\xEDas)" ba-panel-class="medium-panel traffic-panel"><div id="chart-visitor-container"></div></div></div><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="\xDAltimos usuarios registrados" ba-panel-class="medium-panel traffic-panel"><div class="horizontal-scroll"><table class="table table-striped"><thead><tr><th style="text-align: left;">Nombre y Apellidos</th><th>Email</th><th>Fecha de Registro</th></tr></thead><tbody><tr ng-repeat="row in lastRegisteredUsers"><td style="text-align: left;">{{row.firstName + \' \' + row.lastName}}</td><td>{{row.email}}</td><td><span class="badge" style="font-size: 10px;">{{row.created_at | date: \'dd-MM-yyyy HH:mm\'}}</span></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/dashboard/ganalytics.html','<div class="row" ng-show="!isLoading"><div class="col-lg-2" ba-panel=""><div class="chart-total-panel"><h3>Usuarios</h3>{{totalStatistics.users}}</div></div><div class="col-lg-2" ba-panel=""><div class="chart-total-panel"><h3>Duraci\xF3n Media Sesi\xF3n</h3>{{totalStatistics.avgSessionDuration | secondsToTime}}</div></div><div class="col-lg-2" ba-panel=""><div class="chart-total-panel"><h3>Porcentaje de Rebote</h3>{{totalStatistics.bounceRate}}%</div></div><div class="col-lg-2" ba-panel=""><div class="chart-total-panel"><h3>Nuevos Usuarios</h3>{{totalStatistics.newUsers}}</div></div><div class="col-lg-2" ba-panel=""><div class="chart-total-panel"><h3>Sesiones</h3>{{totalStatistics.sessions}}</div></div><div class="col-lg-2" ba-panel=""><div class="chart-total-panel"><h3>Sesiones por Usuario</h3>{{totalStatistics.sessionsPerUse}}</div></div></div><div class="row" ng-show="!isLoading"><div class="col-md-12" ba-panel="" ba-panel-title="Usuarios"><div class="row"><div class="col-md-8"><dashboard-area-chart data="areaChartData"></dashboard-area-chart></div><div class="col-md-4"><input date-range-picker="" class="form-control date-picker" type="text" ng-model="datePicker.date" options="options"><div class="main-channel-bar-container"><div class="title">Canales Principales</div><div class="channel-bar-chart" ng-repeat="channel in mainChannel.values"><h3>{{channel.dimension}} <span class="label">{{generateChannelTag(channel)}}</span></h3><progress value="{{channel.value}}" max="{{mainChannel.total}}">as</progress></div></div></div></div></div></div><div class="row" ng-if="!isLoading"><div class="col-md-4" ba-panel="" ba-panel-title="Visitas nuevas/recurrentes"><div><dashboard-pie-chart id="\'visitor-chart\'" data="visitorChartData" height="\'220px\'"></dashboard-pie-chart></div></div><div class="col-md-8" ba-panel="" ba-panel-title="Informaci\xF3n Geogr\xE1fica"><div class="row"><div class="col-md-5 horizontal-scroll"><table class="table table-striped"><thead><tr><th>Pa\xEDs</th><th>Usuarios</th></tr></thead><tbody><tr ng-repeat="item in countryUsers.values | limitTo:5"><td>{{item.name}}</td><td>{{item.users}}</td></tr></tbody></table></div><div class="col-md-7"><dashboard-map data="mapData"></dashboard-map></div></div></div></div><div class="row" ng-if="!isLoading"><div class="col-md-6" ba-panel="" ba-panel-title="Dispositivos"><div><dashboard-pie-chart id="\'device-usage-chart\'" data="deviceChartData" height="\'220px\'"></dashboard-pie-chart></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Medios Sociales"><div><dashboard-pie-chart id="\'social-media-chart\'" data="socialMediaChartData" height="\'220px\'"></dashboard-pie-chart></div></div></div><div class="row" ng-if="!isLoading"><div class="col-md-12" ba-panel="" ba-panel-title="P\xE1ginas de destino"><div class="horizontal-scroll"><table class="table table-striped"><thead><tr><th></th><th>P\xE1gina</th><th>Sesiones</th></tr></thead><tbody><tr ng-repeat="item in destinationPage.values | limitTo:10"><td>{{$index+1}}</td><td>{{item.url}}</td><td>{{item.sessions}} ({{calculatePercent(item.sessions, destinationPage.totalSessions)}}%)</td></tr></tbody></table></div><div class="col-md-12 p-15"><a ui-sref="main.reports.destination_page({startDate: datePicker.date.startDate.format(\'YYYY-MM-DD\'), endDate: datePicker.date.endDate.format(\'YYYY-MM-DD\')})" class="btn btn-xs btn-default"><i class="fa fa-table"></i> Ver Informe Completo</a></div></div><div class="col-md-12" ba-panel="" ba-panel-title="P\xE1ginas de salida"><div class="horizontal-scroll"><table class="table table-striped"><thead><tr><th></th><th>P\xE1gina</th><th>Salidas</th></tr></thead><tbody><tr ng-repeat="item in exitPage.values | limitTo:10"><td>{{$index+1}}</td><td>{{item.url}}</td><td>{{item.exits}} ({{calculatePercent(item.exits, exitPage.totalExits)}}%)</td></tr></tbody></table></div><div class="col-md-12 p-15"><a ui-sref="main.reports.exit_page({startDate: datePicker.date.startDate.format(\'YYYY-MM-DD\'), endDate: datePicker.date.endDate.format(\'YYYY-MM-DD\')})" class="btn btn-xs btn-default"><i class="fa fa-table"></i> Ver Informe Completo</a></div></div></div>');
$templateCache.put('app/pages/files/files.html','<div class="widgets files-explorer" ng-init="loadContainers()"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Contenedores" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="col-md-1 text-center" ng-repeat="container in containers" ng-click="loadFiles(container)"><button type="button" class="container-btn" ng-class="{\'selected\': (selectedContainer == container)}"><span class="container-icon fa fa-folder fa-2x"></span> <span>{{container.name}}</span></button></div></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ficheros" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th></th><th st-sort="originalFilename">Nombre del archivo</th><th st-sort="size">Tama\xF1o</th><th></th></tr></thead><tbody ng-show="!isLoadingFiles"><tr ng-repeat="row in results"><td><div class="image-wrapper"><img ng-src="{{row.name|imageUrl:row.container}}" alt="row.originalFilename" ng-if="row.type!=\'application/pdf\'"> <span class="fa fa-file-pdf-o fa-5x" ng-if="row.type==\'application/pdf\'"></span></div></td><td><span style="word-break: break-all;">{{row.originalFilename}}</span></td><td>{{row.size/1024/1024 | number: 2}} MB</td><td width="140"><button class="btn btn-xs" ngclipboard="" ngclipboard-success="onSuccess(e);" ngclipboard-error="onError(e);" data-clipboard-text="{{apiUrlBase + row.url}}"><i class="fa fa-clipboard"></i> Copiar url</button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoadingFiles"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/images/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la Imagen" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="image.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="title">T\xEDtulo</label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="title" id="title" class="form-control col-xs-12 col-md-7" ng-model="image.title"></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="url">Url</label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="url" id="url" class="form-control col-xs-12 col-md-7" ng-model="image.url" validate-on="blur"></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="status">Estado</label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="status" id="status" ng-model="image.status" ng-options="status.key as status.name for status in statusList" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" value="">{{\'Estado\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Imagen Web <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><recommended-sizes width="recommendedSizes.desktop.width" height="recommendedSizes.desktop.height" unit="px"></recommended-sizes><div class="userpic banner-web-pic"><div class="userpic-wrapper" ng-click="showFileDialog(\'web\')"><span ng-if="!image.imageWeb" class="fa fa-plus fa-2x"></span> <img ng-if="image.imageWeb" ng-src="{{ image.imageWeb.url | imageUrl }}"></div><i class="ion-ios-close-outline" ng-click="removeFile(\'web\')" ng-if="image.imageWeb"></i></div></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Imagen M\xF3vil <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><recommended-sizes width="recommendedSizes.mobile.width" height="recommendedSizes.mobile.height" unit="px"></recommended-sizes><div class="userpic"><div class="userpic-wrapper" ng-click="showFileDialog(\'mobile\')"><span ng-if="!image.imageMobile" class="fa fa-plus fa-2x"></span> <img ng-if="image.imageMobile" ng-src="{{ image.imageMobile.url | imageUrl }}"></div><i class="ion-ios-close-outline" ng-click="removeFile(\'mobile\')" ng-if="image.imageMobile"></i></div></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.images.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/images/edit.html','<div class="widgets" ng-init="loadImage()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la Imagen" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="update(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="image.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="title">T\xEDtulo</label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="title" id="title" class="form-control col-xs-12 col-md-7" ng-model="image.title"></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="url">Url</label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="url" id="url" class="form-control col-xs-12 col-md-7" ng-model="image.url" validate-on="blur"></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="status">Estado</label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="status" id="status" ng-model="image.status" ng-options="status.key as status.name for status in statusList" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" value="">{{\'Estado\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Imagen Web <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><recommended-sizes width="recommendedSizes.desktop.width" height="recommendedSizes.desktop.height" unit="px"></recommended-sizes><div class="userpic banner-web-pic"><div class="userpic-wrapper" ng-click="showFileDialog(\'web\')"><span ng-if="!image.imageWeb" class="fa fa-plus fa-2x"></span> <img ng-if="image.imageWeb" ng-src="{{ image.imageWeb.url | imageUrl }}"></div><i class="ion-ios-close-outline" ng-click="removeFile(\'web\')" ng-if="image.imageWeb"></i></div></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Imagen M\xF3vil <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><recommended-sizes width="recommendedSizes.mobile.width" height="recommendedSizes.mobile.height" unit="px"></recommended-sizes><div class="userpic"><div class="userpic-wrapper" ng-click="showFileDialog(\'mobile\')"><span ng-if="!image.imageMobile" class="fa fa-plus fa-2x"></span> <img ng-if="image.imageMobile" ng-src="{{ image.imageMobile.url | imageUrl }}"></div><i class="ion-ios-close-outline" ng-click="removeFile(\'mobile\')" ng-if="image.imageMobile"></i></div></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.images.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/images/filesModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Im\xE1genes de slides</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="alert alert-info">El tama\xF1o m\xE1ximo permitido para cada archivo es 10 MB.</div><div ngf-drop="uploadFile($file, $invalidFiles, imageType)" ngf-select="uploadFile($file, $invalidFiles, imageType)" ng-model="picFile" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="false" accept="image/*" ngf-pattern="\'image/*\'" name="picFile" ngf-max-size="10MB" ngf-model-invalid="errorFile">Arrastre el logo aqu\xED o haga click para subir uno.</div><div><span class="control-label has-error validationMessage">{{f.name}} {{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}}</span> <span class="progress pull-right" ng-show="f.progress >= 0"><div style="width:{{f.progress}}%" ng-bind="f.progress + \'%\'"></div></span></div><span class="control-label has-error validationMessage">{{errorMsg}}</span></div></div><br><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callLogoFilesServer" st-table="results"><thead><tr class="sortable"><th></th><th st-sort="originalFilename">Nombre del archivo</th><th st-sort="size">Tama\xF1o</th><th></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td><div class="image-wrapper"><img ng-src="{{row.name|imageUrl:row.container}}" alt="row.originalFilename"></div></td><td><span style="word-break: break-all;">{{row.originalFilename}}</span></td><td>{{row.size/1024/1024 | number: 2}} MB</td><td><button ng-click="setSlideImage(row, imageType)" class="btn btn-primary btn-xs"><i class="fa fa-check"></i> Seleccionar</button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/images/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><td width="120"></td><th st-sort="name">Nombre Referencia</th><th st-sort="title">T\xEDtulo</th><th st-sort="status">Estado</th><th>Acciones</th></tr><tr><th></th><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th><input st-search="title" class="input-sm form-control search-input"></th><th><select st-search="status" class="form-control" name="status" id="status"><option selected="" value=""></option><option value="{{status.key}}" ng-repeat="status in statusList">{{status.name}}</option></select></th><th><a ui-sref="main.images.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td><div class="image-wrapper" ng-if="row.imageMobile"><img ng-src="{{row.imageMobile.url | imageUrl}}"></div></td><td>{{row.name}}</td><td>{{row.title}}</td><td><select class="m-t-1" name="status" ng-change="changeStatus(row.id, row.status)" ng-model="row.status"><option value="{{status.key}}" ng-repeat="status in statusList">{{status.name}}</option></select></td><td><a ui-sref="main.images.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="6" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="6"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/main/main.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div><footer class="al-footer clearfix"><div class="al-footer-main clearfix"><div class="al-copy">Directorio de Proyectos <span current-date="yyyy"></span></div><ul class="al-share clearfix"></ul></div></footer><back-top></back-top></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/notification/user_list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="publicName">Usuario administrador</th><th width="60%">Empresas de las que recibir\xE1 notificaciones</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td></td><td class="p-t-b-20">{{row.firstName}} {{row.lastName}} ({{row.email}})</td><td class="p-t-b-20"><div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" name="receiveNotificationFromAll" ng-change="setReceiveNotificationFromAll(row)" ng-model="row.receiveNotificationFromAll"> <span>Recibir notificaciones de todas las empresas</span></label></div><tags-input ng-if="!row.receiveNotificationFromAll" placeholder="Seleccionar empresa" ng-model="row.notificationCompanies" on-tag-added="tagAdded(row.id, $tag)" on-tag-removed="tagRemoved(row.id, $tag)" template="app/pages/notification/tpl/tags-input.tpl.html" replace-spaces-with-dashes="false" use-strings="false" add-from-autocomplete-only="true" display-property="publicName" key-property="id"><auto-complete source="loadCompanies($query)" min-length="0" load-on-focus="true" load-on-empty="true" max-results-to-show="50" template="app/pages/notification/tpl/auto-complete.tpl.html"></auto-complete></tags-input></td></tr><tr ng-show="results.length == 0"><td colspan="3" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="3"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/project/changesModal.html','<div class="modal-content project-changes-container"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Campos modificados</h4></div><div class="modal-body"><div ng-if="!changes || !changes.length">No existen diferencias respecto a la versi\xF3n publicada</div><div ng-if="changes && changes.length"><div class="row header"><div class="col-md-2">Atributo</div><div class="col-md-5">Versi\xF3n Publicada</div><div class="col-md-5">Actualizaci\xF3n</div></div><div class="row" ng-repeat="change in changes"><div class="col-md-12 p-b-10" ng-if="change.key === \'name\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5">{{change.oldValue}}</div><div class="col-md-5">{{change.newValue}}</div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'nameToPublish\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5">{{change.oldValue}}</div><div class="col-md-5">{{change.newValue}}</div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'idAvatar\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5">{{change.oldValue}}</div><div class="col-md-5">{{change.newValue}}</div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'objective\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5">{{change.oldValue}}</div><div class="col-md-5">{{change.newValue}}</div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'womanEmpowerment\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5">{{change.oldValue ? \'Si\' : \'No\'}}</div><div class="col-md-5">{{change.newValue ? \'Si\' : \'No\'}}</div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'summary\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5" ng-bind-html="change.oldValue"></div><div class="col-md-5" ng-bind-html="change.newValue"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'startDate\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5">{{change.oldValue}}</div><div class="col-md-5">{{change.newValue}}</div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'endDate\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5">{{change.oldValue}}</div><div class="col-md-5">{{change.newValue}}</div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'duration\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5">{{change.oldValue}}</div><div class="col-md-5">{{change.newValue}}</div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'actions\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5" ng-bind-html="change.oldValue"></div><div class="col-md-5" ng-bind-html="change.newValue"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'goals\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5" ng-bind-html="change.oldValue"></div><div class="col-md-5" ng-bind-html="change.newValue"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'monitoring\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5" ng-bind-html="change.oldValue"></div><div class="col-md-5" ng-bind-html="change.newValue"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'results\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5" ng-bind-html="change.oldValue"></div><div class="col-md-5" ng-bind-html="change.newValue"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'impact\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5" ng-bind-html="change.oldValue"></div><div class="col-md-5" ng-bind-html="change.newValue"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'history\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5" ng-bind-html="change.oldValue"></div><div class="col-md-5" ng-bind-html="change.newValue"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'satisfactionIndicator\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5" ng-bind-html="change.oldValue"></div><div class="col-md-5" ng-bind-html="change.newValue"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'videos\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5"><a ng-href="{{item}}" ng-repeat="item in change.oldValue track by $index">{{item}}</a></div><div class="col-md-5"><a ng-href="{{item}}" ng-repeat="item in change.newValue track by $index">{{item}}</a></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'awards\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5"><div ng-repeat="item in change.oldValue track by $index" class="p-b-10">{{item}}</div></div><div class="col-md-5"><div ng-repeat="item in change.newValue track by $index" class="p-b-10">{{item}}</div></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'links\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5"><a ng-href="{{item.url}}" ng-repeat="item in change.oldValue track by $index">{{item.title}}</a></div><div class="col-md-5"><a ng-href="{{item.url}}" ng-repeat="item in change.newValue track by $index">{{item.title}}</a></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'referred\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5" ng-bind-html="change.oldValue"></div><div class="col-md-5" ng-bind-html="change.newValue"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'companyName\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5" ng-bind-html="change.oldValue"></div><div class="col-md-5" ng-bind-html="change.newValue"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'companyCharge\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5" ng-bind-html="change.oldValue"></div><div class="col-md-5" ng-bind-html="change.newValue"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'companyEmail\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5" ng-bind-html="change.oldValue"></div><div class="col-md-5" ng-bind-html="change.newValue"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'companyPhone\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5" ng-bind-html="change.oldValue"></div><div class="col-md-5" ng-bind-html="change.newValue"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'images\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5"><img class="img-thumbs" ng-src="{{item.url | imageUrl}}" ng-repeat="item in change.oldValue track by $index"></div><div class="col-md-5"><img class="img-thumbs" ng-src="{{item.url | imageUrl}}" ng-repeat="item in change.newValue track by $index"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'activities\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5"><div ng-repeat="item in change.oldValue" class="p-t-5">- {{item.activity.name}}{{item.alliance.custom && item.value ? \': \' + item.value : \'\'}}</div></div><div class="col-md-5"><div ng-repeat="item in change.newValue" class="p-t-5">- {{item.activity.name}}{{item.alliance.custom && item.value ? \': \' + item.value : \'\'}}</div></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'alliances\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5"><div ng-repeat="item in change.oldValue" class="p-t-5">- {{item.alliance.name}}{{item.alliance.custom && item.value ? \': \' + item.value : \'\'}}</div></div><div class="col-md-5"><div ng-repeat="item in change.newValue" class="p-t-5">- {{item.alliance.name}}{{item.alliance.custom && item.value ? \': \' + item.value : \'\'}}</div></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'informationBases\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5"><div ng-repeat="item in change.oldValue" class="p-t-5">- {{item.informationBase.name}}{{item.informationBase.custom && item.value ? \': \' + item.value : \'\'}}</div></div><div class="col-md-5"><div ng-repeat="item in change.newValue" class="p-t-5">- {{item.informationBase.name}}{{item.informationBase.custom && item.value ? \': \' + item.value : \'\'}}</div></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'categories\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5"><div ng-repeat="item in change.oldValue" class="p-t-5">- {{item.category.name}}{{item.category.custom && item.value ? \': \' + item.value : \'\'}}</div></div><div class="col-md-5"><div ng-repeat="item in change.newValue" class="p-t-5">- {{item.category.name}}{{item.category.custom && item.value ? \': \' + item.value : \'\'}}</div></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'financing\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5"><div ng-repeat="item in change.oldValue" class="p-t-5">- {{item.financing.name}}{{item.financing.custom && item.value ? \': \' + item.value : \'\'}}</div></div><div class="col-md-5"><div ng-repeat="item in change.newValue" class="p-t-5">- {{item.financing.name}}{{item.financing.custom && item.value ? \': \' + item.value : \'\'}}</div></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'beneficiaries\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5"><div ng-repeat="item in change.oldValue" class="p-t-5">- {{item.beneficiary.name}}{{item.beneficiary.custom && item.value ? \': \' + item.value : \'\'}}</div></div><div class="col-md-5"><div ng-repeat="item in change.newValue" class="p-t-5">- {{item.beneficiary.name}}{{item.beneficiary.custom && item.value ? \': \' + item.value : \'\'}}</div></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'diffusions\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5"><div ng-repeat="item in change.oldValue" class="p-t-5">- {{item.diffusion.name}}{{item.diffusion.custom && item.value ? \': \' + item.value : \'\'}}</div></div><div class="col-md-5"><div ng-repeat="item in change.newValue" class="p-t-5">- {{item.diffusion.name}}{{item.diffusion.custom && item.value ? \': \' + item.value : \'\'}}</div></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'objectives\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5"><img class="img-thumbs" ng-src="{{item.image.url | imageUrl}}" ng-repeat="item in change.oldValue track by $index"></div><div class="col-md-5"><img class="img-thumbs" ng-src="{{item.image.url | imageUrl}}" ng-repeat="item in change.newValue track by $index"></div></div><div class="col-md-12 p-b-10" ng-if="change.key === \'locations\'"><div class="col-md-2">{{change.name}}</div><div class="col-md-5"><div ng-repeat="item in change.oldValue" class="p-t-5"><div class="p-t-5">Regi\xF3n: {{item.region.name}}</div><div class="p-t-5">Provincia: {{item.province.name}}</div><div class="p-t-5">Distrito: {{item.district.name}}</div></div></div><div class="col-md-5"><div ng-repeat="item in change.newValue" class="p-t-5"><div class="p-t-5">Regi\xF3n: {{item.region.name}}</div><div class="p-t-5">Provincia: {{item.province.name}}</div><div class="p-t-5">Distrito: {{item.district.name}}</div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/project/configuration.html','<div class="widgets" ng-init="loadConfiguration()"><div class="row"><div class="col-md-8" ba-panel="" ba-panel-title="Configuraci\xF3n de los campos en la gesti\xF3n de proyectos"><form class="form-horizontal" name="socialForm" id="socialForm" angular-validator-submit="updateProjectSettings(socialForm.$valid)" angular-validator="" novalidate=""><div class="form-group" ng-repeat="key in getObjectKeys(configurationProject)"><label class="control-label col-md-4 col-sm-4 col-xs-12" for="visibility_{{key}}">{{configurationProject[key].name}}</label><div class="col-md-4 col-sm-4 col-xs-6"><select class="form-control" name="visibility_{{key}}" id="visibility_{{key}}" ng-disabled="!configurationProject[key].configurable" ng-model="configurationProject[key].visibility" ng-options="field.id as (field.name) for field in fieldVisibilities"><option selected="" disabled="" value="">{{\'Visibilidad\'|uppercase}}</option></select></div><div class="col-md-4 col-sm-4 col-xs-6"><select class="form-control" name="status_{{key}}" id="status_{{key}}" ng-disabled="!configurationProject[key].configurable" ng-model="configurationProject[key].validation" ng-options="field.id as (field.name) for field in fieldValidation"><option selected="" disabled="" value="">{{\'Validaci\xF3n\'|uppercase}}</option></select></div></div><div class="col-md-12 col-sm-12 col-xs-12 text-right"><button type="submit" class="btn btn-primary"><i class="fa fa-save"></i> Guardar</button></div></form></div><div class="col-md-4" ba-panel="" ba-panel-title="Visibilidad"><div class="alert alert-info" ng-repeat="visibility in fieldVisibilities">{{visibility.name}}<div>{{visibility.desc}}</div></div></div></div></div>');
$templateCache.put('app/pages/project/createOrUpdate.html','<div class="widgets" id="project-form"><div class="row"><div class="col-md-12 project-management" ba-panel="" ba-panel-title="Datos del Proyecto" ba-panel-class=""><div class="text-right p-r-15"><button type="button" class="btn btn-sm btn-primary" ng-click="export()"><i class="fa fa-download"></i> Exportar Captura</button></div><form name="createForm" class="" ng-submit="createOrUpdate(true || createForm.$valid)" novalidate=""><div class="col-md-10 col-md-offset-1">Complete todos los campos del formulario. Los campos sombreados no ser\xE1n publicados.</div><div class="col-md-10 col-md-offset-1"><div class="p-t-10"><selector-company visibility="$projectFieldUtils.getVisibility(\'idCompany\')" is-required="$projectFieldUtils.isRequired(\'idCompany\')" errors="errorDetails[\'idCompany\']" ng-model="project.idCompany" class="col-md-12 no-padding"></selector-company><selector-project-status visibility="$projectFieldUtils.getVisibility(\'status\')" is-required="$projectFieldUtils.isRequired(\'status\')" errors="errorDetails[\'status\']" ng-model="project.status" class="col-md-12 no-padding"></selector-project-status></div><div class="clearfix"><div class="col-md-6 no-padding" ng-if="$projectFieldUtils.isVisible(\'name\')"><div class="form-group"><div class="col-md-12"><input type="text" name="name" id="name" placeholder="Nombre del proyecto {{$projectFieldUtils.isRequired(\'name\') ? \'(*)\' : \'\'}}" class="form-control" ng-model="project.name"></div><div class="col-md-12 p-b-10" ng-if="errorDetails[\'name\'] && errorDetails[\'name\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'name\']">{{error}}</div></div></div></div><div class="col-md-6 no-padding" ng-if="$projectFieldUtils.isVisible(\'nameToPublish\')"><div class="form-group"><div class="col-md-12"><input type="text" name="nameToPublish" id="nameToPublish" placeholder="Nombre con el que se publicar\xE1 {{$projectFieldUtils.isRequired(\'nameToPublish\') ? \'(*)\' : \'\'}}" class="form-control" maxlength="70" ng-model="project.nameToPublish"><char-counter ng-model="project.nameToPublish" limit="70"></char-counter></div><div class="col-md-12 p-b-10" ng-if="errorDetails[\'nameToPublish\'] && errorDetails[\'nameToPublish\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'nameToPublish\']">{{error}}</div></div></div></div></div><selector-location visibility="$projectFieldUtils.getVisibility(\'locations\')" is-required="$projectFieldUtils.isRequired(\'locations\')" errors="errorDetails[\'locations\']" ng-model="selectedLocations" class="col-md-12 no-padding"></selector-location><selector-activity columns="2" visibility="$projectFieldUtils.getVisibility(\'activities\')" is-required="$projectFieldUtils.isRequired(\'activities\')" errors="errorDetails[\'activities\']" ng-model="selectedActivities" class="col-md-12 no-padding"></selector-activity><input-objective ng-model="project.objective" visibility="$projectFieldUtils.getVisibility(\'objective\')" is-required="$projectFieldUtils.isRequired(\'objective\')" errors="errorDetails[\'objective\']" class="col-md-12 no-padding" limit="charLimits.objective"></input-objective><selector-information-base columns="2" visibility="$projectFieldUtils.getVisibility(\'informationBases\')" is-required="$projectFieldUtils.isRequired(\'informationBases\')" errors="errorDetails[\'informationBases\']" ng-model="selectedInformationBases" class="col-md-12 no-padding"></selector-information-base><selector-category columns="3" visibility="$projectFieldUtils.getVisibility(\'categories\')" is-required="$projectFieldUtils.isRequired(\'categories\')" errors="errorDetails[\'categories\']" ng-model="selectedCategories" class="col-md-12 no-padding"></selector-category><selector-woman-empowerment ng-model="project.womanEmpowerment" visibility="$projectFieldUtils.getVisibility(\'womanEmpowerment\')" is-required="$projectFieldUtils.isRequired(\'womanEmpowerment\')" errors="errorDetails[\'womanEmpowerment\']" class="col-md-12 no-padding"></selector-woman-empowerment><selector-ods columns="6" view-mode="horizontal" visibility="$projectFieldUtils.getVisibility(\'objectives\')" is-required="$projectFieldUtils.isRequired(\'objectives\')" errors="errorDetails[\'objectives\']" ng-model="project.objectives" class="col-md-12 no-padding"></selector-ods><input-summary ng-model="project.summary" visibility="$projectFieldUtils.getVisibility(\'summary\')" is-required="$projectFieldUtils.isRequired(\'summary\')" errors="errorDetails[\'summary\']" class="col-md-12 no-padding" limit="charLimits.summary"></input-summary><div class="form-group clearfix" ng-if="$projectFieldUtils.isVisibleSomeItem([\'startDate\', \'endDate\', \'duration\'])"><label class="control-label col-md-12"><strong class="text-uppercase">Fechas de Relevancia</strong></label><div class="col-md-12" ng-if="$projectFieldUtils.isVisible(\'startDate\')"><div class="col-md-8 no-padding"><div class="col-md-11 no-padding"><input type="text" name="startDate" id="startDate" placeholder="Inicio (d\xEDa/mes/a\xF1o) {{$projectFieldUtils.isRequired(\'startDate\') ? \'(*)\' : \'\'}}" class="form-control date-picker" date-range-picker="" readonly="readonly" ng-model="startDatePicker.date" options="options"></div><div class="col-md-1 p-5"><button type="button" class="btn btn-xs" ng-click="clearStartDate()"><span class="fa fa-times"></span></button></div><div class="col-md-12 no-padding p-b-10" ng-if="errorDetails[\'startDate\'] && errorDetails[\'startDate\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'startDate\']">{{error}}</div></div></div></div><div class="col-md-12" ng-if="$projectFieldUtils.isVisible(\'endDate\')"><div class="col-md-8 no-padding p-t-10 p-b-5"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" name="woman-empowerment" ng-model="project.endDateExecution" ng-change="toggleEndDateExecution(project.endDateExecution)"> <span>Proyecto en Ejecuci\xF3n</span></label></div><div class="col-md-8 no-padding"><div class="col-md-11 no-padding"><input type="text" name="endDate" id="endDate" ng-disabled="project.endDateExecution" placeholder="{{project.endDateExecution ? \'En ejecuci\xF3n\' : \'Fin (d\xEDa/mes/a\xF1o)\'}} {{$projectFieldUtils.isRequired(\'endDate\') ? \'(*)\' : \'\'}}" class="form-control date-picker" date-range-picker="" readonly="readonly" ng-model="endDatePicker.date" options="options"></div><div class="col-md-1 p-5"><button type="button" class="btn btn-xs" ng-click="clearEndDate()" ng-disabled="project.endDateExecution"><span class="fa fa-times"></span></button></div><div class="col-md-12 no-padding p-b-10" ng-if="errorDetails[\'endDate\'] && errorDetails[\'endDate\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'endDate\']">{{error}}</div></div></div></div><div class="col-md-12"><div class="col-md-8 no-padding p-t-10" ng-if="$projectFieldUtils.isVisible(\'duration\')"><div class="col-md-11 no-padding"><input type="text" name="duration" id="duration" placeholder="Periodo de duraci\xF3n {{$projectFieldUtils.isRequired(\'duration\') ? \'(*)\' : \'\'}}" class="form-control" ng-model="project.duration"></div><div class="col-md-12 no-padding p-b-10" ng-if="errorDetails[\'duration\'] && errorDetails[\'duration\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'duration\']">{{error}}</div></div></div></div></div><input-action ng-model="project.actions" visibility="$projectFieldUtils.getVisibility(\'actions\')" is-required="$projectFieldUtils.isRequired(\'actions\')" errors="errorDetails[\'actions\']" class="col-md-12 no-padding" limit="charLimits.action"></input-action><input-goals ng-model="project.goals" visibility="$projectFieldUtils.getVisibility(\'goals\')" is-required="$projectFieldUtils.isRequired(\'goals\')" errors="errorDetails[\'goals\']" class="col-md-12 no-padding" limit="charLimits.goals"></input-goals><input-monitoring ng-model="project.monitoring" visibility="$projectFieldUtils.getVisibility(\'monitoring\')" is-required="$projectFieldUtils.isRequired(\'monitoring\')" errors="errorDetails[\'monitoring\']" class="col-md-12 no-padding" limit="charLimits.monitoring"></input-monitoring><input-results ng-model="project.results" visibility="$projectFieldUtils.getVisibility(\'results\')" is-required="$projectFieldUtils.isRequired(\'results\')" errors="errorDetails[\'results\']" class="col-md-12 no-padding" limit="charLimits.results"></input-results><input-impact ng-model="project.impact" visibility="$projectFieldUtils.getVisibility(\'impact\')" is-required="$projectFieldUtils.isRequired(\'impact\')" errors="errorDetails[\'impact\']" class="col-md-12 no-padding" limit="charLimits.impact"></input-impact><selector-alliance columns="1" visibility="$projectFieldUtils.getVisibility(\'alliances\')" is-required="$projectFieldUtils.isRequired(\'alliances\')" errors="errorDetails[\'alliances\']" ng-model="selectedAlliances" class="col-md-12 no-padding"></selector-alliance><selector-financing columns="2" visibility="$projectFieldUtils.getVisibility(\'financing\')" is-required="$projectFieldUtils.isRequired(\'financing\')" errors="errorDetails[\'financing\']" ng-model="selectedFinancings" class="col-md-12 no-padding"></selector-financing><input-history ng-model="project.history" visibility="$projectFieldUtils.getVisibility(\'history\')" is-required="$projectFieldUtils.isRequired(\'history\')" errors="errorDetails[\'history\']" class="col-md-12 no-padding" limit="charLimits.history"></input-history><selector-beneficiary columns="2" visibility="$projectFieldUtils.getVisibility(\'beneficiaries\')" is-required="$projectFieldUtils.isRequired(\'beneficiaries\')" errors="errorDetails[\'beneficiaries\']" ng-model="selectedBeneficiaries" class="col-md-12 no-padding"></selector-beneficiary><selector-diffusion columns="1" visibility="$projectFieldUtils.getVisibility(\'diffusions\')" is-required="$projectFieldUtils.isRequired(\'diffusions\')" errors="errorDetails[\'diffusions\']" ng-model="selectedDiffusions" class="col-md-12 no-padding"></selector-diffusion><input-satisfaction-indicator ng-model="project.satisfactionIndicator" visibility="$projectFieldUtils.getVisibility(\'satisfactionIndicator\')" is-required="$projectFieldUtils.isRequired(\'satisfactionIndicator\')" errors="errorDetails[\'satisfactionIndicator\']" class="col-md-12 no-padding"></input-satisfaction-indicator><selector-image-upload container="\'Projects\'" files="project.images" visibility="$projectFieldUtils.getVisibility(\'images\')" visibility-avatar="$projectFieldUtils.getVisibility(\'idAvatar\')" is-required="$projectFieldUtils.isRequired(\'images\')" is-required-avatar="$projectFieldUtils.isRequired(\'idAvatar\')" id-avatar="project.idAvatar" errors="errorDetails[\'images\']" errors-avatar="errorDetails[\'idAvatar\']" class="col-md-12 no-padding"></selector-image-upload><selector-video ng-model="project.videos" visibility="$projectFieldUtils.getVisibility(\'videos\')" is-required="$projectFieldUtils.isRequired(\'videos\')" errors="errorDetails[\'videos\']" class="col-md-12 no-padding"></selector-video><selector-link ng-model="project.links" visibility="$projectFieldUtils.getVisibility(\'links\')" is-required="$projectFieldUtils.isRequired(\'links\')" errors="errorDetails[\'links\']" class="col-md-12 no-padding"></selector-link><selector-award ng-model="project.awards" visibility="$projectFieldUtils.getVisibility(\'awards\')" is-required="$projectFieldUtils.isRequired(\'awards\')" errors="errorDetails[\'awards\']" class="col-md-12 no-padding" limit="charLimits.award"></selector-award><input-referred ng-model="project.referred" visibility="$projectFieldUtils.getVisibility(\'referred\')" is-required="$projectFieldUtils.isRequired(\'referred\')" errors="errorDetails[\'referred\']" class="col-md-12 no-padding" limit="charLimits.referred"></input-referred><div class="form-group" ng-if="$projectFieldUtils.isVisibleSomeItem([\'companyName\', \'companyCharge\', \'companyEmail\', \'companyPhone\'])"><label class="control-label col-md-12" for="company_name"><strong class="text-uppercase">Respecto de la empresa</strong><div>Contacto para obtener mayor informaci\xF3n sobre el proyecto</div></label><div class="col-md-6" ng-if="$projectFieldUtils.isVisible(\'companyName\')"><input type="text" name="company_name" id="company_name" placeholder="Nombre {{$projectFieldUtils.isRequired(\'companyName\') ? \'(*)\' : \'\'}}" class="form-control" ng-class="{\'private-item\': $projectFieldUtils.isPrivate(\'companyName\')}" ng-model="project.companyName"><div class="p-b-10" ng-if="errorDetails[\'companyName\'] && errorDetails[\'companyName\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'companyName\']">{{error}}</div></div></div><div class="col-md-6" ng-if="$projectFieldUtils.isVisible(\'companyCharge\')"><input type="text" name="company_charge" id="company_charge" placeholder="Cargo {{$projectFieldUtils.isRequired(\'companyCharge\') ? \'(*)\' : \'\'}}" class="form-control" ng-class="{\'private-item\': $projectFieldUtils.isPrivate(\'companyCharge\')}" ng-model="project.companyCharge"><div class="p-b-10" ng-if="errorDetails[\'companyCharge\'] && errorDetails[\'companyCharge\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'companyCharge\']">{{error}}</div></div></div><div class="col-md-6" ng-if="$projectFieldUtils.isVisible(\'companyEmail\')"><input type="text" name="company_email" id="company_email" placeholder="E-MAIL {{$projectFieldUtils.isRequired(\'companyEmail\') ? \'(*)\' : \'\'}}" class="form-control" ng-class="{\'private-item\': $projectFieldUtils.isPrivate(\'companyEmail\')}" ng-model="project.companyEmail"><div class="p-b-10" ng-if="errorDetails[\'companyEmail\'] && errorDetails[\'companyEmail\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'companyEmail\']">{{error}}</div></div></div><div class="col-md-6" ng-if="$projectFieldUtils.isVisible(\'companyPhone\')"><input type="text" name="company_phone" id="company_phone" placeholder="T\xE9lefono {{$projectFieldUtils.isRequired(\'companyPhone\') ? \'(*)\' : \'\'}}" class="form-control" ng-class="{\'private-item\': $projectFieldUtils.isPrivate(\'companyPhone\')}" ng-model="project.companyPhone"><div class="p-b-10" ng-if="errorDetails[\'companyPhone\'] && errorDetails[\'companyPhone\'].length"><div class="error-message" ng-repeat="error in errorDetails[\'companyPhone\']">{{error}}</div></div></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button class="btn" type="button" ui-sref="main.project.list">Ir al listado</button> <button type="submit" class="btn btn-primary">Guardar</button></div></div></div></form></div></div></div>');
$templateCache.put('app/pages/project/export.html','<div class="widgets" ng-init="loadFilterResources()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Exportar Proyectos"><div class="clearfix"><advanced-filters regions="regions" provinces="provinces" districts="districts" sectors="sectors" categories="categories" companies="companies" objectives="objectives" status="status" show-name-filter="true" apply="exportProjects(newPageNumber, newPageFilters)" show-reset="true" reset-icon="fa fa-ban" apply-icon="fa fa-download" reset-text="Limpiar Filtros" apply-text="Exportar Listado"></advanced-filters></div></div></div></div>');
$templateCache.put('app/pages/project/form.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del Proyecto" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="createOrUpdate(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre</label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="project.name"></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre a Publicar</label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="nameToPublish" id="nameToPublish" class="form-control col-xs-12 col-md-7" ng-model="project.nameToPublish"></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button class="btn btn-primary" type="button" ui-sref="main.project.list">Ir al listado</button> <button type="submit" class="btn btn-success">Crear</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/project/list.html','<div class="widgets" ng-init="init(\'list\')"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Filtros" ba-panel-class="z-1"><div class="clearfix"><advanced-filters regions="regions" provinces="provinces" districts="districts" sectors="sectors" categories="categories" companies="companies" objectives="objectives" status="status" show-name-filter="true" apply="applyFilters(newPageNumber, newPageFilters)" reset="applyFilters(newPageNumber, newPageFilters)" show-reset="true" reset-icon="fa fa-ban" apply-icon="fa fa-filter" reset-text="Limpiar Filtros" apply-text="Aplicar Filtros"></advanced-filters></div></div></div><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover projects-table" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th>Nombre P\xFAblico</th><th>Estado</th><th>Asociado</th><th>Regiones</th><th>Sector</th><th>Orden Pub. <i class="fa fa-info-circle" uib-tooltip="La fecha de publicaci\xF3n se emplea para el orden de los proyectos."></i></th><th>Modificaciones</th><th>Vista</th><th>Acciones</th></tr><tr><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th><a ui-sref="main.project.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.nameToPublish}}</td><td>{{getStatusName(row.status)}}</td><td>{{getAssociatedName(row.company)}}</td><td>{{getRegionNames(row.locations)}}</td><td>{{getSectorName(row.company)}}</td><td><input type="text" name="dp_{{row.id}}" id="dp_{{row.id}}" placeholder="(d\xEDa/mes/a\xF1o)" class="form-control date-picker input-sm text-center" date-range-picker="" readonly="readonly" ng-model="rowsDatePickers[row.id].date" options="optionsDatepickerRow"></td><td><div><button type="button" ng-disabled="!(row.publishedVersion && row.status !== \'published\')" ng-click="showChangesDialog(row.id)" uib-tooltip="Comparar" class="btn btn-xs btn-primary"><i class="fa fa-eye"></i></button> <button type="button" ng-disabled="row.status !== \'pending\'" ng-click="changeStatus(row.id, \'draft\')" uib-tooltip="Rechazar" class="btn btn-xs btn-primary"><i class="fa fa-ban"></i></button> <button type="button" ng-disabled="row.status !== \'pending\'" ng-click="changeStatus(row.id, \'published\')" uib-tooltip="Aprobar" class="btn btn-xs btn-primary"><i class="fa fa-check"></i></button></div></td><td><span ng-if="!row.publishedVersion" class="fa fa-info-circle fz-15 pointer" uib-tooltip="No existe versi\xF3n publicada del proyecto. Al editarlo nuevamente o al aprobar cambios del asociado se crear\xE1 una nueva versi\xF3n."></span> <button type="button" ng-if="row.publishedVersion" ng-click="deletePublishedVersion(row.id)" uib-tooltip="Eliminar versi\xF3n publicada" class="btn btn-xs btn-danger"><i class="fa fa-remove"></i> Despublicar</button></td><td><a ui-sref="main.project.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove(row.id)" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="10" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="10" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="10"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/security/change-password.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Cambiar clave" ba-panel-class="with-scroll"><form name="changePasswordForm" class="form-horizontal" angular-validator-submit="updatePassword(changePasswordForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="oldPassword">Clave actual <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="password" name="oldPassword" id="oldPassword" class="form-control col-md-7 col-xs-12" ng-model="changePassword.oldPassword" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="newPassword">Clave nueva <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="password" name="newPassword" id="newPassword" class="form-control col-md-7 col-xs-12" ng-model="changePassword.newPassword" validate-on="blur" ng-pattern="/^(?=^.{6,72}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[a-zA-Z]).*$/" invalid-message="\'Debe contener letras y n\xFAmeros y no menos de 6 caracteres.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="retypePassword">Confirmaci\xF3n <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="password" name="retypePassword" id="retypePassword" validate-on="blur" class="form-control col-md-7 col-xs-12" ng-model="changePassword.retypePassword" validator="changePassword.newPassword === changePassword.retypePassword" invalid-message="\'Las claves no coinciden.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3"><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Cambiar</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/security/profile.html','<div ba-panel="" ba-panel-title="Datos del Usuario" ba-panel-class="profile-page" ng-init="loadCurrentUser()"><div class="panel-content"><form name="profileForm" class="form" angular-validator-submit="updateProfile(profileForm.$valid)" novalidate="" angular-validator=""><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="firstName" class="col-sm-3 control-label">Nombre</label><div class="col-sm-9"><input type="text" name="firstName" id="firstName" class="form-control" ng-model="user.firstName" validate-on="blur" ng-pattern="/^(?=.{1,40}$)([^0-9]*)$/" invalid-message="\'No debe contener n\xFAmeros y tiene una longitud m\xE1xima de 40 caracteres.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group row clearfix"><label for="lastName" class="col-sm-3 control-label">Apellidos</label><div class="col-sm-9"><input type="text" name="lastName" id="lastName" class="form-control" ng-model="user.lastName" validate-on="blur" ng-pattern="/^([^0-9]*)$/" invalid-message="\'No debe contener n\xFAmeros.\'" required-message="\'El campo es requerido.\'" required=""></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="email" class="col-sm-3 control-label">Email</label><div class="col-sm-9"><input type="email" name="email" id="email" class="form-control" ng-model="user.email" validate-on="blur" validator="validateEmail(user.email)" invalid-message="\'El campo es incorrecto.\'" required-message="\'El campo es requerido.\'" readonly="" required=""></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Actualizar perfil</button></form></div></div>');
$templateCache.put('app/pages/security/request-reset-password.html','<div id="login-page"><div id="login"><a href="https://www.snmpe.org.pe" target="_blank"><div class="logo"></div></a><form name="reqResetPasswordForm" autocomplete="off" angular-validator-submit="requestResetPassword(reqResetPasswordForm.$valid)" novalidate="" angular-validator=""><fieldset class="clearfix"><p><span class="fa fa-envelope"></span> <input type="text" id="email" name="email" autocomplete="off" ng-model="recoveryEmail" placeholder="Correo electr\xF3nico" validate-on="blur" validator="validateEmail(recoveryEmail)" invalid-message="\'El campo es incorrecto.\'" required-message="\'El campo es requerido.\'" required=""></p><p><input type="submit" value="Enviar" name="recovery-btn"></p></fieldset></form><p>Regresar el login <a ui-sref="signin">Iniciar sesi\xF3n</a><span class="fa fa-arrow-right"></span></p><div class="copyright"><p>&copy; Sociedad Nacional de Miner\xEDa, Petr\xF3leo y Energ\xEDa.</p><p>Todos los derechos reservados.</p></div></div><div class="footer-copyright-container"><span class="copyright">Powered by NET360</span></div></div>');
$templateCache.put('app/pages/security/reset-password.html','<div id="login-page"><div id="login"><a href="https://www.snmpe.org.pe" target="_blank"><div class="logo"></div></a><form name="resetPasswordForm" autocomplete="off" angular-validator-submit="resetPassword(resetPasswordForm.$valid)" novalidate="" angular-validator=""><fieldset class="clearfix"><p><span class="fa fa-lock"></span> <input type="password" name="newPassword" id="newPassword" ng-model="newPassword" validate-on="blur" ng-pattern="/^(?=^.{6,72}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[a-zA-Z]).*$/" invalid-message="\'Debe contener letras y n\xFAmeros y no menos de 6 caracteres.\'" required-message="\'El campo es requerido.\'" required=""></p><p><span class="fa fa-lock"></span> <input type="password" name="retypePassword" id="retypePassword" ng-model="retypePassword" validate-on="blur" validator="newPassword === retypePassword" invalid-message="\'Las claves no coinciden.\'" required-message="\'El campo es requerido.\'" required=""></p><p><input type="submit" value="Cambiar" name="send-btn"></p></fieldset></form><p>Regresar el login <a ui-sref="signin">Iniciar sesi\xF3n</a><span class="fa fa-arrow-right"></span></p><div class="copyright"><p>&copy; Sociedad Nacional de Miner\xEDa, Petr\xF3leo y Energ\xEDa.</p><p>Todos los derechos reservados.</p></div></div><div class="footer-copyright-container"><span class="copyright">Powered by NET360</span></div></div>');
$templateCache.put('app/pages/security/signin.html','<div id="login-page"><div id="login"><a href="https://www.snmpe.org.pe" target="_blank"><div class="logo"></div></a><form name="loginForm" autocomplete="off" angular-validator-submit="signin(loginForm.$valid)" novalidate="" angular-validator=""><fieldset class="clearfix"><p><span class="fa fa-user"></span> <input type="text" id="username" name="username" autocomplete="off" ng-model="credentials.email" placeholder="Usuario" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></p><p><span class="fa fa-lock"></span> <input type="password" name="password" id="password" placeholder="Password" ng-model="credentials.password" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></p><p><input type="submit" value="Ingresar" name="login-btn"></p></fieldset></form><p>Olvidaste la contrase\xF1a? <a ui-sref="request_reset_password">Recuperar</a><span class="fa fa-arrow-right"></span></p><div class="copyright"><p>&copy; Sociedad Nacional de Miner\xEDa, Petr\xF3leo y Energ\xEDa.</p><p>Todos los derechos reservados.</p></div></div><div class="footer-copyright-container"><a href="http://www.net360.pe" target="_blank"><span class="copyright">Powered by NET360</span></a></div></div>');
$templateCache.put('app/pages/static/about_us.html','<div class="widgets" ng-init="init(\'about-us\')"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la p\xE1gina" ba-panel-class="with-scroll"><form name="createForm" id="createForm" angular-validator-submit="createOrUpdate(createForm.$valid)" angular-validator="" novalidate=""><div class="col-md-9"><div class="form-group"><label for="title">T\xEDtulo <span class="required">*</span></label> <input type="text" name="title" id="title" class="form-control" ng-model="page.title" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="col-md-2 col-md-offset-1" style="padding-top: 20px;"><button type="submit" class="btn btn-primary btn-block">Actualizar</button></div></form><div class="col-md-12" text-angular="" ta-toolbar="taToolbar" ng-model="page.content"></div></div></div></div>');
$templateCache.put('app/pages/static/contact.html','<div class="widgets" ng-init="init(\'contact\')"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la p\xE1gina" ba-panel-class="with-scroll"><form name="createForm" id="createForm" angular-validator-submit="createOrUpdate(createForm.$valid)" angular-validator="" novalidate=""><div class="col-md-9"><div class="form-group"><label for="title">T\xEDtulo <span class="required">*</span></label> <input type="text" name="title" id="title" class="form-control" ng-model="page.title" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="col-md-2 col-md-offset-1" style="padding-top: 20px;"><button type="submit" class="btn btn-primary btn-block">Actualizar</button></div></form><div class="col-md-12" text-angular="" ta-toolbar="taToolbar" ng-model="page.content"></div></div></div></div>');
$templateCache.put('app/pages/static/ods.html','<div class="widgets" ng-init="init(\'ods\')"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la p\xE1gina" ba-panel-class="with-scroll"><form name="createForm" id="createForm" angular-validator-submit="createOrUpdate(createForm.$valid)" angular-validator="" novalidate=""><div class="col-md-9"><div class="form-group"><label for="title">T\xEDtulo <span class="required">*</span></label> <input type="text" name="title" id="title" class="form-control" ng-model="page.title" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="col-md-2 col-md-offset-1" style="padding-top: 20px;"><button type="submit" class="btn btn-primary btn-block">Actualizar</button></div></form><div class="col-md-12" text-angular="" ta-toolbar="taToolbar" ng-model="page.content"></div></div></div></div>');
$templateCache.put('app/pages/static/terms.html','<div class="widgets" ng-init="init(\'terms\')"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la p\xE1gina" ba-panel-class="with-scroll"><form name="createForm" id="createForm" angular-validator-submit="createOrUpdate(createForm.$valid)" angular-validator="" novalidate=""><div class="col-md-9"><div class="form-group"><label for="title">T\xEDtulo <span class="required">*</span></label> <input type="text" name="title" id="title" class="form-control" ng-model="page.title" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="col-md-2 col-md-offset-1" style="padding-top: 20px;"><button type="submit" class="btn btn-primary btn-block">Actualizar</button></div></form><div class="col-md-12" text-angular="" ta-toolbar="taToolbar" ng-model="page.content"></div></div></div></div>');
$templateCache.put('app/pages/subscription/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la Suscripci\xF3n" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="name">Nombre <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="name" id="name" class="form-control col-md-7 col-xs-12" ng-model="subscription.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="email">Email <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="email" name="email" id="email" class="form-control col-md-7 col-xs-12" ng-model="subscription.email" validate-on="blur" validator="validateEmail(subscription.email)" invalid-message="\'El campo es incorrecto.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.subscription.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/subscription/edit.html','<div class="widgets" ng-init="loadSubscription()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la Suscripci\xF3n" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="name">Nombre <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="name" id="name" class="form-control col-md-7 col-xs-12" ng-model="subscription.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="email">Email <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="email" name="email" id="email" class="form-control col-md-7 col-xs-12" ng-model="subscription.email" validate-on="blur" validator="validateEmail(subscription.email)" invalid-message="\'El campo es incorrecto.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="status">Estado <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><select class="form-control col-md-7 col-xs-12" name="status" id="status" ng-model="subscription.status" validate-on="blur" ng-options="status.id as (status.name) for status in statusList" required-message="\'El campo es requerido.\'" required=""></select></div></div><div class="form-group"><div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.subscription.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/subscription/filesModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Importar Suscriptores</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="alert alert-info" style="color: #ffffff;">El tama\xF1o m\xE1ximo permitido para cada archivo es 10 MB.</div><div ngf-drop="uploadFiles($file, $invalidFiles)" ngf-select="uploadFiles($file, $invalidFiles)" ng-model="excelFile" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="false" accept=".xls,.xlsx" ngf-pattern="\'.xls,.xlsx\'" name="excelFile" ngf-max-size="10MB" ngf-model-invalid="errorFile">Arrastre el archivo .xlsx o haga click para subir uno.</div><div><span class="control-label has-error validationMessage">{{f.name}} {{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}}</span> <span class="progress pull-right" ng-show="f.progress >= 0"><div style="width:{{f.progress}}%" ng-bind="f.progress + \'%\'"></div></span></div><span class="control-label has-error validationMessage">{{errorMsg}}</span></div></div><br><div class="horizontal-scroll" ng-if="rowErrors.length"><table class="table table-striped"><thead><tr><th style="text-align: left;">Error</th></tr></thead><tbody><tr ng-repeat="row in rowErrors"><td style="text-align: left;">{{row}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/subscription/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="text-right p-r-15"><button type="button" class="btn btn-sm btn-primary" ng-click="showImportDialog()"><i class="fa fa-upload"></i> Importar Listado</button> <button type="button" class="btn btn-sm btn-primary" ng-click="export()"><i class="fa fa-download"></i> Exportar Listado</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="name">Usuario</th><th st-sort="email">Email</th><th st-sort="created_at">Creaci\xF3n</th><th st-sort="status">Estado</th><th>Reenvio</th><th>Acciones</th></tr><tr><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th><input st-search="email" class="input-sm form-control search-input"></th><th></th><th></th><th></th><th><a ui-sref="main.subscription.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.name}}</td><td>{{row.email}}</td><td><span class="label label-default">{{row.created_at | date: \'dd-MM-yyyy HH:mm\'}}</span></td><td><span class="label label-default">{{row.status}}</span></td><td><button ng-click="resendActivation(row.id)" class="btn btn-xs" ng-if="row.status!==\'confirmed\'"><i class="fa fa-envelope"></i> Reenviar activaci\xF3n</button></td><td><button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="7" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="7" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="7"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/user/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del usuario" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="firstName">Nombre <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="firstName" id="firstName" class="form-control col-md-7 col-xs-12" ng-model="user.firstName" validate-on="blur" ng-pattern="/^(?=.{1,40}$)([^0-9]*)$/" invalid-message="\'No debe contener n\xFAmeros y tiene una longitud m\xE1xima de 40 caracteres.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="lastName">Apellidos <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="lastName" id="lastName" class="form-control col-md-7 col-xs-12" ng-model="user.lastName" validate-on="blur" ng-pattern="/^([^0-9]*)$/" invalid-message="\'No debe contener n\xFAmeros.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="email">Email <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="email" name="email" id="email" class="form-control col-md-7 col-xs-12" ng-model="user.email" validate-on="blur" validator="validateEmail(user.email)" invalid-message="\'El campo es incorrecto.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="password">Contrase\xF1a <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="password" name="password" id="password" class="form-control col-md-7 col-xs-12" autocomplete="new-password" ng-model="user.password" validate-on="blur" ng-pattern="/^(?=^.{6,72}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[a-zA-Z]).*$/" invalid-message="\'Debe contener letras y n\xFAmeros y no menos de 6 caracteres.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="retypePassword">Confirmaci\xF3n <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="password" name="retypePassword" id="retypePassword" validate-on="blur" class="form-control col-md-7 col-xs-12" ng-model="user.retypePassword" validator="user.password === user.retypePassword" invalid-message="\'Las claves no coinciden.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.user.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/user/edit.html','<div class="widgets" ng-init="loadUser()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del usuario" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="firstName">Nombre <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="firstName" id="firstName" class="form-control col-md-7 col-xs-12" ng-model="user.firstName" validate-on="blur" ng-pattern="/^(?=.{1,40}$)([^0-9]*)$/" invalid-message="\'No debe contener n\xFAmeros y tiene una longitud m\xE1xima de 40 caracteres.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="lastName">Apellidos <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="lastName" id="lastName" class="form-control col-md-7 col-xs-12" ng-model="user.lastName" validate-on="blur" ng-pattern="/^([^0-9]*)$/" invalid-message="\'No debe contener n\xFAmeros.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="email">Email <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="email" name="email" id="email" class="form-control col-md-7 col-xs-12" ng-model="user.email" validate-on="blur" validator="validateEmail(user.email)" invalid-message="\'El campo es incorrecto.\'" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="password">Contrase\xF1a <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="password" name="password" id="password" class="form-control col-md-7 col-xs-12" ng-model="user.password" validate-on="blur" autocomplete="new-password" ng-pattern="/^(?=^.{6,72}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[a-zA-Z]).*$/" invalid-message="\'Debe contener letras y n\xFAmeros y no menos de 6 caracteres.\'"></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="retypePassword">Confirmaci\xF3n <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="password" name="retypePassword" id="retypePassword" validate-on="blur" class="form-control col-md-7 col-xs-12" ng-model="user.retypePassword" validator="user.password === user.retypePassword" invalid-message="\'Las claves no coinciden.\'"></div></div><div class="form-group"><div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.user.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/user/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="firstName">Nombre</th><th st-sort="lastName">Apellidos</th><th st-sort="email">Email</th><th st-sort="created_at">Registro</th><th st-sort="lastLogin">\xDAltima sesi\xF3n</th><th>Acciones</th></tr><tr><th></th><th><input st-search="firstName" class="input-sm form-control search-input"></th><th><input st-search="lastName" class="input-sm form-control search-input"></th><th><input st-search="email" class="input-sm form-control search-input"></th><th></th><th></th><th><a ui-sref="main.user.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.firstName}}</td><td>{{row.lastName}}</td><td>{{row.email}}</td><td><span class="label label-default">{{row.created_at | date: \'dd-MM-yyyy HH:mm\'}}</span></td><td><span class="label label-default">{{row.lastLogin ? (row.lastLogin | date: \'dd-MM-yyyy HH:mm\') : \'No ha iniciado sesi\xF3n.\'}}</span></td><td><a ui-sref="main.user.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="7" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="7" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="7"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/associated/company/associated_company.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la Empresa del Asociado" ba-panel-class="with-scroll"><form name="companyForm" class="form-horizontal" angular-validator-submit="createOrUpdate(companyForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="companyName">Nombre de la empresa <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="companyName" id="companyName" class="form-control col-md-7 col-xs-12" ng-model="company.name" ng-required="true" validate-on="blur" required-message="\'El campo es requerido.\'" ng-disabled="company.type === \'remote\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="publicName">Nombre p\xFAblico de la empresa <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="publicName" id="publicName" class="form-control col-md-7 col-xs-12" ng-model="company.publicName" ng-required="true" validate-on="blur" required-message="\'El campo es requerido.\'" ng-disabled="company.type === \'remote\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="email">Email <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="email" name="email" id="email" class="form-control col-md-7 col-xs-12" ng-model="company.email" ng-required="true" validate-on="blur" required-message="\'El campo es requerido.\'" ng-disabled="company.type === \'remote\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="email2">Email 2</label><div class="col-md-6 col-sm-6 col-xs-12"><input type="email" name="email2" id="email2" class="form-control col-md-7 col-xs-12" ng-model="company.email2" validate-on="blur" ng-disabled="company.type === \'remote\'"></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="email2">Email 3</label><div class="col-md-6 col-sm-6 col-xs-12"><input type="email" name="email3" id="email3" class="form-control col-md-7 col-xs-12" ng-model="company.email3" validate-on="blur" ng-disabled="company.type === \'remote\'"></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="email2">Email 4</label><div class="col-md-6 col-sm-6 col-xs-12"><input type="email" name="email4" id="email4" class="form-control col-md-7 col-xs-12" ng-model="company.email4" validate-on="blur" ng-disabled="company.type === \'remote\'"></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="phone">Tel\xE9fono <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="phone" id="phone" class="form-control col-md-7 col-xs-12" ng-model="company.phone" ng-required="true" validate-on="blur" required-message="\'El campo es requerido.\'" ng-disabled="company.type === \'remote\'" required=""></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" for="web">Url - Sitio Web <span class="required">*</span></label><div class="col-md-6 col-sm-6 col-xs-12"><input type="text" name="web" id="web" class="form-control col-md-7 col-xs-12" ng-model="company.webSite" ng-required="true" validate-on="blur" required-message="\'El campo es requerido.\'" ng-disabled="company.type === \'remote\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="sector">Sector <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="sector" id="sector" ng-model="company.idSector" ng-options="sector.id as sector.name for sector in sectors" validate-on="blur" required-message="\'El campo es requerido.\'" ng-disabled="company.type === \'remote\'" required=""><option selected="" value="">{{\'Sector\'|uppercase}}</option></select></div></div><div class="form-group"><div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3"><button type="submit" class="btn btn-primary">Guardar</button> <button class="btn" type="button" ui-sref="main.associated.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/dashboard/reports/destination_page.html','<div class="widgets" ng-init="init(\'destination-page\')"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="row"><div class="col-md-8"><a ui-sref="main.dashboard({startDate: datePicker.date.startDate.format(\'YYYY-MM-DD\'), endDate: datePicker.date.endDate.format(\'YYYY-MM-DD\')})" class="btn btn-sm btn-default"><i class="fa fa-reply"></i> Dashboard</a></div><div class="col-md-4"><input date-range-picker="" class="form-control date-picker" type="text" ng-model="datePicker.date" options="options"></div></div><div class="horizontal-scroll"><table class="table table-striped"><thead><tr><th></th><th>P\xE1gina</th><th>Sesiones</th></tr></thead><tbody><tr ng-repeat="item in destinationPage.values"><td>{{$index+1}}</td><td>{{item.url}}</td><td>{{item.sessions}} ({{calculatePercent(item.sessions, destinationPage.totalSessions)}}%)</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/reports/exit_page.html','<div class="widgets" ng-init="init(\'exit-page\')"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="row"><div class="col-md-8"><a ui-sref="main.dashboard({startDate: datePicker.date.startDate.format(\'YYYY-MM-DD\'), endDate: datePicker.date.endDate.format(\'YYYY-MM-DD\')})" class="btn btn-sm btn-default"><i class="fa fa-reply"></i> Dashboard</a></div><div class="col-md-4"><input date-range-picker="" class="form-control date-picker" type="text" ng-model="datePicker.date" options="options"></div></div><div class="horizontal-scroll"><table class="table table-striped"><thead><tr><th></th><th>P\xE1gina</th><th>Salidas</th></tr></thead><tbody><tr ng-repeat="item in exitPage.values"><td>{{$index+1}}</td><td>{{item.url}}</td><td>{{item.exits}} ({{calculatePercent(item.exits, exitPage.totalExits)}}%)</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/notification/tpl/auto-complete.tpl.html','<div class="right-panel"><span ng-bind-html="$highlight($getDisplayText())"></span> <span>{{data.firstName}} {{data.lastName}}</span></div>');
$templateCache.put('app/pages/notification/tpl/tags-input.tpl.html','<div class="tag-template"><div><span>{{data.firstName}} {{data.lastName}}</span> <span>{{$getDisplayText()}}</span> <a class="remove-button" ng-click="$removeTag()">&#10006;</a></div></div>');
$templateCache.put('app/pages/project/updates/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la actualizaci\xF3n" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="idProject">Proyecto <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="idProject" id="idProject" ng-model="update.idProject" ng-options="project.id as (project.name) for project in projects" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" value="">{{\'Proyecto\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="status">Estado <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="status" id="status" ng-model="update.status" ng-options="status.key as (status.name) for status in statusList" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" value="">{{\'Estado\'|uppercase}}</option></select></div></div><div style="width: 100%; position: absolute; bottom: 0; margin-top: 20px; margin-bottom: 20px;"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.project.updates.list">Ir al listado</button></div></div></form><div class="row" style="margin-bottom: 50px"><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3 text-right" for="content">Contenido <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6" text-angular="" id="content" ng-model="update.content" name="ta-project-update" placeholder="" ta-toolbar="taToolbar" ta-text-editor-class="form-control ta-height-update" ta-html-editor-class="form-control ta-height-update"></div></div></div></div></div></div>');
$templateCache.put('app/pages/project/updates/edit.html','<div class="widgets" ng-init="loadUpdate()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la actualizaci\xF3n" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="updateChanges(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="idProject">Proyecto <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="idProject" id="idProject" ng-model="update.idProject" ng-options="project.id as (project.name) for project in projects" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" value="">{{\'Proyecto\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="status">Estado <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="status" id="status" ng-model="update.status" ng-options="status.key as (status.name) for status in statusList" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" value="">{{\'Estado\'|uppercase}}</option></select></div></div><div style="width: 100%; position: absolute; bottom: 0; margin-top: 20px; margin-bottom: 20px;"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.project.updates.list">Ir al listado</button></div></div></form><div class="row" style="margin-bottom: 50px"><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3 text-right" for="content">Contenido <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6" text-angular="" id="content" ng-model="update.content" name="ta-project-update" placeholder="" ta-toolbar="taToolbar" ta-text-editor-class="form-control ta-height-update" ta-html-editor-class="form-control ta-height-update"></div></div></div></div></div></div>');
$templateCache.put('app/pages/project/updates/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="date">Fecha</th><th st-sort="content" width="40%">Contenido</th><th st-sort="status">Estado</th><th st-sort="idProject">Proyecto</th><th>Acciones</th></tr><tr><th></th><th></th><th><input st-search="content" class="input-sm form-control search-input"></th><th><select st-search="status" class="form-control" name="status" id="status"><option selected="" value=""></option><option value="{{status.key}}" ng-repeat="status in statusList">{{status.name}}</option></select></th><th></th><th><a ui-sref="main.project.updates.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td><span class="label" ng-class="{\'label-info\': row.status === \'published\', \'label-danger\': row.status === \'pending\'}">{{row.date | date: \'dd.MM.yyyy\'}}</span></td><td><p ng-bind-html="row.content"></p></td><td><select class="m-t-1" name="status" ng-change="changeStatus(row.id, row.status)" ng-model="row.status"><option value="{{status.key}}" ng-repeat="status in statusList">{{status.name}}</option></select></td><td><span class="pointer" uib-tooltip="{{row.project.nameToPublish}}">{{row.project && row.project.nameToPublish ? (row.project.nameToPublish | cut : false : 15) : \'-\'}}</span></td><td><a ui-sref="main.project.updates.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="6" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="6"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/resources/activity/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la Actividad" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="activity.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="activity.custom"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.res.activity.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/activity/edit.html','<div class="widgets" ng-init="loadActivity()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la Actividad" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="activity.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="activity.custom"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.res.activity.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/activity/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="name">Nombre</th><th st-sort="custom">Valor Personalizable</th><th>Acciones</th></tr><tr><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th></th><th><a ui-sref="main.res.activity.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.name}}</td><td>{{row.custom ? \'Si\' : \'No\'}}</td><td><a ui-sref="main.res.activity.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/resources/alliance/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la Alianza" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="alliance.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="alliance.custom"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.res.alliance.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/alliance/edit.html','<div class="widgets" ng-init="loadAlliance()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la Alianza" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="alliance.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="alliance.custom"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.res.alliance.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/alliance/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="name">Nombre</th><th st-sort="custom">Valor Personalizable</th><th>Acciones</th></tr><tr><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th></th><th><a ui-sref="main.res.alliance.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.name}}</td><td>{{row.custom ? \'Si\' : \'No\'}}</td><td><a ui-sref="main.res.alliance.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/resources/beneficiary/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del Beneficiario" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="beneficiary.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="beneficiary.custom"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.res.beneficiary.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/beneficiary/edit.html','<div class="widgets" ng-init="loadBeneficiary()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del Beneficiario" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="beneficiary.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="beneficiary.custom"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.res.beneficiary.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/beneficiary/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="name">Nombre</th><th st-sort="custom">Valor Personalizable</th><th>Acciones</th></tr><tr><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th></th><th><a ui-sref="main.res.beneficiary.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.name}}</td><td>{{row.custom ? \'Si\' : \'No\'}}</td><td><a ui-sref="main.res.beneficiary.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/resources/category/create.html','<div class="widgets" ng-init="loadRootCategories()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la categor\xEDa" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="category.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="parent">Categor\xEDa padre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="parent" id="parent" ng-model="category.idCategory" ng-options="category.id as (category.name) for category in rootCategories"><option selected="" value="">{{\'Categor\xEDa\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="category.custom"></ba-switcher></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Men\xFA Principal</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="category.mainMenu"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.res.category.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/category/edit.html','<div class="widgets" ng-init="loadCategory()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la categor\xEDa" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="category.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="parent">Categor\xEDa padre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control col-xs-12 col-md-7" name="parent" id="parent" ng-model="category.idCategory" ng-options="category.id as (category.name) for category in rootCategories"><option selected="" value="">{{\'Categor\xEDa\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="category.custom"></ba-switcher></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Men\xFA Principal</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="category.mainMenu"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.res.category.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/category/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="name">Nombre</th><th st-sort="custom">Valor Personalizable</th><th st-sort="mainMenu">Men\xFA Principal</th><th>Acciones</th></tr><tr><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th></th><th></th><th><a ui-sref="main.res.category.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.name}}</td><td>{{row.custom ? \'Si\' : \'No\'}}</td><td>{{row.mainMenu ? \'Si\' : \'No\'}}</td><td><a ui-sref="main.res.category.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="5" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="5"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/resources/diffusion/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la Difusi\xF3n" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="diffusion.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="diffusion.custom"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.res.diffusion.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/diffusion/edit.html','<div class="widgets" ng-init="loadDiffusion()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la Difusi\xF3n" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="diffusion.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="diffusion.custom"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.res.diffusion.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/diffusion/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="name">Nombre</th><th st-sort="custom">Valor Personalizable</th><th>Acciones</th></tr><tr><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th></th><th><a ui-sref="main.res.diffusion.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.name}}</td><td>{{row.custom ? \'Si\' : \'No\'}}</td><td><a ui-sref="main.res.diffusion.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/resources/district/create.html','<div class="widgets" ng-init="init(\'create\')"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del Distrito" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="region">Regi\xF3n <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control" name="region" id="region" ng-model="district.idRegion" ng-options="region.id as (region.name) for region in regions" ng-change="loadProvinces(district.idRegion)" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" disabled="" value="">{{\'Regi\xF3n\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="province">Provincia <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control" name="province" id="province" ng-model="district.idProvince" ng-options="province.id as (province.name) for province in provinces" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" disabled="" value="">{{\'Provincia\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="district.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.res.district.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/district/edit.html','<div class="widgets" ng-init="init(\'edit\')"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del Distrito" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="region">Regi\xF3n <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control" name="region" id="region" ng-model="district.province.idRegion" ng-options="region.id as (region.name) for region in regions" ng-change="loadProvinces(district.province.idRegion)" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" disabled="" value="">{{\'Regi\xF3n\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="province">Provincia <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control" name="province" id="province" ng-model="district.idProvince" ng-options="province.id as (province.name) for province in provinces" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" disabled="" value="">{{\'Provincia\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="district.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.res.district.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/district/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="name">Nombre</th><th>Acciones</th></tr><tr><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th><a ui-sref="main.res.district.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.name}}</td><td><a ui-sref="main.res.district.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="3" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="3"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/resources/financing/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del Financiamiento" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="financing.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="financing.custom"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.res.financing.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/financing/edit.html','<div class="widgets" ng-init="loadFinancing()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del Financiamiento" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="financing.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="financing.custom"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.res.financing.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/financing/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="name">Nombre</th><th st-sort="custom">Valor Personalizable</th><th>Acciones</th></tr><tr><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th></th><th><a ui-sref="main.res.financing.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.name}}</td><td>{{row.custom ? \'Si\' : \'No\'}}</td><td><a ui-sref="main.res.financing.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/resources/information_base/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la base" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="informationBase.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="informationBase.custom"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.res.information_base.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/information_base/edit.html','<div class="widgets" ng-init="loadInformationBase()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la base" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="informationBase.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Valor Personalizable</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="informationBase.custom"></ba-switcher></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.res.information_base.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/information_base/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="name">Nombre</th><th st-sort="custom">Valor Personalizable</th><th>Acciones</th></tr><tr><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th></th><th><a ui-sref="main.res.information_base.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.name}}</td><td>{{row.custom ? \'Si\' : \'No\'}}</td><td><a ui-sref="main.res.information_base.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/resources/objective/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del objetivo" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="objective.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Imagen</label><div class="col-xs-12 col-md-6 col-sm-6"><div class="userpic"><div class="userpic-wrapper" ng-click="showFileDialog()"><span ng-if="!objective.image" class="fa fa-plus fa-2x"></span> <img ng-if="objective.image" ng-src="{{ objective.image.name | imageUrl : \'ODS\' }}"></div><i class="ion-ios-close-outline" ng-click="removeFile()" ng-if="objective.image"></i></div></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.res.objective.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/objective/edit.html','<div class="widgets" ng-init="loadObjective()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del objetivo" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="objective.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Imagen</label><div class="col-xs-12 col-md-6 col-sm-6"><div class="userpic"><div class="userpic-wrapper" ng-click="showFileDialog()"><span ng-if="!objective.image" class="fa fa-plus fa-2x"></span> <img ng-if="objective.image" ng-src="{{ objective.image.name | imageUrl : \'ODS\' }}"></div><i class="ion-ios-close-outline" ng-click="removeFile()" ng-if="objective.image"></i></div></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.res.objective.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/objective/filesModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Logotipos de Ediciones</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="alert alert-info">El tama\xF1o m\xE1ximo permitido para cada archivo es 10 MB.</div><div ngf-drop="uploadFile($file, $invalidFiles)" ngf-select="uploadFile($file, $invalidFiles)" ng-model="picFile" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="false" accept="image/*" ngf-pattern="\'image/*\'" name="picFile" ngf-max-size="10MB" ngf-model-invalid="errorFile">Arrastre el logo aqu\xED o haga click para subir uno.</div><div><span class="control-label has-error validationMessage">{{f.name}} {{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}}</span> <span class="progress pull-right" ng-show="f.progress >= 0"><div style="width:{{f.progress}}%" ng-bind="f.progress + \'%\'"></div></span></div><span class="control-label has-error validationMessage">{{errorMsg}}</span></div></div><br><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callLogoFilesServer" st-table="results"><thead><tr class="sortable"><th></th><th st-sort="originalFilename">Nombre del archivo</th><th st-sort="size">Tama\xF1o</th><th></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td><div class="image-wrapper"><img ng-src="{{row.name|imageUrl:row.container}}" alt="row.originalFilename"></div></td><td><span style="word-break: break-all;">{{row.originalFilename}}</span></td><td>{{row.size/1024/1024 | number: 2}} MB</td><td><button ng-click="setObjectiveImage(row)" class="btn btn-primary btn-xs"><i class="fa fa-check"></i> Seleccionar</button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/resources/objective/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="name">Nombre</th><th>Acciones</th></tr><tr><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th><a ui-sref="main.res.objective.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.name}}</td><td><a ui-sref="main.res.objective.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="3" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="3"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/resources/province/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la Provincia" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="region">Regi\xF3n <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control" name="region" id="region" ng-model="province.idRegion" ng-options="region.id as (region.name) for region in regions" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" disabled="" value="">{{\'Regi\xF3n\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="province.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.res.province.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/province/edit.html','<div class="widgets" ng-init="loadProvince()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la Provincia" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="region">Regi\xF3n <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><select class="form-control" name="region" id="region" ng-model="province.idRegion" ng-options="region.id as (region.name) for region in regions" validate-on="blur" required-message="\'El campo es requerido.\'" required=""><option selected="" disabled="" value="">{{\'Regi\xF3n\'|uppercase}}</option></select></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="province.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.res.province.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/province/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="name">Nombre</th><th>Acciones</th></tr><tr><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th><a ui-sref="main.res.province.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.name}}</td><td><a ui-sref="main.res.province.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="3" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="3"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/resources/region/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la regi\xF3n" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="region.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.res.region.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/region/edit.html','<div class="widgets" ng-init="loadRegion()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos de la regi\xF3n" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="region.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.res.region.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/region/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="name">Nombre</th><th>Acciones</th></tr><tr><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th><a ui-sref="main.res.region.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.name}}</td><td><a ui-sref="main.res.region.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="3" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="3"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/resources/sector/create.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del sector" ba-panel-class="with-scroll"><form name="createForm" class="form-horizontal" angular-validator-submit="create(createForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="sector.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Men\xFA Principal</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="sector.mainMenu"></ba-switcher></div></div><div class="form-group" ng-show="sector.mainMenu"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="order">Orden en el Men\xFA<span class="required">*</span></label><div class="col-xs-12 col-md-2 col-sm-2"><input type="text" name="order" id="order" class="form-control col-xs-12 col-md-7" ng-model="sector.mainMenuOrder" ng-required="sector.mainMenu" validate-on="blur" required-message="\'El campo es requerido.\'"></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Imagen Marcador <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><recommended-sizes width="markerIcon.width" height="markerIcon.height" unit="px" type="png"></recommended-sizes><div class="userpic"><div class="userpic-wrapper" ng-click="showFileDialog(\'marker\')"><span ng-if="!sector.imageMarker" class="fa fa-plus fa-2x"></span> <img ng-if="sector.imageMarker" ng-src="{{ sector.imageMarker.url | imageUrl }}"></div><i class="ion-ios-close-outline" ng-click="removeFile(\'marker\')" ng-if="sector.imageMarker"></i></div></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Imagen Logo <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><recommended-sizes width="sectorIcon.width" height="sectorIcon.height" unit="px" type="png"></recommended-sizes><div class="userpic"><div class="userpic-wrapper" ng-click="showFileDialog(\'logo\')"><span ng-if="!sector.imageLogo" class="fa fa-plus fa-2x"></span> <img ng-if="sector.imageLogo" ng-src="{{ sector.imageLogo.url | imageUrl }}"></div><i class="ion-ios-close-outline" ng-click="removeFile(\'logo\')" ng-if="sector.imageLogo"></i></div></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Crear</button> <button class="btn" type="button" ui-sref="main.res.sector.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/sector/edit.html','<div class="widgets" ng-init="loadSector()"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Datos del sector" ba-panel-class="with-scroll"><form name="updateForm" class="form-horizontal" angular-validator-submit="update(updateForm.$valid)" angular-validator="" novalidate=""><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Nombre <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><input type="text" name="name" id="name" class="form-control col-xs-12 col-md-7" ng-model="sector.name" validate-on="blur" required-message="\'El campo es requerido.\'" required=""></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="name">Men\xFA Principal</label><div class="col-xs-12 col-md-6 col-sm-6"><ba-switcher switcher-style="primary" switcher-value="sector.mainMenu"></ba-switcher></div></div><div class="form-group" ng-show="sector.mainMenu"><label class="control-label col-xs-12 col-md-3 col-sm-3" for="order">Orden en el Men\xFA<span class="required">*</span></label><div class="col-xs-12 col-md-2 col-sm-2"><input type="text" name="order" id="order" class="form-control col-xs-12 col-md-7" ng-model="sector.mainMenuOrder" ng-required="sector.mainMenu" validate-on="blur" required-message="\'El campo es requerido.\'"></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Imagen Marcador <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><recommended-sizes width="markerIcon.width" height="markerIcon.height" unit="px" type="png"></recommended-sizes><div class="userpic"><div class="userpic-wrapper" ng-click="showFileDialog(\'marker\')"><span ng-if="!sector.imageMarker" class="fa fa-plus fa-2x"></span> <img ng-if="sector.imageMarker" ng-src="{{ sector.imageMarker.url | imageUrl }}"></div><i class="ion-ios-close-outline" ng-click="removeFile(\'marker\')" ng-if="sector.imageMarker"></i></div></div></div><div class="form-group"><label class="control-label col-xs-12 col-md-3 col-sm-3">Imagen Logo <span class="required">*</span></label><div class="col-xs-12 col-md-6 col-sm-6"><recommended-sizes width="sectorIcon.width" height="sectorIcon.height" unit="px" type="png"></recommended-sizes><div class="userpic"><div class="userpic-wrapper" ng-click="showFileDialog(\'logo\')"><span ng-if="!sector.imageLogo" class="fa fa-plus fa-2x"></span> <img ng-if="sector.imageLogo" ng-src="{{ sector.imageLogo.url | imageUrl }}"></div><i class="ion-ios-close-outline" ng-click="removeFile(\'logo\')" ng-if="sector.imageLogo"></i></div></div></div><div class="form-group"><div class="col-xs-12 col-md-6 col-sm-6 col-md-offset-3"><button type="submit" class="btn btn-primary">Actualizar</button> <button class="btn" type="button" ui-sref="main.res.sector.list">Ir al listado</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/resources/sector/filesModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Im\xE1genes de sectores</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="alert alert-info">El tama\xF1o m\xE1ximo permitido para cada archivo es 10 MB.</div><div ngf-drop="uploadFile($file, $invalidFiles, imageType)" ngf-select="uploadFile($file, $invalidFiles, imageType)" ng-model="picFile" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="false" accept="image/*" ngf-pattern="\'image/*\'" name="picFile" ngf-max-size="10MB" ngf-model-invalid="errorFile">Arrastre el logo aqu\xED o haga click para subir uno.</div><div><span class="control-label has-error validationMessage">{{f.name}} {{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}}</span> <span class="progress pull-right" ng-show="f.progress >= 0"><div style="width:{{f.progress}}%" ng-bind="f.progress + \'%\'"></div></span></div><span class="control-label has-error validationMessage">{{errorMsg}}</span></div></div><br><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callLogoFilesServer" st-table="results"><thead><tr class="sortable"><th></th><th st-sort="originalFilename">Nombre del archivo</th><th st-sort="size">Tama\xF1o</th><th></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td><div class="image-wrapper"><img ng-src="{{row.name|imageUrl:row.container}}" alt="row.originalFilename"></div></td><td><span style="word-break: break-all;">{{row.originalFilename}}</span></td><td>{{row.size/1024/1024 | number: 2}} MB</td><td><button ng-click="setSectorImage(row, imageType)" class="btn btn-primary btn-xs"><i class="fa fa-check"></i> Seleccionar</button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/resources/sector/list.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Resultados" ba-panel-class="with-scroll"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callServer" st-table="results"><thead><tr class="sortable"><th class="table-id"></th><th st-sort="name">Nombre</th><th st-sort="mainMenu">Men\xFA Principal</th><th>Acciones</th></tr><tr><th></th><th><input st-search="name" class="input-sm form-control search-input"></th><th></th><th><a ui-sref="main.res.sector.create" class="btn btn-primary btn-xs"><i class="fa fa-plus"></i></a> <button ng-click="removeSelectedItems()" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td cs-select="row"></td><td>{{row.name}}</td><td>{{row.mainMenu ? \'Si\' : \'No\'}} <span class="badge" ng-if="row.mainMenu">{{row.mainMenuOrder}}</span></td><td><a ui-sref="main.res.sector.edit({id: row.id})" class="btn btn-info btn-xs"><i class="fa fa-pencil"></i></a> <button ng-click="remove([row.id])" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/resources/components/taUploadArticleImage/taFilesModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Im\xE1genes de Art\xEDculos</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="alert alert-info" style="color: #ffffff;">El tama\xF1o m\xE1ximo permitido para cada archivo es 10 MB.</div><div ngf-drop="uploadFiles($file, $invalidFiles)" ngf-select="uploadFiles($file, $invalidFiles)" ng-model="picFile" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="false" accept="image/*" ngf-pattern="\'image/*\'" name="picFile" ngf-max-size="10MB" ngf-model-invalid="errorFile">Arrastre la imagen aqu\xED o haga click para subir una.</div><div><span class="control-label has-error validationMessage">{{f.name}} {{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}}</span> <span class="progress pull-right" ng-show="f.progress >= 0"><div style="width:{{f.progress}}%" ng-bind="f.progress + \'%\'"></div></span></div><span class="control-label has-error validationMessage">{{errorMsg}}</span></div></div><br><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callFilesServer" st-table="results"><thead><tr class="sortable"><th></th><th st-sort="originalFilename">Nombre del archivo</th><th st-sort="size">Tama\xF1o</th><th></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td><div class="image-wrapper"><img ng-src="{{row.name|imageUrl:row.container}}" alt="row.originalFilename"></div></td><td><span style="word-break: break-all;">{{row.originalFilename}}</span></td><td>{{row.size/1024/1024 | number: 2}} MB</td><td><button ng-click="setImage(row.name)" class="btn btn-primary btn-xs"><i class="fa fa-check"></i> Seleccionar</button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/resources/components/taUploadImage/taFilesModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Im\xE1genes de Art\xEDculos</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="alert alert-info" style="color: #ffffff;">El tama\xF1o m\xE1ximo permitido para cada archivo es 10 MB.</div><div ngf-drop="uploadFiles($file, $invalidFiles)" ngf-select="uploadFiles($file, $invalidFiles)" ng-model="picFile" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-allow-dir="false" accept="image/*" ngf-pattern="\'image/*\'" name="picFile" ngf-max-size="10MB" ngf-model-invalid="errorFile">Arrastre la imagen aqu\xED o haga click para subir una.</div><div><span class="control-label has-error validationMessage">{{f.name}} {{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}}</span> <span class="progress pull-right" ng-show="f.progress >= 0"><div style="width:{{f.progress}}%" ng-bind="f.progress + \'%\'"></div></span></div><span class="control-label has-error validationMessage">{{errorMsg}}</span></div></div><br><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Resultados por p\xE1gina<select class="form-control selectpicker show-tick" title="Resultados por p\xE1gina" selectpicker="" ng-model="pageSize" ng-options="i for i in pageSizeOptions"></select></label></div><table class="table table-hover" st-pipe="callFilesServer" st-table="results"><thead><tr class="sortable"><th></th><th st-sort="originalFilename">Nombre del archivo</th><th st-sort="size">Tama\xF1o</th><th></th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="row in results"><td><div class="image-wrapper"><img ng-src="{{row.name|imageUrl:row.container}}" alt="row.originalFilename"></div></td><td><span style="word-break: break-all;">{{row.originalFilename}}</span></td><td>{{row.size/1024/1024 | number: 2}} MB</td><td><button ng-click="setImage(row.name)" class="btn btn-primary btn-xs"><i class="fa fa-check"></i> Seleccionar</button></td></tr><tr ng-show="results.length == 0"><td colspan="4" class="text-center">No se encontraron resultados.</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Cargando ...</td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="pageSize" colspan="4"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/resources/directives/advancedAssociatedFilters/advancedAssociatedFilters.html','<div class="advanced-filter-container" ng-if="sectors || showUsernameFilter || showCompanyNameFilter"><form action="" autocomplete="off"><div class="col-md-12 no-padding"><div class="col-md-4"><input type="text" name="username" id="username" class="form-control m-b-10 text-center upper-placeholder" placeholder="Usuario" ng-model="filters.username" ng-if="showUsernameFilter"></div><div class="col-md-4"><input type="text" name="company_name" id="company_name" class="form-control m-b-10 text-center upper-placeholder" placeholder="Compa\xF1\xEDa" ng-model="filters.companyName" ng-if="showCompanyNameFilter"></div><div class="col-md-4"><multiselect ng-model="filters.sectors" options="sectors" show-tooltip="false" show-search="true" search-limit="2000" id-prop="id" display-prop="name" labels="sectorLabels" show-select-all="false" show-unselect-all="true" ng-if="sectors && sectors.length"></multiselect></div></div><div class="col-md-12 p-t-10"><button type="button" class="btn btn-sm" ng-click="resetFilters()" ng-if="showReset"><i class="{{resetIcon}}" ng-if="resetIcon"></i> {{resetText || \'Limpiar Filtros\'}}</button> <button type="button" class="btn btn-primary btn-sm" ng-click="applyFilters()"><i class="{{applyIcon}}" ng-if="applyIcon"></i> {{applyText || \'Filtrar\'}}</button></div></form></div>');
$templateCache.put('app/resources/directives/advancedFilters/advancedFilters.html','<div class="advanced-filter-container" ng-if="sectors || regions || provinces || districts || categories || companies || objectives || status || showNameFilter"><form action="" autocomplete="off"><div class="col-md-12 no-padding"><div class="col-md-3"><input type="text" name="project_name" id="project_name" class="form-control m-b-10 text-center upper-placeholder" placeholder="Nombre del Proyecto" ng-model="filters.projectName" ng-if="showNameFilter"><multiselect ng-model="filters.objectives" options="objectives" show-tooltip="false" show-search="true" search-limit="2000" id-prop="id" display-prop="name" labels="objectiveLabels" show-select-all="false" show-unselect-all="true" ng-if="objectives && objectives.length"></multiselect><multiselect ng-model="filters.status" options="status" show-tooltip="false" show-search="true" search-limit="2000" id-prop="id" display-prop="name" labels="statusLabels" show-select-all="false" show-unselect-all="true" ng-if="status && status.length"></multiselect></div><div class="col-md-3"><multiselect ng-model="filters.sectors" options="sectors" show-tooltip="false" show-search="true" search-limit="2000" id-prop="id" display-prop="name" labels="sectorLabels" show-select-all="false" show-unselect-all="true" ng-if="sectors && sectors.length"></multiselect><multiselect ng-model="filters.categories" options="categories" show-tooltip="false" show-search="true" search-limit="2000" id-prop="id" display-prop="name" labels="categoryLabels" show-select-all="false" show-unselect-all="true" ng-if="categories && categories.length"></multiselect><multiselect ng-model="filters.companies" options="companies" show-tooltip="false" show-search="true" search-limit="2000" id-prop="id" display-prop="name" labels="companyLabels" show-select-all="false" show-unselect-all="true" ng-if="companies && companies.length"></multiselect></div><div class="col-md-3"><multiselect ng-model="filters.regions" options="regions" show-tooltip="false" show-search="true" search-limit="2000" id-prop="id" display-prop="name" labels="regionLabels" show-select-all="false" show-unselect-all="true" ng-if="regions && regions.length"></multiselect><multiselect ng-model="filters.provinces" options="provinces" show-tooltip="false" show-search="true" search-limit="10" id-prop="id" display-prop="name" labels="provinceLabels" show-select-all="false" show-unselect-all="true" ng-if="provinces && provinces.length"></multiselect><multiselect ng-model="filters.districts" options="districts" show-tooltip="false" show-search="true" search-limit="10" id-prop="id" display-prop="name" labels="districtLabels" show-select-all="false" show-unselect-all="true" ng-if="districts && districts.length"></multiselect></div><div class="col-md-3"><div><div class="col-md-11 no-padding"><input type="text" name="startDate" id="startDate" placeholder="Inicio (d\xEDa/mes/a\xF1o)" class="form-control m-b-10 text-center upper-placeholder date-picker" date-range-picker="" ng-model="startDatePicker.date" readonly="readonly" options="options"></div><div class="col-md-1 p-5"><button type="button" class="btn btn-xs" ng-click="clearStartDate()"><span class="fa fa-times"></span></button></div></div><div><div class="col-md-11 no-padding"><input type="text" name="endDate" id="endDate" placeholder="Fin (d\xEDa/mes/a\xF1o)" class="form-control m-b-10 text-center upper-placeholder date-picker" date-range-picker="" ng-model="endDatePicker.date" readonly="readonly" options="options"></div><div class="col-md-1 p-5"><button type="button" class="btn btn-xs" ng-click="clearEndDate()"><span class="fa fa-times"></span></button></div></div></div></div><div class="col-md-12 p-t-10"><button type="button" class="btn btn-sm" ng-click="resetFilters()" ng-if="showReset"><i class="{{resetIcon}}" ng-if="resetIcon"></i> {{resetText || \'Limpiar Filtros\'}}</button> <button type="button" class="btn btn-primary btn-sm" ng-click="applyFilters()"><i class="{{applyIcon}}" ng-if="applyIcon"></i> {{applyText || \'Filtrar\'}}</button></div></form></div>');
$templateCache.put('app/resources/directives/charCounter/charCounter.html','<div class="text-right"><span class="label label-info">{{model.length || 0}} / {{limit}}</span></div>');
$templateCache.put('app/resources/directives/dashboardAreaChart/dashboardAreaChart.html','<div id="areaChart" class="admin-chart"></div>');
$templateCache.put('app/resources/directives/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/resources/directives/dashboardPieChart/dashboardPieChart.html','<div id="{{id}}" class="admin-chart" ng-style="style"></div>');
$templateCache.put('app/resources/directives/recommendedSizes/recommendedSizes.html','<div>Dimensiones recomendadas. {{width}}{{unit}} de ancho por {{height}}{{unit}} de alto {{type ? \'Tipo: \' + type : \'\'}}</div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li ng-if="activePageTitle!=\'Dashboard\'"><a ui-sref="main.dashboard">Dashboard</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a ui-sref="main.dashboard" class="al-logo clearfix"><img src="../../../assets/img/snmpe.png" alt="" width="40"></a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix" ng-controller="SecurityPageCtrl"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{userLogged.avatarFilename | imageUrl : \'userpics\'}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a ui-sref="main.change_password"><i class="fa fa-key"></i>Cambiar clave</a></li><li><a ui-sref="main.profile"><i class="fa fa-user"></i>Perfil</a></li><li><a href="" ng-click="logout()" class="signout"><i class="fa fa-power-off"></i>Salir</a></li></ul></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/resources/directives/article/articleLink/articleLink.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}"><div class="col-md-12"><div class="custom-selector"><div class="clearfix"><div class="list-container" ng-if="items.length"><div ng-repeat="item in items track by $index" class="form-group col-md-12"><div class="col-md-5 no-padding p-r-5"><input type="text" name="link_title{{$index}}" id="link_title{{$index}}" placeholder="T\xEDtulo del enlace" class="form-control" style="display: block;" ng-model="items[$index].title"></div><div class="col-md-5 no-padding p-l-5"><input type="text" name="link_url{{$index}}" id="link_url{{$index}}" placeholder="Url del enlace" class="form-control" style="display: block;" ng-model="items[$index].url"></div><div class="col-md-2 no-padding p-l-5 p-t-10"><a href="javascript:;" ng-click="removeItem($index)" class="remove-item-btn"><i class="fa fa-minus-circle"></i></a></div></div></div><div class="new-container"><div class="form-group col-md-12"><div class="col-md-5 no-padding p-r-5"><input type="text" name="link_add_title{{$index}}" id="link_add_title{{$index}}" placeholder="T\xEDtulo del enlace" class="form-control" style="display: block;" ng-model="newItem.title"></div><div class="col-md-5 no-padding p-l-5"><input type="text" name="link_add_url{{$index}}" id="link_add_url{{$index}}" placeholder="Url del enlace" class="form-control" style="display: block;" ng-model="newItem.url"></div><div class="col-md-2 no-padding p-l-5 p-t-10"><a href="javascript:;" ng-click="addItem()" class="add-item-btn"><i class="fa fa-plus-circle"></i></a></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/article/imageUpload/imageUpload.html','<div class="clearfix image-upload-component" ng-class="{\'has-error-item\': errors && errors.length}"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="subtitle"><div>Formato JPG. M\xE1ximo 2000KB</div><recommended-sizes width="recommendedSizes.width" height="recommendedSizes.height" unit="px"></recommended-sizes></div></div><div class="clearfix"><div class="col-md-12 no-padding" ng-if="fileModel"><div class="clearfix"><div class="col-md-6 no-padding"><img class="img-responsive" ng-src="{{fileModel.url|imageUrl}}"></div><div class="col-md-12 no-padding"><button type="button" class="btn btn-sm btn-danger" ng-click="removeItem()">Eliminar</button></div></div></div><div class="col-md-12 no-padding p-t-2" ng-if="!fileModel"><div class="clearfix"><div class="col-md-6 no-padding"><img ng-if="file" class="img-responsive" ngf-thumbnail="file"></div><div class="col-md-12 no-padding p-t-10"><button class="btn btn-sm" ngf-select="" ng-model="file" accept="image/*" ngf-max-size="2MB">{{file?\'Cambiar\':\'Examinar\'}}</button> <button type="button" class="btn btn-sm btn-primary" ng-click="uploadFile(file, $index)" ng-disabled="!file">Subir</button></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/errorMessage/errorMessage.html','<label class="control-label has-error">El campo es requerido.</label>');
$templateCache.put('app/resources/directives/manageProjects/gmaps/gmaps.html','<div class="form-group"><label class="control-label col-md-12" for="map"><strong class="text-uppercase">Ubicaci\xF3n en el mapa</strong></label><div class="gmap-container" id="map"><ui-gmap-google-map center="map.center" zoom="map.zoom" draggable="true" options="options" control="mapControl" events="events"><ui-gmap-markers models="markers" fit="\'true\'" coords="\'self\'" icon="\'icon\'" options="\'options\'" click="onClick"></ui-gmap-markers></ui-gmap-google-map></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputAction/inputAction.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="actions"><strong class="text-uppercase">Acciones.</strong> Principales acciones realizadas o a realizar <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="actions" ng-model="model" name="ta-actions" ta-toolbar="taToolbar" placeholder="ACCIONES" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputGoals/inputGoals.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="goals"><strong class="text-uppercase">Metas.</strong> Metas logradas del proyecto <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="goals" ng-model="model" name="ta-goals" ta-toolbar="taToolbar" placeholder="METAS" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputHistory/inputHistory.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="history"><strong class="text-uppercase">Historia que contar ...</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="history" ng-model="model" name="ta-history" ta-toolbar="taToolbar" placeholder="HISTORIA" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputImpact/inputImpact.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="impact"><strong class="text-uppercase">Indicadores.</strong> Impacto <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="impact" ng-model="model" name="ta-impact" ta-toolbar="taToolbar" placeholder="IMPACTO" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputMonitoring/inputMonitoring.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="monitoring"><strong class="text-uppercase">Monitoreo y Evaluaci\xF3n.</strong> Describir brevemente <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="monitoring" ng-model="model" name="ta-monitoring" ta-toolbar="taToolbar" placeholder="DESCRIBIR" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputObjective/inputObjective.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="objective"><strong class="text-uppercase">Objetivo.</strong> Describa el objetivo del proyecto <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12"><textarea name="objective" id="objective" cols="30" rows="5" class="form-control" ng-model="model" maxlength="{{limit}}">\n        </textarea><char-counter ng-model="model" limit="limit" ng-if="limit"></char-counter></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputReferred/inputReferred.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="referred"><strong class="text-uppercase">El proyecto ha sido mencionado / referido en:</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12"><textarea name="referred" id="referred" cols="30" rows="5" class="form-control" placeholder="Detalle" ng-model="model" maxlength="{{limit}}">\n        </textarea><char-counter ng-model="model" limit="limit" ng-if="limit"></char-counter></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputResults/inputResults.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="results"><strong class="text-uppercase">Indicadores.</strong> Resultados <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="results" ng-model="model" name="ta-results" ta-toolbar="taToolbar" placeholder="RESULTADOS" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputSatisfactionIndicator/inputSatisfactionIndicator.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="satisfactionIndicator"><strong>\xBFTiene un indicador de satisfacci\xF3n o recepci\xF3n de opini\xF3n sobre el proyecto de parte de los beneficiarios?\xBFCu\xE1l y c\xF3mo?</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12"><textarea name="satisfactionIndicator" id="satisfactionIndicator" cols="30" rows="5" class="form-control" placeholder="Detalle" ng-model="model">\n        </textarea></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/inputSummary/inputSummary.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="summary"><strong class="text-uppercase">Resumen.</strong> Rese\xF1a p\xFAblica <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" text-angular="" id="summary" ng-model="model" name="ta-summary" ta-toolbar="taToolbar" placeholder="RESUMEN" ta-maxlength="{{limit}}" ta-max-text="{{limit}}" ta-text-editor-class="form-control ta-height" ta-html-editor-class="form-control ta-height"></div><div class="text-right p-r-15"><span class="label label-info">{{getCharCount() || 0}} / {{limit}}</span></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorActivity/selectorActivity.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Actividad.</strong> Indique la actividad que realiza la empresa en el entorno de este proyecto <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span>{{item.name}}</span></label><div class="col-md-12" style="padding: 5px 0 0 20px;" ng-if="selection[item.id] === true && item.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-model="item.customValue"></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorAlliance/selectorAlliance.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong>Alianzas en la gesti\xF3n del proyecto</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span>{{item.name}}</span></label><div class="col-md-12" style="padding: 5px 0 0 20px;" ng-if="selection[item.id] === true && item.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-model="item.customValue"></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorAward/selectorAward.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Referencias</strong> (premios, entrevistas, etc) <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="clearfix"><div class="list-container" ng-if="selected.length"><div ng-repeat="item in selected track by $index" class="form-group col-md-12"><textarea name="award" cols="30" rows="3" class="form-control" placeholder="Premios" ng-model="selected[$index]" maxlength="{{limit}}">\n                </textarea><char-counter ng-model="selected[$index]" limit="limit" ng-if="limit"></char-counter><div class="text-right p-t-5"><a href="javascript:;" ng-click="removeItem($index)" class="remove-item-btn"><i class="fa fa-minus-circle"></i></a></div></div></div><div class="new-container"><div class="form-group col-md-12"><textarea name="award" cols="30" rows="3" class="form-control" placeholder="Premios" ng-model="newItem" maxlength="{{limit}}">\n                </textarea><char-counter ng-model="newItem" limit="limit" ng-if="limit"></char-counter><div class="text-right p-t-5"><a href="javascript:;" ng-click="addItem()" class="add-item-btn"><i class="fa fa-plus-circle"></i></a></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorBeneficiary/selectorBeneficiary.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong>Beneficiarios</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><div class="form-group p-t-10"><div class="col-md-2 no-padding"><input type="text" name="customAmount_{{column + \'_\' +$index}}" id="customAmount_{{column + \'_\' +$index}}" class="form-control col-md-12" only-natural-number="" ng-change="changeSelection(item, item.customAmount, item.customValue)" ng-model="item.customAmount"></div><label class="control-label col-md-10 p-t-5" for="customAmount_{{column + \'_\' +$index}}">{{item.name}}</label></div><div class="col-md-12 no-padding p-r-15" ng-if="item.customAmount && item.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-change="changeSelection(item, item.customAmount, item.customValue)" ng-model="item.customValue"></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorCategory/selectorCategory.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Rubro del Proyecto</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span>{{item.name}}</span></label><div ng-if="item.subcategories && item.subcategories.length" style="padding: 10px 0 0 30px;"><div ng-repeat="subcat in item.subcategories" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[subcat.id]" ng-change="changeSelection(subcat, selection[subcat.id])"> <span>{{subcat.name}}</span></label><div class="col-md-12" style="padding: 5px 0 0 20px;" ng-if="selection[subcat.id] === true && subcat.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-model="subcat.customValue"></div></div></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorCompany/selectorCompany.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="company"><strong class="text-uppercase">Empresa</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12"><select class="form-control" name="company" id="company" ng-model="model" ng-options="company.id as company.publicName for company in companies"><option selected="" value="">{{\'Empresa\'|uppercase}}</option></select></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorDiffusion/selectorDiffusion.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Difusi\xF3n</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div><div class="subtitle">Los alcances y avances de este proyecto son informados y conocidos por:</div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span>{{item.name}}</span></label><div class="col-md-12" style="padding: 5px 0 0 20px;" ng-if="selection[item.id] === true && item.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-model="item.customValue"></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorFinancing/selectorFinancing.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong>Financiamiento</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span>{{item.name}}</span></label><div class="col-md-12" style="padding: 5px 0 0 20px;" ng-if="selection[item.id] === true && item.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-model="item.customValue"></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorImageUpload/selectorImageUpload.html','<div class="clearfix" ng-class="{\'has-error-item\': (errors && errors.length) || (errorsAvatar && errorsAvatar.length)}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Elementos gr\xE1ficos</strong> <span ng-if="isRequired || isRequiredAvatar" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div><div class="subtitle"><div>Fotos</div><div>M\xEDnimo 3 fotos</div><div>Formato JPG. M\xE1ximo 2000KB</div><recommended-sizes width="recommendedSizes.width" height="recommendedSizes.height" unit="px"></recommended-sizes></div></div><div class="clearfix"><div ng-repeat="file in files" class="col-md-12 no-padding" ng-class="{\'p-t-1\': !$first}"><div class="clearfix"><div class="col-md-1 no-padding"><img class="img-responsive" ng-src="{{file.url|imageUrl}}"></div><div class="col-md-11"><a href="javascript:;" class="remove-item-btn" ng-click="removeItem($index)"><i class="fa fa-minus-circle"></i></a></div></div><div class="p-t-10 p-b-10"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="files[$index].checked" ng-change="setAsAvatar($index, files[$index].checked)"> <span>Marcar como foto portada</span></label></div></div><div class="col-md-12 no-padding p-t-2"><div class="clearfix"><div class="col-md-2 no-padding"><img ng-if="file" class="img-responsive" ngf-thumbnail="file"></div><div class="col-md-12 no-padding p-t-10"><button class="btn btn-sm" ngf-select="" ng-model="file" accept="image/*" ngf-max-size="2MB">{{file?\'Cambiar\':\'Examinar\'}}</button> <button type="button" class="btn btn-sm btn-primary" ng-click="uploadFile(file, $index)" ng-disabled="!file">Subir</button></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="(errors && errors.length) || (errorsAvatar && errorsAvatar.length)"><div class="error-message" ng-repeat="error in errors">{{error}}</div><div class="error-message" ng-repeat="errorsAvatar in errorsAvatar">{{errorsAvatar}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorInformationBase/selectorInformationBase.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong>\xBFCu\xE1l es la base / informaci\xF3n que sustenta la pertinencia de este proyecto?<br>\xBFPor qu\xE9 se decide hacerlo?</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="selector-body clearfix"><div ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span>{{item.name}}</span></label><div class="col-md-12" style="padding: 5px 0 0 20px;" ng-if="selection[item.id] === true && item.custom === true"><input type="text" placeholder="Especifique" class="form-control" ng-model="item.customValue"></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorLink/selectorLink.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Enlaces</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div></div><div class="clearfix"><div class="list-container" ng-if="selected.length"><div ng-repeat="item in selected track by $index" class="form-group col-md-12"><div class="col-md-6 no-padding p-r-5"><input type="text" name="link_title{{$index}}" id="link_title{{$index}}" placeholder="T\xEDtulo del enlace" class="form-control" style="display: block;" ng-model="selected[$index].title"></div><div class="col-md-6 no-padding p-l-5"><input type="text" name="link_url{{$index}}" id="link_url{{$index}}" placeholder="Url del enlace" class="form-control" style="display: block;" ng-model="selected[$index].url"></div><div class="text-right"><a href="javascript:;" ng-click="removeItem($index)" class="remove-item-btn"><i class="fa fa-minus-circle"></i></a></div></div></div><div class="new-container"><div class="form-group col-md-12"><div class="col-md-6 no-padding p-r-5"><input type="text" name="link_add_title{{$index}}" id="link_add_title{{$index}}" placeholder="T\xEDtulo del enlace" class="form-control" style="display: block;" ng-model="newItem.title"></div><div class="col-md-6 no-padding p-l-5"><input type="text" name="link_add_url{{$index}}" id="link_add_url{{$index}}" placeholder="Url del enlace" class="form-control" style="display: block;" ng-model="newItem.url"></div><div class="text-right"><a href="javascript:;" ng-click="addItem()" class="add-item-btn"><i class="fa fa-plus-circle"></i></a></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorLocation/selectorLocation.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-6 no-padding"><div class="form-group"><label class="control-label col-md-12" for="region"><strong class="text-uppercase">Lugar.</strong> En el que se ha desarrollado el proyecto. <span ng-if="isRequired" class="info-tag" uib-tooltip="El proyecto debe tener al menos una sede" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12"><select class="form-control" name="region" id="region" ng-model="location.idRegion" ng-change="loadProvinces(location.idRegion)" ng-options="region.id as (region.name) for region in regions"><option selected="" disabled="" value="">{{\'Regi\xF3n\'|uppercase}}</option></select></div><div class="col-md-12"><select class="form-control" name="province" id="province" ng-model="location.idProvince" ng-change="loadDistricts(location.idProvince)" ng-options="province.id as (province.name) for province in provinces"><option selected="" disabled="" value="">{{\'Provincia\'|uppercase}}</option></select></div><div class="col-md-12"><select class="form-control" name="district" id="district" ng-model="location.idDistrict" ng-options="district.id as (district.name) for district in districts"><option selected="" disabled="" value="">{{\'Distrito\'|uppercase}}</option></select></div><div class="col-md-12"><input type="text" name="populatedCenter" id="populatedCenter" placeholder="Centro Poblado" class="form-control" ng-model="location.populatedCenter"></div><div class="col-md-12 text-right"><button type="button" class="btn btn-xs" ng-click="calculateCoords()"><span class="fa fa-map-pin"></span> Calcular Coordenadas</button></div></div><div class="form-group"><label class="control-label col-md-12" for="coordinates"><strong class="text-uppercase">Coordenadas.</strong> Un proyecto para editar o actualizar</label><div class="col-md-12" id="coordinates"><input type="text" name="latitude" id="latitude" placeholder="Latitud" class="form-control" ng-model="location.latitude"></div><div class="col-md-12"><input type="text" name="longitude" id="longitude" placeholder="Longitud" class="form-control" ng-model="location.longitude"></div></div><div class="col-md-12 text-right"><button type="button" class="btn btn-xs" ng-click="createOrUpdateLocation()"><span class="fa fa-save"></span> {{(isEdition ? \'Actualizar\' : \'Adicionar\') + \' lugar\'}}</button></div><div class="col-md-12"><table class="table table-location mb-20"><thead><tr><th>Lugares</th><th></th></tr></thead><tbody><tr ng-repeat="location in model track by $index"><td><div class="location-card"><div><span class="fa fa-map-marker"></span> {{location.latitude + \', \' + location.longitude}}</div></div></td><td style="padding-right: 0 !important;"><button type="button" class="btn btn-xs" ng-click="selectLocation(location, $index)"><span class="fa fa-edit"></span></button> <button type="button" class="btn btn-xs" ng-click="removeLocation($index)"><span class="fa fa-trash"></span></button></td></tr><tr ng-if="model.length===0"><td colspan="2">No se han adicionado sedes al proyecto.</td></tr></tbody></table></div></div><div class="col-md-6"><gmaps locations="model"></gmaps></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorODS/selectorODS.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Objetivos de Desarrollo Sostenible (ODS)</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div><div class="subtitle">Para mayor informaci\xF3n sobre la calificaci\xF3n de los ODS para su proyecto, ingrese al link https://www.un.org/sustainabledevelopment/es/objetivos-desarrollo-sostenible/</div></div><div class="selector-body clearfix"><div ng-if="viewMode === \'horizontal\'" class="col-md-12 no-padding"><div ng-repeat="item in objectives" class="item col-md-2 col-xs-4 col-sm-2"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="ods{{item.id}}" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span></span></label> <label for="ods{{item.id}}"><img ng-src="{{item.image.url | url}}" alt="" width="50"></label></div></div><div ng-if="viewMode === \'vertical\'" ng-repeat="column in (columns|range)" class="column"><div ng-repeat="item in getItemsByColumn(column)" class="item"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="ods{{item.id}}" ng-model="selection[item.id]" ng-change="changeSelection(item, selection[item.id])"> <span></span></label> <label for="ods{{item.id}}"><img ng-src="{{item.image.url | url}}" alt="" width="50"></label></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorProjectStatus/selectorProjectStatus.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="project-status"><strong class="text-uppercase">Estado</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12"><select class="form-control" name="project-status" id="project-status" ng-model="model" ng-options="status.id as (status.name) for status in statusList"><option selected="" value="">{{\'Estado\'|uppercase}}</option></select></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorVideo/selectorVideo.html','<div class="clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><div class="col-md-12"><div class="custom-selector"><div class="selector-header"><div class="title"><strong class="text-uppercase">Videos</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></div><div class="subtitle">Ingresar la URL del video de youtube</div></div><div class="clearfix"><div class="list-container" ng-if="selected.length"><div ng-repeat="item in selected track by $index" class="form-group col-md-12"><input type="text" name="video{{$index}}" id="video{{$index}}" placeholder="Url del Video" class="form-control" style="display: block;" ng-model="selected[$index]"><div class="text-right"><a href="javascript:;" ng-click="removeItem($index)" class="remove-item-btn"><i class="fa fa-minus-circle"></i></a></div></div></div><div class="new-container"><div class="form-group col-md-12"><input type="text" name="video-add" id="video-add" placeholder="Url del Video" class="form-control" style="display: block;" ng-model="newItem"><div class="text-right"><a href="javascript:;" ng-click="addItem()" class="add-item-btn"><i class="fa fa-plus-circle"></i></a></div></div></div></div></div></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');
$templateCache.put('app/resources/directives/manageProjects/selectorWomanEmpowerment/selectorWomanEmpowerment.html','<div class="form-group clearfix" ng-class="{\'has-error-item\': errors && errors.length}" ng-show="isVisible()"><label class="control-label col-md-12" for="woman-empowerment"><strong>\xBFEl proyecto implica empoderamiento y/o fortalecimiento de la mujer?</strong> <span ng-if="isRequired" class="info-tag" uib-tooltip="Este campo es requerido" tooltip-append-to-body="true"><i class="fa fa-info-circle"></i></span></label><div class="col-md-12" id="woman-empowerment"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" name="woman-empowerment" ng-checked="model" ng-click="toggleSelection()"> <span>Si</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" name="woman-empowerment" ng-checked="!model" ng-click="toggleSelection()"> <span>No</span></label></div><div class="col-md-12 p-b-10" ng-if="errors && errors.length"><div class="error-message" ng-repeat="error in errors">{{error}}</div></div></div>');}]);